/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _svg4everybody = __webpack_require__(3);
	
	var _svg4everybody2 = _interopRequireDefault(_svg4everybody);
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(4);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _overlay = __webpack_require__(49);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _router = __webpack_require__(51);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _tooltip = __webpack_require__(52);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _geo = __webpack_require__(53);
	
	var _geo2 = _interopRequireDefault(_geo);
	
	var _infomessage = __webpack_require__(54);
	
	var _infomessage2 = _interopRequireDefault(_infomessage);
	
	var _blocked = __webpack_require__(55);
	
	var _blocked2 = _interopRequireDefault(_blocked);
	
	var _main = __webpack_require__(56);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _comingSoon = __webpack_require__(59);
	
	var _comingSoon2 = _interopRequireDefault(_comingSoon);
	
	var _noRegion = __webpack_require__(60);
	
	var _noRegion2 = _interopRequireDefault(_noRegion);
	
	var _roaming = __webpack_require__(61);
	
	var _roaming2 = _interopRequireDefault(_roaming);
	
	var _monthFree = __webpack_require__(65);
	
	var _monthFree2 = _interopRequireDefault(_monthFree);
	
	var _application = __webpack_require__(66);
	
	var _application2 = _interopRequireDefault(_application);
	
	var _internetTariff = __webpack_require__(67);
	
	var _internetTariff2 = _interopRequireDefault(_internetTariff);
	
	var _orderSim = __webpack_require__(69);
	
	var _orderSim2 = _interopRequireDefault(_orderSim);
	
	var _orderSimThankyou = __webpack_require__(73);
	
	var _orderSimThankyou2 = _interopRequireDefault(_orderSimThankyou);
	
	var _international = __webpack_require__(74);
	
	var _international2 = _interopRequireDefault(_international);
	
	var _helper = __webpack_require__(75);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _connect = __webpack_require__(78);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _connectPromo = __webpack_require__(89);
	
	var _connectPromo2 = _interopRequireDefault(_connectPromo);
	
	var _callback = __webpack_require__(90);
	
	var _callback2 = _interopRequireDefault(_callback);
	
	var _b2bModemOrder = __webpack_require__(91);
	
	var _b2bModemOrder2 = _interopRequireDefault(_b2bModemOrder);
	
	var _b2bTariffModem = __webpack_require__(92);
	
	var _b2bTariffModem2 = _interopRequireDefault(_b2bTariffModem);
	
	var _tabletPromo = __webpack_require__(93);
	
	var _tabletPromo2 = _interopRequireDefault(_tabletPromo);
	
	var _way = __webpack_require__(94);
	
	var _way2 = _interopRequireDefault(_way);
	
	var _b2bTariffVoice = __webpack_require__(96);
	
	var _b2bTariffVoice2 = _interopRequireDefault(_b2bTariffVoice);
	
	var _selfcare = __webpack_require__(97);
	
	var _selfcare2 = _interopRequireDefault(_selfcare);
	
	var _plankton = __webpack_require__(98);
	
	var _plankton2 = _interopRequireDefault(_plankton);
	
	var _abcParalax = __webpack_require__(99);
	
	var _abcParalax2 = _interopRequireDefault(_abcParalax);
	
	var _tariffVoice = __webpack_require__(100);
	
	var _tariffVoice2 = _interopRequireDefault(_tariffVoice);
	
	var _info = __webpack_require__(101);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _modemOrder = __webpack_require__(104);
	
	var _modemOrder2 = _interopRequireDefault(_modemOrder);
	
	var _showcase = __webpack_require__(105);
	
	var _showcase2 = _interopRequireDefault(_showcase);
	
	var _payment = __webpack_require__(109);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _roamingBox = __webpack_require__(110);
	
	var _roamingBox2 = _interopRequireDefault(_roamingBox);
	
	var _voiceMobileApp = __webpack_require__(112);
	
	var _voiceMobileApp2 = _interopRequireDefault(_voiceMobileApp);
	
	var _devices = __webpack_require__(113);
	
	var _devices2 = _interopRequireDefault(_devices);
	
	var _tariffMobile = __webpack_require__(114);
	
	var _tariffMobile2 = _interopRequireDefault(_tariffMobile);
	
	var _order = __webpack_require__(115);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _orderThankyou = __webpack_require__(122);
	
	var _orderThankyou2 = _interopRequireDefault(_orderThankyou);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Set defaults underscore template settings
	_underscore2.default.templateSettings = {
		evaluate: /\{\{(.+?)\}\}/g,
		interpolate: /\{\{=(.+?)\}\}/g,
		escape: /\{\{-(.+?)\}\}/g
	};
	
	(0, _jquery2.default)(function () {
		return (0, _svg4everybody2.default)();
	});
	
	// THEME
	
	
	// MAIN
	
	
	// B2B CONNECT
	
	// B2B CALLBACK
	
	
	// B2B MODEM
	
	// TABLET
	
	
	// YOTA WAY
	
	
	// BACKBAY
	
	
	// THEME
	(0, _jquery2.default)(function () {
		return new _header2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _overlay2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _router2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _tooltip2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _geo2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _infomessage2.default().render();
	});
	// MAIN
	(0, _jquery2.default)(function () {
		return new _blocked2.default().render();
	});
	
	(0, _jquery2.default)(function () {
		return new _main2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _comingSoon2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _noRegion2.default().render();
	});
	
	(0, _jquery2.default)(function () {
		return new _roaming2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _monthFree2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _application2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _internetTariff2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _orderSim2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _orderSimThankyou2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _international2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _helper2.default().render();
	});
	
	// B2B CONNECT
	(0, _jquery2.default)(function () {
		return new _connect2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _connectPromo2.default().render();
	});
	// B2B CALLBACK
	(0, _jquery2.default)(function () {
		return new _callback2.default().render();
	});
	
	// B2B MODEM
	(0, _jquery2.default)(function () {
		return new _b2bModemOrder2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _b2bTariffModem2.default().render();
	});
	// TABLET
	(0, _jquery2.default)(function () {
		return new _tabletPromo2.default().render();
	});
	
	// YOTA WAY
	(0, _jquery2.default)(function () {
		return new _way2.default().render();
	});
	
	(0, _jquery2.default)(function () {
		return new _b2bTariffVoice2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _selfcare2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _plankton2.default().render();
	});
	
	(0, _jquery2.default)(function () {
		return new _abcParalax2.default().render();
	});
	
	(0, _jquery2.default)(function () {
		return new _tariffVoice2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _info2.default().render();
	});
	
	// BACKBAY
	(0, _jquery2.default)(function () {
		return new _modemOrder2.default().render();
	});
	
	(0, _jquery2.default)(function () {
		return new _showcase2.default().render();
	});
	
	(function () {
		window.InplatPaymentOnInitiated = function () {
			setTimeout(function () {
				return (0, _jquery2.default)(window).trigger('yota.payment.inplatInitiated');
			}, 1000);
		};
	
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = 'https://v-jet.inplat.ru/static/js/widget_tsp.js';
		document.body.appendChild(script);
	
		(0, _jquery2.default)(function () {
			return new _payment2.default().render();
		});
	})();
	
	(0, _jquery2.default)(function () {
		return new _roamingBox2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _voiceMobileApp2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _devices2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _tariffMobile2.default().render();
	});
	
	(0, _jquery2.default)(function () {
		return new _order2.default().render();
	});
	(0, _jquery2.default)(function () {
		return new _orderThankyou2.default().render();
	});

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v2.2.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-05-20T17:23Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var arr = [];
	
	var document = window.document;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "2.2.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			// Not own constructor property must be Object
			if ( obj.constructor &&
					!hasOwn.call( obj, "constructor" ) &&
					!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
				return false;
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
	
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf( "use strict" ) === 1 ) {
					script = document.createElement( "script" );
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
	
					// Otherwise, avoid the DOM node creation, insertion
					// and removal by using an indirect global eval
	
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
	
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE9-10 only
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		register: function( owner, initial ) {
			var value = initial || {};
	
			// If it is a node unlikely to be stringify-ed or looped over
			// use plain assignment
			if ( owner.nodeType ) {
				owner[ this.expando ] = value;
	
			// Otherwise secure it in a non-enumerable, non-writable property
			// configurability must be true to allow the property to be
			// deleted with the delete operator
			} else {
				Object.defineProperty( owner, this.expando, {
					value: value,
					writable: true,
					configurable: true
				} );
			}
			return owner[ this.expando ];
		},
		cache: function( owner ) {
	
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( !acceptData( owner ) ) {
				return {};
			}
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
				owner[ this.expando ] && owner[ this.expando ][ key ];
		},
		access: function( owner, key, value ) {
			var stored;
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase( key ) );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key === undefined ) {
				this.register( owner );
	
			} else {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
	
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
	
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
	
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <= 35-45+
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://code.google.com/p/chromium/issues/detail?id=378607
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data, camelKey;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// with the key as-is
					data = dataUser.get( elem, key ) ||
	
						// Try to find dashed key if it exists (gh-2779)
						// This is for 2.2.x only
						dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );
	
					if ( data !== undefined ) {
						return data;
					}
	
					camelKey = jQuery.camelCase( key );
	
					// Attempt to get data from the cache
					// with the key camelized
					data = dataUser.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				camelKey = jQuery.camelCase( key );
				this.each( function() {
	
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = dataUser.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					dataUser.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
						dataUser.set( this, key, value );
					}
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE9-11+
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0-4.3, Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
				"screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
			div.style.cssText =
	
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
		}
	
		jQuery.extend( support, {
			pixelPosition: function() {
	
				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
				// since that compresses better and they're computed together anyway.
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			},
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;box-sizing:content-box;" +
					"display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				documentElement.appendChild( container );
	
				ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );
	
				documentElement.removeChild( container );
				div.removeChild( marginDiv );
	
				return ret;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE9-11+
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = dataPriv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = dataPriv.access(
						elem,
						"olddisplay",
						defaultDisplay( elem.nodeName )
					);
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					dataPriv.set(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
	
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
			opt.duration : opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// Handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE8-11+
				// IE throws exception if url is malformed, e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE8-11+
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		return !jQuery.expr.filters.visible( elem );
	};
	jQuery.expr.filters.visible = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		// Use OR instead of AND as the element is not visible if either is true
		// See tickets #10406 and #13132
		return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE9
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE9
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			box = elem.getBoundingClientRect();
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
		size: function() {
			return this.length;
		}
	} );
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(root, factory) {
	     true ? // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return root.svg4everybody = factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof module && module.exports ? // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory() : root.svg4everybody = factory();
	}(this, function() {
	    /*! svg4everybody v2.1.9 | github.com/jonathantneal/svg4everybody */
	    function embed(parent, svg, target) {
	        // if the target exists
	        if (target) {
	            // create a document fragment to hold the contents of the target
	            var fragment = document.createDocumentFragment(), viewBox = !svg.hasAttribute("viewBox") && target.getAttribute("viewBox");
	            // conditionally set the viewBox on the svg
	            viewBox && svg.setAttribute("viewBox", viewBox);
	            // copy the contents of the clone into the fragment
	            for (// clone the target
	            var clone = target.cloneNode(!0); clone.childNodes.length; ) {
	                fragment.appendChild(clone.firstChild);
	            }
	            // append the fragment into the svg
	            parent.appendChild(fragment);
	        }
	    }
	    function loadreadystatechange(xhr) {
	        // listen to changes in the request
	        xhr.onreadystatechange = function() {
	            // if the request is ready
	            if (4 === xhr.readyState) {
	                // get the cached html document
	                var cachedDocument = xhr._cachedDocument;
	                // ensure the cached html document based on the xhr response
	                cachedDocument || (cachedDocument = xhr._cachedDocument = document.implementation.createHTMLDocument(""), 
	                cachedDocument.body.innerHTML = xhr.responseText, xhr._cachedTarget = {}), // clear the xhr embeds list and embed each item
	                xhr._embeds.splice(0).map(function(item) {
	                    // get the cached target
	                    var target = xhr._cachedTarget[item.id];
	                    // ensure the cached target
	                    target || (target = xhr._cachedTarget[item.id] = cachedDocument.getElementById(item.id)), 
	                    // embed the target into the svg
	                    embed(item.parent, item.svg, target);
	                });
	            }
	        }, // test the ready state change immediately
	        xhr.onreadystatechange();
	    }
	    function svg4everybody(rawopts) {
	        function oninterval() {
	            // while the index exists in the live <use> collection
	            for (// get the cached <use> index
	            var index = 0; index < uses.length; ) {
	                // get the current <use>
	                var use = uses[index], parent = use.parentNode, svg = getSVGAncestor(parent), src = use.getAttribute("xlink:href") || use.getAttribute("href");
	                if (!src && opts.attributeName && (src = use.getAttribute(opts.attributeName)), 
	                svg && src) {
	                    if (polyfill) {
	                        if (!opts.validate || opts.validate(src, svg, use)) {
	                            // remove the <use> element
	                            parent.removeChild(use);
	                            // parse the src and get the url and id
	                            var srcSplit = src.split("#"), url = srcSplit.shift(), id = srcSplit.join("#");
	                            // if the link is external
	                            if (url.length) {
	                                // get the cached xhr request
	                                var xhr = requests[url];
	                                // ensure the xhr request exists
	                                xhr || (xhr = requests[url] = new XMLHttpRequest(), xhr.open("GET", url), xhr.send(), 
	                                xhr._embeds = []), // add the svg and id as an item to the xhr embeds list
	                                xhr._embeds.push({
	                                    parent: parent,
	                                    svg: svg,
	                                    id: id
	                                }), // prepare the xhr ready state change event
	                                loadreadystatechange(xhr);
	                            } else {
	                                // embed the local id into the svg
	                                embed(parent, svg, document.getElementById(id));
	                            }
	                        } else {
	                            // increase the index when the previous value was not "valid"
	                            ++index, ++numberOfSvgUseElementsToBypass;
	                        }
	                    }
	                } else {
	                    // increase the index when the previous value was not "valid"
	                    ++index;
	                }
	            }
	            // continue the interval
	            (!uses.length || uses.length - numberOfSvgUseElementsToBypass > 0) && requestAnimationFrame(oninterval, 67);
	        }
	        var polyfill, opts = Object(rawopts), newerIEUA = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/, webkitUA = /\bAppleWebKit\/(\d+)\b/, olderEdgeUA = /\bEdge\/12\.(\d+)\b/, edgeUA = /\bEdge\/.(\d+)\b/, inIframe = window.top !== window.self;
	        polyfill = "polyfill" in opts ? opts.polyfill : newerIEUA.test(navigator.userAgent) || (navigator.userAgent.match(olderEdgeUA) || [])[1] < 10547 || (navigator.userAgent.match(webkitUA) || [])[1] < 537 || edgeUA.test(navigator.userAgent) && inIframe;
	        // create xhr requests object
	        var requests = {}, requestAnimationFrame = window.requestAnimationFrame || setTimeout, uses = document.getElementsByTagName("use"), numberOfSvgUseElementsToBypass = 0;
	        // conditionally start the interval if the polyfill is active
	        polyfill && oninterval();
	    }
	    function getSVGAncestor(node) {
	        for (var svg = node; "svg" !== svg.nodeName.toLowerCase() && (svg = svg.parentNode); ) {}
	        return svg;
	    }
	    return svg4everybody;
	});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define('underscore', factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
	    var current = global._;
	    var exports = global._ = factory();
	    exports.noConflict = function () { global._ = current; return exports; };
	  }()));
	}(this, (function () {
	  //     Underscore.js 1.13.1
	  //     https://underscorejs.org
	  //     (c) 2009-2021 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
	  //     Underscore may be freely distributed under the MIT license.
	
	  // Current version.
	  var VERSION = '1.13.1';
	
	  // Establish the root object, `window` (`self`) in the browser, `global`
	  // on the server, or `this` in some virtual machines. We use `self`
	  // instead of `window` for `WebWorker` support.
	  var root = typeof self == 'object' && self.self === self && self ||
	            typeof global == 'object' && global.global === global && global ||
	            Function('return this')() ||
	            {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
	  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push = ArrayProto.push,
	      slice = ArrayProto.slice,
	      toString = ObjProto.toString,
	      hasOwnProperty = ObjProto.hasOwnProperty;
	
	  // Modern feature detection.
	  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
	      supportsDataView = typeof DataView !== 'undefined';
	
	  // All **ECMAScript 5+** native function implementations that we hope to use
	  // are declared here.
	  var nativeIsArray = Array.isArray,
	      nativeKeys = Object.keys,
	      nativeCreate = Object.create,
	      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;
	
	  // Create references to these builtin functions because we override them.
	  var _isNaN = isNaN,
	      _isFinite = isFinite;
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  // The largest integer that can be represented exactly.
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	
	  // Some functions take a variable number of arguments, or a few expected
	  // arguments at the beginning and then a variable number of values to operate
	  // on. This helper accumulates all remaining arguments past the function’s
	  // argument length (or an explicit `startIndex`), into an array that becomes
	  // the last argument. Similar to ES6’s "rest parameter".
	  function restArguments(func, startIndex) {
	    startIndex = startIndex == null ? func.length - 1 : +startIndex;
	    return function() {
	      var length = Math.max(arguments.length - startIndex, 0),
	          rest = Array(length),
	          index = 0;
	      for (; index < length; index++) {
	        rest[index] = arguments[index + startIndex];
	      }
	      switch (startIndex) {
	        case 0: return func.call(this, rest);
	        case 1: return func.call(this, arguments[0], rest);
	        case 2: return func.call(this, arguments[0], arguments[1], rest);
	      }
	      var args = Array(startIndex + 1);
	      for (index = 0; index < startIndex; index++) {
	        args[index] = arguments[index];
	      }
	      args[startIndex] = rest;
	      return func.apply(this, args);
	    };
	  }
	
	  // Is a given variable an object?
	  function isObject(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  }
	
	  // Is a given value equal to null?
	  function isNull(obj) {
	    return obj === null;
	  }
	
	  // Is a given variable undefined?
	  function isUndefined(obj) {
	    return obj === void 0;
	  }
	
	  // Is a given value a boolean?
	  function isBoolean(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  }
	
	  // Is a given value a DOM element?
	  function isElement(obj) {
	    return !!(obj && obj.nodeType === 1);
	  }
	
	  // Internal function for creating a `toString`-based type tester.
	  function tagTester(name) {
	    var tag = '[object ' + name + ']';
	    return function(obj) {
	      return toString.call(obj) === tag;
	    };
	  }
	
	  var isString = tagTester('String');
	
	  var isNumber = tagTester('Number');
	
	  var isDate = tagTester('Date');
	
	  var isRegExp = tagTester('RegExp');
	
	  var isError = tagTester('Error');
	
	  var isSymbol = tagTester('Symbol');
	
	  var isArrayBuffer = tagTester('ArrayBuffer');
	
	  var isFunction = tagTester('Function');
	
	  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
	  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
	  var nodelist = root.document && root.document.childNodes;
	  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
	    isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  var isFunction$1 = isFunction;
	
	  var hasObjectTag = tagTester('Object');
	
	  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
	  // In IE 11, the most common among them, this problem also applies to
	  // `Map`, `WeakMap` and `Set`.
	  var hasStringTagBug = (
	        supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8)))
	      ),
	      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));
	
	  var isDataView = tagTester('DataView');
	
	  // In IE 10 - Edge 13, we need a different heuristic
	  // to determine whether an object is a `DataView`.
	  function ie10IsDataView(obj) {
	    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
	  }
	
	  var isDataView$1 = (hasStringTagBug ? ie10IsDataView : isDataView);
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native `Array.isArray`.
	  var isArray = nativeIsArray || tagTester('Array');
	
	  // Internal function to check whether `key` is an own property name of `obj`.
	  function has$1(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  }
	
	  var isArguments = tagTester('Arguments');
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  (function() {
	    if (!isArguments(arguments)) {
	      isArguments = function(obj) {
	        return has$1(obj, 'callee');
	      };
	    }
	  }());
	
	  var isArguments$1 = isArguments;
	
	  // Is a given object a finite number?
	  function isFinite$1(obj) {
	    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
	  }
	
	  // Is the given value `NaN`?
	  function isNaN$1(obj) {
	    return isNumber(obj) && _isNaN(obj);
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function constant(value) {
	    return function() {
	      return value;
	    };
	  }
	
	  // Common internal logic for `isArrayLike` and `isBufferLike`.
	  function createSizePropertyCheck(getSizeProperty) {
	    return function(collection) {
	      var sizeProperty = getSizeProperty(collection);
	      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
	    }
	  }
	
	  // Internal helper to generate a function to obtain property `key` from `obj`.
	  function shallowProperty(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  }
	
	  // Internal helper to obtain the `byteLength` property of an object.
	  var getByteLength = shallowProperty('byteLength');
	
	  // Internal helper to determine whether we should spend extensive checks against
	  // `ArrayBuffer` et al.
	  var isBufferLike = createSizePropertyCheck(getByteLength);
	
	  // Is a given value a typed array?
	  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
	  function isTypedArray(obj) {
	    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
	    // Otherwise, fall back on the above regular expression.
	    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
	                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
	  }
	
	  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);
	
	  // Internal helper to obtain the `length` property of an object.
	  var getLength = shallowProperty('length');
	
	  // Internal helper to create a simple lookup structure.
	  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
	  // circular imports. `emulatedSet` is a one-off solution that only works for
	  // arrays of strings.
	  function emulatedSet(keys) {
	    var hash = {};
	    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
	    return {
	      contains: function(key) { return hash[key]; },
	      push: function(key) {
	        hash[key] = true;
	        return keys.push(key);
	      }
	    };
	  }
	
	  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
	  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
	  // needed.
	  function collectNonEnumProps(obj, keys) {
	    keys = emulatedSet(keys);
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = isFunction$1(constructor) && constructor.prototype || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`.
	  function keys(obj) {
	    if (!isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (has$1(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  function isEmpty(obj) {
	    if (obj == null) return true;
	    // Skip the more expensive `toString`-based type checks if `obj` has no
	    // `.length`.
	    var length = getLength(obj);
	    if (typeof length == 'number' && (
	      isArray(obj) || isString(obj) || isArguments$1(obj)
	    )) return length === 0;
	    return getLength(keys(obj)) === 0;
	  }
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  function isMatch(object, attrs) {
	    var _keys = keys(attrs), length = _keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = _keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  }
	
	  // If Underscore is called as a function, it returns a wrapped object that can
	  // be used OO-style. This wrapper holds altered versions of all functions added
	  // through `_.mixin`. Wrapped objects may be chained.
	  function _$1(obj) {
	    if (obj instanceof _$1) return obj;
	    if (!(this instanceof _$1)) return new _$1(obj);
	    this._wrapped = obj;
	  }
	
	  _$1.VERSION = VERSION;
	
	  // Extracts the result from a wrapped and chained object.
	  _$1.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxies for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;
	
	  _$1.prototype.toString = function() {
	    return String(this._wrapped);
	  };
	
	  // Internal function to wrap or shallow-copy an ArrayBuffer,
	  // typed array or DataView to a new view, reusing the buffer.
	  function toBufferView(bufferSource) {
	    return new Uint8Array(
	      bufferSource.buffer || bufferSource,
	      bufferSource.byteOffset || 0,
	      getByteLength(bufferSource)
	    );
	  }
	
	  // We use this string twice, so give it a name for minification.
	  var tagDataView = '[object DataView]';
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null) return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a) return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
	    return deepEq(a, b, aStack, bStack);
	  }
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    if (a instanceof _$1) a = a._wrapped;
	    if (b instanceof _$1) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    // Work around a bug in IE 10 - Edge 13.
	    if (hasStringTagBug && className == '[object Object]' && isDataView$1(a)) {
	      if (!isDataView$1(b)) return false;
	      className = tagDataView;
	    }
	    switch (className) {
	      // These types are compared by value.
	      case '[object RegExp]':
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN.
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	      case '[object Symbol]':
	        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
	      case '[object ArrayBuffer]':
	      case tagDataView:
	        // Coerce to typed array so we can fall through.
	        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays && isTypedArray$1(a)) {
	        var byteLength = getByteLength(a);
	        if (byteLength !== getByteLength(b)) return false;
	        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
	        areArrays = true;
	    }
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
	                               isFunction$1(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var _keys = keys(a), key;
	      length = _keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = _keys[length];
	        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  }
	
	  // Perform a deep comparison to check if two objects are equal.
	  function isEqual(a, b) {
	    return eq(a, b);
	  }
	
	  // Retrieve all the enumerable property names of an object.
	  function allKeys(obj) {
	    if (!isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Since the regular `Object.prototype.toString` type tests don't work for
	  // some types in IE 11, we use a fingerprinting heuristic instead, based
	  // on the methods. It's not great, but it's the best we got.
	  // The fingerprint method lists are defined below.
	  function ie11fingerprint(methods) {
	    var length = getLength(methods);
	    return function(obj) {
	      if (obj == null) return false;
	      // `Map`, `WeakMap` and `Set` have no enumerable keys.
	      var keys = allKeys(obj);
	      if (getLength(keys)) return false;
	      for (var i = 0; i < length; i++) {
	        if (!isFunction$1(obj[methods[i]])) return false;
	      }
	      // If we are testing against `WeakMap`, we need to ensure that
	      // `obj` doesn't have a `forEach` method in order to distinguish
	      // it from a regular `Map`.
	      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
	    };
	  }
	
	  // In the interest of compact minification, we write
	  // each string in the fingerprints only once.
	  var forEachName = 'forEach',
	      hasName = 'has',
	      commonInit = ['clear', 'delete'],
	      mapTail = ['get', hasName, 'set'];
	
	  // `Map`, `WeakMap` and `Set` each have slightly different
	  // combinations of the above sublists.
	  var mapMethods = commonInit.concat(forEachName, mapTail),
	      weakMapMethods = commonInit.concat(mapTail),
	      setMethods = ['add'].concat(commonInit, forEachName, hasName);
	
	  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');
	
	  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');
	
	  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');
	
	  var isWeakSet = tagTester('WeakSet');
	
	  // Retrieve the values of an object's properties.
	  function values(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[_keys[i]];
	    }
	    return values;
	  }
	
	  // Convert an object into a list of `[key, value]` pairs.
	  // The opposite of `_.object` with one argument.
	  function pairs(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [_keys[i], obj[_keys[i]]];
	    }
	    return pairs;
	  }
	
	  // Invert the keys and values of an object. The values must be serializable.
	  function invert(obj) {
	    var result = {};
	    var _keys = keys(obj);
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      result[obj[_keys[i]]] = _keys[i];
	    }
	    return result;
	  }
	
	  // Return a sorted list of the function names available on the object.
	  function functions(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (isFunction$1(obj[key])) names.push(key);
	    }
	    return names.sort();
	  }
	
	  // An internal function for creating assigner functions.
	  function createAssigner(keysFunc, defaults) {
	    return function(obj) {
	      var length = arguments.length;
	      if (defaults) obj = Object(obj);
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!defaults || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  }
	
	  // Extend a given object with all the properties in passed-in object(s).
	  var extend = createAssigner(allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in
	  // object(s).
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  var extendOwn = createAssigner(keys);
	
	  // Fill in a given object with default properties.
	  var defaults = createAssigner(allKeys, true);
	
	  // Create a naked function reference for surrogate-prototype-swapping.
	  function ctor() {
	    return function(){};
	  }
	
	  // An internal function for creating a new object that inherits from another.
	  function baseCreate(prototype) {
	    if (!isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    var Ctor = ctor();
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  }
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  function create(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) extendOwn(result, props);
	    return result;
	  }
	
	  // Create a (shallow-cloned) duplicate of an object.
	  function clone(obj) {
	    if (!isObject(obj)) return obj;
	    return isArray(obj) ? obj.slice() : extend({}, obj);
	  }
	
	  // Invokes `interceptor` with the `obj` and then returns `obj`.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  function tap(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  }
	
	  // Normalize a (deep) property `path` to array.
	  // Like `_.iteratee`, this function can be customized.
	  function toPath$1(path) {
	    return isArray(path) ? path : [path];
	  }
	  _$1.toPath = toPath$1;
	
	  // Internal wrapper for `_.toPath` to enable minification.
	  // Similar to `cb` for `_.iteratee`.
	  function toPath(path) {
	    return _$1.toPath(path);
	  }
	
	  // Internal function to obtain a nested property in `obj` along `path`.
	  function deepGet(obj, path) {
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      if (obj == null) return void 0;
	      obj = obj[path[i]];
	    }
	    return length ? obj : void 0;
	  }
	
	  // Get the value of the (deep) property on `path` from `object`.
	  // If any property in `path` does not exist or if the value is
	  // `undefined`, return `defaultValue` instead.
	  // The `path` is normalized through `_.toPath`.
	  function get(object, path, defaultValue) {
	    var value = deepGet(object, toPath(path));
	    return isUndefined(value) ? defaultValue : value;
	  }
	
	  // Shortcut function for checking if an object has a given property directly on
	  // itself (in other words, not on a prototype). Unlike the internal `has`
	  // function, this public version can also traverse nested properties.
	  function has(obj, path) {
	    path = toPath(path);
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      var key = path[i];
	      if (!has$1(obj, key)) return false;
	      obj = obj[key];
	    }
	    return !!length;
	  }
	
	  // Keep the identity function around for default iteratees.
	  function identity(value) {
	    return value;
	  }
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  function matcher(attrs) {
	    attrs = extendOwn({}, attrs);
	    return function(obj) {
	      return isMatch(obj, attrs);
	    };
	  }
	
	  // Creates a function that, when passed an object, will traverse that object’s
	  // properties down the given `path`, specified as an array of keys or indices.
	  function property(path) {
	    path = toPath(path);
	    return function(obj) {
	      return deepGet(obj, path);
	    };
	  }
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  function optimizeCb(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      // The 2-argument case is omitted because we’re not using it.
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  }
	
	  // An internal function to generate callbacks that can be applied to each
	  // element in a collection, returning the desired result — either `_.identity`,
	  // an arbitrary callback, a property matcher, or a property accessor.
	  function baseIteratee(value, context, argCount) {
	    if (value == null) return identity;
	    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
	    if (isObject(value) && !isArray(value)) return matcher(value);
	    return property(value);
	  }
	
	  // External wrapper for our callback generator. Users may customize
	  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
	  // This abstraction hides the internal-only `argCount` argument.
	  function iteratee(value, context) {
	    return baseIteratee(value, context, Infinity);
	  }
	  _$1.iteratee = iteratee;
	
	  // The function we call internally to generate a callback. It invokes
	  // `_.iteratee` if overridden, otherwise `baseIteratee`.
	  function cb(value, context, argCount) {
	    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
	    return baseIteratee(value, context, argCount);
	  }
	
	  // Returns the results of applying the `iteratee` to each element of `obj`.
	  // In contrast to `_.map` it returns an object.
	  function mapObject(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = keys(obj),
	        length = _keys.length,
	        results = {};
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys[index];
	      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function noop(){}
	
	  // Generates a function for a given object that returns a given property.
	  function propertyOf(obj) {
	    if (obj == null) return noop;
	    return function(path) {
	      return get(obj, path);
	    };
	  }
	
	  // Run a function **n** times.
	  function times(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  }
	
	  // Return a random integer between `min` and `max` (inclusive).
	  function random(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  }
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  var now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	  // Internal helper to generate functions for escaping and unescaping strings
	  // to/from HTML interpolation.
	  function createEscaper(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped.
	    var source = '(?:' + keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  }
	
	  // Internal list of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	
	  // Function for escaping strings to HTML interpolation.
	  var _escape = createEscaper(escapeMap);
	
	  // Internal list of HTML entities for unescaping.
	  var unescapeMap = invert(escapeMap);
	
	  // Function for unescaping strings from HTML interpolation.
	  var _unescape = createEscaper(unescapeMap);
	
	  // By default, Underscore uses ERB-style template delimiters. Change the
	  // following template settings to use alternative delimiters.
	  var templateSettings = _$1.templateSettings = {
	    evaluate: /<%([\s\S]+?)%>/g,
	    interpolate: /<%=([\s\S]+?)%>/g,
	    escape: /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `_.templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'": "'",
	    '\\': '\\',
	    '\r': 'r',
	    '\n': 'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  function escapeChar(match) {
	    return '\\' + escapes[match];
	  }
	
	  // In order to prevent third-party code injection through
	  // `_.templateSettings.variable`, we test it against the following regular
	  // expression. It is intentionally a bit more liberal than just matching valid
	  // identifiers, but still prevents possible loopholes through defaults or
	  // destructuring assignment.
	  var bareIdentifier = /^\s*(\w|\$)+\s*$/;
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  function template(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = defaults({}, settings, _$1.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offset.
	      return match;
	    });
	    source += "';\n";
	
	    var argument = settings.variable;
	    if (argument) {
	      // Insure against third-party code injection. (CVE-2021-23358)
	      if (!bareIdentifier.test(argument)) throw new Error(
	        'variable is not a bare identifier: ' + argument
	      );
	    } else {
	      // If a variable is not specified, place data values in local scope.
	      source = 'with(obj||{}){\n' + source + '}\n';
	      argument = 'obj';
	    }
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    var render;
	    try {
	      render = new Function(argument, '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _$1);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  }
	
	  // Traverses the children of `obj` along `path`. If a child is a function, it
	  // is invoked with its parent as context. Returns the value of the final
	  // child, or `fallback` if any child is undefined.
	  function result(obj, path, fallback) {
	    path = toPath(path);
	    var length = path.length;
	    if (!length) {
	      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
	    }
	    for (var i = 0; i < length; i++) {
	      var prop = obj == null ? void 0 : obj[path[i]];
	      if (prop === void 0) {
	        prop = fallback;
	        i = length; // Ensure we don't continue iterating.
	      }
	      obj = isFunction$1(prop) ? prop.call(obj) : prop;
	    }
	    return obj;
	  }
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  function uniqueId(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  }
	
	  // Start chaining a wrapped Underscore object.
	  function chain(obj) {
	    var instance = _$1(obj);
	    instance._chain = true;
	    return instance;
	  }
	
	  // Internal function to execute `sourceFunc` bound to `context` with optional
	  // `args`. Determines whether to execute a function as a constructor or as a
	  // normal function.
	  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (isObject(result)) return result;
	    return self;
	  }
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
	  // as a placeholder by default, allowing any combination of arguments to be
	  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
	  var partial = restArguments(function(func, boundArgs) {
	    var placeholder = partial.placeholder;
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  });
	
	  partial.placeholder = _$1;
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally).
	  var bind = restArguments(function(func, context, args) {
	    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
	    var bound = restArguments(function(callArgs) {
	      return executeBound(func, bound, context, this, args.concat(callArgs));
	    });
	    return bound;
	  });
	
	  // Internal helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object.
	  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var isArrayLike = createSizePropertyCheck(getLength);
	
	  // Internal implementation of a recursive `flatten` function.
	  function flatten$1(input, depth, strict, output) {
	    output = output || [];
	    if (!depth && depth !== 0) {
	      depth = Infinity;
	    } else if (depth <= 0) {
	      return output.concat(input);
	    }
	    var idx = output.length;
	    for (var i = 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
	        // Flatten current level of array or arguments object.
	        if (depth > 1) {
	          flatten$1(value, depth - 1, strict, output);
	          idx = output.length;
	        } else {
	          var j = 0, len = value.length;
	          while (j < len) output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  }
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  var bindAll = restArguments(function(obj, keys) {
	    keys = flatten$1(keys, false, false);
	    var index = keys.length;
	    if (index < 1) throw new Error('bindAll must be passed function names');
	    while (index--) {
	      var key = keys[index];
	      obj[key] = bind(obj[key], obj);
	    }
	    return obj;
	  });
	
	  // Memoize an expensive function by storing its results.
	  function memoize(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  }
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  var delay = restArguments(function(func, wait, args) {
	    return setTimeout(function() {
	      return func.apply(null, args);
	    }, wait);
	  });
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  var defer = partial(delay, _$1, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  function throttle(func, wait, options) {
	    var timeout, context, args, result;
	    var previous = 0;
	    if (!options) options = {};
	
	    var later = function() {
	      previous = options.leading === false ? 0 : now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	
	    var throttled = function() {
	      var _now = now();
	      if (!previous && options.leading === false) previous = _now;
	      var remaining = wait - (_now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = _now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	
	    throttled.cancel = function() {
	      clearTimeout(timeout);
	      previous = 0;
	      timeout = context = args = null;
	    };
	
	    return throttled;
	  }
	
	  // When a sequence of calls of the returned function ends, the argument
	  // function is triggered. The end of a sequence is defined by the `wait`
	  // parameter. If `immediate` is passed, the argument function will be
	  // triggered at the beginning of the sequence instead of at the end.
	  function debounce(func, wait, immediate) {
	    var timeout, previous, args, result, context;
	
	    var later = function() {
	      var passed = now() - previous;
	      if (wait > passed) {
	        timeout = setTimeout(later, wait - passed);
	      } else {
	        timeout = null;
	        if (!immediate) result = func.apply(context, args);
	        // This check is needed because `func` can recursively invoke `debounced`.
	        if (!timeout) args = context = null;
	      }
	    };
	
	    var debounced = restArguments(function(_args) {
	      context = this;
	      args = _args;
	      previous = now();
	      if (!timeout) {
	        timeout = setTimeout(later, wait);
	        if (immediate) result = func.apply(context, args);
	      }
	      return result;
	    });
	
	    debounced.cancel = function() {
	      clearTimeout(timeout);
	      timeout = args = context = null;
	    };
	
	    return debounced;
	  }
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  function wrap(func, wrapper) {
	    return partial(wrapper, func);
	  }
	
	  // Returns a negated version of the passed-in predicate.
	  function negate(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  }
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  }
	
	  // Returns a function that will only be executed on and after the Nth call.
	  function after(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  }
	
	  // Returns a function that will only be executed up to (but not including) the
	  // Nth call.
	  function before(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  }
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  var once = partial(before, 2);
	
	  // Returns the first key on an object that passes a truth test.
	  function findKey(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = keys(obj), key;
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      key = _keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  }
	
	  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a truth test.
	  var findIndex = createPredicateIndexFinder(1);
	
	  // Returns the last index on an array-like that passes a truth test.
	  var findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  function sortedIndex(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  }
	
	  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	          i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), isNaN$1);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  var indexOf = createIndexFinder(1, findIndex, sortedIndex);
	
	  // Return the position of the last occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  var lastIndexOf = createIndexFinder(-1, findLastIndex);
	
	  // Return the first value which passes a truth test.
	  function find(obj, predicate, context) {
	    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
	    var key = keyFinder(obj, predicate, context);
	    if (key !== void 0 && key !== -1) return obj[key];
	  }
	
	  // Convenience version of a common use case of `_.find`: getting the first
	  // object containing specific `key:value` pairs.
	  function findWhere(obj, attrs) {
	    return find(obj, matcher(attrs));
	  }
	
	  // The cornerstone for collection functions, an `each`
	  // implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  function each(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var _keys = keys(obj);
	      for (i = 0, length = _keys.length; i < length; i++) {
	        iteratee(obj[_keys[i]], _keys[i], obj);
	      }
	    }
	    return obj;
	  }
	
	  // Return the results of applying the iteratee to each element.
	  function map(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Internal helper to create a reducing function, iterating left or right.
	  function createReduce(dir) {
	    // Wrap code that reassigns argument variables in a separate function than
	    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
	    var reducer = function(obj, iteratee, memo, initial) {
	      var _keys = !isArrayLike(obj) && keys(obj),
	          length = (_keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      if (!initial) {
	        memo = obj[_keys ? _keys[index] : index];
	        index += dir;
	      }
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = _keys ? _keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    };
	
	    return function(obj, iteratee, memo, context) {
	      var initial = arguments.length >= 3;
	      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  var reduce = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  var reduceRight = createReduce(-1);
	
	  // Return all the elements that pass a truth test.
	  function filter(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  }
	
	  // Return all the elements for which a truth test fails.
	  function reject(obj, predicate, context) {
	    return filter(obj, negate(cb(predicate)), context);
	  }
	
	  // Determine whether all of the elements pass a truth test.
	  function every(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  }
	
	  // Determine if at least one element in the object passes a truth test.
	  function some(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  }
	
	  // Determine if the array or object contains a given item (using `===`).
	  function contains(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return indexOf(obj, item, fromIndex) >= 0;
	  }
	
	  // Invoke a method (with arguments) on every item in a collection.
	  var invoke = restArguments(function(obj, path, args) {
	    var contextPath, func;
	    if (isFunction$1(path)) {
	      func = path;
	    } else {
	      path = toPath(path);
	      contextPath = path.slice(0, -1);
	      path = path[path.length - 1];
	    }
	    return map(obj, function(context) {
	      var method = func;
	      if (!method) {
	        if (contextPath && contextPath.length) {
	          context = deepGet(context, contextPath);
	        }
	        if (context == null) return void 0;
	        method = context[path];
	      }
	      return method == null ? method : method.apply(context, args);
	    });
	  });
	
	  // Convenience version of a common use case of `_.map`: fetching a property.
	  function pluck(obj, key) {
	    return map(obj, property(key));
	  }
	
	  // Convenience version of a common use case of `_.filter`: selecting only
	  // objects containing specific `key:value` pairs.
	  function where(obj, attrs) {
	    return filter(obj, matcher(attrs));
	  }
	
	  // Return the maximum element (or element-based computation).
	  function max(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Return the minimum element (or element-based computation).
	  function min(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Sample **n** random values from a collection using the modern version of the
	  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `_.map`.
	  function sample(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = values(obj);
	      return obj[random(obj.length - 1)];
	    }
	    var sample = isArrayLike(obj) ? clone(obj) : values(obj);
	    var length = getLength(sample);
	    n = Math.max(Math.min(n, length), 0);
	    var last = length - 1;
	    for (var index = 0; index < n; index++) {
	      var rand = random(index, last);
	      var temp = sample[index];
	      sample[index] = sample[rand];
	      sample[rand] = temp;
	    }
	    return sample.slice(0, n);
	  }
	
	  // Shuffle a collection.
	  function shuffle(obj) {
	    return sample(obj, Infinity);
	  }
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  function sortBy(obj, iteratee, context) {
	    var index = 0;
	    iteratee = cb(iteratee, context);
	    return pluck(map(obj, function(value, key, list) {
	      return {
	        value: value,
	        index: index++,
	        criteria: iteratee(value, key, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  }
	
	  // An internal function used for aggregate "group by" operations.
	  function group(behavior, partition) {
	    return function(obj, iteratee, context) {
	      var result = partition ? [[], []] : {};
	      iteratee = cb(iteratee, context);
	      each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  }
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  var groupBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
	  // when you know that your index values will be unique.
	  var indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  var countBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Split a collection into two arrays: one whose elements all pass the given
	  // truth test, and one whose elements all do not pass the truth test.
	  var partition = group(function(result, value, pass) {
	    result[pass ? 0 : 1].push(value);
	  }, true);
	
	  // Safely create a real, live array from anything iterable.
	  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
	  function toArray(obj) {
	    if (!obj) return [];
	    if (isArray(obj)) return slice.call(obj);
	    if (isString(obj)) {
	      // Keep surrogate pair characters together.
	      return obj.match(reStrSymbol);
	    }
	    if (isArrayLike(obj)) return map(obj, identity);
	    return values(obj);
	  }
	
	  // Return the number of elements in a collection.
	  function size(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : keys(obj).length;
	  }
	
	  // Internal `_.pick` helper function to determine whether `key` is an enumerable
	  // property name of `obj`.
	  function keyInObj(value, key, obj) {
	    return key in obj;
	  }
	
	  // Return a copy of the object only containing the allowed properties.
	  var pick = restArguments(function(obj, keys) {
	    var result = {}, iteratee = keys[0];
	    if (obj == null) return result;
	    if (isFunction$1(iteratee)) {
	      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
	      keys = allKeys(obj);
	    } else {
	      iteratee = keyInObj;
	      keys = flatten$1(keys, false, false);
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  });
	
	  // Return a copy of the object without the disallowed properties.
	  var omit = restArguments(function(obj, keys) {
	    var iteratee = keys[0], context;
	    if (isFunction$1(iteratee)) {
	      iteratee = negate(iteratee);
	      if (keys.length > 1) context = keys[1];
	    } else {
	      keys = map(flatten$1(keys, false, false), String);
	      iteratee = function(value, key) {
	        return !contains(keys, key);
	      };
	    }
	    return pick(obj, iteratee, context);
	  });
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  function initial(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  }
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  function first(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[0];
	    return initial(array, array.length - n);
	  }
	
	  // Returns everything but the first entry of the `array`. Especially useful on
	  // the `arguments` object. Passing an **n** will return the rest N values in the
	  // `array`.
	  function rest(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  }
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  function last(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[array.length - 1];
	    return rest(array, Math.max(0, array.length - n));
	  }
	
	  // Trim out all falsy values from an array.
	  function compact(array) {
	    return filter(array, Boolean);
	  }
	
	  // Flatten out an array, either recursively (by default), or up to `depth`.
	  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
	  function flatten(array, depth) {
	    return flatten$1(array, depth, false);
	  }
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  var difference = restArguments(function(array, rest) {
	    rest = flatten$1(rest, true, true);
	    return filter(array, function(value){
	      return !contains(rest, value);
	    });
	  });
	
	  // Return a version of the array that does not contain the specified value(s).
	  var without = restArguments(function(array, otherArrays) {
	    return difference(array, otherArrays);
	  });
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // The faster algorithm will not work with an iteratee if the iteratee
	  // is not a one-to-one function, so providing an iteratee will disable
	  // the faster algorithm.
	  function uniq(array, isSorted, iteratee, context) {
	    if (!isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted && !iteratee) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  var union = restArguments(function(arrays) {
	    return uniq(flatten$1(arrays, true, true));
	  });
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  function intersection(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (contains(result, item)) continue;
	      var j;
	      for (j = 1; j < argsLength; j++) {
	        if (!contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  }
	
	  // Complement of zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices.
	  function unzip(array) {
	    var length = array && max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = pluck(array, index);
	    }
	    return result;
	  }
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  var zip = restArguments(unzip);
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
	  function object(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  }
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](https://docs.python.org/library/functions.html#range).
	  function range(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    if (!step) {
	      step = stop < start ? -1 : 1;
	    }
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  }
	
	  // Chunk a single array into multiple arrays, each containing `count` or fewer
	  // items.
	  function chunk(array, count) {
	    if (count == null || count < 1) return [];
	    var result = [];
	    var i = 0, length = array.length;
	    while (i < length) {
	      result.push(slice.call(array, i, i += count));
	    }
	    return result;
	  }
	
	  // Helper function to continue chaining intermediate results.
	  function chainResult(instance, obj) {
	    return instance._chain ? _$1(obj).chain() : obj;
	  }
	
	  // Add your own custom functions to the Underscore object.
	  function mixin(obj) {
	    each(functions(obj), function(name) {
	      var func = _$1[name] = obj[name];
	      _$1.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return chainResult(this, func.apply(_$1, args));
	      };
	    });
	    return _$1;
	  }
	
	  // Add all mutator `Array` functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) {
	        method.apply(obj, arguments);
	        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
	          delete obj[0];
	        }
	      }
	      return chainResult(this, obj);
	    };
	  });
	
	  // Add all accessor `Array` functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) obj = method.apply(obj, arguments);
	      return chainResult(this, obj);
	    };
	  });
	
	  // Named Exports
	
	  var allExports = {
	    __proto__: null,
	    VERSION: VERSION,
	    restArguments: restArguments,
	    isObject: isObject,
	    isNull: isNull,
	    isUndefined: isUndefined,
	    isBoolean: isBoolean,
	    isElement: isElement,
	    isString: isString,
	    isNumber: isNumber,
	    isDate: isDate,
	    isRegExp: isRegExp,
	    isError: isError,
	    isSymbol: isSymbol,
	    isArrayBuffer: isArrayBuffer,
	    isDataView: isDataView$1,
	    isArray: isArray,
	    isFunction: isFunction$1,
	    isArguments: isArguments$1,
	    isFinite: isFinite$1,
	    isNaN: isNaN$1,
	    isTypedArray: isTypedArray$1,
	    isEmpty: isEmpty,
	    isMatch: isMatch,
	    isEqual: isEqual,
	    isMap: isMap,
	    isWeakMap: isWeakMap,
	    isSet: isSet,
	    isWeakSet: isWeakSet,
	    keys: keys,
	    allKeys: allKeys,
	    values: values,
	    pairs: pairs,
	    invert: invert,
	    functions: functions,
	    methods: functions,
	    extend: extend,
	    extendOwn: extendOwn,
	    assign: extendOwn,
	    defaults: defaults,
	    create: create,
	    clone: clone,
	    tap: tap,
	    get: get,
	    has: has,
	    mapObject: mapObject,
	    identity: identity,
	    constant: constant,
	    noop: noop,
	    toPath: toPath$1,
	    property: property,
	    propertyOf: propertyOf,
	    matcher: matcher,
	    matches: matcher,
	    times: times,
	    random: random,
	    now: now,
	    escape: _escape,
	    unescape: _unescape,
	    templateSettings: templateSettings,
	    template: template,
	    result: result,
	    uniqueId: uniqueId,
	    chain: chain,
	    iteratee: iteratee,
	    partial: partial,
	    bind: bind,
	    bindAll: bindAll,
	    memoize: memoize,
	    delay: delay,
	    defer: defer,
	    throttle: throttle,
	    debounce: debounce,
	    wrap: wrap,
	    negate: negate,
	    compose: compose,
	    after: after,
	    before: before,
	    once: once,
	    findKey: findKey,
	    findIndex: findIndex,
	    findLastIndex: findLastIndex,
	    sortedIndex: sortedIndex,
	    indexOf: indexOf,
	    lastIndexOf: lastIndexOf,
	    find: find,
	    detect: find,
	    findWhere: findWhere,
	    each: each,
	    forEach: each,
	    map: map,
	    collect: map,
	    reduce: reduce,
	    foldl: reduce,
	    inject: reduce,
	    reduceRight: reduceRight,
	    foldr: reduceRight,
	    filter: filter,
	    select: filter,
	    reject: reject,
	    every: every,
	    all: every,
	    some: some,
	    any: some,
	    contains: contains,
	    includes: contains,
	    include: contains,
	    invoke: invoke,
	    pluck: pluck,
	    where: where,
	    max: max,
	    min: min,
	    shuffle: shuffle,
	    sample: sample,
	    sortBy: sortBy,
	    groupBy: groupBy,
	    indexBy: indexBy,
	    countBy: countBy,
	    partition: partition,
	    toArray: toArray,
	    size: size,
	    pick: pick,
	    omit: omit,
	    first: first,
	    head: first,
	    take: first,
	    initial: initial,
	    last: last,
	    rest: rest,
	    tail: rest,
	    drop: rest,
	    compact: compact,
	    flatten: flatten,
	    without: without,
	    uniq: uniq,
	    unique: uniq,
	    union: union,
	    intersection: intersection,
	    difference: difference,
	    unzip: unzip,
	    transpose: unzip,
	    zip: zip,
	    object: object,
	    range: range,
	    chunk: chunk,
	    mixin: mixin,
	    'default': _$1
	  };
	
	  // Default Export
	
	  // Add all of the Underscore functions to the wrapper object.
	  var _ = mixin(allExports);
	  // Legacy Node.js API.
	  _._ = _;
	
	  return _;

	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _prefixed = __webpack_require__(10);
	
	var _prefixed2 = _interopRequireDefault(_prefixed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: false,
				classes: {
					base: 'animation',
					animation: {
						band: 'animation_type_band',
						shake: 'animation_type_shake',
						ball: 'animation_type_ball',
						slide: 'animation_type_slide'
					},
					duration: {
						long: 'animation_duration_long',
						longer: 'animation__duration_longer'
					}
				},
				callback: {
					start: false,
					iteration: false,
					end: false
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.prefixed = new _prefixed2.default();
			return this;
		}
	
		_createClass(_class, [{
			key: 'onStart',
			value: function onStart() {
				var self = this;
				if (typeof self.options.callback.start === 'function') {
					self.options.callback.start();
				}
				return self;
			}
		}, {
			key: 'onEnd',
			value: function onEnd(animation, duration, event) {
				var self = this;
				var $target = (0, _jquery2.default)(event.currentTarget);
				$target.removeClass(self.options.classes.animation[animation]).removeClass(self.options.classes.base);
	
				if (self.options.classes.duration[duration]) {
					$target.removeClass(self.options.classes.duration[duration]);
				}
				if (typeof self.options.callback.end === 'function') {
					self.options.callback.end();
				}
				return self;
			}
		}, {
			key: 'update',
			value: function update(options) {
				this.options = _jquery2.default.extend(true, {}, this.options, options);
				return this;
			}
		}, {
			key: 'play',
			value: function play(animation, duration) {
				var self = this;
				if (self.options.classes.animation[animation]) {
					self.$el.one(self.prefixed.events.animationStart, self.onStart.bind(self));
					self.$el.one(self.prefixed.events.animationEnd, self.onEnd.bind(self, animation, duration));
	
					if (self.options.classes.duration[duration]) {
						self.$el.addClass(self.options.classes.duration[duration]);
					}
					self.$el.addClass(self.options.classes.animation[animation]).addClass(self.options.classes.base);
				}
				return self;
			}
		}, {
			key: 'stop',
			value: function stop(animation, duration) {
				this.$el.off(this.prefixed.events.animationEnd);
				this.$el.removeClass(this.options.classes.animation[animation]).removeClass(this.options.classes.base);
				if (this.options.classes.duration[duration]) {
					this.$el.removeClass(this.options.classes.duration[duration]);
				}
				if (typeof this.options.callback.end === 'function') {
					this.options.callback.end();
				}
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class() {
			_classCallCheck(this, _class);
	
			this.css = {
				transition: this.prefixed('transition'),
				transform: this.prefixed('transform'),
				animation: this.prefixed('animation')
			};
	
			this.events = {
				transitionEnd: 'webkitTransitionEnd mozTransitionEnd oTransitionEnd otransitionend MSTransitionEnd transitionend',
				animationEnd: 'webkitAnimationEnd mozAnimationEnd oAnimationEnd oanimationend MSAnimationEnd animationend',
				animationStart: 'webkitAnimationStart mozAnimationStart oAnimationStart oanimationstart MSAnimationStart animationstart',
				animationIteration: 'webkitAnimationIteration mozAnimationIteration oAnimationIteration oanimationiteration MSAnimationIteration animationiteration'
			};
			return this;
		}
	
		_createClass(_class, [{
			key: 'prefixed',
			value: function prefixed(p) {
				var d = (document.body || document.documentElement).style;
				return (d = (p + ' ' + 'Moz webkit Webkit Khtml O ms'.replace(/(\w+)/g, '$1' + (p[0].toUpperCase() + p.slice(1)))).split(' ').filter(function (e) {
					return void 0 !== d[e];
				})).length ? d[0] : !1;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! numbered v1.0.6 | pavel-yagodin | MIT License | https://github.com/CSSSR/jquery.numbered */
	(function (root, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			root.Numbered = factory();
		}
	}(this, function () {
		'use strict';
	
		var defaults = {
			mask: '+7 (###) ### - ## - ##',
			numbered: '#',
			empty: '_',
			placeholder: false
		};
	
		var Numbered = function (target, params) {
			var self = this;
	
			if (typeof target !== 'object') {
				self.inputs = document.querySelectorAll(target);
			} else if (typeof target.length !== 'undefined') {
				self.inputs = target;
			} else {
				self.inputs = [target];
			}
			self.inputs = Array.prototype.slice.call(self.inputs);
	
			params = params || (typeof self.inputs[0].numbered !== 'undefined' ? self.inputs[0].numbered.params : {});
	
			for (var def in defaults) {
				if (typeof params[def] === 'undefined') {
					params[def] = defaults[def];
				}
			}
	
			self.params = params;
			self.config = {};
	
			self.config.placeholder = self.params.mask.replace(new RegExp(self.params.numbered, 'g'), self.params.empty);
			self.config.numbered    = self.params.numbered.replace(/([()[\]\.^\#$|?+-])/g, '\\\\$1');
			self.config.numberedCol = self.params.mask.split(self.params.numbered).length -1;
			self.config.empty       = self.params.empty.replace(/([()[\]\.^\#$|?+-])/g, '\\$1');
			self.config.mask        = self.params.mask.replace(/([()[\]\.^\#$|?+-])/g, '\\$1').replace(new RegExp(self.config.numbered, 'g'), '(\\d)');
			self.config.maskNums    = self.params.mask.replace(/[^\d]/gi, '').split('');
			self.config.maskNumsCol = self.config.maskNums.length;
			self.config.regexp      = new RegExp('^' + self.config.mask + '$');
			self.config.events      = ['input', 'change', 'click', 'focusin', 'blur'];
	
			// console.log(self.config);
	
	
			self._eventFire = function(el, etype){
				if (el.fireEvent) {
					el.fireEvent('on' + etype);
				} else {
					var evObj = document.createEvent('Events');
					evObj.initEvent(etype, true, false);
					el.dispatchEvent(evObj);
				}
			};
	
			self._getSelectionRange = function (oElm) {
				var r = { text: '', start: 0, end: 0, length: 0 };
				if (oElm.setSelectionRange) {
					r.start= oElm.selectionStart;
					r.end = oElm.selectionEnd;
					r.text = (r.start != r.end) ? oElm.value.substring(r.start, r.end): '';
				} else if (document.selection) {
					var oR;
					if (oElm.tagName && oElm.tagName === 'TEXTAREA') {
						var oS = document.selection.createRange().duplicate();
						oR = oElm.createTextRange();
						var sB = oS.getBookmark();
						oR.moveToBookmark(sB);
					} else {
						oR = document.selection.createRange().duplicate();
					}
	
					r.text = oR.text;
					for (; oR.moveStart('character', -1) !== 0; r.start++);
					r.end = r.text.length + r.start;
				}
				r.length = r.text.length;
				return r;
			};
	
	
			self.magic = function (event) {
				var numbered = this.numbered;
				var value = numbered.input.value || ' ';
				var valueFormatted = value.replace(/[^\d]/gi, '').split('').join('');
				var valueFormattedArr = valueFormatted.split('');
				var valueFormattedCol = valueFormattedArr.length;
				var valueFormattedIndex = 0;
				var positionStart = -1;
				var positionEnd = -1;
				var positionOld = self._getSelectionRange(numbered.input);
				var maskNumsIndex = 0;
				var valueFormattedRes = [];
				var maskSplit = numbered.params.mask.split('');
				// console.log(valueFormatted);
	
				for (var key in maskSplit) {
					var val = maskSplit[key];
					key = parseInt(key);
					if (maskNumsIndex <= numbered.config.maskNumsCol && val == numbered.config.maskNums[maskNumsIndex] && val == valueFormattedArr[valueFormattedIndex]) {
						valueFormattedRes.push(val);
						maskNumsIndex++;
						valueFormattedIndex++;
					} else if(val == numbered.params.numbered) {
						if (positionStart < 0) {
							positionStart = key;
						}
						if(valueFormattedIndex < valueFormattedCol) {
							valueFormattedRes.push(valueFormattedArr[valueFormattedIndex]);
							valueFormattedIndex++;
							positionEnd = key;
						} else {
							valueFormattedRes.push(numbered.params.empty);
						}
					} else {
						valueFormattedRes.push(val);
					}
				}
				value = valueFormattedRes.join('');
	
				var position = (positionEnd >= 0 ? positionEnd + 1 : positionStart);
				if (event.type !== 'click') {
					if ((event.type === 'blur' || event.type === 'change') && valueFormattedIndex - maskNumsIndex === 0 && !numbered.params.placeholder) {
						this.value = '';
					} else if (numbered.oldValue !== numbered.input.value || event.type === 'focusin') {
						this.value = value;
					}
				}
	
				if(event.type !== 'change' && event.type !== 'blur' && (event.type !== 'click' || (numbered.lastEvent === 'focusin' && event.type === 'click'))) {
					if (numbered.input.setSelectionRange) {
						numbered.input.setSelectionRange(position, position);
					} else if (numbered.input.createTextRange) {
						var range = numbered.input.createTextRange();
						range.collapse(true);
						range.moveEnd('character', position);
						range.moveStart('character', position);
						range.select();
					}
				}
	
				numbered.oldValue = this.value;
				numbered.lastEvent = event.type;
				return event.target;
			};
	
			for (var index in self.inputs) {
				var $input = self.inputs[index];
				var is = false;
				if (typeof $input.numbered === 'оbject' || typeof $input.numbered !== 'undefined') {
					is = true;
				}
				$input.numbered = {
					input: self.inputs[index],
					config: self.config,
					params: self.params,
					oldValue: false
				};
	
				if (!is) {
					for (var key in self.config.events) {
						$input.addEventListener(self.config.events[key], self.magic);
					}
					self._eventFire($input, 'blur');
				}
				self.inputs[index] = $input;
			}
	
			self.destroy = function () {
				var self = this;
				for (var index in self.inputs) {
					var $input = self.inputs[index];
	
					for (var key in self.config.events) {
						$input.removeEventListener(self.config.events[key], self.magic);
						$input.numbered = null;
					}
				}
				return null;
			};
	
			self.validate = function (i) {
				var input = i || false;
				var self = this;
				var res = self.inputs.length > 1 ? [] : false;
				var inputs = input !== false ? [input] : self.inputs;
				for (var index in inputs) {
					var $input = inputs[index];
					var validate;
	
					if (inputs[index].numbered.config.regexp.test(inputs[index].numbered.input.value)) {
						validate = 1;
					} else if (inputs[index].numbered.input.value === '' || inputs[index].numbered.input.value === inputs[index].numbered.config.placeholder) {
						validate = 0;
					} else {
						validate = -1;
					}
	
					if (inputs.length > 1) {
						res.push(validate);
					} else {
						res = validate;
					}
				}
				return res;
			};
	
			self.reInit = function () {
				var self = this;
				var res = self.inputs.length > 1 ? [] : false;
				for (var index in self.inputs) {
					var $input = self.inputs[index];
					self._eventFire($input, 'blur');
				}
				return res;
			};
	
			self.setVal = function (value) {
				var self = this;
				var res = self.inputs.length > 1 ? [] : false;
				for (var index in self.inputs) {
					var $input = self.inputs[index];
					$input.value = value;
					self._eventFire($input, 'blur');
				}
				return res;
			};
	
			self.getVal = function (r) {
				var raw = r || false;
				var values = [];
				for (var index in this.inputs) {
					var $input = this.inputs[index];
					var value = $input.value;
	
					if (raw) {
						if (this.validate($input) > 0) {
							var arr = value.match(this.config.regexp);
							value = arr.slice(1, arr.length).join('');
						} else {
							value = $input.value.replace(/[^\d]/gi, '');
						}
					}
					values.push(value);
				}
				return values.length>1?values:values[0];
			};
	
			return self;
		};
	
		return Numbered;
	}));


/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery Mousewheel 3.1.13
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 */
	
	(function (factory) {
	    if ( true ) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node/CommonJS style for Browserify
	        module.exports = factory;
	    } else {
	        // Browser globals
	        factory(jQuery);
	    }
	}(function ($) {
	
	    var toFix  = ['wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll'],
	        toBind = ( 'onwheel' in document || document.documentMode >= 9 ) ?
	                    ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'],
	        slice  = Array.prototype.slice,
	        nullLowestDeltaTimeout, lowestDelta;
	
	    if ( $.event.fixHooks ) {
	        for ( var i = toFix.length; i; ) {
	            $.event.fixHooks[ toFix[--i] ] = $.event.mouseHooks;
	        }
	    }
	
	    var special = $.event.special.mousewheel = {
	        version: '3.1.12',
	
	        setup: function() {
	            if ( this.addEventListener ) {
	                for ( var i = toBind.length; i; ) {
	                    this.addEventListener( toBind[--i], handler, false );
	                }
	            } else {
	                this.onmousewheel = handler;
	            }
	            // Store the line height and page height for this particular element
	            $.data(this, 'mousewheel-line-height', special.getLineHeight(this));
	            $.data(this, 'mousewheel-page-height', special.getPageHeight(this));
	        },
	
	        teardown: function() {
	            if ( this.removeEventListener ) {
	                for ( var i = toBind.length; i; ) {
	                    this.removeEventListener( toBind[--i], handler, false );
	                }
	            } else {
	                this.onmousewheel = null;
	            }
	            // Clean up the data we added to the element
	            $.removeData(this, 'mousewheel-line-height');
	            $.removeData(this, 'mousewheel-page-height');
	        },
	
	        getLineHeight: function(elem) {
	            var $elem = $(elem),
	                $parent = $elem['offsetParent' in $.fn ? 'offsetParent' : 'parent']();
	            if (!$parent.length) {
	                $parent = $('body');
	            }
	            return parseInt($parent.css('fontSize'), 10) || parseInt($elem.css('fontSize'), 10) || 16;
	        },
	
	        getPageHeight: function(elem) {
	            return $(elem).height();
	        },
	
	        settings: {
	            adjustOldDeltas: true, // see shouldAdjustOldDeltas() below
	            normalizeOffset: true  // calls getBoundingClientRect for each event
	        }
	    };
	
	    $.fn.extend({
	        mousewheel: function(fn) {
	            return fn ? this.bind('mousewheel', fn) : this.trigger('mousewheel');
	        },
	
	        unmousewheel: function(fn) {
	            return this.unbind('mousewheel', fn);
	        }
	    });
	
	
	    function handler(event) {
	        var orgEvent   = event || window.event,
	            args       = slice.call(arguments, 1),
	            delta      = 0,
	            deltaX     = 0,
	            deltaY     = 0,
	            absDelta   = 0,
	            offsetX    = 0,
	            offsetY    = 0;
	        event = $.event.fix(orgEvent);
	        event.type = 'mousewheel';
	
	        // Old school scrollwheel delta
	        if ( 'detail'      in orgEvent ) { deltaY = orgEvent.detail * -1;      }
	        if ( 'wheelDelta'  in orgEvent ) { deltaY = orgEvent.wheelDelta;       }
	        if ( 'wheelDeltaY' in orgEvent ) { deltaY = orgEvent.wheelDeltaY;      }
	        if ( 'wheelDeltaX' in orgEvent ) { deltaX = orgEvent.wheelDeltaX * -1; }
	
	        // Firefox < 17 horizontal scrolling related to DOMMouseScroll event
	        if ( 'axis' in orgEvent && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
	            deltaX = deltaY * -1;
	            deltaY = 0;
	        }
	
	        // Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
	        delta = deltaY === 0 ? deltaX : deltaY;
	
	        // New school wheel delta (wheel event)
	        if ( 'deltaY' in orgEvent ) {
	            deltaY = orgEvent.deltaY * -1;
	            delta  = deltaY;
	        }
	        if ( 'deltaX' in orgEvent ) {
	            deltaX = orgEvent.deltaX;
	            if ( deltaY === 0 ) { delta  = deltaX * -1; }
	        }
	
	        // No change actually happened, no reason to go any further
	        if ( deltaY === 0 && deltaX === 0 ) { return; }
	
	        // Need to convert lines and pages to pixels if we aren't already in pixels
	        // There are three delta modes:
	        //   * deltaMode 0 is by pixels, nothing to do
	        //   * deltaMode 1 is by lines
	        //   * deltaMode 2 is by pages
	        if ( orgEvent.deltaMode === 1 ) {
	            var lineHeight = $.data(this, 'mousewheel-line-height');
	            delta  *= lineHeight;
	            deltaY *= lineHeight;
	            deltaX *= lineHeight;
	        } else if ( orgEvent.deltaMode === 2 ) {
	            var pageHeight = $.data(this, 'mousewheel-page-height');
	            delta  *= pageHeight;
	            deltaY *= pageHeight;
	            deltaX *= pageHeight;
	        }
	
	        // Store lowest absolute delta to normalize the delta values
	        absDelta = Math.max( Math.abs(deltaY), Math.abs(deltaX) );
	
	        if ( !lowestDelta || absDelta < lowestDelta ) {
	            lowestDelta = absDelta;
	
	            // Adjust older deltas if necessary
	            if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
	                lowestDelta /= 40;
	            }
	        }
	
	        // Adjust older deltas if necessary
	        if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
	            // Divide all the things by 40!
	            delta  /= 40;
	            deltaX /= 40;
	            deltaY /= 40;
	        }
	
	        // Get a whole, normalized value for the deltas
	        delta  = Math[ delta  >= 1 ? 'floor' : 'ceil' ](delta  / lowestDelta);
	        deltaX = Math[ deltaX >= 1 ? 'floor' : 'ceil' ](deltaX / lowestDelta);
	        deltaY = Math[ deltaY >= 1 ? 'floor' : 'ceil' ](deltaY / lowestDelta);
	
	        // Normalise offsetX and offsetY properties
	        if ( special.settings.normalizeOffset && this.getBoundingClientRect ) {
	            var boundingRect = this.getBoundingClientRect();
	            offsetX = event.clientX - boundingRect.left;
	            offsetY = event.clientY - boundingRect.top;
	        }
	
	        // Add information to the event object
	        event.deltaX = deltaX;
	        event.deltaY = deltaY;
	        event.deltaFactor = lowestDelta;
	        event.offsetX = offsetX;
	        event.offsetY = offsetY;
	        // Go ahead and set deltaMode to 0 since we converted to pixels
	        // Although this is a little odd since we overwrite the deltaX/Y
	        // properties with normalized deltas.
	        event.deltaMode = 0;
	
	        // Add event and delta to the front of the arguments
	        args.unshift(event, delta, deltaX, deltaY);
	
	        // Clearout lowestDelta after sometime to better
	        // handle multiple device types that give different
	        // a different lowestDelta
	        // Ex: trackpad = 3 and mouse wheel = 120
	        if (nullLowestDeltaTimeout) { clearTimeout(nullLowestDeltaTimeout); }
	        nullLowestDeltaTimeout = setTimeout(nullLowestDelta, 200);
	
	        return ($.event.dispatch || $.event.handle).apply(this, args);
	    }
	
	    function nullLowestDelta() {
	        lowestDelta = null;
	    }
	
	    function shouldAdjustOldDeltas(orgEvent, absDelta) {
	        // If this is an older event and the delta is divisable by 120,
	        // then we are assuming that the browser is treating this as an
	        // older mouse wheel event and that we should divide the deltas
	        // by 40 to try and get a more usable deltaFactor.
	        // Side note, this actually impacts the reported scroll distance
	        // in older browsers and can cause scrolling to be slower than native.
	        // Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
	        return special.settings.adjustOldDeltas && orgEvent.type === 'mousewheel' && absDelta % 120 === 0;
	    }
	
	}));


/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*
	== malihu jquery custom scrollbar plugin ==
	Version: 3.1.3
	Plugin URI: http://manos.malihu.gr/jquery-custom-content-scroller
	Author: malihu
	Author URI: http://manos.malihu.gr
	License: MIT License (MIT)
	*/
	
	/*
	Copyright Manos Malihutsakis (email: manos@malihu.gr)
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	/*
	The code below is fairly long, fully commented and should be normally used in development.
	For production, use either the minified jquery.mNCustomScrollbar.min.js script or
	the production-ready jquery.mNCustomScrollbar.concat.min.js which contains the plugin
	and dependencies (minified).
	*/
	
	(function(factory){
		if(typeof module!=="undefined" && module.exports){
			module.exports=factory;
		}else{
			factory(jQuery,window,document);
		}
	}(function($){
	(function(init){
		var _rjs="function"==="function" && __webpack_require__(30), /* RequireJS */
			_njs=typeof module !== "undefined" && module.exports, /* NodeJS */
			_dlp=("https:"==document.location.protocol) ? "https:" : "http:", /* location protocol */
			_url="cdnjs.cloudflare.com/ajax/libs/jquery-mousewheel/3.1.13/jquery.mousewheel.min.js";
		if(!_rjs){
			if(_njs){
				__webpack_require__(27)($);
			}else{
				/* load jquery-mousewheel plugin (via CDN) if it's not present or not loaded via RequireJS
				(works when mNCustomScrollbar fn is called on window load) */
				$.event.special.mousewheel || $("head").append(decodeURI("%3Cscript src="+_dlp+"//"+_url+"%3E%3C/script%3E"));
			}
		}
		init();
	}(function(){
	
		/*
		----------------------------------------
		PLUGIN NAMESPACE, PREFIX, DEFAULT SELECTOR(S)
		----------------------------------------
		*/
	
		var pluginNS="mNCustomScrollbar",
			pluginPfx="mNCS",
			defaultSelector=".mNCustomScrollbar",
	
	
	
	
	
		/*
		----------------------------------------
		DEFAULT OPTIONS
		----------------------------------------
		*/
	
			defaults={
				/*
				set element/content width/height programmatically
				values: boolean, pixels, percentage
					option						default
					-------------------------------------
					setWidth					false
					setHeight					false
				*/
				/*
				set the initial css top property of content
				values: string (e.g. "-100px", "10%" etc.)
				*/
				setTop:0,
				/*
				set the initial css left property of content
				values: string (e.g. "-100px", "10%" etc.)
				*/
				setLeft:0,
				/*
				scrollbar axis (vertical and/or horizontal scrollbars)
				values (string): "y", "x", "yx"
				*/
				axis:"y",
				/*
				position of scrollbar relative to content
				values (string): "inside", "outside" ("outside" requires elements with position:relative)
				*/
				scrollbarPosition:"inside",
				/*
				scrolling inertia
				values: integer (milliseconds)
				*/
				scrollInertia:950,
				/*
				auto-adjust scrollbar dragger length
				values: boolean
				*/
				autoDraggerLength:true,
				/*
				auto-hide scrollbar when idle
				values: boolean
					option						default
					-------------------------------------
					autoHideScrollbar			false
				*/
				/*
				auto-expands scrollbar on mouse-over and dragging
				values: boolean
					option						default
					-------------------------------------
					autoExpandScrollbar			false
				*/
				/*
				always show scrollbar, even when there's nothing to scroll
				values: integer (0=disable, 1=always show dragger rail and buttons, 2=always show dragger rail, dragger and buttons), boolean
				*/
				alwaysShowScrollbar:0,
				/*
				scrolling always snaps to a multiple of this number in pixels
				values: integer, array ([y,x])
					option						default
					-------------------------------------
					snapAmount					null
				*/
				/*
				when snapping, snap with this number in pixels as an offset
				values: integer
				*/
				snapOffset:0,
				/*
				mouse-wheel scrolling
				*/
				mouseWheel:{
					/*
					enable mouse-wheel scrolling
					values: boolean
					*/
					enable:true,
					/*
					scrolling amount in pixels
					values: "auto", integer
					*/
					scrollAmount:"auto",
					/*
					mouse-wheel scrolling axis
					the default scrolling direction when both vertical and horizontal scrollbars are present
					values (string): "y", "x"
					*/
					axis:"y",
					/*
					prevent the default behaviour which automatically scrolls the parent element(s) when end of scrolling is reached
					values: boolean
						option						default
						-------------------------------------
						preventDefault				null
					*/
					/*
					the reported mouse-wheel delta value. The number of lines (translated to pixels) one wheel notch scrolls.
					values: "auto", integer
					"auto" uses the default OS/browser value
					*/
					deltaFactor:"auto",
					/*
					normalize mouse-wheel delta to -1 or 1 (disables mouse-wheel acceleration)
					values: boolean
						option						default
						-------------------------------------
						normalizeDelta				null
					*/
					/*
					invert mouse-wheel scrolling direction
					values: boolean
						option						default
						-------------------------------------
						invert						null
					*/
					/*
					the tags that disable mouse-wheel when cursor is over them
					*/
					disableOver:["select","option","keygen","datalist","textarea"]
				},
				/*
				scrollbar buttons
				*/
				scrollButtons:{
					/*
					enable scrollbar buttons
					values: boolean
						option						default
						-------------------------------------
						enable						null
					*/
					/*
					scrollbar buttons scrolling type
					values (string): "stepless", "stepped"
					*/
					scrollType:"stepless",
					/*
					scrolling amount in pixels
					values: "auto", integer
					*/
					scrollAmount:"auto"
					/*
					tabindex of the scrollbar buttons
					values: false, integer
						option						default
						-------------------------------------
						tabindex					null
					*/
				},
				/*
				keyboard scrolling
				*/
				keyboard:{
					/*
					enable scrolling via keyboard
					values: boolean
					*/
					enable:true,
					/*
					keyboard scrolling type
					values (string): "stepless", "stepped"
					*/
					scrollType:"stepless",
					/*
					scrolling amount in pixels
					values: "auto", integer
					*/
					scrollAmount:"auto"
				},
				/*
				enable content touch-swipe scrolling
				values: boolean, integer, string (number)
				integer values define the axis-specific minimum amount required for scrolling momentum
				*/
				contentTouchScroll:25,
				/*
				enable/disable document (default) touch-swipe scrolling
				*/
				documentTouchScroll:true,
				/*
				advanced option parameters
				*/
				advanced:{
					/*
					auto-expand content horizontally (for "x" or "yx" axis)
					values: boolean, integer (the value 2 forces the non scrollHeight/scrollWidth method, the value 3 forces the scrollHeight/scrollWidth method)
						option						default
						-------------------------------------
						autoExpandHorizontalScroll	null
					*/
					/*
					auto-scroll to elements with focus
					*/
					autoScrollOnFocus:"input,textarea,select,button,datalist,keygen,a[tabindex],area,object,[contenteditable='true']",
					/*
					auto-update scrollbars on content, element or viewport resize
					should be true for fluid layouts/elements, adding/removing content dynamically, hiding/showing elements, content with images etc.
					values: boolean
					*/
					updateOnContentResize:true,
					/*
					auto-update scrollbars each time each image inside the element is fully loaded
					values: "auto", boolean
					*/
					updateOnImageLoad:"auto",
					/*
					auto-update scrollbars based on the amount and size changes of specific selectors
					useful when you need to update the scrollbar(s) automatically, each time a type of element is added, removed or changes its size
					values: boolean, string (e.g. "ul li" will auto-update scrollbars each time list-items inside the element are changed)
					a value of true (boolean) will auto-update scrollbars each time any element is changed
						option						default
						-------------------------------------
						updateOnSelectorChange		null
					*/
					/*
					extra selectors that'll allow scrollbar dragging upon mousemove/up, pointermove/up, touchend etc. (e.g. "selector-1, selector-2")
						option						default
						-------------------------------------
						extraDraggableSelectors		null
					*/
					/*
					extra selectors that'll release scrollbar dragging upon mouseup, pointerup, touchend etc. (e.g. "selector-1, selector-2")
						option						default
						-------------------------------------
						releaseDraggableSelectors	null
					*/
					/*
					auto-update timeout
					values: integer (milliseconds)
					*/
					autoUpdateTimeout:60
				},
				/*
				scrollbar theme
				values: string (see CSS/plugin URI for a list of ready-to-use themes)
				*/
				theme:"light",
				/*
				user defined callback functions
				*/
				callbacks:{
					/*
					Available callbacks:
						callback					default
						-------------------------------------
						onCreate					null
						onInit						null
						onScrollStart				null
						onScroll					null
						onTotalScroll				null
						onTotalScrollBack			null
						whileScrolling				null
						onOverflowY					null
						onOverflowX					null
						onOverflowYNone				null
						onOverflowXNone				null
						onImageLoad					null
						onSelectorChange			null
						onBeforeUpdate				null
						onUpdate					null
					*/
					onTotalScrollOffset:0,
					onTotalScrollBackOffset:0,
					alwaysTriggerOffsets:true
				}
				/*
				add scrollbar(s) on all elements matching the current selector, now and in the future
				values: boolean, string
				string values: "on" (enable), "once" (disable after first invocation), "off" (disable)
				liveSelector values: string (selector)
					option						default
					-------------------------------------
					live						false
					liveSelector				null
				*/
			},
	
	
	
	
	
		/*
		----------------------------------------
		VARS, CONSTANTS
		----------------------------------------
		*/
	
			totalInstances=0, /* plugin instances amount */
			liveTimers={}, /* live option timers */
			oldIE=(window.attachEvent && !window.addEventListener) ? 1 : 0, /* detect IE < 9 */
			touchActive=false,touchable, /* global touch vars (for touch and pointer events) */
			/* general plugin classes */
			classes=[
				"mNCSB_dragger_onDrag","mNCSB_scrollTools_onDrag","mNCS_img_loaded","mNCS_disabled","mNCS_destroyed","mNCS_no_scrollbar",
				"mNCS-autoHide","mNCS-dir-rtl","mNCS_no_scrollbar_y","mNCS_no_scrollbar_x","mNCS_y_hidden","mNCS_x_hidden","mNCSB_draggerContainer",
				"mNCSB_buttonUp","mNCSB_buttonDown","mNCSB_buttonLeft","mNCSB_buttonRight"
			],
	
	
	
	
	
		/*
		----------------------------------------
		METHODS
		----------------------------------------
		*/
	
			methods={
	
				/*
				plugin initialization method
				creates the scrollbar(s), plugin data object and options
				----------------------------------------
				*/
	
				init:function(options){
	
					var options=$.extend(true,{},defaults,options),
						selector=_selector.call(this); /* validate selector */
	
					/*
					if live option is enabled, monitor for elements matching the current selector and
					apply scrollbar(s) when found (now and in the future)
					*/
					if(options.live){
						var liveSelector=options.liveSelector || this.selector || defaultSelector, /* live selector(s) */
							$liveSelector=$(liveSelector); /* live selector(s) as jquery object */
						if(options.live==="off"){
							/*
							disable live if requested
							usage: $(selector).mNCustomScrollbar({live:"off"});
							*/
							removeLiveTimers(liveSelector);
							return;
						}
						liveTimers[liveSelector]=setTimeout(function(){
							/* call mNCustomScrollbar fn on live selector(s) every half-second */
							$liveSelector.mNCustomScrollbar(options);
							if(options.live==="once" && $liveSelector.length){
								/* disable live after first invocation */
								removeLiveTimers(liveSelector);
							}
						},500);
					}else{
						removeLiveTimers(liveSelector);
					}
	
					/* options backward compatibility (for versions < 3.0.0) and normalization */
					options.setWidth=(options.set_width) ? options.set_width : options.setWidth;
					options.setHeight=(options.set_height) ? options.set_height : options.setHeight;
					options.axis=(options.horizontalScroll) ? "x" : _findAxis(options.axis);
					options.scrollInertia=options.scrollInertia>0 && options.scrollInertia<17 ? 17 : options.scrollInertia;
					if(typeof options.mouseWheel!=="object" &&  options.mouseWheel==true){ /* old school mouseWheel option (non-object) */
						options.mouseWheel={enable:true,scrollAmount:"auto",axis:"y",preventDefault:false,deltaFactor:"auto",normalizeDelta:false,invert:false}
					}
					options.mouseWheel.scrollAmount=!options.mouseWheelPixels ? options.mouseWheel.scrollAmount : options.mouseWheelPixels;
					options.mouseWheel.normalizeDelta=!options.advanced.normalizeMouseWheelDelta ? options.mouseWheel.normalizeDelta : options.advanced.normalizeMouseWheelDelta;
					options.scrollButtons.scrollType=_findScrollButtonsType(options.scrollButtons.scrollType);
	
					_theme(options); /* theme-specific options */
	
					/* plugin constructor */
					return $(selector).each(function(){
	
						var $this=$(this);
	
						if(!$this.data(pluginPfx)){ /* prevent multiple instantiations */
	
							/* store options and create objects in jquery data */
							$this.data(pluginPfx,{
								idx:++totalInstances, /* instance index */
								opt:options, /* options */
								scrollRatio:{y:null,x:null}, /* scrollbar to content ratio */
								overflowed:null, /* overflowed axis */
								contentReset:{y:null,x:null}, /* object to check when content resets */
								bindEvents:false, /* object to check if events are bound */
								tweenRunning:false, /* object to check if tween is running */
								sequential:{}, /* sequential scrolling object */
								langDir:$this.css("direction"), /* detect/store direction (ltr or rtl) */
								cbOffsets:null, /* object to check whether callback offsets always trigger */
								/*
								object to check how scrolling events where last triggered
								"internal" (default - triggered by this script), "external" (triggered by other scripts, e.g. via scrollTo method)
								usage: object.data("mNCS").trigger
								*/
								trigger:null,
								/*
								object to check for changes in elements in order to call the update method automatically
								*/
								poll:{size:{o:0,n:0},img:{o:0,n:0},change:{o:0,n:0}}
							});
	
							var d=$this.data(pluginPfx),o=d.opt,
								/* HTML data attributes */
								htmlDataAxis=$this.data("mNCs-axis"),htmlDataSbPos=$this.data("mNCs-scrollbar-position"),htmlDataTheme=$this.data("mNCs-theme");
	
							if(htmlDataAxis){o.axis=htmlDataAxis;} /* usage example: data-mNCs-axis="y" */
							if(htmlDataSbPos){o.scrollbarPosition=htmlDataSbPos;} /* usage example: data-mNCs-scrollbar-position="outside" */
							if(htmlDataTheme){ /* usage example: data-mNCs-theme="minimal" */
								o.theme=htmlDataTheme;
								_theme(o); /* theme-specific options */
							}
	
							_pluginMarkup.call(this); /* add plugin markup */
	
							if(d && o.callbacks.onCreate && typeof o.callbacks.onCreate==="function"){o.callbacks.onCreate.call(this);} /* callbacks: onCreate */
	
							$("#mNCSB_"+d.idx+"_container img:not(."+classes[2]+")").addClass(classes[2]); /* flag loaded images */
	
							methods.update.call(null,$this); /* call the update method */
	
						}
	
					});
	
				},
				/* ---------------------------------------- */
	
	
	
				/*
				plugin update method
				updates content and scrollbar(s) values, events and status
				----------------------------------------
				usage: $(selector).mNCustomScrollbar("update");
				*/
	
				update:function(el,cb){
	
					var selector=el || _selector.call(this); /* validate selector */
	
					return $(selector).each(function(){
	
						var $this=$(this);
	
						if($this.data(pluginPfx)){ /* check if plugin has initialized */
	
							var d=$this.data(pluginPfx),o=d.opt,
								mNCSB_container=$("#mNCSB_"+d.idx+"_container"),
								mNCustomScrollBox=$("#mNCSB_"+d.idx),
								mNCSB_dragger=[$("#mNCSB_"+d.idx+"_dragger_vertical"),$("#mNCSB_"+d.idx+"_dragger_horizontal")];
	
							if(!mNCSB_container.length){return;}
	
							if(d.tweenRunning){_stop($this);} /* stop any running tweens while updating */
	
							if(cb && d && o.callbacks.onBeforeUpdate && typeof o.callbacks.onBeforeUpdate==="function"){o.callbacks.onBeforeUpdate.call(this);} /* callbacks: onBeforeUpdate */
	
							/* if element was disabled or destroyed, remove class(es) */
							if($this.hasClass(classes[3])){$this.removeClass(classes[3]);}
							if($this.hasClass(classes[4])){$this.removeClass(classes[4]);}
	
							/* css flexbox fix, detect/set max-height */
							mNCustomScrollBox.css("max-height","none");
							if(mNCustomScrollBox.height()!==$this.height()){mNCustomScrollBox.css("max-height",$this.height());}
	
							_expandContentHorizontally.call(this); /* expand content horizontally */
	
							if(o.axis!=="y" && !o.advanced.autoExpandHorizontalScroll){
								mNCSB_container.css("width",_contentWidth(mNCSB_container));
							}
	
							d.overflowed=_overflowed.call(this); /* determine if scrolling is required */
	
							_scrollbarVisibility.call(this); /* show/hide scrollbar(s) */
	
							/* auto-adjust scrollbar dragger length analogous to content */
							if(o.autoDraggerLength){_setDraggerLength.call(this);}
	
							_scrollRatio.call(this); /* calculate and store scrollbar to content ratio */
	
							_bindEvents.call(this); /* bind scrollbar events */
	
							/* reset scrolling position and/or events */
							var to=[Math.abs(mNCSB_container[0].offsetTop),Math.abs(mNCSB_container[0].offsetLeft)];
							if(o.axis!=="x"){ /* y/yx axis */
								if(!d.overflowed[0]){ /* y scrolling is not required */
									_resetContentPosition.call(this); /* reset content position */
									if(o.axis==="y"){
										_unbindEvents.call(this);
									}else if(o.axis==="yx" && d.overflowed[1]){
										_scrollTo($this,to[1].toString(),{dir:"x",dur:0,overwrite:"none"});
									}
								}else if(mNCSB_dragger[0].height()>mNCSB_dragger[0].parent().height()){
									_resetContentPosition.call(this); /* reset content position */
								}else{ /* y scrolling is required */
									_scrollTo($this,to[0].toString(),{dir:"y",dur:0,overwrite:"none"});
									d.contentReset.y=null;
								}
							}
							if(o.axis!=="y"){ /* x/yx axis */
								if(!d.overflowed[1]){ /* x scrolling is not required */
									_resetContentPosition.call(this); /* reset content position */
									if(o.axis==="x"){
										_unbindEvents.call(this);
									}else if(o.axis==="yx" && d.overflowed[0]){
										_scrollTo($this,to[0].toString(),{dir:"y",dur:0,overwrite:"none"});
									}
								}else if(mNCSB_dragger[1].width()>mNCSB_dragger[1].parent().width()){
									_resetContentPosition.call(this); /* reset content position */
								}else{ /* x scrolling is required */
									_scrollTo($this,to[1].toString(),{dir:"x",dur:0,overwrite:"none"});
									d.contentReset.x=null;
								}
							}
	
							/* callbacks: onImageLoad, onSelectorChange, onUpdate */
							if(cb && d){
								if(cb===2 && o.callbacks.onImageLoad && typeof o.callbacks.onImageLoad==="function"){
									o.callbacks.onImageLoad.call(this);
								}else if(cb===3 && o.callbacks.onSelectorChange && typeof o.callbacks.onSelectorChange==="function"){
									o.callbacks.onSelectorChange.call(this);
								}else if(o.callbacks.onUpdate && typeof o.callbacks.onUpdate==="function"){
									o.callbacks.onUpdate.call(this);
								}
							}
	
							_autoUpdate.call(this); /* initialize automatic updating (for dynamic content, fluid layouts etc.) */
	
						}
	
					});
	
				},
				/* ---------------------------------------- */
	
	
	
				/*
				plugin scrollTo method
				triggers a scrolling event to a specific value
				----------------------------------------
				usage: $(selector).mNCustomScrollbar("scrollTo",value,options);
				*/
	
				scrollTo:function(val,options){
	
					/* prevent silly things like $(selector).mNCustomScrollbar("scrollTo",undefined); */
					if(typeof val=="undefined" || val==null){return;}
	
					var selector=_selector.call(this); /* validate selector */
	
					return $(selector).each(function(){
	
						var $this=$(this);
	
						if($this.data(pluginPfx)){ /* check if plugin has initialized */
	
							var d=$this.data(pluginPfx),o=d.opt,
								/* method default options */
								methodDefaults={
									trigger:"external", /* method is by default triggered externally (e.g. from other scripts) */
									scrollInertia:o.scrollInertia, /* scrolling inertia (animation duration) */
									scrollEasing:"mNCsEaseInOut", /* animation easing */
									moveDragger:false, /* move dragger instead of content */
									timeout:60, /* scroll-to delay */
									callbacks:true, /* enable/disable callbacks */
									onStart:true,
									onUpdate:true,
									onComplete:true
								},
								methodOptions=$.extend(true,{},methodDefaults,options),
								to=_arr.call(this,val),dur=methodOptions.scrollInertia>0 && methodOptions.scrollInertia<17 ? 17 : methodOptions.scrollInertia;
	
							/* translate yx values to actual scroll-to positions */
							to[0]=_to.call(this,to[0],"y");
							to[1]=_to.call(this,to[1],"x");
	
							/*
							check if scroll-to value moves the dragger instead of content.
							Only pixel values apply on dragger (e.g. 100, "100px", "-=100" etc.)
							*/
							if(methodOptions.moveDragger){
								to[0]*=d.scrollRatio.y;
								to[1]*=d.scrollRatio.x;
							}
	
							methodOptions.dur=_isTabHidden() ? 0 : dur; //skip animations if browser tab is hidden
	
							setTimeout(function(){
								/* do the scrolling */
								if(to[0]!==null && typeof to[0]!=="undefined" && o.axis!=="x" && d.overflowed[0]){ /* scroll y */
									methodOptions.dir="y";
									methodOptions.overwrite="all";
									_scrollTo($this,to[0].toString(),methodOptions);
								}
								if(to[1]!==null && typeof to[1]!=="undefined" && o.axis!=="y" && d.overflowed[1]){ /* scroll x */
									methodOptions.dir="x";
									methodOptions.overwrite="none";
									_scrollTo($this,to[1].toString(),methodOptions);
								}
							},methodOptions.timeout);
	
						}
	
					});
	
				},
				/* ---------------------------------------- */
	
	
	
				/*
				plugin stop method
				stops scrolling animation
				----------------------------------------
				usage: $(selector).mNCustomScrollbar("stop");
				*/
				stop:function(){
	
					var selector=_selector.call(this); /* validate selector */
	
					return $(selector).each(function(){
	
						var $this=$(this);
	
						if($this.data(pluginPfx)){ /* check if plugin has initialized */
	
							_stop($this);
	
						}
	
					});
	
				},
				/* ---------------------------------------- */
	
	
	
				/*
				plugin disable method
				temporarily disables the scrollbar(s)
				----------------------------------------
				usage: $(selector).mNCustomScrollbar("disable",reset);
				reset (boolean): resets content position to 0
				*/
				disable:function(r){
	
					var selector=_selector.call(this); /* validate selector */
	
					return $(selector).each(function(){
	
						var $this=$(this);
	
						if($this.data(pluginPfx)){ /* check if plugin has initialized */
	
							var d=$this.data(pluginPfx);
	
							_autoUpdate.call(this,"remove"); /* remove automatic updating */
	
							_unbindEvents.call(this); /* unbind events */
	
							if(r){_resetContentPosition.call(this);} /* reset content position */
	
							_scrollbarVisibility.call(this,true); /* show/hide scrollbar(s) */
	
							$this.addClass(classes[3]); /* add disable class */
	
						}
	
					});
	
				},
				/* ---------------------------------------- */
	
	
	
				/*
				plugin destroy method
				completely removes the scrollbar(s) and returns the element to its original state
				----------------------------------------
				usage: $(selector).mNCustomScrollbar("destroy");
				*/
				destroy:function(){
	
					var selector=_selector.call(this); /* validate selector */
	
					return $(selector).each(function(){
	
						var $this=$(this);
	
						if($this.data(pluginPfx)){ /* check if plugin has initialized */
	
							var d=$this.data(pluginPfx),o=d.opt,
								mNCustomScrollBox=$("#mNCSB_"+d.idx),
								mNCSB_container=$("#mNCSB_"+d.idx+"_container"),
								scrollbar=$(".mNCSB_"+d.idx+"_scrollbar");
	
							if(o.live){removeLiveTimers(o.liveSelector || $(selector).selector);} /* remove live timers */
	
							_autoUpdate.call(this,"remove"); /* remove automatic updating */
	
							_unbindEvents.call(this); /* unbind events */
	
							_resetContentPosition.call(this); /* reset content position */
	
							$this.removeData(pluginPfx); /* remove plugin data object */
	
							_delete(this,"mNCs"); /* delete callbacks object */
	
							/* remove plugin markup */
							scrollbar.remove(); /* remove scrollbar(s) first (those can be either inside or outside plugin's inner wrapper) */
							mNCSB_container.find("img."+classes[2]).removeClass(classes[2]); /* remove loaded images flag */
							mNCustomScrollBox.replaceWith(mNCSB_container.contents()); /* replace plugin's inner wrapper with the original content */
							/* remove plugin classes from the element and add destroy class */
							$this.removeClass(pluginNS+" _"+pluginPfx+"_"+d.idx+" "+classes[6]+" "+classes[7]+" "+classes[5]+" "+classes[3]).addClass(classes[4]);
	
						}
	
					});
	
				}
				/* ---------------------------------------- */
	
			},
	
	
	
	
	
		/*
		----------------------------------------
		FUNCTIONS
		----------------------------------------
		*/
	
			/* validates selector (if selector is invalid or undefined uses the default one) */
			_selector=function(){
				return (typeof $(this)!=="object" || $(this).length<1) ? defaultSelector : this;
			},
			/* -------------------- */
	
	
			/* changes options according to theme */
			_theme=function(obj){
				var fixedSizeScrollbarThemes=["rounded","rounded-dark","rounded-dots","rounded-dots-dark"],
					nonExpandedScrollbarThemes=["rounded-dots","rounded-dots-dark","3d","3d-dark","3d-thick","3d-thick-dark","inset","inset-dark","inset-2","inset-2-dark","inset-3","inset-3-dark"],
					disabledScrollButtonsThemes=["minimal","minimal-dark"],
					enabledAutoHideScrollbarThemes=["minimal","minimal-dark"],
					scrollbarPositionOutsideThemes=["minimal","minimal-dark"];
				obj.autoDraggerLength=$.inArray(obj.theme,fixedSizeScrollbarThemes) > -1 ? false : obj.autoDraggerLength;
				obj.autoExpandScrollbar=$.inArray(obj.theme,nonExpandedScrollbarThemes) > -1 ? false : obj.autoExpandScrollbar;
				obj.scrollButtons.enable=$.inArray(obj.theme,disabledScrollButtonsThemes) > -1 ? false : obj.scrollButtons.enable;
				obj.autoHideScrollbar=$.inArray(obj.theme,enabledAutoHideScrollbarThemes) > -1 ? true : obj.autoHideScrollbar;
				obj.scrollbarPosition=$.inArray(obj.theme,scrollbarPositionOutsideThemes) > -1 ? "outside" : obj.scrollbarPosition;
			},
			/* -------------------- */
	
	
			/* live option timers removal */
			removeLiveTimers=function(selector){
				if(liveTimers[selector]){
					clearTimeout(liveTimers[selector]);
					_delete(liveTimers,selector);
				}
			},
			/* -------------------- */
	
	
			/* normalizes axis option to valid values: "y", "x", "yx" */
			_findAxis=function(val){
				return (val==="yx" || val==="xy" || val==="auto") ? "yx" : (val==="x" || val==="horizontal") ? "x" : "y";
			},
			/* -------------------- */
	
	
			/* normalizes scrollButtons.scrollType option to valid values: "stepless", "stepped" */
			_findScrollButtonsType=function(val){
				return (val==="stepped" || val==="pixels" || val==="step" || val==="click") ? "stepped" : "stepless";
			},
			/* -------------------- */
	
	
			/* generates plugin markup */
			_pluginMarkup=function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					expandClass=o.autoExpandScrollbar ? " "+classes[1]+"_expand" : "",
					scrollbar=["<div id='mNCSB_"+d.idx+"_scrollbar_vertical' class='mNCSB_scrollTools mNCSB_"+d.idx+"_scrollbar mNCS-"+o.theme+" mNCSB_scrollTools_vertical"+expandClass+"'><div class='"+classes[12]+"'><div id='mNCSB_"+d.idx+"_dragger_vertical' class='mNCSB_dragger' style='position:absolute;' oncontextmenu='return false;'><div class='mNCSB_dragger_bar' /></div><div class='mNCSB_draggerRail' /></div></div>","<div id='mNCSB_"+d.idx+"_scrollbar_horizontal' class='mNCSB_scrollTools mNCSB_"+d.idx+"_scrollbar mNCS-"+o.theme+" mNCSB_scrollTools_horizontal"+expandClass+"'><div class='"+classes[12]+"'><div id='mNCSB_"+d.idx+"_dragger_horizontal' class='mNCSB_dragger' style='position:absolute;' oncontextmenu='return false;'><div class='mNCSB_dragger_bar' /></div><div class='mNCSB_draggerRail' /></div></div>"],
					wrapperClass=o.axis==="yx" ? "mNCSB_vertical_horizontal" : o.axis==="x" ? "mNCSB_horizontal" : "mNCSB_vertical",
					scrollbars=o.axis==="yx" ? scrollbar[0]+scrollbar[1] : o.axis==="x" ? scrollbar[1] : scrollbar[0],
					contentWrapper=o.axis==="yx" ? "<div id='mNCSB_"+d.idx+"_container_wrapper' class='mNCSB_container_wrapper' />" : "",
					autoHideClass=o.autoHideScrollbar ? " "+classes[6] : "",
					scrollbarDirClass=(o.axis!=="x" && d.langDir==="rtl") ? " "+classes[7] : "";
				if(o.setWidth){$this.css("width",o.setWidth);} /* set element width */
				if(o.setHeight){$this.css("height",o.setHeight);} /* set element height */
				o.setLeft=(o.axis!=="y" && d.langDir==="rtl") ? "989999px" : o.setLeft; /* adjust left position for rtl direction */
				$this.addClass(pluginNS+" _"+pluginPfx+"_"+d.idx+autoHideClass+scrollbarDirClass).wrapInner("<div id='mNCSB_"+d.idx+"' class='mNCustomScrollBox mNCS-"+o.theme+" "+wrapperClass+"'><div id='mNCSB_"+d.idx+"_container' class='mNCSB_container' style='position:relative; top:"+o.setTop+"; left:"+o.setLeft+";' dir="+d.langDir+" /></div>");
				var mNCustomScrollBox=$("#mNCSB_"+d.idx),
					mNCSB_container=$("#mNCSB_"+d.idx+"_container");
				if(o.axis!=="y" && !o.advanced.autoExpandHorizontalScroll){
					mNCSB_container.css("width",_contentWidth(mNCSB_container));
				}
				if(o.scrollbarPosition==="outside"){
					if($this.css("position")==="static"){ /* requires elements with non-static position */
						$this.css("position","relative");
					}
					$this.css("overflow","visible");
					mNCustomScrollBox.addClass("mNCSB_outside").after(scrollbars);
				}else{
					mNCustomScrollBox.addClass("mNCSB_inside").append(scrollbars);
					mNCSB_container.wrap(contentWrapper);
				}
				_scrollButtons.call(this); /* add scrollbar buttons */
				/* minimum dragger length */
				var mNCSB_dragger=[$("#mNCSB_"+d.idx+"_dragger_vertical"),$("#mNCSB_"+d.idx+"_dragger_horizontal")];
				mNCSB_dragger[0].css("min-height",mNCSB_dragger[0].height());
				mNCSB_dragger[1].css("min-width",mNCSB_dragger[1].width());
			},
			/* -------------------- */
	
	
			/* calculates content width */
			_contentWidth=function(el){
				var val=[el[0].scrollWidth,Math.max.apply(Math,el.children().map(function(){return $(this).outerWidth(true);}).get())],w=el.parent().width();
				return val[0]>w ? val[0] : val[1]>w ? val[1] : "100%";
			},
			/* -------------------- */
	
	
			/* expands content horizontally */
			_expandContentHorizontally=function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					mNCSB_container=$("#mNCSB_"+d.idx+"_container");
				if(o.advanced.autoExpandHorizontalScroll && o.axis!=="y"){
					/* calculate scrollWidth */
					mNCSB_container.css({"width":"auto","min-width":0,"overflow-x":"scroll"});
					var w=Math.ceil(mNCSB_container[0].scrollWidth);
					if(o.advanced.autoExpandHorizontalScroll===3 || (o.advanced.autoExpandHorizontalScroll!==2 && w>mNCSB_container.parent().width())){
						mNCSB_container.css({"width":w,"min-width":"100%","overflow-x":"inherit"});
					}else{
						/*
						wrap content with an infinite width div and set its position to absolute and width to auto.
						Setting width to auto before calculating the actual width is important!
						We must let the browser set the width as browser zoom values are impossible to calculate.
						*/
						mNCSB_container.css({"overflow-x":"inherit","position":"absolute"})
							.wrap("<div class='mNCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />")
							.css({ /* set actual width, original position and un-wrap */
								/*
								get the exact width (with decimals) and then round-up.
								Using jquery outerWidth() will round the width value which will mess up with inner elements that have non-integer width
								*/
								"width":(Math.ceil(mNCSB_container[0].getBoundingClientRect().right+0.4)-Math.floor(mNCSB_container[0].getBoundingClientRect().left)),
								"min-width":"100%",
								"position":"relative"
							}).unwrap();
					}
				}
			},
			/* -------------------- */
	
	
			/* adds scrollbar buttons */
			_scrollButtons=function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					mNCSB_scrollTools=$(".mNCSB_"+d.idx+"_scrollbar:first"),
					tabindex=!_isNumeric(o.scrollButtons.tabindex) ? "" : "tabindex='"+o.scrollButtons.tabindex+"'",
					btnHTML=[
						"<a href='#' class='"+classes[13]+"' oncontextmenu='return false;' "+tabindex+" />",
						"<a href='#' class='"+classes[14]+"' oncontextmenu='return false;' "+tabindex+" />",
						"<a href='#' class='"+classes[15]+"' oncontextmenu='return false;' "+tabindex+" />",
						"<a href='#' class='"+classes[16]+"' oncontextmenu='return false;' "+tabindex+" />"
					],
					btn=[(o.axis==="x" ? btnHTML[2] : btnHTML[0]),(o.axis==="x" ? btnHTML[3] : btnHTML[1]),btnHTML[2],btnHTML[3]];
				if(o.scrollButtons.enable){
					mNCSB_scrollTools.prepend(btn[0]).append(btn[1]).next(".mNCSB_scrollTools").prepend(btn[2]).append(btn[3]);
				}
			},
			/* -------------------- */
	
	
			/* auto-adjusts scrollbar dragger length */
			_setDraggerLength=function(){
				var $this=$(this),d=$this.data(pluginPfx),
					mNCustomScrollBox=$("#mNCSB_"+d.idx),
					mNCSB_container=$("#mNCSB_"+d.idx+"_container"),
					mNCSB_dragger=[$("#mNCSB_"+d.idx+"_dragger_vertical"),$("#mNCSB_"+d.idx+"_dragger_horizontal")],
					ratio=[mNCustomScrollBox.height()/mNCSB_container.outerHeight(false),mNCustomScrollBox.width()/mNCSB_container.outerWidth(false)],
					l=[
						parseInt(mNCSB_dragger[0].css("min-height")),Math.round(ratio[0]*mNCSB_dragger[0].parent().height()),
						parseInt(mNCSB_dragger[1].css("min-width")),Math.round(ratio[1]*mNCSB_dragger[1].parent().width())
					],
					h=oldIE && (l[1]<l[0]) ? l[0] : l[1],w=oldIE && (l[3]<l[2]) ? l[2] : l[3];
				mNCSB_dragger[0].css({
					"height":h,"max-height":(mNCSB_dragger[0].parent().height()-10)
				}).find(".mNCSB_dragger_bar").css({"line-height":l[0]+"px"});
				mNCSB_dragger[1].css({
					"width":w,"max-width":(mNCSB_dragger[1].parent().width()-10)
				});
			},
			/* -------------------- */
	
	
			/* calculates scrollbar to content ratio */
			_scrollRatio=function(){
				var $this=$(this),d=$this.data(pluginPfx),
					mNCustomScrollBox=$("#mNCSB_"+d.idx),
					mNCSB_container=$("#mNCSB_"+d.idx+"_container"),
					mNCSB_dragger=[$("#mNCSB_"+d.idx+"_dragger_vertical"),$("#mNCSB_"+d.idx+"_dragger_horizontal")],
					scrollAmount=[mNCSB_container.outerHeight(false)-mNCustomScrollBox.height(),mNCSB_container.outerWidth(false)-mNCustomScrollBox.width()],
					ratio=[
						scrollAmount[0]/(mNCSB_dragger[0].parent().height()-mNCSB_dragger[0].height()),
						scrollAmount[1]/(mNCSB_dragger[1].parent().width()-mNCSB_dragger[1].width())
					];
				d.scrollRatio={y:ratio[0],x:ratio[1]};
			},
			/* -------------------- */
	
	
			/* toggles scrolling classes */
			_onDragClasses=function(el,action,xpnd){
				var expandClass=xpnd ? classes[0]+"_expanded" : "",
					scrollbar=el.closest(".mNCSB_scrollTools");
				if(action==="active"){
					el.toggleClass(classes[0]+" "+expandClass); scrollbar.toggleClass(classes[1]);
					el[0]._draggable=el[0]._draggable ? 0 : 1;
				}else{
					if(!el[0]._draggable){
						if(action==="hide"){
							el.removeClass(classes[0]); scrollbar.removeClass(classes[1]);
						}else{
							el.addClass(classes[0]); scrollbar.addClass(classes[1]);
						}
					}
				}
			},
			/* -------------------- */
	
	
			/* checks if content overflows its container to determine if scrolling is required */
			_overflowed=function(){
				var $this=$(this),d=$this.data(pluginPfx),
					mNCustomScrollBox=$("#mNCSB_"+d.idx),
					mNCSB_container=$("#mNCSB_"+d.idx+"_container"),
					contentHeight=d.overflowed==null ? mNCSB_container.height() : mNCSB_container.outerHeight(false),
					contentWidth=d.overflowed==null ? mNCSB_container.width() : mNCSB_container.outerWidth(false),
					h=mNCSB_container[0].scrollHeight,w=mNCSB_container[0].scrollWidth;
				if(h>contentHeight){contentHeight=h;}
				if(w>contentWidth){contentWidth=w;}
				return [contentHeight>mNCustomScrollBox.height(),contentWidth>mNCustomScrollBox.width()];
			},
			/* -------------------- */
	
	
			/* resets content position to 0 */
			_resetContentPosition=function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					mNCustomScrollBox=$("#mNCSB_"+d.idx),
					mNCSB_container=$("#mNCSB_"+d.idx+"_container"),
					mNCSB_dragger=[$("#mNCSB_"+d.idx+"_dragger_vertical"),$("#mNCSB_"+d.idx+"_dragger_horizontal")];
				_stop($this); /* stop any current scrolling before resetting */
				if((o.axis!=="x" && !d.overflowed[0]) || (o.axis==="y" && d.overflowed[0])){ /* reset y */
					mNCSB_dragger[0].add(mNCSB_container).css("top",0);
					_scrollTo($this,"_resetY");
				}
				if((o.axis!=="y" && !d.overflowed[1]) || (o.axis==="x" && d.overflowed[1])){ /* reset x */
					var cx=dx=0;
					if(d.langDir==="rtl"){ /* adjust left position for rtl direction */
						cx=mNCustomScrollBox.width()-mNCSB_container.outerWidth(false);
						dx=Math.abs(cx/d.scrollRatio.x);
					}
					mNCSB_container.css("left",cx);
					mNCSB_dragger[1].css("left",dx);
					_scrollTo($this,"_resetX");
				}
			},
			/* -------------------- */
	
	
			/* binds scrollbar events */
			_bindEvents=function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt;
				if(!d.bindEvents){ /* check if events are already bound */
					_draggable.call(this);
					if(o.contentTouchScroll){_contentDraggable.call(this);}
					_selectable.call(this);
					if(o.mouseWheel.enable){ /* bind mousewheel fn when plugin is available */
						function _mwt(){
							mousewheelTimeout=setTimeout(function(){
								if(!$.event.special.mousewheel){
									_mwt();
								}else{
									clearTimeout(mousewheelTimeout);
									_mousewheel.call($this[0]);
								}
							},100);
						}
						var mousewheelTimeout;
						_mwt();
					}
					_draggerRail.call(this);
					_wrapperScroll.call(this);
					if(o.advanced.autoScrollOnFocus){_focus.call(this);}
					if(o.scrollButtons.enable){_buttons.call(this);}
					if(o.keyboard.enable){_keyboard.call(this);}
					d.bindEvents=true;
				}
			},
			/* -------------------- */
	
	
			/* unbinds scrollbar events */
			_unbindEvents=function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					namespace=pluginPfx+"_"+d.idx,
					sb=".mNCSB_"+d.idx+"_scrollbar",
					sel=$("#mNCSB_"+d.idx+",#mNCSB_"+d.idx+"_container,#mNCSB_"+d.idx+"_container_wrapper,"+sb+" ."+classes[12]+",#mNCSB_"+d.idx+"_dragger_vertical,#mNCSB_"+d.idx+"_dragger_horizontal,"+sb+">a"),
					mNCSB_container=$("#mNCSB_"+d.idx+"_container");
				if(o.advanced.releaseDraggableSelectors){sel.add($(o.advanced.releaseDraggableSelectors));}
				if(o.advanced.extraDraggableSelectors){sel.add($(o.advanced.extraDraggableSelectors));}
				if(d.bindEvents){ /* check if events are bound */
					/* unbind namespaced events from document/selectors */
					$(document).add($(!_canAccessIFrame() || top.document)).unbind("."+namespace);
					sel.each(function(){
						$(this).unbind("."+namespace);
					});
					/* clear and delete timeouts/objects */
					clearTimeout($this[0]._focusTimeout); _delete($this[0],"_focusTimeout");
					clearTimeout(d.sequential.step); _delete(d.sequential,"step");
					clearTimeout(mNCSB_container[0].onCompleteTimeout); _delete(mNCSB_container[0],"onCompleteTimeout");
					d.bindEvents=false;
				}
			},
			/* -------------------- */
	
	
			/* toggles scrollbar visibility */
			_scrollbarVisibility=function(disabled){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					contentWrapper=$("#mNCSB_"+d.idx+"_container_wrapper"),
					content=contentWrapper.length ? contentWrapper : $("#mNCSB_"+d.idx+"_container"),
					scrollbar=[$("#mNCSB_"+d.idx+"_scrollbar_vertical"),$("#mNCSB_"+d.idx+"_scrollbar_horizontal")],
					mNCSB_dragger=[scrollbar[0].find(".mNCSB_dragger"),scrollbar[1].find(".mNCSB_dragger")];
				if(o.axis!=="x"){
					if(d.overflowed[0] && !disabled){
						scrollbar[0].add(mNCSB_dragger[0]).add(scrollbar[0].children("a")).css("display","block");
						content.removeClass(classes[8]+" "+classes[10]);
					}else{
						if(o.alwaysShowScrollbar){
							if(o.alwaysShowScrollbar!==2){mNCSB_dragger[0].css("display","none");}
							content.removeClass(classes[10]);
						}else{
							scrollbar[0].css("display","none");
							content.addClass(classes[10]);
						}
						content.addClass(classes[8]);
					}
				}
				if(o.axis!=="y"){
					if(d.overflowed[1] && !disabled){
						scrollbar[1].add(mNCSB_dragger[1]).add(scrollbar[1].children("a")).css("display","block");
						content.removeClass(classes[9]+" "+classes[11]);
					}else{
						if(o.alwaysShowScrollbar){
							if(o.alwaysShowScrollbar!==2){mNCSB_dragger[1].css("display","none");}
							content.removeClass(classes[11]);
						}else{
							scrollbar[1].css("display","none");
							content.addClass(classes[11]);
						}
						content.addClass(classes[9]);
					}
				}
				if(!d.overflowed[0] && !d.overflowed[1]){
					$this.addClass(classes[5]);
				}else{
					$this.removeClass(classes[5]);
				}
			},
			/* -------------------- */
	
	
			/* returns input coordinates of pointer, touch and mouse events (relative to document) */
			_coordinates=function(e){
				var t=e.type,o=e.target.ownerDocument!==document ? [$(frameElement).offset().top,$(frameElement).offset().left] : null,
					io=_canAccessIFrame() && e.target.ownerDocument!==top.document ? [$(e.view.frameElement).offset().top,$(e.view.frameElement).offset().left] : [0,0];
				switch(t){
					case "pointerdown": case "MSPointerDown": case "pointermove": case "MSPointerMove": case "pointerup": case "MSPointerUp":
						return o ? [e.originalEvent.pageY-o[0]+io[0],e.originalEvent.pageX-o[1]+io[1],false] : [e.originalEvent.pageY,e.originalEvent.pageX,false];
						break;
					case "touchstart": case "touchmove": case "touchend":
						var touch=e.originalEvent.touches[0] || e.originalEvent.changedTouches[0],
							touches=e.originalEvent.touches.length || e.originalEvent.changedTouches.length;
						return e.target.ownerDocument!==document ? [touch.screenY,touch.screenX,touches>1] : [touch.pageY,touch.pageX,touches>1];
						break;
					default:
						return o ? [e.pageY-o[0]+io[0],e.pageX-o[1]+io[1],false] : [e.pageY,e.pageX,false];
				}
			},
			/* -------------------- */
	
	
			/*
			SCROLLBAR DRAG EVENTS
			scrolls content via scrollbar dragging
			*/
			_draggable=function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					namespace=pluginPfx+"_"+d.idx,
					draggerId=["mNCSB_"+d.idx+"_dragger_vertical","mNCSB_"+d.idx+"_dragger_horizontal"],
					mNCSB_container=$("#mNCSB_"+d.idx+"_container"),
					mNCSB_dragger=$("#"+draggerId[0]+",#"+draggerId[1]),
					draggable,dragY,dragX,
					rds=o.advanced.releaseDraggableSelectors ? mNCSB_dragger.add($(o.advanced.releaseDraggableSelectors)) : mNCSB_dragger,
					eds=o.advanced.extraDraggableSelectors ? $(!_canAccessIFrame() || top.document).add($(o.advanced.extraDraggableSelectors)) : $(!_canAccessIFrame() || top.document);
				mNCSB_dragger.bind("mousedown."+namespace+" touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace,function(e){
					e.stopImmediatePropagation();
					e.preventDefault();
					if(!_mouseBtnLeft(e)){return;} /* left mouse button only */
					touchActive=true;
					if(oldIE){document.onselectstart=function(){return false;}} /* disable text selection for IE < 9 */
					_iframe(false); /* enable scrollbar dragging over iframes by disabling their events */
					_stop($this);
					draggable=$(this);
					var offset=draggable.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left,
						h=draggable.height()+offset.top,w=draggable.width()+offset.left;
					if(y<h && y>0 && x<w && x>0){
						dragY=y;
						dragX=x;
					}
					_onDragClasses(draggable,"active",o.autoExpandScrollbar);
				}).bind("touchmove."+namespace,function(e){
					e.stopImmediatePropagation();
					e.preventDefault();
					var offset=draggable.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left;
					_drag(dragY,dragX,y,x);
				});
				$(document).add(eds).bind("mousemove."+namespace+" pointermove."+namespace+" MSPointerMove."+namespace,function(e){
					if(draggable){
						var offset=draggable.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left;
						if(dragY===y && dragX===x){return;} /* has it really moved? */
						_drag(dragY,dragX,y,x);
					}
				}).add(rds).bind("mouseup."+namespace+" touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace,function(e){
					if(draggable){
						_onDragClasses(draggable,"active",o.autoExpandScrollbar);
						draggable=null;
					}
					touchActive=false;
					if(oldIE){document.onselectstart=null;} /* enable text selection for IE < 9 */
					_iframe(true); /* enable iframes events */
				});
				function _iframe(evt){
					var el=mNCSB_container.find("iframe");
					if(!el.length){return;} /* check if content contains iframes */
					var val=!evt ? "none" : "auto";
					el.css("pointer-events",val); /* for IE11, iframe's display property should not be "block" */
				}
				function _drag(dragY,dragX,y,x){
					mNCSB_container[0].idleTimer=o.scrollInertia<233 ? 250 : 0;
					if(draggable.attr("id")===draggerId[1]){
						var dir="x",to=((draggable[0].offsetLeft-dragX)+x)*d.scrollRatio.x;
					}else{
						var dir="y",to=((draggable[0].offsetTop-dragY)+y)*d.scrollRatio.y;
					}
					_scrollTo($this,to.toString(),{dir:dir,drag:true});
				}
			},
			/* -------------------- */
	
	
			/*
			TOUCH SWIPE EVENTS
			scrolls content via touch swipe
			Emulates the native touch-swipe scrolling with momentum found in iOS, Android and WP devices
			*/
			_contentDraggable=function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					namespace=pluginPfx+"_"+d.idx,
					mNCustomScrollBox=$("#mNCSB_"+d.idx),
					mNCSB_container=$("#mNCSB_"+d.idx+"_container"),
					mNCSB_dragger=[$("#mNCSB_"+d.idx+"_dragger_vertical"),$("#mNCSB_"+d.idx+"_dragger_horizontal")],
					draggable,dragY,dragX,touchStartY,touchStartX,touchMoveY=[],touchMoveX=[],startTime,runningTime,endTime,distance,speed,amount,
					durA=0,durB,overwrite=o.axis==="yx" ? "none" : "all",touchIntent=[],touchDrag,docDrag,
					iframe=mNCSB_container.find("iframe"),
					events=[
						"touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace, //start
						"touchmove."+namespace+" pointermove."+namespace+" MSPointerMove."+namespace, //move
						"touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace //end
					],
					touchAction=document.body.style.touchAction!==undefined;
				mNCSB_container.bind(events[0],function(e){
					_onTouchstart(e);
				}).bind(events[1],function(e){
					_onTouchmove(e);
				});
				mNCustomScrollBox.bind(events[0],function(e){
					_onTouchstart2(e);
				}).bind(events[2],function(e){
					_onTouchend(e);
				});
				if(iframe.length){
					iframe.each(function(){
						$(this).load(function(){
							/* bind events on accessible iframes */
							if(_canAccessIFrame(this)){
								$(this.contentDocument || this.contentWindow.document).bind(events[0],function(e){
									_onTouchstart(e);
									_onTouchstart2(e);
								}).bind(events[1],function(e){
									_onTouchmove(e);
								}).bind(events[2],function(e){
									_onTouchend(e);
								});
							}
						});
					});
				}
				function _onTouchstart(e){
					if(!_pointerTouch(e) || touchActive || _coordinates(e)[2]){touchable=0; return;}
					touchable=1; touchDrag=0; docDrag=0; draggable=1;
					$this.removeClass("mNCS_touch_action");
					var offset=mNCSB_container.offset();
					dragY=_coordinates(e)[0]-offset.top;
					dragX=_coordinates(e)[1]-offset.left;
					touchIntent=[_coordinates(e)[0],_coordinates(e)[1]];
				}
				function _onTouchmove(e){
					if(!_pointerTouch(e) || touchActive || _coordinates(e)[2]){return;}
					if(!o.documentTouchScroll){e.preventDefault();}
					e.stopImmediatePropagation();
					if(docDrag && !touchDrag){return;}
					if(draggable){
						runningTime=_getTime();
						var offset=mNCustomScrollBox.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left,
							easing="mNCsLinearOut";
						touchMoveY.push(y);
						touchMoveX.push(x);
						touchIntent[2]=Math.abs(_coordinates(e)[0]-touchIntent[0]); touchIntent[3]=Math.abs(_coordinates(e)[1]-touchIntent[1]);
						if(d.overflowed[0]){
							var limit=mNCSB_dragger[0].parent().height()-mNCSB_dragger[0].height(),
								prevent=((dragY-y)>0 && (y-dragY)>-(limit*d.scrollRatio.y) && (touchIntent[3]*2<touchIntent[2] || o.axis==="yx"));
						}
						if(d.overflowed[1]){
							var limitX=mNCSB_dragger[1].parent().width()-mNCSB_dragger[1].width(),
								preventX=((dragX-x)>0 && (x-dragX)>-(limitX*d.scrollRatio.x) && (touchIntent[2]*2<touchIntent[3] || o.axis==="yx"));
						}
						if(prevent || preventX){ /* prevent native document scrolling */
							if(!touchAction){e.preventDefault();}
							touchDrag=1;
						}else{
							docDrag=1;
							$this.addClass("mNCS_touch_action");
						}
						if(touchAction){e.preventDefault();}
						amount=o.axis==="yx" ? [(dragY-y),(dragX-x)] : o.axis==="x" ? [null,(dragX-x)] : [(dragY-y),null];
						mNCSB_container[0].idleTimer=250;
						if(d.overflowed[0]){_drag(amount[0],durA,easing,"y","all",true);}
						if(d.overflowed[1]){_drag(amount[1],durA,easing,"x",overwrite,true);}
					}
				}
				function _onTouchstart2(e){
					if(!_pointerTouch(e) || touchActive || _coordinates(e)[2]){touchable=0; return;}
					touchable=1;
					e.stopImmediatePropagation();
					_stop($this);
					startTime=_getTime();
					var offset=mNCustomScrollBox.offset();
					touchStartY=_coordinates(e)[0]-offset.top;
					touchStartX=_coordinates(e)[1]-offset.left;
					touchMoveY=[]; touchMoveX=[];
				}
				function _onTouchend(e){
					if(!_pointerTouch(e) || touchActive || _coordinates(e)[2]){return;}
					draggable=0;
					e.stopImmediatePropagation();
					touchDrag=0; docDrag=0;
					endTime=_getTime();
					var offset=mNCustomScrollBox.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left;
					if((endTime-runningTime)>30){return;}
					speed=1000/(endTime-startTime);
					var easing="mNCsEaseOut",slow=speed<2.5,
						diff=slow ? [touchMoveY[touchMoveY.length-2],touchMoveX[touchMoveX.length-2]] : [0,0];
					distance=slow ? [(y-diff[0]),(x-diff[1])] : [y-touchStartY,x-touchStartX];
					var absDistance=[Math.abs(distance[0]),Math.abs(distance[1])];
					speed=slow ? [Math.abs(distance[0]/4),Math.abs(distance[1]/4)] : [speed,speed];
					var a=[
						Math.abs(mNCSB_container[0].offsetTop)-(distance[0]*_m((absDistance[0]/speed[0]),speed[0])),
						Math.abs(mNCSB_container[0].offsetLeft)-(distance[1]*_m((absDistance[1]/speed[1]),speed[1]))
					];
					amount=o.axis==="yx" ? [a[0],a[1]] : o.axis==="x" ? [null,a[1]] : [a[0],null];
					durB=[(absDistance[0]*4)+o.scrollInertia,(absDistance[1]*4)+o.scrollInertia];
					var md=parseInt(o.contentTouchScroll) || 0; /* absolute minimum distance required */
					amount[0]=absDistance[0]>md ? amount[0] : 0;
					amount[1]=absDistance[1]>md ? amount[1] : 0;
					if(d.overflowed[0]){_drag(amount[0],durB[0],easing,"y",overwrite,false);}
					if(d.overflowed[1]){_drag(amount[1],durB[1],easing,"x",overwrite,false);}
				}
				function _m(ds,s){
					var r=[s*1.5,s*2,s/1.5,s/2];
					if(ds>90){
						return s>4 ? r[0] : r[3];
					}else if(ds>60){
						return s>3 ? r[3] : r[2];
					}else if(ds>30){
						return s>8 ? r[1] : s>6 ? r[0] : s>4 ? s : r[2];
					}else{
						return s>8 ? s : r[3];
					}
				}
				function _drag(amount,dur,easing,dir,overwrite,drag){
					if(!amount){return;}
					_scrollTo($this,amount.toString(),{dur:dur,scrollEasing:easing,dir:dir,overwrite:overwrite,drag:drag});
				}
			},
			/* -------------------- */
	
	
			/*
			SELECT TEXT EVENTS
			scrolls content when text is selected
			*/
			_selectable=function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,seq=d.sequential,
					namespace=pluginPfx+"_"+d.idx,
					mNCSB_container=$("#mNCSB_"+d.idx+"_container"),
					wrapper=mNCSB_container.parent(),
					action;
				mNCSB_container.bind("mousedown."+namespace,function(e){
					if(touchable){return;}
					if(!action){action=1; touchActive=true;}
				}).add(document).bind("mousemove."+namespace,function(e){
					if(!touchable && action && _sel()){
						var offset=mNCSB_container.offset(),
							y=_coordinates(e)[0]-offset.top+mNCSB_container[0].offsetTop,x=_coordinates(e)[1]-offset.left+mNCSB_container[0].offsetLeft;
						if(y>0 && y<wrapper.height() && x>0 && x<wrapper.width()){
							if(seq.step){_seq("off",null,"stepped");}
						}else{
							if(o.axis!=="x" && d.overflowed[0]){
								if(y<0){
									_seq("on",38);
								}else if(y>wrapper.height()){
									_seq("on",40);
								}
							}
							if(o.axis!=="y" && d.overflowed[1]){
								if(x<0){
									_seq("on",37);
								}else if(x>wrapper.width()){
									_seq("on",39);
								}
							}
						}
					}
				}).bind("mouseup."+namespace+" dragend."+namespace,function(e){
					if(touchable){return;}
					if(action){action=0; _seq("off",null);}
					touchActive=false;
				});
				function _sel(){
					return 	window.getSelection ? window.getSelection().toString() :
							document.selection && document.selection.type!="Control" ? document.selection.createRange().text : 0;
				}
				function _seq(a,c,s){
					seq.type=s && action ? "stepped" : "stepless";
					seq.scrollAmount=10;
					_sequentialScroll($this,a,c,"mNCsLinearOut",s ? 60 : null);
				}
			},
			/* -------------------- */
	
	
			/*
			MOUSE WHEEL EVENT
			scrolls content via mouse-wheel
			via mouse-wheel plugin (https://github.com/brandonaaron/jquery-mousewheel)
			*/
			_mousewheel=function(){
				if(!$(this).data(pluginPfx)){return;} /* Check if the scrollbar is ready to use mousewheel events (issue: #185) */
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					namespace=pluginPfx+"_"+d.idx,
					mNCustomScrollBox=$("#mNCSB_"+d.idx),
					mNCSB_dragger=[$("#mNCSB_"+d.idx+"_dragger_vertical"),$("#mNCSB_"+d.idx+"_dragger_horizontal")],
					iframe=$("#mNCSB_"+d.idx+"_container").find("iframe");
				if(iframe.length){
					iframe.each(function(){
						$(this).load(function(){
							/* bind events on accessible iframes */
							if(_canAccessIFrame(this)){
								$(this.contentDocument || this.contentWindow.document).bind("mousewheel."+namespace,function(e,delta){
									_onMousewheel(e,delta);
								});
							}
						});
					});
				}
				mNCustomScrollBox.bind("mousewheel."+namespace,function(e,delta){
					_onMousewheel(e,delta);
				});
				function _onMousewheel(e,delta){
					_stop($this);
					if(_disableMousewheel($this,e.target)){return;} /* disables mouse-wheel when hovering specific elements */
					var deltaFactor=o.mouseWheel.deltaFactor!=="auto" ? parseInt(o.mouseWheel.deltaFactor) : (oldIE && e.deltaFactor<100) ? 100 : e.deltaFactor || 100,
						dur=o.scrollInertia;
					if(o.axis==="x" || o.mouseWheel.axis==="x"){
						var dir="x",
							px=[Math.round(deltaFactor*d.scrollRatio.x),parseInt(o.mouseWheel.scrollAmount)],
							amount=o.mouseWheel.scrollAmount!=="auto" ? px[1] : px[0]>=mNCustomScrollBox.width() ? mNCustomScrollBox.width()*0.9 : px[0],
							contentPos=Math.abs($("#mNCSB_"+d.idx+"_container")[0].offsetLeft),
							draggerPos=mNCSB_dragger[1][0].offsetLeft,
							limit=mNCSB_dragger[1].parent().width()-mNCSB_dragger[1].width(),
							dlt=e.deltaX || e.deltaY || delta;
					}else{
						var dir="y",
							px=[Math.round(deltaFactor*d.scrollRatio.y),parseInt(o.mouseWheel.scrollAmount)],
							amount=o.mouseWheel.scrollAmount!=="auto" ? px[1] : px[0]>=mNCustomScrollBox.height() ? mNCustomScrollBox.height()*0.9 : px[0],
							contentPos=Math.abs($("#mNCSB_"+d.idx+"_container")[0].offsetTop),
							draggerPos=mNCSB_dragger[0][0].offsetTop,
							limit=mNCSB_dragger[0].parent().height()-mNCSB_dragger[0].height(),
							dlt=e.deltaY || delta;
					}
					if((dir==="y" && !d.overflowed[0]) || (dir==="x" && !d.overflowed[1])){return;}
					if(o.mouseWheel.invert || e.webkitDirectionInvertedFromDevice){dlt=-dlt;}
					if(o.mouseWheel.normalizeDelta){dlt=dlt<0 ? -1 : 1;}
					if((dlt>0 && draggerPos!==0) || (dlt<0 && draggerPos!==limit) || o.mouseWheel.preventDefault){
						e.stopImmediatePropagation();
						e.preventDefault();
					}
					if(e.deltaFactor<2 && !o.mouseWheel.normalizeDelta){
						//very low deltaFactor values mean some kind of delta acceleration (e.g. osx trackpad), so adjusting scrolling accordingly
						amount=e.deltaFactor; dur=17;
					}
					_scrollTo($this,(contentPos-(dlt*amount)).toString(),{dir:dir,dur:dur});
				}
			},
			/* -------------------- */
	
	
			/* checks if iframe can be accessed */
			_canAccessIFrame=function(iframe){
				var html=null;
				if(!iframe){
					try{
						var doc=top.document;
						html=doc.body.innerHTML;
					}catch(err){/* do nothing */}
					return(html!==null);
				}else{
					try{
						var doc=iframe.contentDocument || iframe.contentWindow.document;
						html=doc.body.innerHTML;
					}catch(err){/* do nothing */}
					return(html!==null);
				}
			},
			/* -------------------- */
	
	
			/* disables mouse-wheel when hovering specific elements like select, datalist etc. */
			_disableMousewheel=function(el,target){
				var tag=target.nodeName.toLowerCase(),
					tags=el.data(pluginPfx).opt.mouseWheel.disableOver,
					/* elements that require focus */
					focusTags=["select","textarea"];
				return $.inArray(tag,tags) > -1 && !($.inArray(tag,focusTags) > -1 && !$(target).is(":focus"));
			},
			/* -------------------- */
	
	
			/*
			DRAGGER RAIL CLICK EVENT
			scrolls content via dragger rail
			*/
			_draggerRail=function(){
				var $this=$(this),d=$this.data(pluginPfx),
					namespace=pluginPfx+"_"+d.idx,
					mNCSB_container=$("#mNCSB_"+d.idx+"_container"),
					wrapper=mNCSB_container.parent(),
					mNCSB_draggerContainer=$(".mNCSB_"+d.idx+"_scrollbar ."+classes[12]),
					clickable;
				mNCSB_draggerContainer.bind("mousedown."+namespace+" touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace,function(e){
					touchActive=true;
					if(!$(e.target).hasClass("mNCSB_dragger")){clickable=1;}
				}).bind("touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace,function(e){
					touchActive=false;
				}).bind("click."+namespace,function(e){
					if(!clickable){return;}
					clickable=0;
					if($(e.target).hasClass(classes[12]) || $(e.target).hasClass("mNCSB_draggerRail")){
						_stop($this);
						var el=$(this),mNCSB_dragger=el.find(".mNCSB_dragger");
						if(el.parent(".mNCSB_scrollTools_horizontal").length>0){
							if(!d.overflowed[1]){return;}
							var dir="x",
								clickDir=e.pageX>mNCSB_dragger.offset().left ? -1 : 1,
								to=Math.abs(mNCSB_container[0].offsetLeft)-(clickDir*(wrapper.width()*0.9));
						}else{
							if(!d.overflowed[0]){return;}
							var dir="y",
								clickDir=e.pageY>mNCSB_dragger.offset().top ? -1 : 1,
								to=Math.abs(mNCSB_container[0].offsetTop)-(clickDir*(wrapper.height()*0.9));
						}
						_scrollTo($this,to.toString(),{dir:dir,scrollEasing:"mNCsEaseInOut"});
					}
				});
			},
			/* -------------------- */
	
	
			/*
			FOCUS EVENT
			scrolls content via element focus (e.g. clicking an input, pressing TAB key etc.)
			*/
			_focus=function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					namespace=pluginPfx+"_"+d.idx,
					mNCSB_container=$("#mNCSB_"+d.idx+"_container"),
					wrapper=mNCSB_container.parent();
				mNCSB_container.bind("focusin."+namespace,function(e){
					var el=$(document.activeElement),
						nested=mNCSB_container.find(".mNCustomScrollBox").length,
						dur=0;
					if(!el.is(o.advanced.autoScrollOnFocus)){return;}
					_stop($this);
					clearTimeout($this[0]._focusTimeout);
					$this[0]._focusTimer=nested ? (dur+17)*nested : 0;
					$this[0]._focusTimeout=setTimeout(function(){
						var	to=[_childPos(el)[0],_childPos(el)[1]],
							contentPos=[mNCSB_container[0].offsetTop,mNCSB_container[0].offsetLeft],
							isVisible=[
								(contentPos[0]+to[0]>=0 && contentPos[0]+to[0]<wrapper.height()-el.outerHeight(false)),
								(contentPos[1]+to[1]>=0 && contentPos[0]+to[1]<wrapper.width()-el.outerWidth(false))
							],
							overwrite=(o.axis==="yx" && !isVisible[0] && !isVisible[1]) ? "none" : "all";
						if(o.axis!=="x" && !isVisible[0]){
							_scrollTo($this,to[0].toString(),{dir:"y",scrollEasing:"mNCsEaseInOut",overwrite:overwrite,dur:dur});
						}
						if(o.axis!=="y" && !isVisible[1]){
							_scrollTo($this,to[1].toString(),{dir:"x",scrollEasing:"mNCsEaseInOut",overwrite:overwrite,dur:dur});
						}
					},$this[0]._focusTimer);
				});
			},
			/* -------------------- */
	
	
			/* sets content wrapper scrollTop/scrollLeft always to 0 */
			_wrapperScroll=function(){
				var $this=$(this),d=$this.data(pluginPfx),
					namespace=pluginPfx+"_"+d.idx,
					wrapper=$("#mNCSB_"+d.idx+"_container").parent();
				wrapper.bind("scroll."+namespace,function(e){
					if(wrapper.scrollTop()!==0 || wrapper.scrollLeft()!==0){
						$(".mNCSB_"+d.idx+"_scrollbar").css("visibility","hidden"); /* hide scrollbar(s) */
					}
				});
			},
			/* -------------------- */
	
	
			/*
			BUTTONS EVENTS
			scrolls content via up, down, left and right buttons
			*/
			_buttons=function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,seq=d.sequential,
					namespace=pluginPfx+"_"+d.idx,
					sel=".mNCSB_"+d.idx+"_scrollbar",
					btn=$(sel+">a");
				btn.bind("mousedown."+namespace+" touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace+" mouseup."+namespace+" touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace+" mouseout."+namespace+" pointerout."+namespace+" MSPointerOut."+namespace+" click."+namespace,function(e){
					e.preventDefault();
					if(!_mouseBtnLeft(e)){return;} /* left mouse button only */
					var btnClass=$(this).attr("class");
					seq.type=o.scrollButtons.scrollType;
					switch(e.type){
						case "mousedown": case "touchstart": case "pointerdown": case "MSPointerDown":
							if(seq.type==="stepped"){return;}
							touchActive=true;
							d.tweenRunning=false;
							_seq("on",btnClass);
							break;
						case "mouseup": case "touchend": case "pointerup": case "MSPointerUp":
						case "mouseout": case "pointerout": case "MSPointerOut":
							if(seq.type==="stepped"){return;}
							touchActive=false;
							if(seq.dir){_seq("off",btnClass);}
							break;
						case "click":
							if(seq.type!=="stepped" || d.tweenRunning){return;}
							_seq("on",btnClass);
							break;
					}
					function _seq(a,c){
						seq.scrollAmount=o.scrollButtons.scrollAmount;
						_sequentialScroll($this,a,c);
					}
				});
			},
			/* -------------------- */
	
	
			/*
			KEYBOARD EVENTS
			scrolls content via keyboard
			Keys: up arrow, down arrow, left arrow, right arrow, PgUp, PgDn, Home, End
			*/
			_keyboard=function(){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,seq=d.sequential,
					namespace=pluginPfx+"_"+d.idx,
					mNCustomScrollBox=$("#mNCSB_"+d.idx),
					mNCSB_container=$("#mNCSB_"+d.idx+"_container"),
					wrapper=mNCSB_container.parent(),
					editables="input,textarea,select,datalist,keygen,[contenteditable='true']",
					iframe=mNCSB_container.find("iframe"),
					events=["blur."+namespace+" keydown."+namespace+" keyup."+namespace];
				if(iframe.length){
					iframe.each(function(){
						$(this).load(function(){
							/* bind events on accessible iframes */
							if(_canAccessIFrame(this)){
								$(this.contentDocument || this.contentWindow.document).bind(events[0],function(e){
									_onKeyboard(e);
								});
							}
						});
					});
				}
				mNCustomScrollBox.attr("tabindex","0").bind(events[0],function(e){
					_onKeyboard(e);
				});
				function _onKeyboard(e){
					switch(e.type){
						case "blur":
							if(d.tweenRunning && seq.dir){_seq("off",null);}
							break;
						case "keydown": case "keyup":
							var code=e.keyCode ? e.keyCode : e.which,action="on";
							if((o.axis!=="x" && (code===38 || code===40)) || (o.axis!=="y" && (code===37 || code===39))){
								/* up (38), down (40), left (37), right (39) arrows */
								if(((code===38 || code===40) && !d.overflowed[0]) || ((code===37 || code===39) && !d.overflowed[1])){return;}
								if(e.type==="keyup"){action="off";}
								if(!$(document.activeElement).is(editables)){
									e.preventDefault();
									e.stopImmediatePropagation();
									_seq(action,code);
								}
							}else if(code===33 || code===34){
								/* PgUp (33), PgDn (34) */
								if(d.overflowed[0] || d.overflowed[1]){
									e.preventDefault();
									e.stopImmediatePropagation();
								}
								if(e.type==="keyup"){
									_stop($this);
									var keyboardDir=code===34 ? -1 : 1;
									if(o.axis==="x" || (o.axis==="yx" && d.overflowed[1] && !d.overflowed[0])){
										var dir="x",to=Math.abs(mNCSB_container[0].offsetLeft)-(keyboardDir*(wrapper.width()*0.9));
									}else{
										var dir="y",to=Math.abs(mNCSB_container[0].offsetTop)-(keyboardDir*(wrapper.height()*0.9));
									}
									_scrollTo($this,to.toString(),{dir:dir,scrollEasing:"mNCsEaseInOut"});
								}
							}else if(code===35 || code===36){
								/* End (35), Home (36) */
								if(!$(document.activeElement).is(editables)){
									if(d.overflowed[0] || d.overflowed[1]){
										e.preventDefault();
										e.stopImmediatePropagation();
									}
									if(e.type==="keyup"){
										if(o.axis==="x" || (o.axis==="yx" && d.overflowed[1] && !d.overflowed[0])){
											var dir="x",to=code===35 ? Math.abs(wrapper.width()-mNCSB_container.outerWidth(false)) : 0;
										}else{
											var dir="y",to=code===35 ? Math.abs(wrapper.height()-mNCSB_container.outerHeight(false)) : 0;
										}
										_scrollTo($this,to.toString(),{dir:dir,scrollEasing:"mNCsEaseInOut"});
									}
								}
							}
							break;
					}
					function _seq(a,c){
						seq.type=o.keyboard.scrollType;
						seq.scrollAmount=o.keyboard.scrollAmount;
						if(seq.type==="stepped" && d.tweenRunning){return;}
						_sequentialScroll($this,a,c);
					}
				}
			},
			/* -------------------- */
	
	
			/* scrolls content sequentially (used when scrolling via buttons, keyboard arrows etc.) */
			_sequentialScroll=function(el,action,trigger,e,s){
				var d=el.data(pluginPfx),o=d.opt,seq=d.sequential,
					mNCSB_container=$("#mNCSB_"+d.idx+"_container"),
					once=seq.type==="stepped" ? true : false,
					steplessSpeed=o.scrollInertia < 26 ? 26 : o.scrollInertia, /* 26/1.5=17 */
					steppedSpeed=o.scrollInertia < 1 ? 17 : o.scrollInertia;
				switch(action){
					case "on":
						seq.dir=[
							(trigger===classes[16] || trigger===classes[15] || trigger===39 || trigger===37 ? "x" : "y"),
							(trigger===classes[13] || trigger===classes[15] || trigger===38 || trigger===37 ? -1 : 1)
						];
						_stop(el);
						if(_isNumeric(trigger) && seq.type==="stepped"){return;}
						_on(once);
						break;
					case "off":
						_off();
						if(once || (d.tweenRunning && seq.dir)){
							_on(true);
						}
						break;
				}
	
				/* starts sequence */
				function _on(once){
					if(o.snapAmount){seq.scrollAmount=!(o.snapAmount instanceof Array) ? o.snapAmount : seq.dir[0]==="x" ? o.snapAmount[1] : o.snapAmount[0];} /* scrolling snapping */
					var c=seq.type!=="stepped", /* continuous scrolling */
						t=s ? s : !once ? 1000/60 : c ? steplessSpeed/1.5 : steppedSpeed, /* timer */
						m=!once ? 2.5 : c ? 7.5 : 40, /* multiplier */
						contentPos=[Math.abs(mNCSB_container[0].offsetTop),Math.abs(mNCSB_container[0].offsetLeft)],
						ratio=[d.scrollRatio.y>10 ? 10 : d.scrollRatio.y,d.scrollRatio.x>10 ? 10 : d.scrollRatio.x],
						amount=seq.dir[0]==="x" ? contentPos[1]+(seq.dir[1]*(ratio[1]*m)) : contentPos[0]+(seq.dir[1]*(ratio[0]*m)),
						px=seq.dir[0]==="x" ? contentPos[1]+(seq.dir[1]*parseInt(seq.scrollAmount)) : contentPos[0]+(seq.dir[1]*parseInt(seq.scrollAmount)),
						to=seq.scrollAmount!=="auto" ? px : amount,
						easing=e ? e : !once ? "mNCsLinear" : c ? "mNCsLinearOut" : "mNCsEaseInOut",
						onComplete=!once ? false : true;
					if(once && t<17){
						to=seq.dir[0]==="x" ? contentPos[1] : contentPos[0];
					}
					_scrollTo(el,to.toString(),{dir:seq.dir[0],scrollEasing:easing,dur:t,onComplete:onComplete});
					if(once){
						seq.dir=false;
						return;
					}
					clearTimeout(seq.step);
					seq.step=setTimeout(function(){
						_on();
					},t);
				}
				/* stops sequence */
				function _off(){
					clearTimeout(seq.step);
					_delete(seq,"step");
					_stop(el);
				}
			},
			/* -------------------- */
	
	
			/* returns a yx array from value */
			_arr=function(val){
				var o=$(this).data(pluginPfx).opt,vals=[];
				if(typeof val==="function"){val=val();} /* check if the value is a single anonymous function */
				/* check if value is object or array, its length and create an array with yx values */
				if(!(val instanceof Array)){ /* object value (e.g. {y:"100",x:"100"}, 100 etc.) */
					vals[0]=val.y ? val.y : val.x || o.axis==="x" ? null : val;
					vals[1]=val.x ? val.x : val.y || o.axis==="y" ? null : val;
				}else{ /* array value (e.g. [100,100]) */
					vals=val.length>1 ? [val[0],val[1]] : o.axis==="x" ? [null,val[0]] : [val[0],null];
				}
				/* check if array values are anonymous functions */
				if(typeof vals[0]==="function"){vals[0]=vals[0]();}
				if(typeof vals[1]==="function"){vals[1]=vals[1]();}
				return vals;
			},
			/* -------------------- */
	
	
			/* translates values (e.g. "top", 100, "100px", "#id") to actual scroll-to positions */
			_to=function(val,dir){
				if(val==null || typeof val=="undefined"){return;}
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					mNCSB_container=$("#mNCSB_"+d.idx+"_container"),
					wrapper=mNCSB_container.parent(),
					t=typeof val;
				if(!dir){dir=o.axis==="x" ? "x" : "y";}
				var contentLength=dir==="x" ? mNCSB_container.outerWidth(false) : mNCSB_container.outerHeight(false),
					contentPos=dir==="x" ? mNCSB_container[0].offsetLeft : mNCSB_container[0].offsetTop,
					cssProp=dir==="x" ? "left" : "top";
				switch(t){
					case "function": /* this currently is not used. Consider removing it */
						return val();
						break;
					case "object": /* js/jquery object */
						var obj=val.jquery ? val : $(val);
						if(!obj.length){return;}
						return dir==="x" ? _childPos(obj)[1] : _childPos(obj)[0];
						break;
					case "string": case "number":
						if(_isNumeric(val)){ /* numeric value */
							return Math.abs(val);
						}else if(val.indexOf("%")!==-1){ /* percentage value */
							return Math.abs(contentLength*parseInt(val)/100);
						}else if(val.indexOf("-=")!==-1){ /* decrease value */
							return Math.abs(contentPos-parseInt(val.split("-=")[1]));
						}else if(val.indexOf("+=")!==-1){ /* inrease value */
							var p=(contentPos+parseInt(val.split("+=")[1]));
							return p>=0 ? 0 : Math.abs(p);
						}else if(val.indexOf("px")!==-1 && _isNumeric(val.split("px")[0])){ /* pixels string value (e.g. "100px") */
							return Math.abs(val.split("px")[0]);
						}else{
							if(val==="top" || val==="left"){ /* special strings */
								return 0;
							}else if(val==="bottom"){
								return Math.abs(wrapper.height()-mNCSB_container.outerHeight(false));
							}else if(val==="right"){
								return Math.abs(wrapper.width()-mNCSB_container.outerWidth(false));
							}else if(val==="first" || val==="last"){
								var obj=mNCSB_container.find(":"+val);
								return dir==="x" ? _childPos(obj)[1] : _childPos(obj)[0];
							}else{
								if($(val).length){ /* jquery selector */
									return dir==="x" ? _childPos($(val))[1] : _childPos($(val))[0];
								}else{ /* other values (e.g. "100em") */
									mNCSB_container.css(cssProp,val);
									methods.update.call(null,$this[0]);
									return;
								}
							}
						}
						break;
				}
			},
			/* -------------------- */
	
	
			/* calls the update method automatically */
			_autoUpdate=function(rem){
				var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
					mNCSB_container=$("#mNCSB_"+d.idx+"_container");
				if(rem){
					/*
					removes autoUpdate timer
					usage: _autoUpdate.call(this,"remove");
					*/
					clearTimeout(mNCSB_container[0].autoUpdate);
					_delete(mNCSB_container[0],"autoUpdate");
					return;
				}
				upd();
				function upd(){
					clearTimeout(mNCSB_container[0].autoUpdate);
					if($this.parents("html").length===0){
						/* check element in dom tree */
						$this=null;
						return;
					}
					mNCSB_container[0].autoUpdate=setTimeout(function(){
						/* update on specific selector(s) length and size change */
						if(o.advanced.updateOnSelectorChange){
							d.poll.change.n=sizesSum();
							if(d.poll.change.n!==d.poll.change.o){
								d.poll.change.o=d.poll.change.n;
								doUpd(3);
								return;
							}
						}
						/* update on main element and scrollbar size changes */
						if(o.advanced.updateOnContentResize){
							d.poll.size.n=$this[0].scrollHeight+$this[0].scrollWidth+mNCSB_container[0].offsetHeight+$this[0].offsetHeight+$this[0].offsetWidth;
							if(d.poll.size.n!==d.poll.size.o){
								d.poll.size.o=d.poll.size.n;
								doUpd(1);
								return;
							}
						}
						/* update on image load */
						if(o.advanced.updateOnImageLoad){
							if(!(o.advanced.updateOnImageLoad==="auto" && o.axis==="y")){ //by default, it doesn't run on vertical content
								d.poll.img.n=mNCSB_container.find("img").length;
								if(d.poll.img.n!==d.poll.img.o){
									d.poll.img.o=d.poll.img.n;
									mNCSB_container.find("img").each(function(){
										imgLoader(this);
									});
									return;
								}
							}
						}
						if(o.advanced.updateOnSelectorChange || o.advanced.updateOnContentResize || o.advanced.updateOnImageLoad){upd();}
					},o.advanced.autoUpdateTimeout);
				}
				/* a tiny image loader */
				function imgLoader(el){
					if($(el).hasClass(classes[2])){doUpd(); return;}
					var img=new Image();
					function createDelegate(contextObject,delegateMethod){
						return function(){return delegateMethod.apply(contextObject,arguments);}
					}
					function imgOnLoad(){
						this.onload=null;
						$(el).addClass(classes[2]);
						doUpd(2);
					}
					img.onload=createDelegate(img,imgOnLoad);
					img.src=el.src;
				}
				/* returns the total height and width sum of all elements matching the selector */
				function sizesSum(){
					if(o.advanced.updateOnSelectorChange===true){o.advanced.updateOnSelectorChange="*";}
					var total=0,sel=mNCSB_container.find(o.advanced.updateOnSelectorChange);
					if(o.advanced.updateOnSelectorChange && sel.length>0){sel.each(function(){total+=this.offsetHeight+this.offsetWidth;});}
					return total;
				}
				/* calls the update method */
				function doUpd(cb){
					clearTimeout(mNCSB_container[0].autoUpdate);
					methods.update.call(null,$this[0],cb);
				}
			},
			/* -------------------- */
	
	
			/* snaps scrolling to a multiple of a pixels number */
			_snapAmount=function(to,amount,offset){
				return (Math.round(to/amount)*amount-offset);
			},
			/* -------------------- */
	
	
			/* stops content and scrollbar animations */
			_stop=function(el){
				var d=el.data(pluginPfx),
					sel=$("#mNCSB_"+d.idx+"_container,#mNCSB_"+d.idx+"_container_wrapper,#mNCSB_"+d.idx+"_dragger_vertical,#mNCSB_"+d.idx+"_dragger_horizontal");
				sel.each(function(){
					_stopTween.call(this);
				});
			},
			/* -------------------- */
	
	
			/*
			ANIMATES CONTENT
			This is where the actual scrolling happens
			*/
			_scrollTo=function(el,to,options){
				var d=el.data(pluginPfx),o=d.opt,
					defaults={
						trigger:"internal",
						dir:"y",
						scrollEasing:"mNCsEaseOut",
						drag:false,
						dur:o.scrollInertia,
						overwrite:"all",
						callbacks:true,
						onStart:true,
						onUpdate:true,
						onComplete:true
					},
					options=$.extend(defaults,options),
					dur=[options.dur,(options.drag ? 0 : options.dur)],
					mNCustomScrollBox=$("#mNCSB_"+d.idx),
					mNCSB_container=$("#mNCSB_"+d.idx+"_container"),
					wrapper=mNCSB_container.parent(),
					totalScrollOffsets=o.callbacks.onTotalScrollOffset ? _arr.call(el,o.callbacks.onTotalScrollOffset) : [0,0],
					totalScrollBackOffsets=o.callbacks.onTotalScrollBackOffset ? _arr.call(el,o.callbacks.onTotalScrollBackOffset) : [0,0];
				d.trigger=options.trigger;
				if(wrapper.scrollTop()!==0 || wrapper.scrollLeft()!==0){ /* always reset scrollTop/Left */
					$(".mNCSB_"+d.idx+"_scrollbar").css("visibility","visible");
					wrapper.scrollTop(0).scrollLeft(0);
				}
				if(to==="_resetY" && !d.contentReset.y){
					/* callbacks: onOverflowYNone */
					if(_cb("onOverflowYNone")){o.callbacks.onOverflowYNone.call(el[0]);}
					d.contentReset.y=1;
				}
				if(to==="_resetX" && !d.contentReset.x){
					/* callbacks: onOverflowXNone */
					if(_cb("onOverflowXNone")){o.callbacks.onOverflowXNone.call(el[0]);}
					d.contentReset.x=1;
				}
				if(to==="_resetY" || to==="_resetX"){return;}
				if((d.contentReset.y || !el[0].mNCs) && d.overflowed[0]){
					/* callbacks: onOverflowY */
					if(_cb("onOverflowY")){o.callbacks.onOverflowY.call(el[0]);}
					d.contentReset.x=null;
				}
				if((d.contentReset.x || !el[0].mNCs) && d.overflowed[1]){
					/* callbacks: onOverflowX */
					if(_cb("onOverflowX")){o.callbacks.onOverflowX.call(el[0]);}
					d.contentReset.x=null;
				}
				if(o.snapAmount){ /* scrolling snapping */
					var snapAmount=!(o.snapAmount instanceof Array) ? o.snapAmount : options.dir==="x" ? o.snapAmount[1] : o.snapAmount[0];
					to=_snapAmount(to,snapAmount,o.snapOffset);
				}
				switch(options.dir){
					case "x":
						var mNCSB_dragger=$("#mNCSB_"+d.idx+"_dragger_horizontal"),
							property="left",
							contentPos=mNCSB_container[0].offsetLeft,
							limit=[
								mNCustomScrollBox.width()-mNCSB_container.outerWidth(false),
								mNCSB_dragger.parent().width()-mNCSB_dragger.width()
							],
							scrollTo=[to,to===0 ? 0 : (to/d.scrollRatio.x)],
							tso=totalScrollOffsets[1],
							tsbo=totalScrollBackOffsets[1],
							totalScrollOffset=tso>0 ? tso/d.scrollRatio.x : 0,
							totalScrollBackOffset=tsbo>0 ? tsbo/d.scrollRatio.x : 0;
						break;
					case "y":
						var mNCSB_dragger=$("#mNCSB_"+d.idx+"_dragger_vertical"),
							property="top",
							contentPos=mNCSB_container[0].offsetTop,
							limit=[
								mNCustomScrollBox.height()-mNCSB_container.outerHeight(false),
								mNCSB_dragger.parent().height()-mNCSB_dragger.height()
							],
							scrollTo=[to,to===0 ? 0 : (to/d.scrollRatio.y)],
							tso=totalScrollOffsets[0],
							tsbo=totalScrollBackOffsets[0],
							totalScrollOffset=tso>0 ? tso/d.scrollRatio.y : 0,
							totalScrollBackOffset=tsbo>0 ? tsbo/d.scrollRatio.y : 0;
						break;
				}
				if(scrollTo[1]<0 || (scrollTo[0]===0 && scrollTo[1]===0)){
					scrollTo=[0,0];
				}else if(scrollTo[1]>=limit[1]){
					scrollTo=[limit[0],limit[1]];
				}else{
					scrollTo[0]=-scrollTo[0];
				}
				if(!el[0].mNCs){
					_mNCs();  /* init mNCs object (once) to make it available before callbacks */
					if(_cb("onInit")){o.callbacks.onInit.call(el[0]);} /* callbacks: onInit */
				}
				clearTimeout(mNCSB_container[0].onCompleteTimeout);
				_tweenTo(mNCSB_dragger[0],property,Math.round(scrollTo[1]),dur[1],options.scrollEasing);
				if(!d.tweenRunning && ((contentPos===0 && scrollTo[0]>=0) || (contentPos===limit[0] && scrollTo[0]<=limit[0]))){return;}
				_tweenTo(mNCSB_container[0],property,Math.round(scrollTo[0]),dur[0],options.scrollEasing,options.overwrite,{
					onStart:function(){
						if(options.callbacks && options.onStart && !d.tweenRunning){
							/* callbacks: onScrollStart */
							if(_cb("onScrollStart")){_mNCs(); o.callbacks.onScrollStart.call(el[0]);}
							d.tweenRunning=true;
							_onDragClasses(mNCSB_dragger);
							d.cbOffsets=_cbOffsets();
						}
					},onUpdate:function(){
						if(options.callbacks && options.onUpdate){
							/* callbacks: whileScrolling */
							if(_cb("whileScrolling")){_mNCs(); o.callbacks.whileScrolling.call(el[0]);}
						}
					},onComplete:function(){
						if(options.callbacks && options.onComplete){
							if(o.axis==="yx"){clearTimeout(mNCSB_container[0].onCompleteTimeout);}
							var t=mNCSB_container[0].idleTimer || 0;
							mNCSB_container[0].onCompleteTimeout=setTimeout(function(){
								/* callbacks: onScroll, onTotalScroll, onTotalScrollBack */
								if(_cb("onScroll")){_mNCs(); o.callbacks.onScroll.call(el[0]);}
								if(_cb("onTotalScroll") && scrollTo[1]>=limit[1]-totalScrollOffset && d.cbOffsets[0]){_mNCs(); o.callbacks.onTotalScroll.call(el[0]);}
								if(_cb("onTotalScrollBack") && scrollTo[1]<=totalScrollBackOffset && d.cbOffsets[1]){_mNCs(); o.callbacks.onTotalScrollBack.call(el[0]);}
								d.tweenRunning=false;
								mNCSB_container[0].idleTimer=0;
								_onDragClasses(mNCSB_dragger,"hide");
							},t);
						}
					}
				});
				/* checks if callback function exists */
				function _cb(cb){
					return d && o.callbacks[cb] && typeof o.callbacks[cb]==="function";
				}
				/* checks whether callback offsets always trigger */
				function _cbOffsets(){
					return [o.callbacks.alwaysTriggerOffsets || contentPos>=limit[0]+tso,o.callbacks.alwaysTriggerOffsets || contentPos<=-tsbo];
				}
				/*
				populates object with useful values for the user
				values:
					content: this.mNCs.content
					content top position: this.mNCs.top
					content left position: this.mNCs.left
					dragger top position: this.mNCs.draggerTop
					dragger left position: this.mNCs.draggerLeft
					scrolling y percentage: this.mNCs.topPct
					scrolling x percentage: this.mNCs.leftPct
					scrolling direction: this.mNCs.direction
				*/
				function _mNCs(){
					var cp=[mNCSB_container[0].offsetTop,mNCSB_container[0].offsetLeft], /* content position */
						dp=[mNCSB_dragger[0].offsetTop,mNCSB_dragger[0].offsetLeft], /* dragger position */
						cl=[mNCSB_container.outerHeight(false),mNCSB_container.outerWidth(false)], /* content length */
						pl=[mNCustomScrollBox.height(),mNCustomScrollBox.width()]; /* content parent length */
					el[0].mNCs={
						content:mNCSB_container, /* original content wrapper as jquery object */
						top:cp[0],left:cp[1],draggerTop:dp[0],draggerLeft:dp[1],
						topPct:Math.round((100*Math.abs(cp[0]))/(Math.abs(cl[0])-pl[0])),leftPct:Math.round((100*Math.abs(cp[1]))/(Math.abs(cl[1])-pl[1])),
						direction:options.dir
					};
					/*
					this refers to the original element containing the scrollbar(s)
					usage: this.mNCs.top, this.mNCs.leftPct etc.
					*/
				}
			},
			/* -------------------- */
	
	
			/*
			CUSTOM JAVASCRIPT ANIMATION TWEEN
			Lighter and faster than jquery animate() and css transitions
			Animates top/left properties and includes easings
			*/
			_tweenTo=function(el,prop,to,duration,easing,overwrite,callbacks){
				if(!el._mTween){el._mTween={top:{},left:{}};}
				var callbacks=callbacks || {},
					onStart=callbacks.onStart || function(){},onUpdate=callbacks.onUpdate || function(){},onComplete=callbacks.onComplete || function(){},
					startTime=_getTime(),_delay,progress=0,from=el.offsetTop,elStyle=el.style,_request,tobj=el._mTween[prop];
				if(prop==="left"){from=el.offsetLeft;}
				var diff=to-from;
				tobj.stop=0;
				if(overwrite!=="none"){_cancelTween();}
				_startTween();
				function _step(){
					if(tobj.stop){return;}
					if(!progress){onStart.call();}
					progress=_getTime()-startTime;
					_tween();
					if(progress>=tobj.time){
						tobj.time=(progress>tobj.time) ? progress+_delay-(progress-tobj.time) : progress+_delay-1;
						if(tobj.time<progress+1){tobj.time=progress+1;}
					}
					if(tobj.time<duration){tobj.id=_request(_step);}else{onComplete.call();}
				}
				function _tween(){
					if(duration>0){
						tobj.currVal=_ease(tobj.time,from,diff,duration,easing);
						elStyle[prop]=Math.round(tobj.currVal)+"px";
					}else{
						elStyle[prop]=to+"px";
					}
					onUpdate.call();
				}
				function _startTween(){
					_delay=1000/60;
					tobj.time=progress+_delay;
					_request=(!window.requestAnimationFrame) ? function(f){_tween(); return setTimeout(f,0.01);} : window.requestAnimationFrame;
					tobj.id=_request(_step);
				}
				function _cancelTween(){
					if(tobj.id==null){return;}
					if(!window.requestAnimationFrame){clearTimeout(tobj.id);
					}else{window.cancelAnimationFrame(tobj.id);}
					tobj.id=null;
				}
				function _ease(t,b,c,d,type){
					switch(type){
						case "linear": case "mNCsLinear":
							return c*t/d + b;
							break;
						case "mNCsLinearOut":
							t/=d; t--; return c * Math.sqrt(1 - t*t) + b;
							break;
						case "easeInOutSmooth":
							t/=d/2;
							if(t<1) return c/2*t*t + b;
							t--;
							return -c/2 * (t*(t-2) - 1) + b;
							break;
						case "easeInOutStrong":
							t/=d/2;
							if(t<1) return c/2 * Math.pow( 2, 10 * (t - 1) ) + b;
							t--;
							return c/2 * ( -Math.pow( 2, -10 * t) + 2 ) + b;
							break;
						case "easeInOut": case "mNCsEaseInOut":
							t/=d/2;
							if(t<1) return c/2*t*t*t + b;
							t-=2;
							return c/2*(t*t*t + 2) + b;
							break;
						case "easeOutSmooth":
							t/=d; t--;
							return -c * (t*t*t*t - 1) + b;
							break;
						case "easeOutStrong":
							return c * ( -Math.pow( 2, -10 * t/d ) + 1 ) + b;
							break;
						case "easeOut": case "mNCsEaseOut": default:
							var ts=(t/=d)*t,tc=ts*t;
							return b+c*(0.499999999999997*tc*ts + -2.5*ts*ts + 5.5*tc + -6.5*ts + 4*t);
					}
				}
			},
			/* -------------------- */
	
	
			/* returns current time */
			_getTime=function(){
				if(window.performance && window.performance.now){
					return window.performance.now();
				}else{
					if(window.performance && window.performance.webkitNow){
						return window.performance.webkitNow();
					}else{
						if(Date.now){return Date.now();}else{return new Date().getTime();}
					}
				}
			},
			/* -------------------- */
	
	
			/* stops a tween */
			_stopTween=function(){
				var el=this;
				if(!el._mTween){el._mTween={top:{},left:{}};}
				var props=["top","left"];
				for(var i=0; i<props.length; i++){
					var prop=props[i];
					if(el._mTween[prop].id){
						if(!window.requestAnimationFrame){clearTimeout(el._mTween[prop].id);
						}else{window.cancelAnimationFrame(el._mTween[prop].id);}
						el._mTween[prop].id=null;
						el._mTween[prop].stop=1;
					}
				}
			},
			/* -------------------- */
	
	
			/* deletes a property (avoiding the exception thrown by IE) */
			_delete=function(c,m){
				try{delete c[m];}catch(e){c[m]=null;}
			},
			/* -------------------- */
	
	
			/* detects left mouse button */
			_mouseBtnLeft=function(e){
				return !(e.which && e.which!==1);
			},
			/* -------------------- */
	
	
			/* detects if pointer type event is touch */
			_pointerTouch=function(e){
				var t=e.originalEvent.pointerType;
				return !(t && t!=="touch" && t!==2);
			},
			/* -------------------- */
	
	
			/* checks if value is numeric */
			_isNumeric=function(val){
				return !isNaN(parseFloat(val)) && isFinite(val);
			},
			/* -------------------- */
	
	
			/* returns element position according to content */
			_childPos=function(el){
				var p=el.parents(".mNCSB_container");
				return [el.offset().top-p.offset().top,el.offset().left-p.offset().left];
			},
			/* -------------------- */
	
	
			/* checks if browser tab is hidden/inactive via Page Visibility API */
			_isTabHidden=function(){
				var prop=_getHiddenProp();
				if(!prop) return false;
				return document[prop];
				function _getHiddenProp(){
					var pfx=["webkit","moz","ms","o"];
					if("hidden" in document) return "hidden"; //natively supported
					for(var i=0; i<pfx.length; i++){ //prefixed
					    if((pfx[i]+"Hidden") in document)
					        return pfx[i]+"Hidden";
					}
					return null; //not supported
				}
			};
			/* -------------------- */
	
	
	
	
	
		/*
		----------------------------------------
		PLUGIN SETUP
		----------------------------------------
		*/
	
		/* plugin constructor functions */
		$.fn[pluginNS]=function(method){ /* usage: $(selector).mNCustomScrollbar(); */
			if(methods[method]){
				return methods[method].apply(this,Array.prototype.slice.call(arguments,1));
			}else if(typeof method==="object" || !method){
				return methods.init.apply(this,arguments);
			}else{
				$.error("Method "+method+" does not exist");
			}
		};
		$[pluginNS]=function(method){ /* usage: $.mNCustomScrollbar(); */
			if(methods[method]){
				return methods[method].apply(this,Array.prototype.slice.call(arguments,1));
			}else if(typeof method==="object" || !method){
				return methods.init.apply(this,arguments);
			}else{
				$.error("Method "+method+" does not exist");
			}
		};
	
		/*
		allow setting plugin default options.
		usage: $.mNCustomScrollbar.defaults.scrollInertia=500;
		to apply any changed default options on default selectors (below), use inside document ready fn
		e.g.: $(document).ready(function(){ $.mNCustomScrollbar.defaults.scrollInertia=500; });
		*/
		$[pluginNS].defaults=defaults;
	
		/*
		add window object (window.mNCustomScrollbar)
		usage: if(window.mNCustomScrollbar){console.log("custom scrollbar plugin loaded");}
		*/
		window[pluginNS]=true;
	
		$(window).load(function(){
	
			$(defaultSelector)[pluginNS](); /* add scrollbars automatically on default selector */
	
			/* extend jQuery expressions */
			$.extend($.expr[":"],{
				/* checks if element is within scrollable viewport */
				mNCsInView:$.expr[":"].mNCsInView || function(el){
					var $el=$(el),content=$el.parents(".mNCSB_container"),wrapper,cPos;
					if(!content.length){return;}
					wrapper=content.parent();
					cPos=[content[0].offsetTop,content[0].offsetLeft];
					return 	cPos[0]+_childPos($el)[0]>=0 && cPos[0]+_childPos($el)[0]<wrapper.height()-$el.outerHeight(false) &&
							cPos[1]+_childPos($el)[1]>=0 && cPos[1]+_childPos($el)[1]<wrapper.width()-$el.outerWidth(false);
				},
				/* checks if element is overflowed having visible scrollbar(s) */
				mNCsOverflow:$.expr[":"].mNCsOverflow || function(el){
					var d=$(el).data(pluginPfx);
					if(!d){return;}
					return d.overflowed[0] || d.overflowed[1];
				}
			});
	
		});
	
	}))}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! nouislider - 8.5.1 - 2016-04-24 16:00:29 */
	
	(function (factory) {
	
	    if ( true ) {
	
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	    } else if ( typeof exports === 'object' ) {
	
	        // Node/CommonJS
	        module.exports = factory();
	
	    } else {
	
	        // Browser globals
	        window.noUiSlider = factory();
	    }
	
	}(function( ){
	
		'use strict';
	
	
		// Removes duplicates from an array.
		function unique(array) {
			return array.filter(function(a){
				return !this[a] ? this[a] = true : false;
			}, {});
		}
	
		// Round a value to the closest 'to'.
		function closest ( value, to ) {
			return Math.round(value / to) * to;
		}
	
		// Current position of an element relative to the document.
		function offset ( elem ) {
	
		var rect = elem.getBoundingClientRect(),
			doc = elem.ownerDocument,
			docElem = doc.documentElement,
			pageOffset = getPageOffset();
	
			// getBoundingClientRect contains left scroll in Chrome on Android.
			// I haven't found a feature detection that proves this. Worst case
			// scenario on mis-match: the 'tap' feature on horizontal sliders breaks.
			if ( /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) ) {
				pageOffset.x = 0;
			}
	
			return {
				top: rect.top + pageOffset.y - docElem.clientTop,
				left: rect.left + pageOffset.x - docElem.clientLeft
			};
		}
	
		// Checks whether a value is numerical.
		function isNumeric ( a ) {
			return typeof a === 'number' && !isNaN( a ) && isFinite( a );
		}
	
		// Sets a class and removes it after [duration] ms.
		function addClassFor ( element, className, duration ) {
			addClass(element, className);
			setTimeout(function(){
				removeClass(element, className);
			}, duration);
		}
	
		// Limits a value to 0 - 100
		function limit ( a ) {
			return Math.max(Math.min(a, 100), 0);
		}
	
		// Wraps a variable as an array, if it isn't one yet.
		function asArray ( a ) {
			return Array.isArray(a) ? a : [a];
		}
	
		// Counts decimals
		function countDecimals ( numStr ) {
			var pieces = numStr.split(".");
			return pieces.length > 1 ? pieces[1].length : 0;
		}
	
		// http://youmightnotneedjquery.com/#add_class
		function addClass ( el, className ) {
			if ( el.classList ) {
				el.classList.add(className);
			} else {
				el.className += ' ' + className;
			}
		}
	
		// http://youmightnotneedjquery.com/#remove_class
		function removeClass ( el, className ) {
			if ( el.classList ) {
				el.classList.remove(className);
			} else {
				el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
			}
		}
	
		// https://plainjs.com/javascript/attributes/adding-removing-and-testing-for-classes-9/
		function hasClass ( el, className ) {
			return el.classList ? el.classList.contains(className) : new RegExp('\\b' + className + '\\b').test(el.className);
		}
	
		// https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY#Notes
		function getPageOffset ( ) {
	
			var supportPageOffset = window.pageXOffset !== undefined,
				isCSS1Compat = ((document.compatMode || "") === "CSS1Compat"),
				x = supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft,
				y = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
	
			return {
				x: x,
				y: y
			};
		}
	
		// we provide a function to compute constants instead
		// of accessing window.* as soon as the module needs it
		// so that we do not compute anything if not needed
		function getActions ( ) {
	
			// Determine the events to bind. IE11 implements pointerEvents without
			// a prefix, which breaks compatibility with the IE10 implementation.
			return window.navigator.pointerEnabled ? {
				start: 'pointerdown',
				move: 'pointermove',
				end: 'pointerup'
			} : window.navigator.msPointerEnabled ? {
				start: 'MSPointerDown',
				move: 'MSPointerMove',
				end: 'MSPointerUp'
			} : {
				start: 'mousedown touchstart',
				move: 'mousemove touchmove',
				end: 'mouseup touchend'
			};
		}
	
	
	// Value calculation
	
		// Determine the size of a sub-range in relation to a full range.
		function subRangeRatio ( pa, pb ) {
			return (100 / (pb - pa));
		}
	
		// (percentage) How many percent is this value of this range?
		function fromPercentage ( range, value ) {
			return (value * 100) / ( range[1] - range[0] );
		}
	
		// (percentage) Where is this value on this range?
		function toPercentage ( range, value ) {
			return fromPercentage( range, range[0] < 0 ?
				value + Math.abs(range[0]) :
					value - range[0] );
		}
	
		// (value) How much is this percentage on this range?
		function isPercentage ( range, value ) {
			return ((value * ( range[1] - range[0] )) / 100) + range[0];
		}
	
	
	// Range conversion
	
		function getJ ( value, arr ) {
	
			var j = 1;
	
			while ( value >= arr[j] ){
				j += 1;
			}
	
			return j;
		}
	
		// (percentage) Input a value, find where, on a scale of 0-100, it applies.
		function toStepping ( xVal, xPct, value ) {
	
			if ( value >= xVal.slice(-1)[0] ){
				return 100;
			}
	
			var j = getJ( value, xVal ), va, vb, pa, pb;
	
			va = xVal[j-1];
			vb = xVal[j];
			pa = xPct[j-1];
			pb = xPct[j];
	
			return pa + (toPercentage([va, vb], value) / subRangeRatio (pa, pb));
		}
	
		// (value) Input a percentage, find where it is on the specified range.
		function fromStepping ( xVal, xPct, value ) {
	
			// There is no range group that fits 100
			if ( value >= 100 ){
				return xVal.slice(-1)[0];
			}
	
			var j = getJ( value, xPct ), va, vb, pa, pb;
	
			va = xVal[j-1];
			vb = xVal[j];
			pa = xPct[j-1];
			pb = xPct[j];
	
			return isPercentage([va, vb], (value - pa) * subRangeRatio (pa, pb));
		}
	
		// (percentage) Get the step that applies at a certain value.
		function getStep ( xPct, xSteps, snap, value ) {
	
			if ( value === 100 ) {
				return value;
			}
	
			var j = getJ( value, xPct ), a, b;
	
			// If 'snap' is set, steps are used as fixed points on the slider.
			if ( snap ) {
	
				a = xPct[j-1];
				b = xPct[j];
	
				// Find the closest position, a or b.
				if ((value - a) > ((b-a)/2)){
					return b;
				}
	
				return a;
			}
	
			if ( !xSteps[j-1] ){
				return value;
			}
	
			return xPct[j-1] + closest(
				value - xPct[j-1],
				xSteps[j-1]
			);
		}
	
	
	// Entry parsing
	
		function handleEntryPoint ( index, value, that ) {
	
			var percentage;
	
			// Wrap numerical input in an array.
			if ( typeof value === "number" ) {
				value = [value];
			}
	
			// Reject any invalid input, by testing whether value is an array.
			if ( Object.prototype.toString.call( value ) !== '[object Array]' ){
				throw new Error("noUiSlider: 'range' contains invalid value.");
			}
	
			// Covert min/max syntax to 0 and 100.
			if ( index === 'min' ) {
				percentage = 0;
			} else if ( index === 'max' ) {
				percentage = 100;
			} else {
				percentage = parseFloat( index );
			}
	
			// Check for correct input.
			if ( !isNumeric( percentage ) || !isNumeric( value[0] ) ) {
				throw new Error("noUiSlider: 'range' value isn't numeric.");
			}
	
			// Store values.
			that.xPct.push( percentage );
			that.xVal.push( value[0] );
	
			// NaN will evaluate to false too, but to keep
			// logging clear, set step explicitly. Make sure
			// not to override the 'step' setting with false.
			if ( !percentage ) {
				if ( !isNaN( value[1] ) ) {
					that.xSteps[0] = value[1];
				}
			} else {
				that.xSteps.push( isNaN(value[1]) ? false : value[1] );
			}
		}
	
		function handleStepPoint ( i, n, that ) {
	
			// Ignore 'false' stepping.
			if ( !n ) {
				return true;
			}
	
			// Factor to range ratio
			that.xSteps[i] = fromPercentage([
				 that.xVal[i]
				,that.xVal[i+1]
			], n) / subRangeRatio (
				that.xPct[i],
				that.xPct[i+1] );
		}
	
	
	// Interface
	
		// The interface to Spectrum handles all direction-based
		// conversions, so the above values are unaware.
	
		function Spectrum ( entry, snap, direction, singleStep ) {
	
			this.xPct = [];
			this.xVal = [];
			this.xSteps = [ singleStep || false ];
			this.xNumSteps = [ false ];
	
			this.snap = snap;
			this.direction = direction;
	
			var index, ordered = [ /* [0, 'min'], [1, '50%'], [2, 'max'] */ ];
	
			// Map the object keys to an array.
			for ( index in entry ) {
				if ( entry.hasOwnProperty(index) ) {
					ordered.push([entry[index], index]);
				}
			}
	
			// Sort all entries by value (numeric sort).
			if ( ordered.length && typeof ordered[0][0] === "object" ) {
				ordered.sort(function(a, b) { return a[0][0] - b[0][0]; });
			} else {
				ordered.sort(function(a, b) { return a[0] - b[0]; });
			}
	
	
			// Convert all entries to subranges.
			for ( index = 0; index < ordered.length; index++ ) {
				handleEntryPoint(ordered[index][1], ordered[index][0], this);
			}
	
			// Store the actual step values.
			// xSteps is sorted in the same order as xPct and xVal.
			this.xNumSteps = this.xSteps.slice(0);
	
			// Convert all numeric steps to the percentage of the subrange they represent.
			for ( index = 0; index < this.xNumSteps.length; index++ ) {
				handleStepPoint(index, this.xNumSteps[index], this);
			}
		}
	
		Spectrum.prototype.getMargin = function ( value ) {
			return this.xPct.length === 2 ? fromPercentage(this.xVal, value) : false;
		};
	
		Spectrum.prototype.toStepping = function ( value ) {
	
			value = toStepping( this.xVal, this.xPct, value );
	
			// Invert the value if this is a right-to-left slider.
			if ( this.direction ) {
				value = 100 - value;
			}
	
			return value;
		};
	
		Spectrum.prototype.fromStepping = function ( value ) {
	
			// Invert the value if this is a right-to-left slider.
			if ( this.direction ) {
				value = 100 - value;
			}
	
			return fromStepping( this.xVal, this.xPct, value );
		};
	
		Spectrum.prototype.getStep = function ( value ) {
	
			// Find the proper step for rtl sliders by search in inverse direction.
			// Fixes issue #262.
			if ( this.direction ) {
				value = 100 - value;
			}
	
			value = getStep(this.xPct, this.xSteps, this.snap, value );
	
			if ( this.direction ) {
				value = 100 - value;
			}
	
			return value;
		};
	
		Spectrum.prototype.getApplicableStep = function ( value ) {
	
			// If the value is 100%, return the negative step twice.
			var j = getJ(value, this.xPct), offset = value === 100 ? 2 : 1;
			return [this.xNumSteps[j-2], this.xVal[j-offset], this.xNumSteps[j-offset]];
		};
	
		// Outside testing
		Spectrum.prototype.convert = function ( value ) {
			return this.getStep(this.toStepping(value));
		};
	
	/*	Every input option is tested and parsed. This'll prevent
		endless validation in internal methods. These tests are
		structured with an item for every option available. An
		option can be marked as required by setting the 'r' flag.
		The testing function is provided with three arguments:
			- The provided value for the option;
			- A reference to the options object;
			- The name for the option;
	
		The testing function returns false when an error is detected,
		or true when everything is OK. It can also modify the option
		object, to make sure all values can be correctly looped elsewhere. */
	
		var defaultFormatter = { 'to': function( value ){
			return value !== undefined && value.toFixed(2);
		}, 'from': Number };
	
		function testStep ( parsed, entry ) {
	
			if ( !isNumeric( entry ) ) {
				throw new Error("noUiSlider: 'step' is not numeric.");
			}
	
			// The step option can still be used to set stepping
			// for linear sliders. Overwritten if set in 'range'.
			parsed.singleStep = entry;
		}
	
		function testRange ( parsed, entry ) {
	
			// Filter incorrect input.
			if ( typeof entry !== 'object' || Array.isArray(entry) ) {
				throw new Error("noUiSlider: 'range' is not an object.");
			}
	
			// Catch missing start or end.
			if ( entry.min === undefined || entry.max === undefined ) {
				throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
			}
	
			// Catch equal start or end.
			if ( entry.min === entry.max ) {
				throw new Error("noUiSlider: 'range' 'min' and 'max' cannot be equal.");
			}
	
			parsed.spectrum = new Spectrum(entry, parsed.snap, parsed.dir, parsed.singleStep);
		}
	
		function testStart ( parsed, entry ) {
	
			entry = asArray(entry);
	
			// Validate input. Values aren't tested, as the public .val method
			// will always provide a valid location.
			if ( !Array.isArray( entry ) || !entry.length || entry.length > 2 ) {
				throw new Error("noUiSlider: 'start' option is incorrect.");
			}
	
			// Store the number of handles.
			parsed.handles = entry.length;
	
			// When the slider is initialized, the .val method will
			// be called with the start options.
			parsed.start = entry;
		}
	
		function testSnap ( parsed, entry ) {
	
			// Enforce 100% stepping within subranges.
			parsed.snap = entry;
	
			if ( typeof entry !== 'boolean' ){
				throw new Error("noUiSlider: 'snap' option must be a boolean.");
			}
		}
	
		function testAnimate ( parsed, entry ) {
	
			// Enforce 100% stepping within subranges.
			parsed.animate = entry;
	
			if ( typeof entry !== 'boolean' ){
				throw new Error("noUiSlider: 'animate' option must be a boolean.");
			}
		}
	
		function testAnimationDuration ( parsed, entry ) {
	
			parsed.animationDuration = entry;
	
			if ( typeof entry !== 'number' ){
				throw new Error("noUiSlider: 'animationDuration' option must be a number.");
			}
		}
	
		function testConnect ( parsed, entry ) {
	
			if ( entry === 'lower' && parsed.handles === 1 ) {
				parsed.connect = 1;
			} else if ( entry === 'upper' && parsed.handles === 1 ) {
				parsed.connect = 2;
			} else if ( entry === true && parsed.handles === 2 ) {
				parsed.connect = 3;
			} else if ( entry === false ) {
				parsed.connect = 0;
			} else {
				throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
			}
		}
	
		function testOrientation ( parsed, entry ) {
	
			// Set orientation to an a numerical value for easy
			// array selection.
			switch ( entry ){
			  case 'horizontal':
				parsed.ort = 0;
				break;
			  case 'vertical':
				parsed.ort = 1;
				break;
			  default:
				throw new Error("noUiSlider: 'orientation' option is invalid.");
			}
		}
	
		function testMargin ( parsed, entry ) {
	
			if ( !isNumeric(entry) ){
				throw new Error("noUiSlider: 'margin' option must be numeric.");
			}
	
			// Issue #582
			if ( entry === 0 ) {
				return;
			}
	
			parsed.margin = parsed.spectrum.getMargin(entry);
	
			if ( !parsed.margin ) {
				throw new Error("noUiSlider: 'margin' option is only supported on linear sliders.");
			}
		}
	
		function testLimit ( parsed, entry ) {
	
			if ( !isNumeric(entry) ){
				throw new Error("noUiSlider: 'limit' option must be numeric.");
			}
	
			parsed.limit = parsed.spectrum.getMargin(entry);
	
			if ( !parsed.limit ) {
				throw new Error("noUiSlider: 'limit' option is only supported on linear sliders.");
			}
		}
	
		function testDirection ( parsed, entry ) {
	
			// Set direction as a numerical value for easy parsing.
			// Invert connection for RTL sliders, so that the proper
			// handles get the connect/background classes.
			switch ( entry ) {
			  case 'ltr':
				parsed.dir = 0;
				break;
			  case 'rtl':
				parsed.dir = 1;
				parsed.connect = [0,2,1,3][parsed.connect];
				break;
			  default:
				throw new Error("noUiSlider: 'direction' option was not recognized.");
			}
		}
	
		function testBehaviour ( parsed, entry ) {
	
			// Make sure the input is a string.
			if ( typeof entry !== 'string' ) {
				throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
			}
	
			// Check if the string contains any keywords.
			// None are required.
			var tap = entry.indexOf('tap') >= 0,
				drag = entry.indexOf('drag') >= 0,
				fixed = entry.indexOf('fixed') >= 0,
				snap = entry.indexOf('snap') >= 0,
				hover = entry.indexOf('hover') >= 0;
	
			// Fix #472
			if ( drag && !parsed.connect ) {
				throw new Error("noUiSlider: 'drag' behaviour must be used with 'connect': true.");
			}
	
			parsed.events = {
				tap: tap || snap,
				drag: drag,
				fixed: fixed,
				snap: snap,
				hover: hover
			};
		}
	
		function testTooltips ( parsed, entry ) {
	
			var i;
	
			if ( entry === false ) {
				return;
			} else if ( entry === true ) {
	
				parsed.tooltips = [];
	
				for ( i = 0; i < parsed.handles; i++ ) {
					parsed.tooltips.push(true);
				}
	
			} else {
	
				parsed.tooltips = asArray(entry);
	
				if ( parsed.tooltips.length !== parsed.handles ) {
					throw new Error("noUiSlider: must pass a formatter for all handles.");
				}
	
				parsed.tooltips.forEach(function(formatter){
					if ( typeof formatter !== 'boolean' && (typeof formatter !== 'object' || typeof formatter.to !== 'function') ) {
						throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
					}
				});
			}
		}
	
		function testFormat ( parsed, entry ) {
	
			parsed.format = entry;
	
			// Any object with a to and from method is supported.
			if ( typeof entry.to === 'function' && typeof entry.from === 'function' ) {
				return true;
			}
	
			throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
		}
	
		function testCssPrefix ( parsed, entry ) {
	
			if ( entry !== undefined && typeof entry !== 'string' && entry !== false ) {
				throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
			}
	
			parsed.cssPrefix = entry;
		}
	
		function testCssClasses ( parsed, entry ) {
	
			if ( entry !== undefined && typeof entry !== 'object' ) {
				throw new Error("noUiSlider: 'cssClasses' must be an object.");
			}
	
			if ( typeof parsed.cssPrefix === 'string' ) {
				parsed.cssClasses = {};
	
				for ( var key in entry ) {
					if ( !entry.hasOwnProperty(key) ) { continue; }
	
					parsed.cssClasses[key] = parsed.cssPrefix + entry[key];
				}
			} else {
				parsed.cssClasses = entry;
			}
		}
	
		// Test all developer settings and parse to assumption-safe values.
		function testOptions ( options ) {
	
			// To prove a fix for #537, freeze options here.
			// If the object is modified, an error will be thrown.
			// Object.freeze(options);
	
			var parsed = {
				margin: 0,
				limit: 0,
				animate: true,
				animationDuration: 300,
				format: defaultFormatter
			}, tests;
	
			// Tests are executed in the order they are presented here.
			tests = {
				'step': { r: false, t: testStep },
				'start': { r: true, t: testStart },
				'connect': { r: true, t: testConnect },
				'direction': { r: true, t: testDirection },
				'snap': { r: false, t: testSnap },
				'animate': { r: false, t: testAnimate },
				'animationDuration': { r: false, t: testAnimationDuration },
				'range': { r: true, t: testRange },
				'orientation': { r: false, t: testOrientation },
				'margin': { r: false, t: testMargin },
				'limit': { r: false, t: testLimit },
				'behaviour': { r: true, t: testBehaviour },
				'format': { r: false, t: testFormat },
				'tooltips': { r: false, t: testTooltips },
				'cssPrefix': { r: false, t: testCssPrefix },
				'cssClasses': { r: false, t: testCssClasses }
			};
	
			var defaults = {
				'connect': false,
				'direction': 'ltr',
				'behaviour': 'tap',
				'orientation': 'horizontal',
				'cssPrefix' : 'noUi-',
				'cssClasses': {
					target: 'target',
					base: 'base',
					origin: 'origin',
					handle: 'handle',
					handleLower: 'handle-lower',
					handleUpper: 'handle-upper',
					horizontal: 'horizontal',
					vertical: 'vertical',
					background: 'background',
					connect: 'connect',
					ltr: 'ltr',
					rtl: 'rtl',
					draggable: 'draggable',
					drag: 'state-drag',
					tap: 'state-tap',
					active: 'active',
					stacking: 'stacking',
					tooltip: 'tooltip',
					pips: 'pips',
					pipsHorizontal: 'pips-horizontal',
					pipsVertical: 'pips-vertical',
					marker: 'marker',
					markerHorizontal: 'marker-horizontal',
					markerVertical: 'marker-vertical',
					markerNormal: 'marker-normal',
					markerLarge: 'marker-large',
					markerSub: 'marker-sub',
					value: 'value',
					valueHorizontal: 'value-horizontal',
					valueVertical: 'value-vertical',
					valueNormal: 'value-normal',
					valueLarge: 'value-large',
					valueSub: 'value-sub'
				}
			};
	
			// Run all options through a testing mechanism to ensure correct
			// input. It should be noted that options might get modified to
			// be handled properly. E.g. wrapping integers in arrays.
			Object.keys(tests).forEach(function( name ){
	
				// If the option isn't set, but it is required, throw an error.
				if ( options[name] === undefined && defaults[name] === undefined ) {
	
					if ( tests[name].r ) {
						throw new Error("noUiSlider: '" + name + "' is required.");
					}
	
					return true;
				}
	
				tests[name].t( parsed, options[name] === undefined ? defaults[name] : options[name] );
			});
	
			// Forward pips options
			parsed.pips = options.pips;
	
			// Pre-define the styles.
			parsed.style = parsed.ort ? 'top' : 'left';
	
			return parsed;
		}
	
	
	function closure ( target, options, originalOptions ){
		var
			actions = getActions( ),
			// All variables local to 'closure' are prefixed with 'scope_'
			scope_Target = target,
			scope_Locations = [-1, -1],
			scope_Base,
			scope_Handles,
			scope_Spectrum = options.spectrum,
			scope_Values = [],
			scope_Events = {},
			scope_Self;
	
	
		// Delimit proposed values for handle positions.
		function getPositions ( a, b, delimit ) {
	
			// Add movement to current position.
			var c = a + b[0], d = a + b[1];
	
			// Only alter the other position on drag,
			// not on standard sliding.
			if ( delimit ) {
				if ( c < 0 ) {
					d += Math.abs(c);
				}
				if ( d > 100 ) {
					c -= ( d - 100 );
				}
	
				// Limit values to 0 and 100.
				return [limit(c), limit(d)];
			}
	
			return [c,d];
		}
	
		// Provide a clean event with standardized offset values.
		function fixEvent ( e, pageOffset ) {
	
			// Prevent scrolling and panning on touch events, while
			// attempting to slide. The tap event also depends on this.
			e.preventDefault();
	
			// Filter the event to register the type, which can be
			// touch, mouse or pointer. Offset changes need to be
			// made on an event specific basis.
			var touch = e.type.indexOf('touch') === 0,
				mouse = e.type.indexOf('mouse') === 0,
				pointer = e.type.indexOf('pointer') === 0,
				x,y, event = e;
	
			// IE10 implemented pointer events with a prefix;
			if ( e.type.indexOf('MSPointer') === 0 ) {
				pointer = true;
			}
	
			if ( touch ) {
				// noUiSlider supports one movement at a time,
				// so we can select the first 'changedTouch'.
				x = e.changedTouches[0].pageX;
				y = e.changedTouches[0].pageY;
			}
	
			pageOffset = pageOffset || getPageOffset();
	
			if ( mouse || pointer ) {
				x = e.clientX + pageOffset.x;
				y = e.clientY + pageOffset.y;
			}
	
			event.pageOffset = pageOffset;
			event.points = [x, y];
			event.cursor = mouse || pointer; // Fix #435
	
			return event;
		}
	
		// Append a handle to the base.
		function addHandle ( direction, index ) {
	
			var origin = document.createElement('div'),
				handle = document.createElement('div'),
				classModifier = [options.cssClasses.handleLower, options.cssClasses.handleUpper];
	
			if ( direction ) {
				classModifier.reverse();
			}
	
			addClass(handle, options.cssClasses.handle);
			addClass(handle, classModifier[index]);
	
			addClass(origin, options.cssClasses.origin);
			origin.appendChild(handle);
	
			return origin;
		}
	
		// Add the proper connection classes.
		function addConnection ( connect, target, handles ) {
	
			// Apply the required connection classes to the elements
			// that need them. Some classes are made up for several
			// segments listed in the class list, to allow easy
			// renaming and provide a minor compression benefit.
			switch ( connect ) {
				case 1:	addClass(target, options.cssClasses.connect);
						addClass(handles[0], options.cssClasses.background);
						break;
				case 3: addClass(handles[1], options.cssClasses.background);
						/* falls through */
				case 2: addClass(handles[0], options.cssClasses.connect);
						/* falls through */
				case 0: addClass(target, options.cssClasses.background);
						break;
			}
		}
	
		// Add handles to the slider base.
		function addHandles ( nrHandles, direction, base ) {
	
			var index, handles = [];
	
			// Append handles.
			for ( index = 0; index < nrHandles; index += 1 ) {
	
				// Keep a list of all added handles.
				handles.push( base.appendChild(addHandle( direction, index )) );
			}
	
			return handles;
		}
	
		// Initialize a single slider.
		function addSlider ( direction, orientation, target ) {
	
			// Apply classes and data to the target.
			addClass(target, options.cssClasses.target);
	
			if ( direction === 0 ) {
				addClass(target, options.cssClasses.ltr);
			} else {
				addClass(target, options.cssClasses.rtl);
			}
	
			if ( orientation === 0 ) {
				addClass(target, options.cssClasses.horizontal);
			} else {
				addClass(target, options.cssClasses.vertical);
			}
	
			var div = document.createElement('div');
			addClass(div, options.cssClasses.base);
			target.appendChild(div);
			return div;
		}
	
	
		function addTooltip ( handle, index ) {
	
			if ( !options.tooltips[index] ) {
				return false;
			}
	
			var element = document.createElement('div');
			element.className = options.cssClasses.tooltip;
			return handle.firstChild.appendChild(element);
		}
	
		// The tooltips option is a shorthand for using the 'update' event.
		function tooltips ( ) {
	
			if ( options.dir ) {
				options.tooltips.reverse();
			}
	
			// Tooltips are added with options.tooltips in original order.
			var tips = scope_Handles.map(addTooltip);
	
			if ( options.dir ) {
				tips.reverse();
				options.tooltips.reverse();
			}
	
			bindEvent('update', function(f, o, r) {
				if ( tips[o] ) {
					tips[o].innerHTML = options.tooltips[o] === true ? f[o] : options.tooltips[o].to(r[o]);
				}
			});
		}
	
	
		function getGroup ( mode, values, stepped ) {
	
			// Use the range.
			if ( mode === 'range' || mode === 'steps' ) {
				return scope_Spectrum.xVal;
			}
	
			if ( mode === 'count' ) {
	
				// Divide 0 - 100 in 'count' parts.
				var spread = ( 100 / (values-1) ), v, i = 0;
				values = [];
	
				// List these parts and have them handled as 'positions'.
				while ((v=i++*spread) <= 100 ) {
					values.push(v);
				}
	
				mode = 'positions';
			}
	
			if ( mode === 'positions' ) {
	
				// Map all percentages to on-range values.
				return values.map(function( value ){
					return scope_Spectrum.fromStepping( stepped ? scope_Spectrum.getStep( value ) : value );
				});
			}
	
			if ( mode === 'values' ) {
	
				// If the value must be stepped, it needs to be converted to a percentage first.
				if ( stepped ) {
	
					return values.map(function( value ){
	
						// Convert to percentage, apply step, return to value.
						return scope_Spectrum.fromStepping( scope_Spectrum.getStep( scope_Spectrum.toStepping( value ) ) );
					});
	
				}
	
				// Otherwise, we can simply use the values.
				return values;
			}
		}
	
		function generateSpread ( density, mode, group ) {
	
			function safeIncrement(value, increment) {
				// Avoid floating point variance by dropping the smallest decimal places.
				return (value + increment).toFixed(7) / 1;
			}
	
			var originalSpectrumDirection = scope_Spectrum.direction,
				indexes = {},
				firstInRange = scope_Spectrum.xVal[0],
				lastInRange = scope_Spectrum.xVal[scope_Spectrum.xVal.length-1],
				ignoreFirst = false,
				ignoreLast = false,
				prevPct = 0;
	
			// This function loops the spectrum in an ltr linear fashion,
			// while the toStepping method is direction aware. Trick it into
			// believing it is ltr.
			scope_Spectrum.direction = 0;
	
			// Create a copy of the group, sort it and filter away all duplicates.
			group = unique(group.slice().sort(function(a, b){ return a - b; }));
	
			// Make sure the range starts with the first element.
			if ( group[0] !== firstInRange ) {
				group.unshift(firstInRange);
				ignoreFirst = true;
			}
	
			// Likewise for the last one.
			if ( group[group.length - 1] !== lastInRange ) {
				group.push(lastInRange);
				ignoreLast = true;
			}
	
			group.forEach(function ( current, index ) {
	
				// Get the current step and the lower + upper positions.
				var step, i, q,
					low = current,
					high = group[index+1],
					newPct, pctDifference, pctPos, type,
					steps, realSteps, stepsize;
	
				// When using 'steps' mode, use the provided steps.
				// Otherwise, we'll step on to the next subrange.
				if ( mode === 'steps' ) {
					step = scope_Spectrum.xNumSteps[ index ];
				}
	
				// Default to a 'full' step.
				if ( !step ) {
					step = high-low;
				}
	
				// Low can be 0, so test for false. If high is undefined,
				// we are at the last subrange. Index 0 is already handled.
				if ( low === false || high === undefined ) {
					return;
				}
	
				// Find all steps in the subrange.
				for ( i = low; i <= high; i = safeIncrement(i, step) ) {
	
					// Get the percentage value for the current step,
					// calculate the size for the subrange.
					newPct = scope_Spectrum.toStepping( i );
					pctDifference = newPct - prevPct;
	
					steps = pctDifference / density;
					realSteps = Math.round(steps);
	
					// This ratio represents the ammount of percentage-space a point indicates.
					// For a density 1 the points/percentage = 1. For density 2, that percentage needs to be re-devided.
					// Round the percentage offset to an even number, then divide by two
					// to spread the offset on both sides of the range.
					stepsize = pctDifference/realSteps;
	
					// Divide all points evenly, adding the correct number to this subrange.
					// Run up to <= so that 100% gets a point, event if ignoreLast is set.
					for ( q = 1; q <= realSteps; q += 1 ) {
	
						// The ratio between the rounded value and the actual size might be ~1% off.
						// Correct the percentage offset by the number of points
						// per subrange. density = 1 will result in 100 points on the
						// full range, 2 for 50, 4 for 25, etc.
						pctPos = prevPct + ( q * stepsize );
						indexes[pctPos.toFixed(5)] = ['x', 0];
					}
	
					// Determine the point type.
					type = (group.indexOf(i) > -1) ? 1 : ( mode === 'steps' ? 2 : 0 );
	
					// Enforce the 'ignoreFirst' option by overwriting the type for 0.
					if ( !index && ignoreFirst ) {
						type = 0;
					}
	
					if ( !(i === high && ignoreLast)) {
						// Mark the 'type' of this point. 0 = plain, 1 = real value, 2 = step value.
						indexes[newPct.toFixed(5)] = [i, type];
					}
	
					// Update the percentage count.
					prevPct = newPct;
				}
			});
	
			// Reset the spectrum.
			scope_Spectrum.direction = originalSpectrumDirection;
	
			return indexes;
		}
	
		function addMarking ( spread, filterFunc, formatter ) {
	
			var element = document.createElement('div'),
				out = '',
				valueSizeClasses = [
					options.cssClasses.valueNormal,
					options.cssClasses.valueLarge,
					options.cssClasses.valueSub
				],
				markerSizeClasses = [
					options.cssClasses.markerNormal,
					options.cssClasses.markerLarge,
					options.cssClasses.markerSub
				],
				valueOrientationClasses = [
					options.cssClasses.valueHorizontal,
					options.cssClasses.valueVertical
				],
				markerOrientationClasses = [
					options.cssClasses.markerHorizontal,
					options.cssClasses.markerVertical
				];
	
			addClass(element, options.cssClasses.pips);
			addClass(element, options.ort === 0 ? options.cssClasses.pipsHorizontal : options.cssClasses.pipsVertical);
	
			function getClasses( type, source ){
				var a = source === options.cssClasses.value,
					orientationClasses = a ? valueOrientationClasses : markerOrientationClasses,
					sizeClasses = a ? valueSizeClasses : markerSizeClasses;
	
				return source + ' ' + orientationClasses[options.ort] + ' ' + sizeClasses[type];
			}
	
			function getTags( offset, source, values ) {
				return 'class="' + getClasses(values[1], source) + '" style="' + options.style + ': ' + offset + '%"';
			}
	
			function addSpread ( offset, values ){
	
				if ( scope_Spectrum.direction ) {
					offset = 100 - offset;
				}
	
				// Apply the filter function, if it is set.
				values[1] = (values[1] && filterFunc) ? filterFunc(values[0], values[1]) : values[1];
	
				// Add a marker for every point
				out += '<div ' + getTags(offset, options.cssClasses.marker, values) + '></div>';
	
				// Values are only appended for points marked '1' or '2'.
				if ( values[1] ) {
					out += '<div ' + getTags(offset, options.cssClasses.value, values) + '>' + formatter.to(values[0]) + '</div>';
				}
			}
	
			// Append all points.
			Object.keys(spread).forEach(function(a){
				addSpread(a, spread[a]);
			});
	
			element.innerHTML = out;
	
			return element;
		}
	
		function pips ( grid ) {
	
		var mode = grid.mode,
			density = grid.density || 1,
			filter = grid.filter || false,
			values = grid.values || false,
			stepped = grid.stepped || false,
			group = getGroup( mode, values, stepped ),
			spread = generateSpread( density, mode, group ),
			format = grid.format || {
				to: Math.round
			};
	
			return scope_Target.appendChild(addMarking(
				spread,
				filter,
				format
			));
		}
	
	
		// Shorthand for base dimensions.
		function baseSize ( ) {
			var rect = scope_Base.getBoundingClientRect(), alt = 'offset' + ['Width', 'Height'][options.ort];
			return options.ort === 0 ? (rect.width||scope_Base[alt]) : (rect.height||scope_Base[alt]);
		}
	
		// External event handling
		function fireEvent ( event, handleNumber, tap ) {
	
			var i;
	
			// During initialization, do not fire events.
			for ( i = 0; i < options.handles; i++ ) {
				if ( scope_Locations[i] === -1 ) {
					return;
				}
			}
	
			if ( handleNumber !== undefined && options.handles !== 1 ) {
				handleNumber = Math.abs(handleNumber - options.dir);
			}
	
			Object.keys(scope_Events).forEach(function( targetEvent ) {
	
				var eventType = targetEvent.split('.')[0];
	
				if ( event === eventType ) {
					scope_Events[targetEvent].forEach(function( callback ) {
	
						callback.call(
							// Use the slider public API as the scope ('this')
							scope_Self,
							// Return values as array, so arg_1[arg_2] is always valid.
							asArray(valueGet()),
							// Handle index, 0 or 1
							handleNumber,
							// Unformatted slider values
							asArray(inSliderOrder(Array.prototype.slice.call(scope_Values))),
							// Event is fired by tap, true or false
							tap || false,
							// Left offset of the handle, in relation to the slider
							scope_Locations
						);
					});
				}
			});
		}
	
		// Returns the input array, respecting the slider direction configuration.
		function inSliderOrder ( values ) {
	
			// If only one handle is used, return a single value.
			if ( values.length === 1 ){
				return values[0];
			}
	
			if ( options.dir ) {
				return values.reverse();
			}
	
			return values;
		}
	
	
		// Handler for attaching events trough a proxy.
		function attach ( events, element, callback, data ) {
	
			// This function can be used to 'filter' events to the slider.
			// element is a node, not a nodeList
	
			var method = function ( e ){
	
				if ( scope_Target.hasAttribute('disabled') ) {
					return false;
				}
	
				// Stop if an active 'tap' transition is taking place.
				if ( hasClass(scope_Target, options.cssClasses.tap) ) {
					return false;
				}
	
				e = fixEvent(e, data.pageOffset);
	
				// Ignore right or middle clicks on start #454
				if ( events === actions.start && e.buttons !== undefined && e.buttons > 1 ) {
					return false;
				}
	
				// Ignore right or middle clicks on start #454
				if ( data.hover && e.buttons ) {
					return false;
				}
	
				e.calcPoint = e.points[ options.ort ];
	
				// Call the event handler with the event [ and additional data ].
				callback ( e, data );
	
			}, methods = [];
	
			// Bind a closure on the target for every event type.
			events.split(' ').forEach(function( eventName ){
				element.addEventListener(eventName, method, false);
				methods.push([eventName, method]);
			});
	
			return methods;
		}
	
		// Handle movement on document for handle and range drag.
		function move ( event, data ) {
	
			// Fix #498
			// Check value of .buttons in 'start' to work around a bug in IE10 mobile (data.buttonsProperty).
			// https://connect.microsoft.com/IE/feedback/details/927005/mobile-ie10-windows-phone-buttons-property-of-pointermove-event-always-zero
			// IE9 has .buttons and .which zero on mousemove.
			// Firefox breaks the spec MDN defines.
			if ( navigator.appVersion.indexOf("MSIE 9") === -1 && event.buttons === 0 && data.buttonsProperty !== 0 ) {
				return end(event, data);
			}
	
			var handles = data.handles || scope_Handles, positions, state = false,
				proposal = ((event.calcPoint - data.start) * 100) / data.baseSize,
				handleNumber = handles[0] === scope_Handles[0] ? 0 : 1, i;
	
			// Calculate relative positions for the handles.
			positions = getPositions( proposal, data.positions, handles.length > 1);
	
			state = setHandle ( handles[0], positions[handleNumber], handles.length === 1 );
	
			if ( handles.length > 1 ) {
	
				state = setHandle ( handles[1], positions[handleNumber?0:1], false ) || state;
	
				if ( state ) {
					// fire for both handles
					for ( i = 0; i < data.handles.length; i++ ) {
						fireEvent('slide', i);
					}
				}
			} else if ( state ) {
				// Fire for a single handle
				fireEvent('slide', handleNumber);
			}
		}
	
		// Unbind move events on document, call callbacks.
		function end ( event, data ) {
	
			// The handle is no longer active, so remove the class.
			var active = scope_Base.querySelector( '.' + options.cssClasses.active ),
				handleNumber = data.handles[0] === scope_Handles[0] ? 0 : 1;
	
			if ( active !== null ) {
				removeClass(active, options.cssClasses.active);
			}
	
			// Remove cursor styles and text-selection events bound to the body.
			if ( event.cursor ) {
				document.body.style.cursor = '';
				document.body.removeEventListener('selectstart', document.body.noUiListener);
			}
	
			var d = document.documentElement;
	
			// Unbind the move and end events, which are added on 'start'.
			d.noUiListeners.forEach(function( c ) {
				d.removeEventListener(c[0], c[1]);
			});
	
			// Remove dragging class.
			removeClass(scope_Target, options.cssClasses.drag);
	
			// Fire the change and set events.
			fireEvent('set', handleNumber);
			fireEvent('change', handleNumber);
	
			// If this is a standard handle movement, fire the end event.
			if ( data.handleNumber !== undefined ) {
				fireEvent('end', data.handleNumber);
			}
		}
	
		// Fire 'end' when a mouse or pen leaves the document.
		function documentLeave ( event, data ) {
			if ( event.type === "mouseout" && event.target.nodeName === "HTML" && event.relatedTarget === null ){
				end ( event, data );
			}
		}
	
		// Bind move events on document.
		function start ( event, data ) {
	
			var d = document.documentElement;
	
			// Mark the handle as 'active' so it can be styled.
			if ( data.handles.length === 1 ) {
				// Support 'disabled' handles
				if ( data.handles[0].hasAttribute('disabled') ) {
					return false;
				}
	
				addClass(data.handles[0].children[0], options.cssClasses.active);
			}
	
			// Fix #551, where a handle gets selected instead of dragged.
			event.preventDefault();
	
			// A drag should never propagate up to the 'tap' event.
			event.stopPropagation();
	
			// Attach the move and end events.
			var moveEvent = attach(actions.move, d, move, {
				start: event.calcPoint,
				baseSize: baseSize(),
				pageOffset: event.pageOffset,
				handles: data.handles,
				handleNumber: data.handleNumber,
				buttonsProperty: event.buttons,
				positions: [
					scope_Locations[0],
					scope_Locations[scope_Handles.length - 1]
				]
			}), endEvent = attach(actions.end, d, end, {
				handles: data.handles,
				handleNumber: data.handleNumber
			});
	
			var outEvent = attach("mouseout", d, documentLeave, {
				handles: data.handles,
				handleNumber: data.handleNumber
			});
	
			d.noUiListeners = moveEvent.concat(endEvent, outEvent);
	
			// Text selection isn't an issue on touch devices,
			// so adding cursor styles can be skipped.
			if ( event.cursor ) {
	
				// Prevent the 'I' cursor and extend the range-drag cursor.
				document.body.style.cursor = getComputedStyle(event.target).cursor;
	
				// Mark the target with a dragging state.
				if ( scope_Handles.length > 1 ) {
					addClass(scope_Target, options.cssClasses.drag);
				}
	
				var f = function(){
					return false;
				};
	
				document.body.noUiListener = f;
	
				// Prevent text selection when dragging the handles.
				document.body.addEventListener('selectstart', f, false);
			}
	
			if ( data.handleNumber !== undefined ) {
				fireEvent('start', data.handleNumber);
			}
		}
	
		// Move closest handle to tapped location.
		function tap ( event ) {
	
			var location = event.calcPoint, total = 0, handleNumber, to;
	
			// The tap event shouldn't propagate up and cause 'edge' to run.
			event.stopPropagation();
	
			// Add up the handle offsets.
			scope_Handles.forEach(function(a){
				total += offset(a)[ options.style ];
			});
	
			// Find the handle closest to the tapped position.
			handleNumber = ( location < total/2 || scope_Handles.length === 1 ) ? 0 : 1;
	
			// Check if handler is not disablet if yes set number to the next handler
			if (scope_Handles[handleNumber].hasAttribute('disabled')) {
				handleNumber = handleNumber ? 0 : 1;
			}
	
			location -= offset(scope_Base)[ options.style ];
	
			// Calculate the new position.
			to = ( location * 100 ) / baseSize();
	
			if ( !options.events.snap ) {
				// Flag the slider as it is now in a transitional state.
				// Transition takes a configurable amount of ms (default 300). Re-enable the slider after that.
				addClassFor( scope_Target, options.cssClasses.tap, options.animationDuration );
			}
	
			// Support 'disabled' handles
			if ( scope_Handles[handleNumber].hasAttribute('disabled') ) {
				return false;
			}
	
			// Find the closest handle and calculate the tapped point.
			// The set handle to the new position.
			setHandle( scope_Handles[handleNumber], to );
	
			fireEvent('slide', handleNumber, true);
			fireEvent('set', handleNumber, true);
			fireEvent('change', handleNumber, true);
	
			if ( options.events.snap ) {
				start(event, { handles: [scope_Handles[handleNumber]] });
			}
		}
	
		// Fires a 'hover' event for a hovered mouse/pen position.
		function hover ( event ) {
	
			var location = event.calcPoint - offset(scope_Base)[ options.style ],
				to = scope_Spectrum.getStep(( location * 100 ) / baseSize()),
				value = scope_Spectrum.fromStepping( to );
	
			Object.keys(scope_Events).forEach(function( targetEvent ) {
				if ( 'hover' === targetEvent.split('.')[0] ) {
					scope_Events[targetEvent].forEach(function( callback ) {
						callback.call( scope_Self, value );
					});
				}
			});
		}
	
		// Attach events to several slider parts.
		function events ( behaviour ) {
	
			// Attach the standard drag event to the handles.
			if ( !behaviour.fixed ) {
	
				scope_Handles.forEach(function( handle, index ){
	
					// These events are only bound to the visual handle
					// element, not the 'real' origin element.
					attach ( actions.start, handle.children[0], start, {
						handles: [ handle ],
						handleNumber: index
					});
				});
			}
	
			// Attach the tap event to the slider base.
			if ( behaviour.tap ) {
	
				attach ( actions.start, scope_Base, tap, {
					handles: scope_Handles
				});
			}
	
			// Fire hover events
			if ( behaviour.hover ) {
				attach ( actions.move, scope_Base, hover, { hover: true } );
			}
	
			// Make the range draggable.
			if ( behaviour.drag ){
	
				var drag = [scope_Base.querySelector( '.' + options.cssClasses.connect )];
				addClass(drag[0], options.cssClasses.draggable);
	
				// When the range is fixed, the entire range can
				// be dragged by the handles. The handle in the first
				// origin will propagate the start event upward,
				// but it needs to be bound manually on the other.
				if ( behaviour.fixed ) {
					drag.push(scope_Handles[(drag[0] === scope_Handles[0] ? 1 : 0)].children[0]);
				}
	
				drag.forEach(function( element ) {
					attach ( actions.start, element, start, {
						handles: scope_Handles
					});
				});
			}
		}
	
	
		// Test suggested values and apply margin, step.
		function setHandle ( handle, to, noLimitOption ) {
	
			var trigger = handle !== scope_Handles[0] ? 1 : 0,
				lowerMargin = scope_Locations[0] + options.margin,
				upperMargin = scope_Locations[1] - options.margin,
				lowerLimit = scope_Locations[0] + options.limit,
				upperLimit = scope_Locations[1] - options.limit;
	
			// For sliders with multiple handles,
			// limit movement to the other handle.
			// Apply the margin option by adding it to the handle positions.
			if ( scope_Handles.length > 1 ) {
				to = trigger ? Math.max( to, lowerMargin ) : Math.min( to, upperMargin );
			}
	
			// The limit option has the opposite effect, limiting handles to a
			// maximum distance from another. Limit must be > 0, as otherwise
			// handles would be unmoveable. 'noLimitOption' is set to 'false'
			// for the .val() method, except for pass 4/4.
			if ( noLimitOption !== false && options.limit && scope_Handles.length > 1 ) {
				to = trigger ? Math.min ( to, lowerLimit ) : Math.max( to, upperLimit );
			}
	
			// Handle the step option.
			to = scope_Spectrum.getStep( to );
	
			// Limit percentage to the 0 - 100 range
			to = limit(to);
	
			// Return false if handle can't move
			if ( to === scope_Locations[trigger] ) {
				return false;
			}
	
			// Set the handle to the new position.
			// Use requestAnimationFrame for efficient painting.
			// No significant effect in Chrome, Edge sees dramatic
			// performace improvements.
			if ( window.requestAnimationFrame ) {
				window.requestAnimationFrame(function(){
					handle.style[options.style] = to + '%';
				});
			} else {
				handle.style[options.style] = to + '%';
			}
	
			// Force proper handle stacking
			if ( !handle.previousSibling ) {
				removeClass(handle, options.cssClasses.stacking);
				if ( to > 50 ) {
					addClass(handle, options.cssClasses.stacking);
				}
			}
	
			// Update locations.
			scope_Locations[trigger] = to;
	
			// Convert the value to the slider stepping/range.
			scope_Values[trigger] = scope_Spectrum.fromStepping( to );
	
			fireEvent('update', trigger);
	
			return true;
		}
	
		// Loop values from value method and apply them.
		function setValues ( count, values ) {
	
			var i, trigger, to;
	
			// With the limit option, we'll need another limiting pass.
			if ( options.limit ) {
				count += 1;
			}
	
			// If there are multiple handles to be set run the setting
			// mechanism twice for the first handle, to make sure it
			// can be bounced of the second one properly.
			for ( i = 0; i < count; i += 1 ) {
	
				trigger = i%2;
	
				// Get the current argument from the array.
				to = values[trigger];
	
				// Setting with null indicates an 'ignore'.
				// Inputting 'false' is invalid.
				if ( to !== null && to !== false ) {
	
					// If a formatted number was passed, attemt to decode it.
					if ( typeof to === 'number' ) {
						to = String(to);
					}
	
					to = options.format.from( to );
	
					// Request an update for all links if the value was invalid.
					// Do so too if setting the handle fails.
					if ( to === false || isNaN(to) || setHandle( scope_Handles[trigger], scope_Spectrum.toStepping( to ), i === (3 - options.dir) ) === false ) {
						fireEvent('update', trigger);
					}
				}
			}
		}
	
		// Set the slider value.
		function valueSet ( input, fireSetEvent ) {
	
			var count, values = asArray( input ), i;
	
			// Event fires by default
			fireSetEvent = (fireSetEvent === undefined ? true : !!fireSetEvent);
	
			// The RTL settings is implemented by reversing the front-end,
			// internal mechanisms are the same.
			if ( options.dir && options.handles > 1 ) {
				values.reverse();
			}
	
			// Animation is optional.
			// Make sure the initial values where set before using animated placement.
			if ( options.animate && scope_Locations[0] !== -1 ) {
				addClassFor( scope_Target, options.cssClasses.tap, options.animationDuration );
			}
	
			// Determine how often to set the handles.
			count = scope_Handles.length > 1 ? 3 : 1;
	
			if ( values.length === 1 ) {
				count = 1;
			}
	
			setValues ( count, values );
	
			// Fire the 'set' event for both handles.
			for ( i = 0; i < scope_Handles.length; i++ ) {
	
				// Fire the event only for handles that received a new value, as per #579
				if ( values[i] !== null && fireSetEvent ) {
					fireEvent('set', i);
				}
			}
		}
	
		// Get the slider value.
		function valueGet ( ) {
	
			var i, retour = [];
	
			// Get the value from all handles.
			for ( i = 0; i < options.handles; i += 1 ){
				retour[i] = options.format.to( scope_Values[i] );
			}
	
			return inSliderOrder( retour );
		}
	
		// Removes classes from the root and empties it.
		function destroy ( ) {
	
			for ( var key in options.cssClasses ) {
				if ( !options.cssClasses.hasOwnProperty(key) ) { continue; }
				removeClass(scope_Target, options.cssClasses[key]);
			}
	
			while (scope_Target.firstChild) {
				scope_Target.removeChild(scope_Target.firstChild);
			}
	
			delete scope_Target.noUiSlider;
		}
	
		// Get the current step size for the slider.
		function getCurrentStep ( ) {
	
			// Check all locations, map them to their stepping point.
			// Get the step point, then find it in the input list.
			var retour = scope_Locations.map(function( location, index ){
	
				var step = scope_Spectrum.getApplicableStep( location ),
	
					// As per #391, the comparison for the decrement step can have some rounding issues.
					// Round the value to the precision used in the step.
					stepDecimals = countDecimals(String(step[2])),
	
					// Get the current numeric value
					value = scope_Values[index],
	
					// To move the slider 'one step up', the current step value needs to be added.
					// Use null if we are at the maximum slider value.
					increment = location === 100 ? null : step[2],
	
					// Going 'one step down' might put the slider in a different sub-range, so we
					// need to switch between the current or the previous step.
					prev = Number((value - step[2]).toFixed(stepDecimals)),
	
					// If the value fits the step, return the current step value. Otherwise, use the
					// previous step. Return null if the slider is at its minimum value.
					decrement = location === 0 ? null : (prev >= step[1]) ? step[2] : (step[0] || false);
	
				return [decrement, increment];
			});
	
			// Return values in the proper order.
			return inSliderOrder( retour );
		}
	
		// Attach an event to this slider, possibly including a namespace
		function bindEvent ( namespacedEvent, callback ) {
			scope_Events[namespacedEvent] = scope_Events[namespacedEvent] || [];
			scope_Events[namespacedEvent].push(callback);
	
			// If the event bound is 'update,' fire it immediately for all handles.
			if ( namespacedEvent.split('.')[0] === 'update' ) {
				scope_Handles.forEach(function(a, index){
					fireEvent('update', index);
				});
			}
		}
	
		// Undo attachment of event
		function removeEvent ( namespacedEvent ) {
	
			var event = namespacedEvent && namespacedEvent.split('.')[0],
				namespace = event && namespacedEvent.substring(event.length);
	
			Object.keys(scope_Events).forEach(function( bind ){
	
				var tEvent = bind.split('.')[0],
					tNamespace = bind.substring(tEvent.length);
	
				if ( (!event || event === tEvent) && (!namespace || namespace === tNamespace) ) {
					delete scope_Events[bind];
				}
			});
		}
	
		// Updateable: margin, limit, step, range, animate, snap
		function updateOptions ( optionsToUpdate, fireSetEvent ) {
	
			// Spectrum is created using the range, snap, direction and step options.
			// 'snap' and 'step' can be updated, 'direction' cannot, due to event binding.
			// If 'snap' and 'step' are not passed, they should remain unchanged.
			var v = valueGet(), newOptions = testOptions({
				start: [0, 0],
				margin: optionsToUpdate.margin,
				limit: optionsToUpdate.limit,
				step: optionsToUpdate.step === undefined ? options.singleStep : optionsToUpdate.step,
				range: optionsToUpdate.range,
				animate: optionsToUpdate.animate,
				snap: optionsToUpdate.snap === undefined ? options.snap : optionsToUpdate.snap
			});
	
			['margin', 'limit', 'range', 'animate'].forEach(function(name){
	
				// Only change options that we're actually passed to update.
				if ( optionsToUpdate[name] !== undefined ) {
					options[name] = optionsToUpdate[name];
				}
			});
	
			// Save current spectrum direction as testOptions in testRange call
			// doesn't rely on current direction
			newOptions.spectrum.direction = scope_Spectrum.direction;
			scope_Spectrum = newOptions.spectrum;
	
			// Invalidate the current positioning so valueSet forces an update.
			scope_Locations = [-1, -1];
			valueSet(optionsToUpdate.start || v, fireSetEvent);
		}
	
	
		// Throw an error if the slider was already initialized.
		if ( scope_Target.noUiSlider ) {
			throw new Error('Slider was already initialized.');
		}
	
		// Create the base element, initialise HTML and set classes.
		// Add handles and links.
		scope_Base = addSlider( options.dir, options.ort, scope_Target );
		scope_Handles = addHandles( options.handles, options.dir, scope_Base );
	
		// Set the connect classes.
		addConnection ( options.connect, scope_Target, scope_Handles );
	
		if ( options.pips ) {
			pips(options.pips);
		}
	
		if ( options.tooltips ) {
			tooltips();
		}
	
		scope_Self = {
			destroy: destroy,
			steps: getCurrentStep,
			on: bindEvent,
			off: removeEvent,
			get: valueGet,
			set: valueSet,
			updateOptions: updateOptions,
			options: originalOptions, // Issue #600
			target: scope_Target, // Issue #597
			pips: pips // Issue #594
		};
	
		// Attach user events.
		events( options.events );
	
		return scope_Self;
	
	}
	
	
		// Run the standard initializer
		function initialize ( target, originalOptions ) {
	
			if ( !target.nodeName ) {
				throw new Error('noUiSlider.create requires a single element.');
			}
	
			// Test the options and create the slider environment;
			var options = testOptions( originalOptions, target ),
				slider = closure( target, options, originalOptions );
	
			// Use the public value method to set the start values.
			slider.set(options.start);
	
			target.noUiSlider = slider;
			return slider;
		}
	
		// Use an object instead of a function for future expansibility;
		return {
			create: initialize
		};
	
	}));

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _nav = __webpack_require__(42);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _ask = __webpack_require__(43);
	
	var _ask2 = _interopRequireDefault(_ask);
	
	var _region = __webpack_require__(44);
	
	var _region2 = _interopRequireDefault(_region);
	
	var _user = __webpack_require__(48);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class() {
			_classCallCheck(this, _class);
	
			this.$header = (0, _jquery2.default)('#header');
			this.nav = new _nav2.default();
			this.region = new _region2.default();
			this.ask = new _ask2.default();
			this.user = new _user2.default();
			return this;
		}
	
		_createClass(_class, [{
			key: 'render',
			value: function render() {
				if (this.$header.length) {
					this.nav.render();
					this.region.render();
					this.ask.render();
					this.user.render();
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _prefixed = __webpack_require__(10);
	
	var _prefixed2 = _interopRequireDefault(_prefixed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#headerNav',
				dom: {
					item: '.js-nav-item',
					subnav: '.js-subnav',
					subnavItem: '.js-subnav-item',
					subnavLine: '.js-subnav-line'
				},
				classes: {
					current: 'b-header-nav__item_state_current',
					hover: 'b-header-nav__item_state_hover',
					active: 'b-header-nav__item_state_active'
				}
			};
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.enterTimeout = false;
			this.leaveTimeout = false;
			this.$window = (0, _jquery2.default)(window);
			this.hash = false;
			this.prefixed = new _prefixed2.default();
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$item = this.$el.find(this.options.dom.item);
				this.$current = this.$item.filter('.' + this.options.classes.current);
				this.$subnav = this.$current.find(this.options.dom.subnav);
				this.$subnavItem = this.$subnav.find(this.options.dom.subnavItem);
				this.$subnavLine = this.$current.find(this.options.dom.subnavLine);
				return this;
			}
		}, {
			key: 'onMouseenter',
			value: function onMouseenter(event) {
				var self = this;
				var $target = (0, _jquery2.default)(event.currentTarget);
				self.$item.not($target).removeClass(self.options.classes.hover);
				$target.addClass(self.options.classes.hover);
				clearTimeout(self.enterTimeout);
				clearTimeout(self.leaveTimeout);
				if (!$target.hasClass(self.options.classes.active)) {
					self.enterTimeout = setTimeout(function () {
						self.$item.not($target).removeClass(self.options.classes.active);
						$target.addClass(self.options.classes.active);
					}, 250);
				}
			}
		}, {
			key: 'onMouseleave',
			value: function onMouseleave(event) {
				var self = this;
				var $target = (0, _jquery2.default)(event.currentTarget);
				$target.removeClass(self.options.classes.hover);
				clearTimeout(self.enterTimeout);
				clearTimeout(self.leaveTimeout);
				self.leaveTimeout = setTimeout(function () {
					self.$item.not(self.$current).removeClass(self.options.classes.active);
					self.$current.addClass(self.options.classes.active);
				}, 250);
			}
		}, {
			key: 'setLine',
			value: function setLine() {
				if (this.$subnavActive.length && this.$subnavLine.length) {
					var left = this.$subnavActive.offset().left - this.$subnavItem.eq(0).offset().left;
					var width = this.$subnavActive.outerWidth();
					var scale = 1 / 100 * width;
					this.$subnavLine.css(this.prefixed.css.transform, 'translateX(' + left + 'px) scaleX(' + scale + ') translateZ(0px)');
				}
			}
		}, {
			key: 'onHash',
			value: function onHash() {
				var hash = '#' + this.$window.data('hash');
				if (hash !== this.hash) {
					this.hash = hash;
					this.$subnavActive = this.$subnavItem.filter('[href*="' + this.hash + '"]');
					this.setLine();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom();
	
					this.$item.on('mouseenter', this.onMouseenter.bind(this)).on('mouseleave', this.onMouseleave.bind(this));
	
					if (this.$subnav.length && this.$subnavItem.length) {
						this.$subnavActive = this.$subnavItem.first();
						this.$window.on('resize.nav', this.setLine.bind(this)).on('yota.router.hash', this.onHash.bind(this));
					}
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _region = __webpack_require__(44);
	
	var _region2 = _interopRequireDefault(_region);
	
	var _cookie = __webpack_require__(46);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#headerAsk',
				dom: {
					header: '#header',
					layout: '#layout',
					close: '#headerAskClose',
					open: '#headerAskOpen'
				},
				classes: {
					header: 'b-header_state_ask',
					layout: 'b-layout_state_ask'
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$header = (0, _jquery2.default)(this.options.dom.header);
			this.cookie = new _cookie2.default();
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$layout = (0, _jquery2.default)(this.options.dom.layout);
				this.$close = (0, _jquery2.default)(this.options.dom.close);
				this.$open = (0, _jquery2.default)(this.options.dom.open);
				return this;
			}
		}, {
			key: 'close',
			value: function close() {
				this.$header.removeClass(this.options.classes.header);
				this.$layout.removeClass(this.options.classes.layout);
				this.cookie.set('YOTA_CITY_ANSWERED', 1, 365, this.cookie.getDomain());
			}
		}, {
			key: 'open',
			value: function open() {
				var self = this;
				self.$header.removeClass(self.options.classes.header);
				self.$layout.removeClass(self.options.classes.layout);
				this.cookie.set('YOTA_CITY_ANSWERED', 1, 365, this.cookie.getDomain());
				setTimeout(function () {
					self.region.open();
				}, 50);
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$header.length && this.$el.length) {
					this.getDom();
					this.region = new _region2.default();
					this.$close.on('click', this.close.bind(this));
					this.$open.on('click', this.open.bind(this));
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _region = __webpack_require__(45);
	
	var _region2 = _interopRequireDefault(_region);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#headerRegion',
				dom: {
					toggle: '.js-header-region-toggle',
					region: '.js-region',
					input: '.js-region-input',
					current: '.js-header-region-current'
	
				},
				classes: {
					state: {
						open: 'b-header-region_state_open'
					}
				}
			};
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$input = this.$el.find(this.options.dom.input);
			this.$document = (0, _jquery2.default)(document);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$toggle = this.$el.find(this.options.dom.toggle);
				this.$region = this.$el.find(this.options.dom.region);
				this.$current = (0, _jquery2.default)(this.options.dom.current);
				return this;
			}
		}, {
			key: 'onToggle',
			value: function onToggle() {
				this.$el.toggleClass(this.options.classes.state.open);
				if (this.$el.hasClass(this.options.classes.state.open)) {
					this.$input.focus();
				}
			}
		}, {
			key: 'open',
			value: function open() {
				this.$el.addClass(this.options.classes.state.open);
				this.$input.focus();
			}
		}, {
			key: 'close',
			value: function close() {
				this.$el.removeClass(this.options.classes.state.open);
			}
		}, {
			key: 'onDocumentAction',
			value: function onDocumentAction(event) {
				var $target = (0, _jquery2.default)(event.target);
				if (!$target.is(this.$el) && !$target.closest(this.$el).length && this.$el.hasClass(this.options.classes.state.open)) {
					this.close();
				}
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom();
					this.$toggle.on('click', this.onToggle.bind(this));
					this.region = new _region2.default({ el: this.$region }).render();
					this.$document.on('click', this.onDocumentAction.bind(this));
					if (yotaPortlets.region && yotaPortlets.region.name) {
						this.$current.text(yotaPortlets.region.name);
					}
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(27);
	
	var _underscore = __webpack_require__(4);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _cookie = __webpack_require__(46);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _transcriptor = __webpack_require__(47);
	
	var _transcriptor2 = _interopRequireDefault(_transcriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(29)(_jquery2.default);
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-region',
				dom: {
					input: '.js-region-input',
					dropdown: '.js-region-dropdown',
					list: '.js-region-list',
					search: '.js-region-search',
					item: '.js-region-item',
					template: {
						list: '.js-region-list-template',
						search: '.js-region-search-template'
					},
					form: {
						search: {
							el: '.js-region-form-search',
							query: '.js-region-form-search-query'
						},
						set: {
							el: '.js-region-form-set',
							id: '.js-region-form-set-id'
						}
					}
				},
				classes: {
					state: {
						open: 'b-region_state_open',
						search: 'b-region_state_search',
						empty: 'b-region_state_empty',
						load: 'b-region_state_load'
					},
					item: {
						state: {
							active: 'b-region__item_state_active',
							hidden: 'b-region__item_state_hidden'
						}
					}
				},
				size: {
					height: 34,
					count: 7
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.searchQuery = '';
			this.preventSearch = false;
			this.searchInputDebounced = false;
			this.searchInputDebounce = false;
			this.searchLoadDebounce = false;
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.$document = (0, _jquery2.default)(document);
			this.$window = (0, _jquery2.default)(window);
			this.cookie = new _cookie2.default();
			this.transcriptor = new _transcriptor2.default();
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$input = this.$el.find(this.options.dom.input);
				this.$dropdown = this.$el.find(this.options.dom.dropdown);
				this.$list = this.$el.find(this.options.dom.list);
				this.$listItems = this.$list.find(this.options.dom.item);
				this.$search = this.$el.find(this.options.dom.search);
				this.$searchItems = this.$search.find(this.options.dom.item);
				this.$templateList = this.$el.find(this.options.dom.template.list);
				this.$templateSearch = this.$el.find(this.options.dom.template.search);
				this.templateList = _underscore2.default.template(this.$templateList.html().trim());
				this.templateSearch = _underscore2.default.template(this.$templateSearch.html().trim());
				this.$fromSearch = this.$el.find(this.options.dom.form.search.el);
				this.$fromSearchQuery = this.$el.find(this.options.dom.form.search.query);
				this.$fromSet = this.$el.find(this.options.dom.form.set.el);
				this.$fromSetId = this.$el.find(this.options.dom.form.set.id);
				return this;
			}
		}, {
			key: 'setListOptions',
			value: function setListOptions(options) {
				this.$list.html(this.templateList(options));
				this.$listItems = this.$list.find(this.options.dom.item);
				this.$items = this.$listItems;
				return this;
			}
		}, {
			key: 'setSearchOptions',
			value: function setSearchOptions(options) {
				this.$search.html(this.templateSearch({ data: options }));
				this.$searchItems = this.$search.find(this.options.dom.item);
				this.$items = this.$searchItems;
				this.$el.toggleClass(this.options.classes.state.empty, this.$items.length === 0);
				this.$el.addClass(this.options.classes.state.search);
				return this;
			}
		}, {
			key: 'search',
			value: function search(query) {
				var self = this;
				var thisQuery = self.transcriptor.toCyrillic(query);
				self.searchQuery = thisQuery;
				self.$fromSearchQuery.val(thisQuery);
				_jquery2.default.ajax({
					url: self.$fromSearch.attr('action'),
					type: self.$fromSearch.attr('method'),
					data: self.$fromSearch.serialize(),
					dataType: 'json',
					success: function success(json) {
						if (thisQuery === self.searchQuery) {
							self.find(json);
						}
					}
				});
			}
		}, {
			key: 'find',
			value: function find(data) {
				clearTimeout(this.searchLoadDebounce);
				this.setSearchOptions(data);
				this.$el.removeClass(this.options.classes.state.load);
			}
		}, {
			key: 'set',
			value: function set(id) {
				var self = this;
				self.$fromSetId.val(id);
	
				_jquery2.default.ajax({
					url: self.$fromSet.attr('action'),
					type: self.$fromSet.attr('method'),
					data: self.$fromSet.serialize(),
					dataType: 'json',
					success: function success() {
						self.cookie.set('YOTA_CITY_ANSWERED', 1, 365, self.cookie.getDomain());
						location.reload();
					}
				});
			}
		}, {
			key: 'filter',
			value: function filter(query) {
				var self = this;
				var thisQuery = query;
	
				clearTimeout(self.searchInputDebounce);
				clearTimeout(self.searchLoadDebounce);
	
				if (query.length >= 2) {
					self.searchInputDebounce = setTimeout(function () {
						self.searchInputDebounced = false;
						self.searchLoadDebounce = setTimeout(function () {
							self.$el.addClass(self.options.classes.state.load);
						}, self.$searchItems.length > 0 ? 1000 : 50);
						self.search(thisQuery);
					}, self.searchInputDebounced ? 0 : 300);
					self.searchInputDebounced = true;
				} else {
					self.searchQuery = '';
					self.$items = self.$listItems;
					self.$el.removeClass(self.options.classes.state.search).removeClass(self.options.classes.state.empty).removeClass(self.options.classes.state.load);
				}
				return self;
			}
		}, {
			key: 'clear',
			value: function clear() {
				this.filter('');
				this.$input.val('');
				return this;
			}
		}, {
			key: 'open',
			value: function open() {
				this.$el.removeClass(this.options.classes.state.search).removeClass(this.options.classes.state.empty).removeClass(this.options.classes.state.load).addClass(this.options.classes.state.open);
				this.$el.find(this.options.dom.item).removeClass(this.options.classes.item.state.active);
				this.$dropdown.data('position', 0);
				this.$dropdown.mNCustomScrollbar('scrollTo', 0);
				this.$el.trigger('yota.region.open');
				return this;
			}
		}, {
			key: 'close',
			value: function close() {
				this.$el.removeClass(this.options.classes.state.search).removeClass(this.options.classes.state.empty).removeClass(this.options.classes.state.load).removeClass(this.options.classes.state.open);
	
				this.$el.trigger('yota.region.close');
				return this;
			}
		}, {
			key: 'onFocusIn',
			value: function onFocusIn() {
				this.clear().open();
			}
		}, {
			key: 'onDocumentClick',
			value: function onDocumentClick(event) {
				var $target = (0, _jquery2.default)(event.target);
				if (this.$el.hasClass(this.options.classes.state.open)) {
					if (!$target.is(this.$el) && !$target.closest(this.$el).length) {
						this.clear().close();
					}
				}
			}
		}, {
			key: 'selectActive',
			value: function selectActive() {
				var $active = this.getActive();
				if ($active !== false) {
					$active.trigger('click');
					this.$input.blur();
				}
				return this;
			}
		}, {
			key: 'getActive',
			value: function getActive() {
				var $visible = this.$items.filter(this.options.dom.item + ':not(.' + this.options.classes.item.state.hidden + ')');
				var $active = $visible.filter('.' + this.options.classes.item.state.active).eq(0);
				this.$items.not($active).removeClass(this.options.classes.item.state.active);
				if (!$active.length) {
					$visible.first().addClass(this.options.classes.item.state.active);
					return false;
				}
				return $active;
			}
		}, {
			key: 'scrollToItem',
			value: function scrollToItem($active) {
				var itemHeight = $active.outerHeight(true);
				var itemTop = $active.position().top;
				var scrollTop = this.$dropdown.data('position');
				var scrollHeight = this.$dropdown.outerHeight(true);
				var scrollTo = false;
				if (itemTop < scrollTop) {
					scrollTo = itemTop;
				}
				if (itemTop + itemHeight - scrollHeight > scrollTop) {
					scrollTo = itemTop + itemHeight - scrollHeight;
				}
				if (scrollTo !== false) {
					this.$dropdown.mNCustomScrollbar('scrollTo', scrollTo);
				}
				return this;
			}
		}, {
			key: 'moveActive',
			value: function moveActive(direction) {
				var $active = this.getActive();
				if ($active !== false) {
					var $set = $active[direction ? 'nextAll' : 'prevAll'](this.options.dom.item + ':not(.' + this.options.classes.item.state.hidden + ')').eq(0);
					if (!$set.length) {
						$set = this.$items.filter(':not(.' + this.options.classes.item.state.hidden + ')')[direction ? 'first' : 'last']();
					}
					this.$items.not($set).removeClass(this.options.classes.item.state.active);
					$set.addClass(this.options.classes.item.state.active);
					this.scrollToItem($set);
				}
				return this;
			}
		}, {
			key: 'onInput',
			value: function onInput(event) {
				var code = event.which;
				var codeUp = code === 38;
				var codeDown = code === 40;
				var codeEnter = code === 13;
	
				var $target = (0, _jquery2.default)(event.target);
				var value = $target[0].value;
				var val = value.replace(/[^a-zа-яё\s-;:\"\',\.\`\{\}\<\>\~\[\]]/gim, '');
	
				if (val != value) {
					this.$input.val(val);
				}
	
				if (codeUp || codeDown || codeEnter) {
					event.preventDefault();
					if (codeEnter) {
						this.selectActive();
					} else {
						this.moveActive(codeDown);
					}
				} else if (!this.preventSearch) {
					var filter = this.$input.val().trim();
					this.filter(filter);
				}
			}
		}, {
			key: 'onClick',
			value: function onClick(event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
				this.preventSearch = true;
				this.set($target.data('value'));
				this.$input.val($target.text());
				this.close();
				this.preventSearch = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					if (yotaPortlets.regions) {
						self.getDom();
	
						self.$dropdown.mNCustomScrollbar({
							autoDraggerLength: false,
							mouseWheel: {
								enable: true,
								preventDefault: true
							},
							contentTouchScroll: self.options.size.height * 2,
							mouseWheelPixels: self.options.size.height * 2,
							scrollButtons: false,
							scrollInertia: self.options.size.height * self.options.size.count,
							theme: '',
							callbacks: {
								onCreate: function onCreate() {
									self.$dropdown.data('position', 0);
								},
								onUpdate: function onUpdate() {
									if (this.mncs) {
										self.$dropdown.data('position', this.mncs.top < 0 ? -this.mncs.top : 0);
									}
								},
								whileScrolling: function whileScrolling() {
									if (this.mncs) {
										self.$dropdown.data('position', this.mncs.top < 0 ? -this.mncs.top : 0);
									}
								}
							}
						});
	
						self.$el.on('focusin.region', self.options.dom.input, self.onFocusIn.bind(self)).on('input.region paste.region keydown.region', self.options.dom.input, self.onInput.bind(self)).on('click.region', self.options.dom.item, self.onClick.bind(self));
	
						self.$document.on('click.region', self.onDocumentClick.bind(self));
	
						self.setListOptions(yotaPortlets.regions);
					} else {
						console.error('The Region module has no data, set data to "yotaPortlets.regions"');
					}
				}
	
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class() {
			_classCallCheck(this, _class);
	
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDomain',
			value: function getDomain() {
				var a = location.hostname.replace(/^.*(\.)([^\.]+\.[^\.]+)$/, '$2');
				return a !== 'localhost' ? a : '';
			}
		}, {
			key: 'set',
			value: function set(name, value, days, domain) {
				var expires = '';
				if (days) {
					var d = new Date();
					d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
					expires = '; expires=' + d.toGMTString();
				}
				document.cookie = name + '=' + value + expires + '; path=/' + (typeof domain !== 'undefined' ? '; domain=' + domain.replace(/^\./, '') : '');
				return this.get(name);
			}
		}, {
			key: 'get',
			value: function get(name) {
				name += '=';
				var b = document.cookie.split(';');
				var c = '';
				for (var i = 0; i < b.length; i++) {
					c = b[i].replace(/(^\s+)|(\s+$)/g, '');
					while (c.charAt(0) === ' ') {
						c = c.substring(1, c.length);
					}
					if (c.indexOf(name) === 0) {
						return c.substring(name.length, c.length);
					}
				}
				return null;
			}
		}, {
			key: 'remove',
			value: function remove(name) {
				this.set(name, '', -1);
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class() {
			_classCallCheck(this, _class);
	
			this.data = {
				toCyrillic: {
					q: 'й',
					w: 'ц',
					e: 'у',
					r: 'к',
					t: 'е',
					y: 'н',
					u: 'г',
					i: 'ш',
					o: 'щ',
					p: 'з',
					'[': 'х',
					']': 'ъ',
					a: 'ф',
					s: 'ы',
					d: 'в',
					f: 'а',
					g: 'п',
					h: 'р',
					j: 'о',
					k: 'л',
					l: 'д',
					';': 'ж',
					'\'': 'э',
					z: 'я',
					x: 'ч',
					c: 'с',
					v: 'м',
					b: 'и',
					n: 'т',
					m: 'ь',
					',': 'б',
					'.': 'ю',
					'`': 'ё',
					Q: 'Й',
					W: 'Ц',
					E: 'У',
					R: 'К',
					T: 'Е',
					Y: 'Н',
					U: 'Г',
					I: 'Ш',
					O: 'Щ',
					P: 'З',
					'{': 'Х',
					'}': 'Ъ',
					A: 'Ф',
					S: 'Ы',
					D: 'В',
					F: 'А',
					G: 'П',
					H: 'Р',
					J: 'О',
					K: 'Л',
					L: 'Д',
					':': 'Ж',
					'"': 'Э',
					Z: 'Я',
					X: 'Ч',
					C: 'С',
					V: 'М',
					B: 'И',
					N: 'Т',
					M: 'Ь',
					'<': 'Б',
					'>': 'Ю',
					'~': 'Ё'
				}
			};
			return this;
		}
	
		_createClass(_class, [{
			key: 'toCyrillic',
			value: function toCyrillic(word) {
				var self = this;
				return word.split('').map(function (char) {
					return self.data.toCyrillic[char] || char;
				}).join('');
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#headerUser',
				classes: {
					hover: 'b-header-user_state_hover'
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'onMouseEnter',
			value: function onMouseEnter() {
				var self = this;
				if (!self.$el.hasClass(self.options.classes.hover)) {
					clearTimeout(self.enterTimeout);
					clearTimeout(self.leaveTimeout);
					self.enterTimeout = setTimeout(function () {
						self.$el.addClass(self.options.classes.hover);
					}, 250);
				}
			}
		}, {
			key: 'onMouseLeave',
			value: function onMouseLeave() {
				var self = this;
				if (self.$el.hasClass(self.options.classes.hover)) {
					clearTimeout(self.enterTimeout);
					clearTimeout(self.leaveTimeout);
					self.leaveTimeout = setTimeout(function () {
						self.$el.removeClass(self.options.classes.hover);
					}, 250);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.$el.on('mouseleave', this.onMouseLeave.bind(this)).on('mouseenter', this.onMouseEnter.bind(this));
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _scrollbarwidth = __webpack_require__(50);
	
	var _scrollbarwidth2 = _interopRequireDefault(_scrollbarwidth);
	
	var _prefixed = __webpack_require__(10);
	
	var _prefixed2 = _interopRequireDefault(_prefixed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: false,
				dom: {
					overlay: '.js-overlay',
					fixed: '.js-overlay-fixed',
					onfixed: '.js-overlay-onfixed',
					open: '.js-overlay-open',
					close: '.js-overlay-close',
					header: '#header, .js-overlay-right'
				},
				classes: {
					state: {
						open: 'b-overlay_state_open',
						back: 'b-overlay_state_back'
					},
					body: {
						open: 'on-overlay'
					}
				},
				callback: {
					open: false,
					close: false
				}
	
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.$overlay = (0, _jquery2.default)(this.options.dom.overlay);
			this.$document = (0, _jquery2.default)(document);
			this.overlays = [];
			this.scrollbarWidth = (0, _scrollbarwidth2.default)();
			this.prefixed = new _prefixed2.default();
			this.setCallback(this.options.callback);
			return this;
		}
	
		_createClass(_class, [{
			key: 'setCallback',
			value: function setCallback(callback) {
				if (this.$el.length) {
					this.$el.data('callback', callback);
				} else {
					this.$overlay.data('callback', callback);
				}
			}
		}, {
			key: 'callback',
			value: function callback($overlay, type) {
				var callback = $overlay.data('callback');
				if (callback) {
					if (typeof callback[type] === 'function') {
						callback[type]();
					}
				}
			}
		}, {
			key: 'getDom',
			value: function getDom() {
				this.$html = (0, _jquery2.default)('html');
				this.$body = (0, _jquery2.default)(document.body);
				this.$window = (0, _jquery2.default)(window);
				this.$htmlBody = this.$html.add(this.$body);
	
				this.$htmlBody.attr('style', 'height: auto !important;');
	
				this.$open = (0, _jquery2.default)(this.options.dom.open);
				this.$close = (0, _jquery2.default)(this.options.dom.close);
				this.$fixed = this.$overlay.find(this.options.dom.fixed);
				this.$onfixed = (0, _jquery2.default)(this.options.dom.onfixed);
				this.$closed = this.$close.filter(function () {
					return (0, _jquery2.default)(this).css('position') === 'fixed';
				});
				this.$header = (0, _jquery2.default)(this.options.dom.header);
			}
		}, {
			key: 'onClick',
			value: function onClick(type, event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
				var $overlay = { length: 0 };
				if (type === 'opened') {
					$overlay = this.$overlay.filter('#' + $target.data('overlay'));
				} else {
					$overlay = $target.closest(this.options.dom.overlay);
				}
				if ($overlay.length) {
					$overlay.trigger('yota.overlay.' + type);
				}
			}
		}, {
			key: 'open',
			value: function open(event) {
				var self = this;
				var inArray = false;
				var $overlay = (0, _jquery2.default)(event.currentTarget);
				if (!$overlay.hasClass(self.options.classes.state.back)) {
					$overlay.scrollTop(0);
				}
				if (self.overlays.length) {
					_jquery2.default.each(self.overlays, function (key, $item) {
						if ($item.is($overlay)) {
							inArray = true;
						}
						$item.toggleClass(self.options.classes.state.back, !$item.is($overlay));
					});
				}
				$overlay.addClass(self.options.classes.state.open);
	
				if (!inArray) {
					self.overlays.push($overlay);
				}
				self.$htmlBody.addClass(self.options.classes.body.open);
				self.$header.css({ marginRight: self.scrollbarWidth });
				self.$onfixed.css({ marginRight: self.scrollbarWidth });
				self.$closed.css({ marginRight: self.scrollbarWidth });
				self.$body.css({ paddingRight: self.scrollbarWidth });
				self.$window.trigger('yota.overlay.open');
				self.callback($overlay, 'open');
				if (typeof this.options.callback.open === 'function') {
					this.options.callback.open();
				}
				this.$document.trigger('yota.document.overlay.open');
				return this;
			}
		}, {
			key: 'close',
			value: function close(event) {
				var $overlay = (0, _jquery2.default)(event.currentTarget);
				this.overlays.splice(-1, 1);
				$overlay.one(this.prefixed.events.transitionEnd, this.onTransitionEnd.bind(this)).removeClass(this.options.classes.state.open);
				this.$document.trigger('yota.document.overlay.close');
				return this;
			}
		}, {
			key: 'onTransitionEnd',
			value: function onTransitionEnd(event) {
				var $overlay = (0, _jquery2.default)(event.currentTarget);
				var self = this;
				if (self.overlays.length) {
					self.overlays[self.overlays.length - 1].removeClass(self.options.classes.state.back);
					self.$window.trigger('yota.overlay.open');
					self.callback(self.overlays[self.overlays.length - 1], 'open');
					self.callback($overlay, 'close');
				} else {
					setTimeout(function () {
						self.$htmlBody.removeClass(self.options.classes.body.open);
						self.$header.css({ marginRight: 0 });
						self.$body.css({ paddingRight: 0 });
						self.$onfixed.css({ marginRight: 0 });
						self.$window.trigger('yota.overlay.close');
						self.callback($overlay, 'close');
					}, 250);
				}
			}
		}, {
			key: 'active',
			value: function active() {
				return this.$overlay.filter('.' + this.options.classes.state.open + ':not(.' + this.options.classes.state.back + ')');
			}
		}, {
			key: 'isActive',
			value: function isActive() {
				var active = false;
				if (this.$overlay.length) {
					active = this.$el.hasClass(this.options.classes.state.open);
				}
				return active;
			}
		}, {
			key: 'hasActive',
			value: function hasActive() {
				var active = false;
				if (this.$overlay.length) {
					active = this.$overlay.filter('.' + this.options.classes.state.open).length > 0;
				}
				return active;
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$overlay.length) {
					this.getDom();
					this.$open.on('click', this.onClick.bind(this, 'opened'));
					this.$close.on('click', this.onClick.bind(this, 'closed'));
					this.$overlay.on('yota.overlay.open', this.open.bind(this));
					this.$overlay.on('yota.overlay.close', this.close.bind(this));
					this.$overlay.on('yota.overlay.opened', this.open.bind(this));
					this.$overlay.on('yota.overlay.closed', this.close.bind(this));
					this.$fixed.css({ right: this.scrollbarWidth });
				}
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! scrollbarWidth.js v0.1.3 | felixexter | MIT | https://github.com/felixexter/scrollbarWidth */
	(function (root, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			(root.jQuery || root).scrollbarWidth = factory();
		}
	}(this, function () {
		'use strict';
	
		function scrollbarWidth() {
			if (typeof document === 'undefined') {
				return 0
			}
	
			var
				body = document.body,
				box = document.createElement('div'),
				boxStyle = box.style,
				width;
	
			boxStyle.position = 'absolute';
			boxStyle.top = boxStyle.left = '-9999px';
			boxStyle.width = boxStyle.height = '100px';
			boxStyle.overflow = 'scroll';
	
			body.appendChild(box);
	
			width = box.offsetWidth - box.clientWidth;
	
			body.removeChild(box);
	
			return width;
		}
	
		return scrollbarWidth;
	}));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _overlay = __webpack_require__(49);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class() {
			_classCallCheck(this, _class);
	
			this.$window = (0, _jquery2.default)(window);
			this.$body = (0, _jquery2.default)(document.body);
			this.$html = (0, _jquery2.default)('html');
			this.$htmlBody = this.$body.add(this.$html);
			this.$section = (0, _jquery2.default)('.js-section');
			this.$overlay = (0, _jquery2.default)('.js-overlay');
			this.$header = (0, _jquery2.default)('#header');
	
			this.hashPrevent = false;
			this.hashScrollChange = true;
			this.activated = true;
			this.hashes = [];
			this.alternative = [];
			return this;
		}
	
		_createClass(_class, [{
			key: 'scan',
			value: function scan() {
				var self = this;
				self.$section.add(self.$overlay).each(function () {
					var _$$data = (0, _jquery2.default)(this).data(),
					    hash = _$$data.hash,
					    alternative = _$$data.alternative;
	
					if (hash) {
						self.hashes.push(hash);
					}
					if (alternative && hash) {
						self.alternative.push({
							hash: hash,
							alternative: alternative
						});
					}
				});
				return self;
			}
		}, {
			key: 'checkBase',
			value: function checkBase(hash) {
				var self = this;
				var current = hash;
				var base = false;
				var alternative = false;
	
				_jquery2.default.each(self.hashes, function (index, alt) {
					if (base === false || alt.length > base.length) {
						if (current.indexOf(alt) == 0) {
							base = alt;
							alternative = false;
						}
					}
				});
	
				_jquery2.default.each(self.alternative, function (index, alt) {
					if (base === false || alt.length > base.length) {
						if (current.indexOf(alt.hash) == 0) {
							base = alt.hash;
							alternative = false;
						} else if (hash.indexOf(alt.alternative) == 0) {
							base = alt.hash;
							alternative = alt.alternative;
						}
					}
				});
	
				var result = false;
				if (base !== false) {
					result = { base: base, alternative: alternative };
				}
				return result;
			}
		}, {
			key: 'getHash',
			value: function getHash() {
				this.hash = location.hash.substr(1);
				if (this.hash.substring(0, 1) == '/') {
					this.hash = this.hash.substr(1);
				}
	
				var bases = this.checkBase(this.hash);
				this.params = [];
				if (bases === false) {
					this.hash = '';
				} else {
					var way = this.hash;
					this.hash = bases.base;
					if (bases.alternative !== false) {
						way = way.split(bases.alternative)[1];
					} else {
						way = way.split(bases.base)[1];
					}
					if (way.substring(0, 1) == '/') {
						way = way.substr(1);
					}
					var params = way.split('/');
					for (var i = 0; i < params.length; i++) {
						if (params[i] !== '') {
							this.params.push(params[i]);
						}
					}
				}
				return this;
			}
		}, {
			key: 'onScroll',
			value: function onScroll() {
				var self = this;
				var $overlay = this.overlay.active();
				if (self.hashScrollChange && self.$section.length && $overlay.length == 0) {
					var headerHeight = self.$header.height();
					var windowPosition = window.pageYOffset + headerHeight + (self.$window.height() - headerHeight) / 2;
					var sections = [];
					var hash = false;
					var $el = false;
					var params = [];
					self.$section.each(function () {
						var $section = (0, _jquery2.default)(this);
						var top = $section.offset().top;
						sections.push({
							el: $section,
							top: top,
							bottom: top + $section.outerHeight(true),
							hash: $section.data('hash'),
							params: $section.data('params') || []
						});
					});
	
					_jquery2.default.each(sections, function (key, section) {
						if (section.top <= windowPosition && section.bottom > windowPosition) {
							$el = section.el;
							hash = section.hash;
							params = section.params;
						}
					});
	
					if (hash !== false) {
						self.setHash(hash, 'section', params);
					}
					if ($el.length) {
						$el.data('activated', true).trigger('yota.router.activate');
					}
				}
				return self;
			}
		}, {
			key: 'onCheckOrverlay',
			value: function onCheckOrverlay() {
				var self = this;
				var $overlay = this.overlay.active();
				var hash = false;
				var params = [];
				if ($overlay.length) {
					hash = $overlay.data('hash');
					params = $overlay.data('params');
				}
				if (hash !== false) {
					self.setHash(hash, 'overlay', params);
				}
				if ($overlay.length) {
					$overlay.data('activated', true).trigger('yota.router.activate');
				}
				return false;
			}
		}, {
			key: 'scrollTo',
			value: function scrollTo($el) {
				var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				var self = this;
				var $hashed = $el;
				if (self.hashScrollChange || init) {
					var scrollTop = $hashed.offset().top - self.$header.height();
					if (scrollTop !== window.pageYOffset) {
						self.hashScrollChange = false;
						self.$htmlBody.animate({ scrollTop: scrollTop }, 250, function () {
							scrollTop = $hashed.offset().top - self.$header.height();
							if (scrollTop !== window.pageYOffset) {
								self.$htmlBody.animate({ scrollTop: scrollTop }, 250, function () {
									self.hashScrollChange = true;
									self.onScroll();
								});
							} else {
								self.hashScrollChange = true;
								self.onScroll();
							}
						});
					} else {
						self.hashScrollChange = true;
						self.onScroll();
					}
				}
			}
		}, {
			key: 'setHash',
			value: function setHash(hash, type, params) {
				var additional = '';
				if (typeof params != 'undefined') {
					additional = params.join('/');
				}
	
				if (additional != '') {
					additional = '/' + additional;
				}
	
				if (history.state !== null) {
					if (history.state.hash !== hash + additional) {
						window.history.replaceState({ hash: hash + additional, main: hash, params: params }, type, hash !== '' ? '#' + hash + additional : ' ');
						this.$window.data('hash', hash).trigger('yota.router.hash');
					}
				} else {
					window.history.replaceState({ hash: hash + additional, main: hash, params: params }, type, hash !== '' ? '#' + hash + additional : ' ');
					this.$window.data('hash', hash).trigger('yota.router.hash');
				}
	
				return this;
			}
		}, {
			key: 'onOverlayOpen',
			value: function onOverlayOpen() {
				var $overlay = this.overlay.active();
				if ($overlay.length) {
					var hash = $overlay.data('hash');
					this.hashScrollChange = false;
					this.setHash(hash, 'overlay', $overlay.data('params') || []);
				} else {
					this.hashScrollChange = true;
				}
				return this;
			}
		}, {
			key: 'onOverlayClose',
			value: function onOverlayClose() {
				this.hashScrollChange = true;
				this.onScroll();
				return this;
			}
		}, {
			key: 'init',
			value: function init(hash, params) {
				var $hashed = this.$overlay.add(this.$section).filter('[data-hash="' + hash + '"]');
				if ($hashed.length) {
					if (params.length) {
						$hashed.data('params', params).trigger('yota.router.update');
					} else {
						this.getHash();
					}
					this.scrollTo($hashed, true);
				}
				if ($hashed.length && $hashed.is(this.$overlay)) {
					$hashed.trigger('yota.overlay.open');
				}
				this.$window.data('hash', this.hash);
				this.$window.trigger('yota.router.hash');
			}
		}, {
			key: 'onPopState',
			value: function onPopState() {
				this.getHash();
				var $hashed = this.$overlay.add(this.$section).filter('[data-hash="' + this.hash + '"]');
	
				var $overlayActive = this.overlay.active();
				if (!$hashed.length && $overlayActive.length) {
					$overlayActive.trigger('yota.overlay.close');
				}
				if ($hashed.length) {
					if (this.params.length) {
						$hashed.data('params', this.params).trigger('yota.router.update');
					} else {
						this.getHash();
					}
					this.scrollTo($hashed, true);
				}
	
				if ($hashed.length && $hashed.is(this.$overlay)) {
					$hashed.trigger('yota.overlay.open');
				}
				this.$window.data('hash', this.hash).trigger('yota.router.hash');
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$section.length || this.$overlay.length) {
					this.scan();
					this.getHash();
					this.$window.on('scroll.router resize.router yota.router.check', this.onScroll.bind(this)).on('yota.router.check.overlay', this.onCheckOrverlay.bind(this)).on('yota.overlay.open', this.onOverlayOpen.bind(this)).on('yota.overlay.close', this.onOverlayClose.bind(this));
	
					if (window.history && window.history.pushState) {
						this.$window.on('popstate.router hashchange.router', this.onPopState.bind(this));
					} else {
						this.$window.on('hashchange.router', this.onPopState.bind(this));
					}
					this.overlay = new _overlay2.default();
					this.init(this.hash, this.params);
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-tooltip',
				dom: {
					close: '.js-tooltip-close',
					open: '.js-tooltip-open'
				},
				classes: {
					active: 'b-tooltip_state_active'
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.$document = (0, _jquery2.default)(document);
	
			this.classes = {
				active: 'b-tooltip_state_active'
			};
		}
	
		_createClass(_class, [{
			key: 'toggle',
			value: function toggle(event) {
				var $target = (0, _jquery2.default)(event.target);
				var $tooltip = $target.closest(this.$el);
				if ($tooltip.hasClass(this.options.classes.active)) {
					this.close($tooltip);
				} else {
					this.open($tooltip);
				}
				event.preventDefault();
			}
		}, {
			key: 'open',
			value: function open() {
				var $el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				var $tooltip = $el === false ? this.$el : $el;
				$tooltip.addClass(this.options.classes.active);
			}
		}, {
			key: 'close',
			value: function close() {
				var $el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				var $tooltip = $el === false ? this.$el : $el;
				$tooltip.removeClass(this.options.classes.active);
			}
		}, {
			key: 'onDocumentAction',
			value: function onDocumentAction(event) {
				var self = this;
				var $target = (0, _jquery2.default)(event.target);
				self.$el.each(function () {
					var $tooltip = (0, _jquery2.default)(this);
					if (!$target.is($tooltip) && !$target.closest($tooltip).length && $tooltip.hasClass(self.options.classes.active)) {
						self.close($tooltip);
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (this.$el.length) {
					this.$el.on('click.tooltip', this.options.dom.open, this.toggle.bind(this)).on('click.tooltip', this.options.dom.close, this.toggle.bind(this));
					this.$document.on('click', this.onDocumentAction.bind(this));
					this.$el.addClass('tooltipInited');
				}
	
				setInterval(function () {
					(0, _jquery2.default)('.js-tooltip:not(.tooltipInited)').on('click.tooltip', self.options.dom.open, self.toggle.bind(self)).on('click.tooltip', self.options.dom.close, self.toggle.bind(self)).addClass('tooltipInited');
					self.$el = (0, _jquery2.default)('.js-tooltip');
				}, 1000);
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-geo-data',
				inited: '.js-geo-data-inited'
			};
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'prepare',
			value: function prepare(json) {
				var data = {};
				_jquery2.default.each(json, function (key, val) {
					data[key.toLowerCase()] = val;
				});
				return data;
			}
		}, {
			key: 'setData',
			value: function setData() {
				var self = this;
				self.$el = (0, _jquery2.default)(this.options.el + ':not(' + this.options.inited + ')');
				if (self.$el.length) {
					self.$el.each(function () {
						var $geo = (0, _jquery2.default)(this);
						var type = $geo.data('type').toLowerCase();
						if (typeof self.data[type] != 'undefined') {
							var set = self.data[type];
							set = set.replace(/\./g, ',');
							$geo.addClass('js-geo-data-inited').text(set);
						}
					});
				}
				return self;
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
	
				if (yotaPortlets.geo) {
					self.data = self.prepare(yotaPortlets.geo);
				} else {
					console.error('The GEO content has no data, set data to "yotaPortlets.geo"');
				}
	
				if (self.$el.length) {
					self.setData();
				}
	
				setInterval(function () {
					self.setData();
				}, 1000);
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class() {
			var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-info-message',
				dom: {
					closeButton: '.js-info-message-close'
				},
				classes: {
					visible: 'visible'
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.hideTimeout = this.$el.data('hide-timeout') * 1000 || false;
			this.localHideDate = Number(window.localStorage.yCookieMessageHideDate);
			this.localMessageViewed = window.localStorage.yCookieMessageViewed;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$closeButton = this.$el.find(this.options.dom.closeButton);
	
				return this;
			}
		}, {
			key: 'close',
			value: function close() {
				this.$el.removeClass(this.options.classes.visible);
				window.localStorage.removeItem('yCookieMessageHideDate');
				window.localStorage.setItem('yCookieMessageViewed', 'true');
			}
		}, {
			key: 'checkExpireTime',
			value: function checkExpireTime() {
				if (this.localMessageViewed || !this.hideTimeout && !this.localHideDate) {
					return;
				}
	
				if (this.localHideDate) {
					var hideDelay = this.localHideDate - Date.now();
	
					if (hideDelay <= 0) {
						window.localStorage.removeItem('yCookieMessageHideDate');
						window.localStorage.setItem('yCookieMessageViewed', 'true');
	
						return;
					}
	
					this.$el.addClass(this.options.classes.visible);
					setTimeout(this.close.bind(this), hideDelay);
	
					return;
				}
	
				window.localStorage.setItem('yCookieMessageHideDate', '' + (Date.now() + this.hideTimeout));
				this.$el.addClass(this.options.classes.visible);
				setTimeout(this.close.bind(this), this.hideTimeout);
			}
		}, {
			key: 'init',
			value: function init() {
				this.checkExpireTime();
				this.$closeButton.on('click', this.close.bind(this));
	
				return this;
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom().init();
				}
	
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _region = __webpack_require__(45);
	
	var _region2 = _interopRequireDefault(_region);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaBlocked',
				dom: {
					layout: '#layout',
					region: '.js-blocked-region'
				},
				classes: {
					state: {
						active: 'b-blocked_state_active'
					},
					layout: {
						state: {
							blocked: 'b-layout_state_blocked'
						}
					}
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.products = {};
			this.productType = false;
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$layout = (0, _jquery2.default)(this.options.dom.layout);
				this.$region = this.$el.find(this.options.dom.region);
				return this;
			}
		}, {
			key: 'blocked',
			value: function blocked() {
				this.$layout.addClass(this.options.classes.layout.state.blocked);
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.products = yotaPortlets.region.products;
					this.getDom();
					this.region = new _region2.default({ el: this.$region }).render();
	
					if (yotaPortlets.productType) {
						this.productType = yotaPortlets.productType;
	
						if (this.products[yotaPortlets.productType] === true) {
							window.location.href = '/';
						}
						if (this.products[yotaPortlets.productType] === false) {
							this.blocked();
						}
					}
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(4);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _slider = __webpack_require__(57);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _soon = __webpack_require__(58);
	
	var _soon2 = _interopRequireDefault(_soon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaMain',
				dom: {
					slider: '.js-main-slider',
					banner: '.js-main-banner',
					button: '.js-main-button'
				},
				template: {
					button: '.js-main-button-template'
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				var self = this;
				self.$button = (0, _jquery2.default)(self.options.dom.button);
				self.$buttonTmpl = (0, _jquery2.default)(self.options.template.button);
				self.buttonTmpl = _underscore2.default.template(self.$buttonTmpl.html().trim());
				self.$slider = self.$el.find(self.options.dom.slider);
	
				// self.$soon = self.$el.find(self.options.dom.soon);
				return self;
			}
		}, {
			key: 'openSoon',
			value: function openSoon(event) {
				var self = this;
				var $target = (0, _jquery2.default)(event.currentTarget);
				var type = $target.data('js');
				if (yotaPortlets.region.products[type] === true) {
					event.preventDefault();
					self.soon.open(type);
				}
				return self;
			}
		}, {
			key: 'build',
			value: function build() {
				var self = this;
				self.$button.each(function () {
					var $button = (0, _jquery2.default)(this);
					var type = $button.data('type');
					var text = 'От ' + yotaPortlets.region.products[type] + ' <span class="b-rur">p</span>/мес.';
					text = 'Подробнее';
					if (yotaPortlets.region.products[type] === false) {
						text = 'Подробнее';
					}
					if (yotaPortlets.region.products[type] === true) {
						text = 'Предзаказ';
					}
	
					$button.html(self.buttonTmpl({ text: text }));
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
					self.build();
	
					self.slider = new _slider2.default({
						el: self.$slider,
						time: 5000
					}).render();
					self.soon = new _soon2.default().render();
					self.$el.on('click', self.options.dom.banner, self.openSoon.bind(self));
				}
				return self;
			}
		}]);
	
		return _class;
	}();
	
	// import $ from 'jquery';
	// import _ from 'underscore';
	// import Slider from 'blocks/slider/slider';
	// import Soon from 'portlets/site/main/soon/soon';
	
	// export default class {
	// 	constructor(options) {
	// 		const defaults = {
	// 			el: '#yotaMainLayout',
	// 			dom: {
	// 				main: '#yotaMain',
	// 				mainTmpl: '#yotaMainTmpl',
	// 				roamingTmpl: '#yotaMainRoamingTmpl',
	// 				soonTmpl: '#yotaMainSoonTmpl',
	// 				regionTmpl: '#yotaMainRegionTmpl',
	// 				slider: '.js-main-slider',
	// 				soon: '.js-main-soon-open'
	// 			}
	// 		};
	
	// 		this.options = $.extend(true, {}, defaults, options);
	// 		this.$el = $(this.options.el);
	// 		return this;
	// 	}
	
	// 	build() {
	// 		const self = this;
	// 		let html = false;
	
	// 		if (self.data.products.roaming === true) {
	// 			html = self.roamingTmpl();
	// 		} else if (self.data.products.voice === true && self.data.products.tablet === true && self.data.products.modem === true) {
	// 			html = self.soonTmpl();
	// 		} else if (self.data.products.voice === false && self.data.products.tablet === false && self.data.products.modem === false) {
	// 			html = self.regionTmpl();
	// 		} else if (self.data.products.isMoscow !== true) {
	// 			html = self.mainTmpl(self.data.products);
	// 		}
	
	// 		if (html !== false) {
	// 			html = html
	// 				.split('{TMPL{').join('{{')
	// 				.split('}TMPL}').join('}}')
	// 				.split('{script}').join('<script')
	// 				.split('{/script}').join('</script>');
	
	// 			self.$el.html(html);
	// 		}
	// 		return self;
	// 	}
	
	// 	getBaseDom() {
	// 		const self = this;
	// 		self.$main = self.$el.find(self.options.dom.main);
	
	// 		self.$mainTmpl = $(self.options.dom.mainTmpl);
	// 		this.mainTmpl = _.template(this.$mainTmpl.html().trim());
	
	// 		self.$roamingTmpl = $(self.options.dom.roamingTmpl);
	// 		this.roamingTmpl = _.template(this.$roamingTmpl.html().trim());
	
	// 		self.$soonTmpl = $(self.options.dom.soonTmpl);
	// 		this.soonTmpl = _.template(this.$soonTmpl.html().trim());
	
	// 		self.$regionTmpl = $(self.options.dom.regionTmpl);
	// 		this.regionTmpl = _.template(this.$regionTmpl.html().trim());
	// 		return self;
	// 	}
	
	// 	getDom() {
	// 		const self = this;
	// 		self.$slider = self.$el.find(self.options.dom.slider);
	// 		self.$soon = self.$el.find(self.options.dom.soon);
	// 		return self;
	// 	}
	
	// 	openSoon(event) {
	// 		const self = this;
	// 		const $target = $(event.currentTarget);
	// 		const type = $target.data('js');
	// 		self.soon.open(type);
	// 		return self;
	// 	}
	
	// 	render() {
	// 		const self = this;
	// 		if (self.$el.length) {
	// 			if (yotaPortlets.region) {
	// 				self.data = yotaPortlets.region;
	
	// 				self
	// 					.getBaseDom()
	// 					.build()
	// 					.getDom();
	
	// 				self.slider = new Slider({
	// 					el: self.$slider,
	// 					time: 5000
	// 				}).render();
	
	// 				if (self.$soon.length) {
	// 					self.soon = new Soon().render();
	
	// 					self.$soon.on('click', self.openSoon.bind(self));
	// 				}
	// 			} else {
	// 				console.error('The yotaMain portlet has no data, set data to "yotaPortlets.region"');
	// 			}
	// 		}
	// 		return self;
	// 	}
	// }
	

	exports.default = _class;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _prefixed = __webpack_require__(10);
	
	var _prefixed2 = _interopRequireDefault(_prefixed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-slider',
				dom: {
					slide: '.js-slider-slide',
					control: '.js-slider-control',
					page: '.js-slider-page',
					select: '.js-select'
				},
				classes: {
					theme: {
						white: 'b-slider_theme_white'
					},
					state: {
						animated: 'b-slider_state_animated'
					},
					pages: {
						hidden: 'b-slider_pages_hidden'
					},
					slide: {
						state: {
							active: 'b-slider__slide_state_active'
						},
						from: {
							prev: 'b-slider__slide_from_prev',
							next: 'b-slider__slide_from_next'
						},
						to: {
							prev: 'b-slider__slide_to_prev',
							next: 'b-slider__slide_to_next'
						}
					},
					page: {
						state: {
							active: 'b-slider__page_state_active'
						}
					}
				},
				callback: {
					start: false,
					end: false
				},
				time: false
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.prefixed = new _prefixed2.default();
			this.interval = false;
			this.pause = false;
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				var self = this;
				self.$slide = self.$el.find(self.options.dom.slide);
				self.$control = self.$el.find(self.options.dom.control);
				self.$page = self.$el.find(self.options.dom.page);
				self.$select = self.$el.find(self.options.dom.select);
				return self;
			}
		}, {
			key: 'onComplete',
			value: function onComplete($active, $set, direction) {
				var self = this;
				$set.removeClass(self.options.classes.slide.from[direction]);
				$active.removeClass(self.options.classes.slide.to[direction]);
				self.$el.removeClass(self.options.classes.state.animated);
				if (typeof self.options.callback.end == 'function') {
					self.options.callback.end();
				}
				if (this.interval != false) {
					self.startTimer();
				}
				return self;
			}
		}, {
			key: 'setSlide',
			value: function setSlide(eq) {
				var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
				var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
				var self = this;
				var $active = self.$slide.filter('.' + self.options.classes.slide.state.active);
				var $set = self.$slide.eq(eq);
				if (!$active.is($set) && (!self.$el.hasClass(self.options.classes.state.animated) || force)) {
					if (force) {
						self.startTimer();
						self.$slide.removeClass(self.options.classes.slide.from.prev).removeClass(self.options.classes.slide.from.next).removeClass(self.options.classes.slide.to.prev).removeClass(self.options.classes.slide.to.next).removeClass(self.options.classes.slide.state.active).off(self.prefixed.events.transitionEnd);
						$set.addClass(self.options.classes.slide.state.active);
					} else {
						self.pauseTimer(false);
						if (typeof self.options.callback.start == 'function') {
							self.options.callback.start(eq);
						}
						/* eslint no-nested-ternary: 0 */
						var direction = dir !== false ? dir : $active.index() < $set.index() ? 'next' : 'prev';
						self.$el.addClass(self.options.classes.state.animated);
						$set.addClass(self.options.classes.slide.from[direction]);
						$set.one(self.prefixed.events.transitionEnd, self.onComplete.bind(self, $active, $set, direction));
						setTimeout(function () {
							$active.addClass(self.options.classes.slide.to[direction]).removeClass(self.options.classes.slide.state.active);
							$set.addClass(self.options.classes.slide.state.active);
						}, 50);
					}
	
					self.$page.not(':eq(' + eq + ')').removeClass(self.options.classes.page.state.active);
					self.$page.eq(eq).addClass(self.options.classes.page.state.active);
	
					var theme = $set.data('theme') || false;
					_jquery2.default.each(self.options.classes.theme, function (key, item) {
						self.$el.toggleClass(item, theme == key);
					});
				}
				return self;
			}
		}, {
			key: 'nextSlide',
			value: function nextSlide() {
				var self = this;
				var $active = self.$slide.filter('.' + self.options.classes.slide.state.active);
				var $set = $active.next();
				if (!$set.is(self.$slide)) {
					$set = self.$slide.eq(0);
				}
				self.setSlide($set.index(), 'next');
				return self;
			}
		}, {
			key: 'prevSlide',
			value: function prevSlide() {
				var self = this;
				var $active = self.$slide.filter('.' + self.options.classes.slide.state.active);
				var $set = $active.prev();
				if (!$set.is(self.$slide)) {
					$set = self.$slide.eq(-1);
				}
				self.setSlide($set.index(), 'prev');
				return self;
			}
		}, {
			key: 'onControl',
			value: function onControl(event) {
				var self = this;
				self[(0, _jquery2.default)(event.currentTarget).data('js')]();
				return self;
			}
		}, {
			key: 'onPage',
			value: function onPage(event) {
				var self = this;
				self.setSlide((0, _jquery2.default)(event.currentTarget).index());
				return self;
			}
		}, {
			key: 'togglePage',
			value: function togglePage(show) {
				var self = this;
				if (typeof show !== 'undefined') {
					self.$el.toggleClass(self.options.classes.pages.hidden, !show);
				} else {
					self.$el.toggleClass(self.options.classes.pages.hidden);
				}
				return self;
			}
		}, {
			key: 'startTimer',
			value: function startTimer() {
				var self = this;
				if (self.options.time != false) {
					clearInterval(self.interval);
	
					self.interval = setInterval(function () {
						self.nextSlide();
					}, self.options.time);
				}
			}
		}, {
			key: 'pauseTimer',
			value: function pauseTimer(force) {
				clearInterval(this.interval);
				if (force !== false) {
					this.interval = false;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
	
					self.$control.on('click', self.onControl.bind(self));
					self.$page.on('click', self.onPage.bind(self));
	
					self.$select.on('yota.select.open', self.togglePage.bind(self, false)).on('yota.select.close', self.togglePage.bind(self, true));
	
					self.$el.on('mouseenter', self.pauseTimer.bind(self)).on('mouseleave', self.startTimer.bind(self));
	
					self.startTimer();
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _input = __webpack_require__(18);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _animation = __webpack_require__(9);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaMainSoon',
				dom: {
					container: '.js-main-soon-container',
					close: '.js-main-soon-close',
					form: '.js-main-soon-form',
					wrapper: '.js-main-soon-wrapper',
					type: '.js-main-soon-type',
					phone: '.js-main-soon-phone',
					numbered: '#yotaMainSoonNumbered'
				},
				classes: {
					state: {
						open: 'b-main-soon_state_open',
						send: 'b-main-soon_state_send'
					},
					field: {
						state: {
							error: 'b-field_state_error'
						}
					}
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.sended = false;
			this.$el = (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				var self = this;
				self.$container = self.$el.find(self.options.dom.container);
				self.$close = self.$el.find(self.options.dom.close);
				self.$form = self.$el.find(self.options.dom.form);
				self.$wrapper = self.$el.find(self.options.dom.wrapper);
				self.$type = self.$el.find(self.options.dom.type);
				self.$phone = self.$el.find(self.options.dom.phone);
				self.$numbered = (0, _jquery2.default)(self.options.dom.numbered);
				return self;
			}
		}, {
			key: 'onClick',
			value: function onClick(event) {
				var self = this;
				var $target = (0, _jquery2.default)(event.target);
				if (!$target.is(self.$container) && !$target.closest(self.$container).length) {
					self.close();
				}
				return self;
			}
		}, {
			key: 'open',
			value: function open(type) {
				var self = this;
				self.$el.removeClass(self.options.classes.state.send).addClass(self.options.classes.state.open);
				self.$type.val(type);
				self.numbered.setVal('');
				self.sended = false;
				return self;
			}
		}, {
			key: 'close',
			value: function close() {
				var self = this;
				self.$el.removeClass(self.options.classes.state.open);
				return self;
			}
		}, {
			key: 'state',
			value: function state(error) {
				var self = this;
				self.$numbered.parent().toggleClass(self.options.classes.field.state.error, error);
				self.$phone.val(self.$numbered.val().replace(/[^\d]/gi, ''));
				if (error) {
					self.wrapper.play('shake');
				}
				return self;
			}
		}, {
			key: 'validate',
			value: function validate() {
				var self = this;
				var valid = self.numbered.validate();
				if (valid > 0) {
					self.$phone.val(self.$numbered.val().replace(/[^\d]/gi, ''));
				}
				return valid;
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(event) {
				/* eslint no-alert: 0 */
				var self = this;
				event.preventDefault();
				if (!self.sended) {
					if (self.validate() > 0) {
						self.sended = true;
						_jquery2.default.ajax({
							url: self.$form.attr('action'),
							type: self.$form.attr('method'),
							data: self.$form.serialize(),
							dataType: 'json',
							success: function success(json) {
								if (json && json.success) {
									self.$el.addClass(self.options.classes.state.send);
								} else {
									alert(self.$form.data('error'));
								}
								self.sended = false;
							},
							error: function error() {
								self.container.play('shake');
								alert(self.$form.data('error'));
								self.sended = false;
							}
						});
					} else {
						self.state(true);
					}
				}
	
				return self;
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
					self.$el.on('click', self.onClick.bind(self));
					self.$close.on('click', self.close.bind(self));
					self.$form.on('submit', self.onSubmit.bind(self));
	
					self.wrapper = new _animation2.default({ el: self.$wrapper });
					self.container = new _animation2.default({ el: self.$container });
	
					self.numbered = new _input2.default(self.$numbered, { placeholder: true });
					self.$numbered.on('change input focusin', self.state.bind(self, false));
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _input = __webpack_require__(18);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _animation = __webpack_require__(9);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaComingSoon',
				dom: {
					form: '.js-coming-soon-form',
					container: '.js-coming-soon-container',
					wrapper: '.js-coming-soon-wrapper',
					phone: '.js-coming-soon-phone',
					numbered: '#yotaCommingSoonNumbered'
				},
				classes: {
					state: {
						send: 'b-coming-soon_state_send'
					},
					field: {
						state: {
							error: 'b-field_state_error'
						}
					}
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.sended = false;
			this.$el = (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				var self = this;
				self.$form = self.$el.find(self.options.dom.form);
				self.$container = self.$el.find(self.options.dom.container);
				self.$wrapper = self.$el.find(self.options.dom.wrapper);
				self.$phone = self.$el.find(self.options.dom.phone);
				self.$numbered = (0, _jquery2.default)(self.options.dom.numbered);
				return self;
			}
		}, {
			key: 'state',
			value: function state(error) {
				var self = this;
				self.$numbered.parent().toggleClass(self.options.classes.field.state.error, error);
				self.$phone.val(self.$numbered.val().replace(/[^\d]/gi, ''));
				if (error) {
					self.wrapper.play('shake');
				}
				return self;
			}
		}, {
			key: 'validate',
			value: function validate() {
				var self = this;
				var valid = self.numbered.validate();
				if (valid > 0) {
					self.$phone.val(self.$numbered.val().replace(/[^\d]/gi, ''));
				}
				return valid;
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(event) {
				/* eslint no-alert: 0 */
				var self = this;
				event.preventDefault();
				if (!self.sended) {
					if (self.validate() > 0) {
						self.sended = true;
						_jquery2.default.ajax({
							url: self.$form.attr('action'),
							type: self.$form.attr('method'),
							data: self.$form.serialize(),
							dataType: 'json',
							success: function success(json) {
								if (json && json.success) {
									self.$el.addClass(self.options.classes.state.send);
								} else {
									alert(self.$form.data('error'));
								}
								self.sended = false;
							},
							error: function error() {
								self.container.play('shake');
								alert(self.$form.data('error'));
								self.sended = false;
							}
						});
					} else {
						self.state(true);
					}
				}
	
				return self;
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
	
					self.$form.on('submit', self.onSubmit.bind(self));
					self.wrapper = new _animation2.default({ el: self.$wrapper });
					self.container = new _animation2.default({ el: self.$container });
	
					self.numbered = new _input2.default(self.$numbered, { placeholder: true });
					self.$numbered.on('change input focusin', self.state.bind(self, false));
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _region = __webpack_require__(45);
	
	var _region2 = _interopRequireDefault(_region);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaNoRegion',
				dom: {
					region: '.js-no-region-region'
				},
				classes: {}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$region = this.$el.find(this.options.dom.region);
				return this;
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom();
					this.region = new _region2.default({ el: this.$region }).render();
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _select = __webpack_require__(62);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _overlay = __webpack_require__(49);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _info = __webpack_require__(63);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _price = __webpack_require__(64);
	
	var _price2 = _interopRequireDefault(_price);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaRoaming',
				dom: {
					overlay: '#yotaOverlayRoaming',
					select: '.js-roaming-select',
					content: '.js-roaming-content'
				},
				classes: {
					state: {
						select: 'b-roaming_state_select',
						scroll: 'b-roaming_state_scroll'
					}
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			this.preventChange = false;
			this.current = false;
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$selects = (0, _jquery2.default)(this.options.dom.select);
				this.$overlay = (0, _jquery2.default)(this.options.dom.overlay);
				this.$content = this.$el.find(this.options.dom.content);
			}
		}, {
			key: 'prepareOptions',
			value: function prepareOptions(data) {
				var self = this;
				var options = [];
				_jquery2.default.each(data, function (key, item) {
					options.push({
						value: key,
						text: item.title
					});
					if (yotaPortlets.region.products.roaming && yotaPortlets.region.roaming == item.code) {
						self.current = key;
					}
				});
				return options;
			}
		}, {
			key: 'onSelect',
			value: function onSelect(event, data) {
				var self = this;
				var value = data.value;
				if (!self.preventChange) {
					self.preventChange = true;
					_jquery2.default.each(self.select, function (key, select) {
						select.setValue(value);
					});
					self.price.set(self.data[value]);
					self.$el.addClass(self.options.classes.state.select);
					if (!self.overlay.isActive()) {
						self.$overlay.trigger('yota.overlay.open');
					}
					self.$overlay.data('params', [self.data[value].code.toLowerCase()]);
					self.$window.trigger('yota.router.check');
					self.onResize();
					setTimeout(function () {
						self.preventChange = false;
					}, 100);
				}
			}
		}, {
			key: 'onClear',
			value: function onClear() {
				_jquery2.default.each(this.select, function (key, select) {
					select.clear();
				});
				this.$el.removeClass(this.options.classes.state.select);
				this.$overlay.data('params', []);
				this.$window.trigger('yota.router.check');
				this.onResize();
			}
		}, {
			key: 'onOpen',
			value: function onOpen() {
				this.info.close();
				this.onResize();
			}
		}, {
			key: 'onClose',
			value: function onClose() {
				this.onClear();
				this.info.close();
				this.onResize();
			}
		}, {
			key: 'onResize',
			value: function onResize() {
				var windowHeight = this.$window.outerHeight(true);
				var contentHeight = this.$content.outerHeight(true);
				this.$el.toggleClass(this.options.classes.state.scroll, windowHeight < contentHeight);
			}
		}, {
			key: 'init',
			value: function init() {
				var self = this;
	
				self.getDom();
				self.data = yotaPortlets.roaming;
				self.select = [];
				self.selectOptions = self.prepareOptions(self.data);
	
				self.$selects.each(function () {
					var select = new _select2.default({ el: (0, _jquery2.default)(this) }).render();
					select.setOptions(self.selectOptions);
					self.select.push(select);
				});
	
				self.overlay = new _overlay2.default({
					el: self.$overlay,
					callback: {
						open: self.onOpen.bind(self),
						close: self.onClose.bind(self)
					}
				});
	
				self.$selects.on('yota.select.change', self.onSelect.bind(self)).on('yota.select.clean', self.onClear.bind(self));
	
				self.info = new _info2.default({
					callback: {
						height: self.onResize.bind(self)
					}
				}).render();
				self.price = new _price2.default().render();
	
				self.$window.on('resize.yota.roaming', self.onResize.bind(self)).trigger('resize.yota.roaming');
	
				if (self.current !== false) {
					self.onSelect(false, { value: self.current });
				}
	
				self.$overlay.on('yota.router.update', this.update.bind(this)).on('yota.router.activate', this.activate.bind(this)).trigger('yota.router.update').trigger('yota.router.activate');
	
				return self;
			}
		}, {
			key: 'find',
			value: function find(code) {
				var self = this;
				var find = code;
				var search = false;
				_jquery2.default.each(self.selectOptions, function (key, item) {
					if (self.data[item.value].code.toLowerCase() == find) {
						search = item.value;
					}
				});
				return search;
			}
		}, {
			key: 'update',
			value: function update() {
				var params = this.$overlay.data('params') || [];
				if (params.length) {
					var value = this.find(params[0]);
					if (value !== false) {
						this.onSelect(false, { value: value });
					}
				}
			}
		}, {
			key: 'activate',
			value: function activate() {
				var params = this.$overlay.data('params') || [];
				if (params.length) {
					var value = this.find(params[0]);
					if (value !== false) {
						this.onSelect(false, { value: value });
					}
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					if (yotaPortlets.roaming) {
						if (yotaPortlets.roamingWait === true) {
							self.wait = setInterval(function () {
								if (yotaPortlets.roamingWait !== true) {
									self.init();
									clearInterval(self.wait);
								}
							}, 250);
						} else {
							self.init();
						}
					} else {
						console.error('The overlayRoaming portlet has no data, set data to "yotaPortlets.roaming"');
					}
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(27);
	
	var _underscore = __webpack_require__(4);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(29)(_jquery2.default);
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-select',
				dom: {
					value: '.js-select-value',
					input: '.js-select-input',
					current: '.js-select-current',
					dropdown: '.js-select-dropdown',
					list: '.js-select-list',
					item: '.js-select-item',
					template: '.js-select-template'
				},
				classes: {
					direction: {
						up: 'b-select_direction_up'
					},
					state: {
						open: 'b-select_state_open'
					},
					item: {
						state: {
							active: 'b-select__item_state_active',
							hidden: 'b-select__item_state_hidden'
						}
					}
				},
				size: {
					height: 34,
					count: 7
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.$document = (0, _jquery2.default)(document);
			return this;
		}
	
		_createClass(_class, [{
			key: 'setOptions',
			value: function setOptions(options) {
				this.$list.html(this.template({ list: options }));
				this.$items = this.$list.find(this.options.dom.item);
				return this;
			}
		}, {
			key: 'getDom',
			value: function getDom() {
				this.$value = this.$el.find(this.options.dom.value);
				this.$input = this.$el.find(this.options.dom.input);
				this.$current = this.$el.find(this.options.dom.current);
				this.$dropdown = this.$el.find(this.options.dom.dropdown);
				this.$list = this.$el.find(this.options.dom.list);
				this.$items = this.$el.find(this.options.dom.item);
				this.$template = this.$el.find(this.options.dom.template);
				this.template = _underscore2.default.template(this.$template.html().trim());
				return this;
			}
		}, {
			key: 'setValue',
			value: function setValue(val) {
				var self = this;
				var value = val;
				var lastValue = self.$value.val();
	
				var find = false;
	
				self.$items.each(function () {
					var $this = (0, _jquery2.default)(this);
					var option = $this.data('value');
					if (option == value) {
						find = {
							value: option,
							text: $this.text()
						};
						self.$input.val(find.text);
						self.$current.text(find.text);
						self.$value.val(find.value).trigger('change');
						$this.addClass(self.options.classes.item.state.active);
					} else {
						$this.removeClass(self.options.classes.item.state.active);
					}
				});
	
				if (find !== false && lastValue !== find.value) {
					self.$el.trigger('yota.select.change', find);
				}
				return self;
			}
		}, {
			key: 'close',
			value: function close() {
				var $active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				this.$el.removeClass(this.options.classes.state.open);
				if ($active !== false) {
					this.setValue($active.data('value'));
				}
				this.$el.trigger('yota.select.close');
				return this;
			}
		}, {
			key: 'clear',
			value: function clear() {
				var isClear = this.$input.val() ? this.$input.val().trim() === '' : false;
				this.filter('', true);
				this.$input.val('');
				this.$value.val('').trigger('change');
				if (!isClear) {
					this.$el.trigger('yota.select.clean');
				}
				return this;
			}
		}, {
			key: 'open',
			value: function open() {
				this.$el.addClass(this.options.classes.state.open);
				this.$dropdown.data('position', 0);
				var $active = this.getActive();
				if ($active !== false) {
					this.scrollToItem($active);
				}
				this.$el.trigger('yota.select.open');
				// TODO: Direction top
				return this;
			}
		}, {
			key: 'filter',
			value: function filter(key) {
				var open = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				var self = this;
				var filter = key.toLowerCase().replace(/ё/g, 'е');
	
				if (filter.length) {
					var visibleCount = 0;
					self.$items.each(function () {
						var $item = (0, _jquery2.default)(this);
						var text = $item.text().toLowerCase().replace(/ё/g, 'е');
						var hide = text.indexOf(filter) < 0;
						visibleCount += hide ? 0 : 1;
						$item.toggleClass(self.options.classes.item.state.hidden, hide);
					});
					if (visibleCount === 0) {
						self.$items.removeClass(self.options.classes.item.state.hidden);
					}
				} else {
					self.$items.removeClass(this.options.classes.item.state.hidden);
				}
				if (!open) {
					var $active = self.$items.filter(':not(.' + self.options.classes.item.state.hidden + ')').eq(0);
					self.$items.not($active).removeClass(self.options.classes.item.state.active);
					$active.addClass(self.options.classes.item.state.active);
					self.$dropdown.mNCustomScrollbar('scrollTo', 0);
				}
				return self;
			}
		}, {
			key: 'getActive',
			value: function getActive() {
				var $visible = this.$items.filter(':not(.' + this.options.classes.item.state.hidden + ')');
				var $active = $visible.filter('.' + this.options.classes.item.state.active).eq(0);
				this.$items.not($active).removeClass(this.options.classes.item.state.active);
				if (!$active.length) {
					$visible.first().addClass(this.options.classes.item.state.active);
					return false;
				}
				return $active;
			}
		}, {
			key: 'scrollToItem',
			value: function scrollToItem($active) {
				var itemHeight = $active.outerHeight(true);
				var itemTop = $active.position().top;
				var scrollTop = this.$dropdown.data('position');
				var scrollHeight = this.$dropdown.outerHeight(true);
				var scrollTo = false;
	
				if (itemTop < scrollTop) {
					scrollTo = itemTop;
				}
	
				if (itemTop + itemHeight - scrollHeight > scrollTop) {
					scrollTo = itemTop + itemHeight - scrollHeight;
				}
	
				if (scrollTo !== false) {
					this.$dropdown.mNCustomScrollbar('scrollTo', scrollTo);
				}
	
				return this;
			}
		}, {
			key: 'moveActive',
			value: function moveActive(direction) {
				var $active = this.getActive();
				if ($active !== false) {
					var $set = $active[direction ? 'nextAll' : 'prevAll'](this.options.dom.item + ':not(.' + this.options.classes.item.state.hidden + ')').eq(0);
					if (!$set.length) {
						$set = this.$items.filter(this.options.dom.item + ':not(.' + this.options.classes.item.state.hidden + ')')[direction ? 'first' : 'last']();
					}
					this.$items.not($set).removeClass(this.options.classes.item.state.active);
					$set.addClass(this.options.classes.item.state.active);
					this.scrollToItem($set);
				}
				return this;
			}
		}, {
			key: 'selectActive',
			value: function selectActive() {
				var $active = this.getActive();
				if ($active !== false) {
					this.close($active);
					this.$input.blur();
				}
				return this;
			}
		}, {
			key: 'onInput',
			value: function onInput(event) {
				var code = event.which;
				var codeUp = code === 38;
				var codeDown = code === 40;
				var codeEnter = code === 13;
	
				if (codeUp || codeDown || codeEnter) {
					event.preventDefault();
					if (codeEnter) {
						this.selectActive();
					} else {
						this.moveActive(codeDown);
					}
				} else {
					var filter = this.$input.val().trim();
					this.filter(filter);
				}
			}
		}, {
			key: 'onFocusIn',
			value: function onFocusIn() {
				this.clear().open();
			}
		}, {
			key: 'onCurrent',
			value: function onCurrent() {
				if (this.$el.hasClass(this.options.classes.state.open)) {
					this.close();
				} else {
					this.open();
				}
			}
		}, {
			key: 'onClick',
			value: function onClick(event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
				this.$items.not($target).removeClass(this.options.classes.item.state.active);
				$target.addClass(this.options.classes.item.state.active);
				this.close($target);
			}
		}, {
			key: 'onDocumentClick',
			value: function onDocumentClick(event) {
				var $target = (0, _jquery2.default)(event.target);
				if (this.$el.hasClass(this.options.classes.state.open)) {
					if (!$target.is(this.$el) && !$target.closest(this.$el).length) {
						this.clear().close();
					}
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.$el.each(function () {
						self.getDom();
	
						self.$dropdown.mNCustomScrollbar({
							autoDraggerLength: false,
							mouseWheel: {
								enable: true,
								preventDefault: true
							},
							contentTouchScroll: self.options.size.height * 2,
							mouseWheelPixels: self.options.size.height * 2,
							scrollButtons: false,
							scrollInertia: self.options.size.height * self.options.size.count,
							theme: '',
							callbacks: {
								onCreate: function onCreate() {
									self.$dropdown.data('position', 0);
								},
								onUpdate: function onUpdate() {
									if (this.mNCs) {
										self.$dropdown.data('position', this.mNCs.top < 0 ? -this.mNCs.top : 0);
									}
								},
								whileScrolling: function whileScrolling() {
									self.$dropdown.data('position', this.mNCs.top < 0 ? -this.mNCs.top : 0);
								}
							}
	
						});
	
						self.$el.on('click.select', self.options.dom.current, self.onCurrent.bind(self)).on('focusin.select', self.options.dom.input, self.onFocusIn.bind(self)).on('input.select paste.select keydown.select', self.options.dom.input, self.onInput.bind(self)).on('click.select', self.options.dom.item, self.onClick.bind(self)).on('yota.select.clear', self.clear.bind(self));
	
						self.$document.on('click.select', self.onDocumentClick.bind(self));
					});
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _prefixed = __webpack_require__(10);
	
	var _prefixed2 = _interopRequireDefault(_prefixed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-roaming-info',
				dom: {
					toogle: '.js-roaming-info-toggle'
				},
				classes: {
					state: {
						open: 'b-roaming-info_state_open'
					}
				},
				callback: {
					height: false
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.heightInterval = false;
			this.prefixed = new _prefixed2.default();
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				var self = this;
				self.$toogle = (0, _jquery2.default)(self.options.dom.toogle);
				return self;
			}
		}, {
			key: 'startHeight',
			value: function startHeight() {
				var self = this;
				self.heightInterval = setInterval(function () {
					if (typeof self.options.callback.height === 'function') {
						self.options.callback.height();
					}
				}, 50);
			}
		}, {
			key: 'endHeight',
			value: function endHeight() {
				clearInterval(this.heightInterval);
				if (typeof this.options.callback.height === 'function') {
					this.options.callback.height();
				}
			}
		}, {
			key: 'open',
			value: function open() {
				this.$el.removeClass(this.options.classes.state.open);
				return this;
			}
		}, {
			key: 'close',
			value: function close() {
				this.$el.removeClass(this.options.classes.state.open);
				return this;
			}
		}, {
			key: 'toogle',
			value: function toogle() {
				this.startHeight();
				this.$el.one(this.prefixed.events.animationEnd, this.endHeight.bind(this)).toggleClass(this.options.classes.state.open);
				return this;
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
					self.$toogle.on('click', self.toogle.bind(self));
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(4);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-roaming-price',
				dom: {
					tiles: '.js-roaming-price-tiles',
					template: '.js-roaming-price-template'
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				var self = this;
				self.$tiles = self.$el.find(self.options.dom.tiles);
				self.$template = self.$el.find(self.options.dom.template);
				this.template = _underscore2.default.template(this.$template.html().trim());
				return self;
			}
		}, {
			key: 'set',
			value: function set(data) {
				this.$tiles.html(this.template(data));
				return this;
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaMonthFree',
				dom: {
					minutes: '.js-month-free-minutes'
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.minutes = false;
			this.$el = (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$minutes = this.$el.find(this.options.dom.minutes);
				return this;
			}
		}, {
			key: 'declOfNum',
			value: function declOfNum(number, titles) {
				var cases = [2, 0, 1, 1, 1, 2];
				return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					if (yotaPortlets.monthFree) {
						this.minutes = yotaPortlets.monthFree.minutes;
						this.getDom();
						this.$minutes.text(this.minutes + ' ' + this.declOfNum(this.minutes, ['минуту', 'минуты', 'минут']));
					} else {
						console.error('The monthFree portlet has no data, set data to "yotaPortlets.monthFree"');
					}
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _slider = __webpack_require__(57);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _animation = __webpack_require__(9);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _input = __webpack_require__(18);
	
	var _input2 = _interopRequireDefault(_input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.b-application#yotaApplication',
				dom: {
					form: '.js-application-form',
					tabs: '.js-application-tabs .js-tab',
					slider: '.js-application-slider',
					control: '.js-application-control',
					links: '.js-application-links',
					numbered: '#applicationNumbered',
					button: '.js-application-send',
					mask: '.js-application-mask',
					fileds: '.js-application-fileds',
					reset: '.js-application-reset',
					captcha: '#applicationCaptcha',
					phone: '.js-application-phone',
					callback: '.js-application-callback'
				},
				classes: {
					state: {
						tabs: {
							ios: 'b-application_tab_ios',
							android: 'b-application_tab_android',
							'windows-phone': 'b-application_tab_windows'
						},
						active: 'b-application_state_active',
						form: {
							captcha: 'b-application_state_captcha',
							send: 'b-application_state_send'
						},
						input: {
							error: 'b-application__input_state_error'
						},
						mask: {
							hidden: 'b-application__mask_state_hidden'
						}
					}
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			this.preventChange = false;
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				var self = this;
				self.$form = self.$el.find(self.options.dom.form);
				self.$tabs = self.$el.find(self.options.dom.tabs);
				self.$slider = self.$el.find(self.options.dom.slider);
				self.$control = self.$el.find(self.options.dom.control);
				// self.$links = self.$el.find(self.options.dom.links);
				self.$numbered = self.$el.find(self.options.dom.numbered);
				self.$button = self.$el.find(self.options.dom.button);
				self.$mask = self.$el.find(self.options.dom.mask);
				self.$fileds = self.$el.find(self.options.dom.fileds);
				self.$reset = self.$el.find(self.options.dom.reset);
				self.$captcha = self.$el.find(self.options.dom.captcha);
				self.$phone = self.$el.find(self.options.dom.phone);
				self.$callback = self.$el.find(self.options.dom.callback);
				return self;
			}
		}, {
			key: 'onTabChange',
			value: function onTabChange(init, event) {
				var self = this;
				var isinit = init || false;
				var active = self.$tabs.filter(':checked').data('js');
				self.$el.data('params', [active]);
	
				if (self.preventChange) {
					event.preventDefault();
				} else {
					_jquery2.default.each(self.options.classes.state.tabs, function (key, item) {
						self.$el.toggleClass(item, active == key);
					});
					if (!isinit) {
						// self.links.play('band', 'long');
						// self.preventChange = true;
					}
					self.$window.trigger('yota.router.check');
				}
	
				return self;
			}
		}, {
			key: 'onTabChangeEnd',
			value: function onTabChangeEnd() {
				this.preventChange = false;
			}
		}, {
			key: 'onControl',
			value: function onControl(event) {
				var self = this;
				var active = self.$tabs.filter(':checked').data('js');
				var $control = (0, _jquery2.default)(event.currentTarget);
	
				self.slider[active][$control.data('js')]();
	
				return self;
			}
		}, {
			key: 'validate',
			value: function validate() {
				var self = this;
				var valid = self.numbered.validate();
				if (valid > 0) {
					self.$phone.val(self.$numbered.val());
					self.$numbered.val(self.$numbered.val().replace(/[^\d]/gi, ''));
				}
				return valid;
			}
		}, {
			key: 'onChange',
			value: function onChange() {
				var self = this;
				self.$numbered.removeClass(self.options.classes.state.input.error);
				self.$captcha.removeClass(self.options.classes.state.input.error);
				if (self.$el.hasClass(self.options.classes.state.form.send)) {
					self.reset();
				}
				if (self.$numbered.val() === self.defNumberedValue) {
					self.$mask.removeClass(self.options.classes.state.mask.hidden);
				} else {
					self.$mask.addClass(self.options.classes.state.mask.hidden);
				}
			}
		}, {
			key: 'reset',
			value: function reset() {
				var self = this;
				self.$numbered.val(self.defNumberedValue);
				self.$captcha.val('');
				self.$phone.val('');
				self.$callback.attr('data-phone', '+7 (xxx) xxx - xx - xx');
				self.$mask.removeClass(self.options.classes.state.mask.hidden);
				self.$el.removeClass(self.options.classes.state.form.captcha);
				self.$el.removeClass(self.options.classes.state.form.send);
				self.$numbered.removeClass(self.options.classes.state.input.error);
				self.$captcha.removeClass(self.options.classes.state.input.error);
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(e) {
				var self = this;
				e.preventDefault();
				if (self.$el.hasClass(self.options.classes.state.form.send)) {
					self.$numbered.focus();
					return;
				}
	
				if (!self.$el.hasClass(self.options.classes.state.form.captcha)) {
					if (self.validate() > 0) {
						self.$el.addClass(self.options.classes.state.form.captcha);
					} else {
						self.fileds.play('shake');
						self.$numbered.addClass(self.options.classes.state.input.error);
					}
				} else {
					var validCaptcha = self.$captcha.val().trim().length;
					_jquery2.default.ajax({
						url: self.$form.attr('action'),
						type: self.$form.attr('method'),
						data: self.$form.serialize(),
						dataType: 'json',
						success: function success(json) {
							if (json && json.success && validCaptcha > 0) {
								self.$el.removeClass(self.options.classes.state.form.captcha);
								self.$callback.attr('data-phone', self.$phone.val());
								self.$el.addClass(self.options.classes.state.form.send);
								self.$numbered.val('');
							} else {
								self.fileds.play('shake');
								self.$captcha.addClass(self.options.classes.state.input.error);
							}
						}
					});
				}
			}
		}, {
			key: 'update',
			value: function update() {
				var params = this.$el.data('params') || [];
				if (params.length) {
					var $tab = this.$tabs.filter('[data-js="' + params[0] + '"]');
					if ($tab.length) {
						this.$tabs.not($tab).prop('checked', false);
						$tab.prop('checked', true);
						this.onTabChange(true);
					}
				}
			}
		}, {
			key: 'activate',
			value: function activate() {
				if (!this.activated && this.$el.data('activated') === true) {
					this.activated = true;
					this.$el.addClass(this.options.classes.state.active);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
	
					self.slider = {};
					self.$slider.each(function () {
						var $slider = (0, _jquery2.default)(this);
						self.slider[$slider.data('js')] = new _slider2.default({
							el: $slider[0]
						}).render();
					});
					self.$control.on('click', self.onControl.bind(this));
	
					self.numbered = new _input2.default(self.$numbered, { placeholder: true });
					self.fileds = new _animation2.default({ el: self.$fileds });
					self.$tabs.on('change click', self.onTabChange.bind(this, false));
	
					self.defNumberedValue = self.$numbered.val();
					self.$numbered.on('keyup focus', self.onChange.bind(this));
					self.$captcha.on('keyup focus', self.onChange.bind(this));
					self.$button.on('click', self.onSubmit.bind(this));
					self.$reset.on('click', self.reset.bind(this));
	
					self.$el.on('yota.router.update', self.update.bind(this)).on('yota.router.activate', this.activate.bind(this)).trigger('yota.router.update').trigger('yota.router.activate');
	
					self.onTabChange(true);
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(4);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _sliderRange = __webpack_require__(68);
	
	var _sliderRange2 = _interopRequireDefault(_sliderRange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaInternetTariff',
				dom: {
					hour: '#yotaInternetTariffHour',
					year: '#yotaInternetTariffYear',
					sliderRange: '.js-slider-range',
					templateTabs: '.js-internet-tariff-template-tabs',
					templateHour: '.js-internet-tariff-template-hour',
					templateYear: '.js-internet-tariff-template-year',
					tabs: '.js-internet-tariff-tabs',
					tab: '.js-internet-tariff-tabs .js-tab',
					actionPrice: '.js-internet-tariff-action-price',
					price: '.js-internet-tariff-price',
					time: '.js-internet-tariff-time',
					speed: '.js-internet-tariff-speed',
					speedMax: '.js-internet-tariff-speed-max',
					speedUnit: '.js-internet-tariff-speed-unit'
				},
				classes: {
					state: {
						years: 'b-internet-tariff_state_years',
						hours: 'b-internet-tariff_state_hours',
						action: 'b-internet-tariff_state_action'
					}
				},
				data: {}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.rate = false;
			this.activated = false;
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$hour = this.$el.find(this.options.dom.hour);
				this.$year = this.$el.find(this.options.dom.year);
				this.$sliderRange = this.$el.find(this.options.dom.sliderRange);
				this.$templateTabs = this.$el.find(this.options.dom.templateTabs);
				this.templateTabs = _underscore2.default.template(this.$templateTabs.html().trim());
				this.$templateHour = this.$el.find(this.options.dom.templateHour);
				this.templateHour = _underscore2.default.template(this.$templateHour.html().trim());
				this.$templateYear = this.$el.find(this.options.dom.templateYear);
				this.templateYear = _underscore2.default.template(this.$templateYear.html().trim());
				this.$tabs = this.$el.find(this.options.dom.tabs);
				this.$tab = this.$el.find(this.options.dom.tab);
				this.$actionPrice = this.$el.find(this.options.dom.actionPrice);
				this.$price = this.$el.find(this.options.dom.price);
				this.$time = this.$el.find(this.options.dom.time);
				this.$speed = this.$el.find(this.options.dom.speed);
				this.$speedMax = this.$el.find(this.options.dom.speedMax);
				this.$speedUnit = this.$el.find(this.options.dom.speedUnit);
				return this;
			}
		}, {
			key: 'setTabs',
			value: function setTabs() {
				var html = this.templateTabs({ items: [this.data.turbo_rates] });
				var hour = this.templateHour(this.data.turbo_rates);
				var year = this.templateYear({ items: this.data.year_rates });
				console.log({ items: [this.data.year_rates] });
				this.$tabs.append(html);
				this.$hour.html(hour);
				this.$year.html(year);
				this.$tab = this.$el.find(this.options.dom.tab);
			}
		}, {
			key: 'setInfo',
			value: function setInfo(data) {
				this.$el.toggleClass(this.options.classes.state.action, data.action !== false);
				this.$actionPrice.text(data.action === false ? '' : data.action);
				this.$price.text(data.price);
	
				if (this.data.internet_rates[this.data.internet_rates.length - 1].speed == data.speed) {
					data.speed = this.$speedMax.data('max');
					data.speedUnit = '';
				}
	
				if (data.speedUnit != '') {
					this.$speed.text(data.speed);
					this.$speedMax.text('');
					this.$speedUnit.text(data.speedUnit);
				} else {
					this.$speed.text('');
					this.$speedUnit.text('');
					this.$speedMax.text(data.speed);
				}
			}
		}, {
			key: 'getActiveAncor',
			value: function getActiveAncor(ancor) {
				var action = ancor;
				var selected = false;
				_underscore2.default.each(this.data.turbo_rates, function (item) {
					if (item.ancor == action) {
						selected = item;
					}
				});
				return selected;
			}
		}, {
			key: 'onTabChange',
			value: function onTabChange() {
				var active = this.$tab.filter(':checked').data('js');
				this.$el.toggleClass(this.options.classes.state.hours, active == 'hour');
				this.$el.toggleClass(this.options.classes.state.years, active == 'year');
				if (active !== 'month') {
					this.$el.data('params', [active]);
				} else {
					this.$time.text(this.$time.data(active));
					this.setInfo(this.rate);
					this.$el.data('params', [active, this.rate.ancor]);
				}
	
				this.$window.trigger('yota.router.check');
			}
		}, {
			key: 'onSlide',
			value: function onSlide(position, rate) {
				var active = this.$tab.filter(':checked').data('js');
				rate.action = rate.action || false;
				this.rate = rate;
				this.setInfo(this.rate);
				this.$el.data('params', [active, this.rate.ancor]);
				this.$window.trigger('yota.router.check');
			}
		}, {
			key: 'update',
			value: function update() {
				var params = this.$el.data('params') || [];
				if (params.length) {
					var $tab = this.$tab.filter('[data-js="' + params[0] + '"]');
					if ($tab.length) {
						this.$tab.not($tab).prop('checked', false);
						$tab.prop('checked', true);
					}
					if (params[0] == 'month' && params.length > 1) {
						this.data.internet_base_rate = this.sliderRange.getRate(params[1], 'ancor').rate.price;
						this.sliderRange.update({ base: this.data.internet_base_rate });
					}
				}
			}
		}, {
			key: 'activate',
			value: function activate() {
				var self = this;
				if (!self.activated && self.$el.data('activated') === true) {
					self.activated = true;
					setTimeout(function () {
						self.sliderRange.animate();
					}, 100);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					if (yotaPortlets.internetTariff) {
						this.data = yotaPortlets.internetTariff;
						this.getDom();
						this.setTabs();
	
						this.sliderRange = new _sliderRange2.default({
							el: this.$sliderRange,
							base: this.data.internet_base_rate,
							rates: this.data.internet_rates,
							callback: {
								update: this.onSlide.bind(this)
							}
						});
						this.$el.on('yota.router.update', this.update.bind(this)).on('yota.router.activate', this.activate.bind(this)).trigger('yota.router.update');
	
						this.sliderRange.render();
	
						this.$tab.on('change click', this.onTabChange.bind(this)).trigger('change');
	
						this.$el.trigger('yota.router.activate');
					} else {
						console.error('The internetTariff portlet has no data, set data to "yotaPortlets.internetTariff"');
					}
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(4);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _nouislider = __webpack_require__(33);
	
	var _nouislider2 = _interopRequireDefault(_nouislider);
	
	var _animation = __webpack_require__(9);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-slider-range',
				dom: {
					control: '.js-slider-range-control',
					labels: '.js-slider-range-labels',
					label: '.js-slider-range-label',
					slider: '.js-slider-range-slider',
					roll: '.js-slider-range-roll',
					template: '.js-slider-range-template'
				},
				rates: [],
				base: false,
				callback: {
					update: false
				},
				colors: {
					start: [205, 34, 110],
					edit: [-205, 139, 128]
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.rates = this.options.rates;
			this.base = this.options.base;
			this.animation = false;
			this.position = false;
			self.inited = false;
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$control = this.$el.find(this.options.dom.control);
				this.$label = this.$el.find(this.options.dom.label);
				this.$slider = this.$el.find(this.options.dom.slider);
				this.slider = this.$slider[0];
				this.$roll = this.$el.find(this.options.dom.roll);
				return this;
			}
		}, {
			key: 'rollDom',
			value: function rollDom() {
				this.$handle = this.$slider.find('.noUi-handle');
				this.$origin = this.$slider.find('.noUi-origin');
				this.$handle.append(this.$roll);
				this.origin = new _animation2.default({ el: this.$origin });
				return this;
			}
		}, {
			key: 'animate',
			value: function animate() {
				var self = this;
				var base = parseInt(self.$origin[0].style.left);
				var min = base - 25 < 0 ? 0 : base - 25;
				var max = base + 25 > 100 ? 100 : base + 25;
	
				self.$origin.addClass('animate');
				self.$origin.css('left', min + '%');
				self.animation = setInterval(function () {
					if (max !== false) {
						self.$origin.css('left', max + '%');
						max = false;
					} else if (base !== false) {
						self.$origin.css('left', base + '%');
						base = false;
					} else {
						self.$origin.removeClass('animate');
						clearInterval(self.animation);
					}
				}, 750);
			}
		}, {
			key: 'buildLabels',
			value: function buildLabels(labels, tobase) {
				this.$labels = this.$el.find(this.options.dom.labels);
				this.$template = this.$el.find(this.options.dom.template);
				this.template = _underscore2.default.template(this.$template.html().trim());
	
				this.$labels.html(this.template({ labels: labels }));
				if (tobase) {
					this.$labels.appendTo(this.$slider.find('.noUi-base'));
				}
	
				this.$label = this.$el.find(this.options.dom.label);
				return this;
			}
		}, {
			key: 'getRate',
			value: function getRate(value) {
				var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'price';
	
				var self = this;
				var getType = type;
				var getValue = value;
				var rate = false;
				var key = false;
				_jquery2.default.each(self.rates, function (rateKey, rateItem) {
					if (rateItem[getType] == getValue) {
						rate = rateItem;
						key = rateKey;
					}
				});
				return { key: key, rate: rate };
			}
		}, {
			key: 'onSlide',
			value: function onSlide(value) {
				this.setColor(value);
				value = Math.round(value);
				this.$label.removeClass('active').eq(value).addClass('active');
				if (this.position !== value) {
					this.position = value;
					if (typeof this.options.callback.update === 'function') {
						this.options.callback.update(this.position, this.rates[this.position]);
					}
				}
			}
		}, {
			key: 'setColor',
			value: function setColor(value) {
				var factor = value <= this.rates.length * 0.8 ? value / (this.rates.length * 0.8) : 1;
				var start = this.options.colors.start;
				var edit = this.options.colors.edit;
				var background = 'rgb(' + parseInt(start[0] + edit[0] * factor) + ',' + parseInt(start[1] + edit[1] * factor) + ',' + parseInt(start[2] + edit[2] * factor) + ')';
				this.$slider.css({ 'background-color': background });
			}
		}, {
			key: 'set',
			value: function set(key) {
				this.slider.noUiSlider.set(key);
				return this;
			}
		}, {
			key: 'setPrice',
			value: function setPrice(value) {
				var data = this.getRate(value, 'price');
				this.set(data.key);
				return this;
			}
		}, {
			key: 'setAncor',
			value: function setAncor(value) {
				var data = this.getRate(value, 'ancor');
				this.set(data.key);
				return this;
			}
		}, {
			key: 'onLabel',
			value: function onLabel(event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
	
				var _$target$data = $target.data(),
				    js = _$target$data.js;
	
				if (js >= 0) {
					this.set(js);
				} else {
					this.set(this.rates.length - 1);
				}
			}
		}, {
			key: 'update',
			value: function update(data) {
				this.options = _jquery2.default.extend(true, {}, this.options, data);
				this.base = this.options.base;
				var value = this.getRate(this.base).key;
				if (value !== this.position && this.inited) {
					this.set(value).onSlide(value);
				}
				return this;
			}
		}, {
			key: 'onControl',
			value: function onControl(event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
	
				var _$target$data2 = $target.data(),
				    js = _$target$data2.js;
	
				var set = this.position;
				if (js == 'plus' && set + 1 <= this.rates.length - 1) {
					set++;
				}
				if (js == 'minus' && set - 1 >= 0) {
					set--;
				}
				this.set(set);
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
					_nouislider2.default.create(this.slider, {
						start: self.getRate(self.base).key,
						animate: true,
						connect: 'lower',
						range: {
							min: 0,
							max: self.rates.length - 1
						}
					});
					self.rollDom();
	
					self.slider.noUiSlider.on('update', function () {
						var value = self.slider.noUiSlider.get();
						self.onSlide(value);
						clearInterval(self.animation);
						self.$origin.removeClass('animate');
					});
	
					self.slider.noUiSlider.on('set', function () {
						clearInterval(self.animation);
						self.$origin.removeClass('animate');
						var value = self.slider.noUiSlider.get();
						if (value != Math.round(value)) {
							self.slider.noUiSlider.set(Math.round(value));
						}
					});
	
					self.slider.noUiSlider.on('end', function () {
						var value = self.slider.noUiSlider.get();
						if (value != Math.round(value)) {
							self.slider.noUiSlider.set(Math.round(value));
						}
					});
	
					self.$label.on('click', self.onLabel.bind(this));
					self.$control.on('click', self.onControl.bind(this));
	
					self.inited = true;
					// setTimeout(function () {
					// 	self.animate();
					// }, 1500);
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _sms = __webpack_require__(70);
	
	var _sms2 = _interopRequireDefault(_sms);
	
	var _delivery = __webpack_require__(71);
	
	var _delivery2 = _interopRequireDefault(_delivery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaOrderSim',
				dom: {
					price: '.js-order-sim-price'
				},
				classes: {}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$price = this.$el.find(this.options.dom.price);
				return this;
			}
		}, {
			key: 'onPriceChange',
			value: function onPriceChange(price) {
				this.$price.html(price);
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
					self.sms = new _sms2.default().render();
					self.delivery = new _delivery2.default({
						update: self.onPriceChange.bind(self)
					}).render();
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _animation = __webpack_require__(9);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaOrderSimSms',
				dom: {
					code: '#yotaOrderSimSmsCode',
					again: '#yotaOrderSimSmsAgain',
					wait: '#yotaOrderSimSmsWait',
					cmd: '#yotaOrderSimSmsCmd'
				},
				classes: {
					wait: 'b-order-sim-sms_state_wait',
					error: 'b-field_state_error'
				},
				code: {
					max: 6,
					min: 6
				},
				time: 60
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
	
			this.send = false;
			this.timer = 0;
			this.interval = false;
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$code = this.$el.find(this.options.dom.code);
				this.$again = this.$el.find(this.options.dom.again);
				this.$wait = this.$el.find(this.options.dom.wait);
				this.$cmd = this.$el.find(this.options.dom.cmd);
				return this;
			}
		}, {
			key: 'getHtmlOptions',
			value: function getHtmlOptions() {
				this.options.code.max = this.$code.data('max') || this.options.code.max;
				this.options.code.min = this.$code.data('min') || this.options.code.min;
				this.options.time = this.$wait.data('time') || this.options.time;
			}
		}, {
			key: 'onInput',
			value: function onInput(event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
				this.$code.parent().removeClass(this.options.classes.error);
				var val = $target.val();
				if (val.length > this.options.code.max) {
					$target[0].value = val.substr(0, this.options.code.max);
				}
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(event) {
				var self = this;
				event.preventDefault();
				if (!self.send) {
					var code = self.$code.val();
					if (code.length > self.options.code.max || code.length < self.options.code.min) {
						self.$code.parent().addClass(self.options.classes.error);
						(0, _jquery2.default)(function () {
							return new _animation2.default({ el: self.$code.parent().parent() }).play('shake');
						});
					} else {
						self.send = true;
						self.$cmd.val('confirm');
						_jquery2.default.ajax({
							url: self.$el.attr('action'),
							type: self.$el.attr('method'),
							data: self.$el.find(':input').serialize(),
							dataType: 'json',
							success: function success(json) {
								if (json && json.success) {
									if (json.location) {
										window.location.assign(json.location);
									}
								} else {
									self.$code.parent().addClass(self.options.classes.error);
									(0, _jquery2.default)(function () {
										return new _animation2.default({ el: self.$code.parent().parent() }).play('shake');
									});
								}
								self.send = false;
							}
						});
					}
				}
			}
		}, {
			key: 'onResend',
			value: function onResend(event) {
				event.preventDefault();
				var self = this;
				self.$cmd.val('resend');
				if (self.timer <= 0) {
					self.timer = 1;
					_jquery2.default.ajax({
						url: self.$again.attr('href'),
						type: self.$again.attr('method'),
						data: { cmd: 'resend' },
						dataType: 'json',
						success: function success(json) {
							if (json && json.success) {
								self.startTimer(json.timer || 60);
							} else {
								self.timer = 0;
							}
						}
					});
				}
			}
		}, {
			key: 'declOfNum',
			value: function declOfNum(number, titles) {
				var cases = [2, 0, 1, 1, 1, 2];
				return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
			}
		}, {
			key: 'updateTimer',
			value: function updateTimer() {
				var _$wait$data = this.$wait.data(),
				    text = _$wait$data.text;
	
				var time = this.timer + ' ' + this.declOfNum(this.timer, ['секунду', 'секунды', 'секунд']);
				text = text.replace('{{=time}}', time);
				this.$wait.html(text);
			}
		}, {
			key: 'startTimer',
			value: function startTimer(time) {
				this.timer = time - 1;
				this.updateTimer();
				this.$el.addClass(this.options.classes.wait);
				clearInterval(this.interval);
				this.interval = setInterval(this.stopTimer.bind(this), 1000);
				return this;
			}
		}, {
			key: 'stopTimer',
			value: function stopTimer() {
				this.timer--;
				this.updateTimer();
				if (this.timer <= 0) {
					this.$el.removeClass(this.options.classes.wait);
					clearInterval(this.interval);
				}
				return this;
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
					self.getHtmlOptions();
					self.$code.on('change input blur keypress focus', self.onInput.bind(self));
					self.$again.on('click', self.onResend.bind(self));
					self.$el.on('submit', self.onSubmit.bind(self));
					if (yotaPortlets.orderSim) {
						if (yotaPortlets.orderSim.wait) {
							self.startTimer(yotaPortlets.orderSim.wait);
						}
					}
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _city = __webpack_require__(72);
	
	var _city2 = _interopRequireDefault(_city);
	
	var _animation = __webpack_require__(9);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _input = __webpack_require__(18);
	
	var _input2 = _interopRequireDefault(_input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaOrderSimDelivery',
				dom: {
					city: '.js-city',
					cityId: '#yotaOrderSimDeliveryCityId',
					cityCode: '#yotaOrderSimDeliveryCityCode',
					cityName: '#yotaOrderSimDeliveryCityName',
					cityJson: '#yotaOrderSimDeliveryCityJson',
					phone: '#yotaOrderSimDeliveryPhone',
					mnp: '#yotaOrderSimDeliveryMnp',
					express: '#yotaOrderSimDeliveryExpress',
					standart: '#yotaOrderSimDeliveryStandart',
					self: '#yotaOrderSimDeliverySelf'
				},
				classes: {
					mnp: 'b-order-sim-delivery_state_mnp',
					self: 'b-order-sim-delivery_state_self',
					standart: 'b-order-sim-delivery_state_standart',
					express: 'b-order-sim-delivery_state_express',
					field: {
						error: 'b-field_state_error'
					}
				},
				update: false
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			this.priceDefault = 300;
			this.cityData = false;
			this.data = {};
			this.expressTime = {};
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$city = this.$el.find(this.options.dom.city);
				this.$cityId = this.$el.find(this.options.dom.cityId);
				this.$cityCode = this.$el.find(this.options.dom.cityCode);
				this.$cityName = this.$el.find(this.options.dom.cityName);
				this.$cityJson = this.$el.find(this.options.dom.cityJson);
				this.$phone = this.$el.find(this.options.dom.phone);
				this.$mnp = this.$el.find(this.options.dom.mnp);
				this.$express = this.$el.find(this.options.dom.express);
				this.$standart = this.$el.find(this.options.dom.standart);
				this.$self = this.$el.find(this.options.dom.self);
				return this;
			}
		}, {
			key: 'updatePrice',
			value: function updatePrice(price) {
				if (this.options.update != false) {
					this.options.update(price);
				}
			}
		}, {
			key: 'onCitySet',
			value: function onCitySet(data) {
				if (this.cityData.id != data.id) {
					this.cityData = data;
					this.setDelivery(this.cityData[this.data.delivery] && this.cityData[this.data.express]);
	
					this.updatePrice(this.cityData[this.data.price]);
	
					this.$el.toggleClass(this.options.classes.self, !this.cityData[this.data.delivery]).toggleClass(this.options.classes.standart, this.cityData[this.data.delivery] && !this.cityData[this.data.express]).toggleClass(this.options.classes.express, this.cityData[this.data.delivery] && this.cityData[this.data.express]).toggleClass(this.options.classes.mnp, this.cityData[this.data.mnp]);
	
					this.$cityId.val(this.cityData.id);
					this.$cityCode.val(this.cityData.code);
					this.$cityName.val(this.cityData.name);
					this.$cityJson.val(JSON.stringify(this.cityData));
	
					var hrefSelf = this.$self.data('href').replace('{#code}', this.cityData.code).replace('{#center}', this.cityData.center).replace('{#id}', this.cityData.id).replace('{#map1}', this.cityData.map[0]).replace('{#map2}', this.cityData.map[1]);
	
					this.$self.attr('href', hrefSelf);
				}
				this.$window.trigger('resize');
			}
		}, {
			key: 'validate',
			value: function validate() {
				var _this = this;
	
				var valid = true;
				var phone = this.$phone.val().replace(/[^\d]/gi, '');
				if (phone.length < 11) {
					this.$phone.parent().addClass(this.options.classes.field.error);
					(0, _jquery2.default)(function () {
						return new _animation2.default({ el: _this.$phone.parent().parent().parent() }).play('shake');
					});
					valid = false;
				}
				return valid;
			}
		}, {
			key: 'onFocusin',
			value: function onFocusin(event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
				$target.parent().removeClass(this.options.classes.field.error);
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(event) {
				var valid = this.validate();
				if (!valid) {
					event.preventDefault();
				}
			}
		}, {
			key: 'setDelivery',
			value: function setDelivery(express) {
				if (!this.$express.length || this.$express.prop('disabled')) {
					express = false;
				}
				this.$express.prop('checked', express);
				this.$standart.prop('checked', !express);
			}
		}, {
			key: 'setData',
			value: function setData(data) {
				this.$mnp.prop('checked', data.mnp);
				this.$phone.val(data.phone);
	
				this.city.addData([data.city]).set(data.city.id, data.city.name).set(data.city.id);
	
				this.setDelivery(data.delivery == this.$express.val());
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					if (yotaPortlets.orderSim) {
						self.data = yotaPortlets.orderSim;
	
						if (yotaPortlets.region && yotaPortlets.region.simStartPrice) {
							self.priceDefault = yotaPortlets.region.simStartPrice;
						}
	
						self.getDom();
						self.city = new _city2.default({
							el: self.$city,
							callback: {
								set: self.onCitySet.bind(self)
							}
						}).render();
	
						if (_typeof(self.data.data) == 'object') {
							self.setData(self.data.data);
						}
	
						self.numbered = new _input2.default(self.$phone, { placeholder: false });
	
						self.$el.on('submit', self.onSubmit.bind(self));
						self.$phone.on('focusin', self.onFocusin.bind(self));
					}
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(27);
	
	var _underscore = __webpack_require__(4);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _cookie = __webpack_require__(46);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _transcriptor = __webpack_require__(47);
	
	var _transcriptor2 = _interopRequireDefault(_transcriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(29)(_jquery2.default);
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-city',
				dom: {
					input: '.js-city-input',
					dropdown: '.js-city-dropdown',
					list: '.js-city-list',
					search: '.js-city-search',
					item: '.js-city-item',
					template: {
						list: '.js-city-list-template',
						search: '.js-city-search-template'
					},
					form: {
						search: {
							el: '.js-city-form-search',
							query: '.js-city-form-search-query'
						},
						set: {
							el: '.js-city-form-set',
							id: '.js-city-form-set-id'
						}
					}
				},
				classes: {
					state: {
						open: 'b-city_state_open',
						search: 'b-city_state_search',
						empty: 'b-city_state_empty',
						load: 'b-city_state_load'
					},
					item: {
						state: {
							active: 'b-city__item_state_active',
							hidden: 'b-city__item_state_hidden'
						}
					}
				},
				size: {
					height: 34,
					count: 7
				},
				callback: {
					set: false,
					clear: false
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.searchQuery = '';
			this.preventSearch = false;
			this.searchInputDebounced = false;
			this.searchInputDebounce = false;
			this.searchLoadDebounce = false;
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.$document = (0, _jquery2.default)(document);
			this.$window = (0, _jquery2.default)(window);
			this.cookie = new _cookie2.default();
			this.transcriptor = new _transcriptor2.default();
			this.data = [];
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$input = this.$el.find(this.options.dom.input);
				this.$dropdown = this.$el.find(this.options.dom.dropdown);
				this.$list = this.$el.find(this.options.dom.list);
				this.$listItems = this.$list.find(this.options.dom.item);
				this.$search = this.$el.find(this.options.dom.search);
				this.$searchItems = this.$search.find(this.options.dom.item);
				this.$templateList = this.$el.find(this.options.dom.template.list);
				this.$templateSearch = this.$el.find(this.options.dom.template.search);
				this.templateList = _underscore2.default.template(this.$templateList.html().trim());
				this.templateSearch = _underscore2.default.template(this.$templateSearch.html().trim());
				this.$fromSearch = this.$el.find(this.options.dom.form.search.el);
				this.$fromSearchQuery = this.$el.find(this.options.dom.form.search.query);
				this.$fromSet = this.$el.find(this.options.dom.form.set.el);
				this.$fromSetId = this.$el.find(this.options.dom.form.set.id);
				return this;
			}
		}, {
			key: 'addData',
			value: function addData(data) {
				var self = this;
				_jquery2.default.each(data, function (key, value) {
					self.data[value.id] = value;
				});
				return self;
			}
		}, {
			key: 'setListOptions',
			value: function setListOptions(options) {
				this.addData(options.main).addData(options.all);
				this.$list.html(this.templateList(options));
				this.$listItems = this.$list.find(this.options.dom.item);
				this.$items = this.$listItems;
				return this;
			}
		}, {
			key: 'setSearchOptions',
			value: function setSearchOptions(options) {
				this.addData(options);
				this.$search.html(this.templateSearch({ data: options }));
				this.$searchItems = this.$search.find(this.options.dom.item);
				this.$items = this.$searchItems;
				this.$el.toggleClass(this.options.classes.state.empty, this.$items.length === 0);
				this.$el.addClass(this.options.classes.state.search);
				return this;
			}
		}, {
			key: 'search',
			value: function search(query) {
				var self = this;
				var thisQuery = self.transcriptor.toCyrillic(query);
				self.searchQuery = thisQuery;
	
				self.$fromSearchQuery.val(thisQuery);
	
				_jquery2.default.ajax({
					url: self.$fromSearch.attr('action'),
					type: self.$fromSearch.attr('method'),
					data: self.$fromSearch.find(':input').serialize(),
					dataType: 'json',
					success: function success(json) {
						if (thisQuery === self.searchQuery) {
							self.find(json);
						}
					}
				});
			}
		}, {
			key: 'find',
			value: function find(data) {
				clearTimeout(this.searchLoadDebounce);
				this.setSearchOptions(data);
				this.$el.removeClass(this.options.classes.state.load);
			}
		}, {
			key: 'set',
			value: function set(id) {
				var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				var self = this;
				self.$fromSetId.val(id);
				if (val != false) {
					self.$input.val(val);
				} else if (typeof self.options.callback.set == 'function') {
					self.options.callback.set(self.data[id]);
				}
				return this;
			}
		}, {
			key: 'filter',
			value: function filter(query) {
				var self = this;
				var thisQuery = query;
	
				clearTimeout(self.searchInputDebounce);
				clearTimeout(self.searchLoadDebounce);
	
				if (query.length >= 2) {
					self.searchInputDebounce = setTimeout(function () {
						self.searchInputDebounced = false;
						self.searchLoadDebounce = setTimeout(function () {
							self.$el.addClass(self.options.classes.state.load);
						}, self.$searchItems.length > 0 ? 1000 : 50);
						self.search(thisQuery);
					}, self.searchInputDebounced ? 0 : 300);
					self.searchInputDebounced = true;
				} else {
					self.searchQuery = '';
					self.$items = self.$listItems;
					self.$el.removeClass(self.options.classes.state.search).removeClass(self.options.classes.state.empty).removeClass(self.options.classes.state.load);
				}
				return self;
			}
		}, {
			key: 'clear',
			value: function clear() {
				var id = this.$fromSetId.val();
				if (id != '') {
					this.filter(this.data[id].name);
					this.$input.val(this.data[id].name);
				} else {
					this.filter('');
					this.$input.val('');
					if (typeof this.options.callback.clear == 'function') {
						this.options.callback.clear();
					}
				}
				return this;
			}
		}, {
			key: 'open',
			value: function open() {
				this.$el.removeClass(this.options.classes.state.search).removeClass(this.options.classes.state.empty).removeClass(this.options.classes.state.load).addClass(this.options.classes.state.open);
				this.$el.find(this.options.dom.item).removeClass(this.options.classes.item.state.active);
				this.$dropdown.data('position', 0);
				this.$dropdown.mNCustomScrollbar('scrollTo', 0);
				this.$el.trigger('yota.city.open');
				return this;
			}
		}, {
			key: 'close',
			value: function close() {
				this.$el.removeClass(this.options.classes.state.search).removeClass(this.options.classes.state.empty).removeClass(this.options.classes.state.load).removeClass(this.options.classes.state.open);
	
				this.$el.trigger('yota.city.close');
				return this;
			}
		}, {
			key: 'onFocusIn',
			value: function onFocusIn() {
				var filter = this.$input.val().trim();
				this.open().filter(filter);
				if (filter.length >= 2) {
					this.$el.addClass(this.options.classes.state.search);
				}
			}
		}, {
			key: 'onDocumentClick',
			value: function onDocumentClick(event) {
				var $target = (0, _jquery2.default)(event.target);
				if (this.$el.hasClass(this.options.classes.state.open)) {
					if (!$target.is(this.$el) && !$target.closest(this.$el).length) {
						this.clear().close();
					}
				}
			}
		}, {
			key: 'selectActive',
			value: function selectActive() {
				var $active = this.getActive();
				if ($active !== false) {
					$active.trigger('click');
					this.$input.blur();
				}
				return this;
			}
		}, {
			key: 'getActive',
			value: function getActive() {
				var $visible = this.$items.filter(this.options.dom.item + ':not(.' + this.options.classes.item.state.hidden + ')');
				var $active = $visible.filter('.' + this.options.classes.item.state.active).eq(0);
				this.$items.not($active).removeClass(this.options.classes.item.state.active);
				if (!$active.length) {
					$visible.first().addClass(this.options.classes.item.state.active);
					return false;
				}
				return $active;
			}
		}, {
			key: 'scrollToItem',
			value: function scrollToItem($active) {
				var itemHeight = $active.outerHeight(true);
				var itemTop = $active.position().top;
				var scrollTop = this.$dropdown.data('position');
				var scrollHeight = this.$dropdown.outerHeight(true);
				var scrollTo = false;
				if (itemTop < scrollTop) {
					scrollTo = itemTop;
				}
				if (itemTop + itemHeight - scrollHeight > scrollTop) {
					scrollTo = itemTop + itemHeight - scrollHeight;
				}
				if (scrollTo !== false) {
					this.$dropdown.mNCustomScrollbar('scrollTo', scrollTo);
				}
				return this;
			}
		}, {
			key: 'moveActive',
			value: function moveActive(direction) {
				var $active = this.getActive();
				if ($active !== false) {
					var $set = $active[direction ? 'nextAll' : 'prevAll'](this.options.dom.item + ':not(.' + this.options.classes.item.state.hidden + ')').eq(0);
					if (!$set.length) {
						$set = this.$items.filter(':not(.' + this.options.classes.item.state.hidden + ')')[direction ? 'first' : 'last']();
					}
					this.$items.not($set).removeClass(this.options.classes.item.state.active);
					$set.addClass(this.options.classes.item.state.active);
					this.scrollToItem($set);
				}
				return this;
			}
		}, {
			key: 'onInput',
			value: function onInput(event) {
				var code = event.which;
				var codeUp = code === 38;
				var codeDown = code === 40;
				var codeEnter = code === 13;
	
				var $target = (0, _jquery2.default)(event.target);
				var value = $target[0].value;
				var val = value.replace(/[^a-zа-яё\s-;:\"\',\.\`\{\}\<\>\~\[\]]/gim, '');
	
				if (val != value) {
					this.$input.val(val);
				}
	
				if (codeUp || codeDown || codeEnter) {
					event.preventDefault();
					if (codeEnter) {
						this.selectActive();
					} else {
						this.moveActive(codeDown);
					}
				} else if (!this.preventSearch) {
					var filter = this.$input.val().trim();
					this.filter(filter);
				}
			}
		}, {
			key: 'onClick',
			value: function onClick(event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
				this.preventSearch = true;
				this.set($target.data('value'));
				this.$input.val($target.text());
				this.close();
				this.preventSearch = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					if (yotaPortlets.city) {
						self.getDom();
	
						self.$dropdown.mNCustomScrollbar({
							autoDraggerLength: false,
							mouseWheel: {
								enable: true,
								preventDefault: true
							},
							contentTouchScroll: self.options.size.height * 2,
							mouseWheelPixels: self.options.size.height * 2,
							scrollButtons: false,
							scrollInertia: self.options.size.height * self.options.size.count,
							theme: '',
							callbacks: {
								onCreate: function onCreate() {
									self.$dropdown.data('position', 0);
								},
								onUpdate: function onUpdate() {
									if (this.mncs) {
										self.$dropdown.data('position', this.mncs.top < 0 ? -this.mncs.top : 0);
									}
								},
								whileScrolling: function whileScrolling() {
									if (this.mncs) {
										self.$dropdown.data('position', this.mncs.top < 0 ? -this.mncs.top : 0);
									}
								}
							}
						});
	
						self.$el.on('focusin.city', self.options.dom.input, self.onFocusIn.bind(self)).on('input.city paste.city keydown.city', self.options.dom.input, self.onInput.bind(self)).on('click.city', self.options.dom.item, self.onClick.bind(self));
	
						self.$document.on('click.city', self.onDocumentClick.bind(self));
	
						self.setListOptions(yotaPortlets.city);
					} else {
						console.error('The city module has no data, set data to "yotaPortlets.city"');
					}
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaOrderSimThankyou',
				dom: {
					banner: {
						modem: '.js-order-sim-thankyou-modem-price'
					}
				},
				classes: {
					banner: {
						modem: 'b-order-sim-thankyou_banner_modem'
					}
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.modemPrice = false;
			this.$el = (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$bannerModem = this.$el.find(this.options.dom.banner.modem);
				return this;
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					if (yotaPortlets.region) {
						this.modemPrice = yotaPortlets.region.products.modem;
						this.getDom();
						if (this.modemPrice !== false && this.modemPrice !== true) {
							this.$bannerModem.text(this.modemPrice);
						} else {
							this.$el.removeClass(this.options.classes.banner.modem);
						}
					} else {
						console.error('The orderSimThankyou portlet has no data, set data to "yotaPortlets.region"');
					}
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _select = __webpack_require__(62);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _overlay = __webpack_require__(49);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _underscore = __webpack_require__(4);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#international',
				dom: {
					select: '.js-international-select',
					tiles: '.js-tiles',
					template: '.js-international-template',
					overlay: '.js-overlay'
				},
				classes: {
					state: {
						select: 'b-international_state_select'
					}
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			this.preventChange = false;
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				var self = this;
				self.$overlay = self.$el.closest(self.options.dom.overlay);
				self.$select = self.$el.find(self.options.dom.select);
				self.$tiles = self.$el.find(self.options.dom.tiles);
				self.$template = self.$el.find(self.options.dom.template);
				this.template = _underscore2.default.template(this.$template.html().trim());
				return self;
			}
		}, {
			key: 'onClose',
			value: function onClose() {
				this.onClear();
				this.$el.removeClass(this.options.classes.state.select);
				return this;
			}
		}, {
			key: 'onClear',
			value: function onClear() {
				_jquery2.default.each(this.select, function (key, select) {
					select.clear();
				});
				this.$el.removeClass(this.options.classes.state.select);
				this.$overlay.data('params', []);
				this.$window.trigger('yota.router.check');
			}
		}, {
			key: 'set',
			value: function set(data) {
				this.$tiles.html(this.template(data));
				return this;
			}
		}, {
			key: 'prepareOptions',
			value: function prepareOptions(data) {
				var options = [];
				_jquery2.default.each(data, function (key, item) {
					options.push({
						value: key,
						text: item.name
					});
				});
				return options;
			}
		}, {
			key: 'onSelect',
			value: function onSelect(event, data) {
				var self = this;
				var value = data.value;
				if (!self.preventChange) {
					self.preventChange = true;
					_jquery2.default.each(self.select, function (key, select) {
						select.setValue(value);
					});
					self.set(self.data[value]);
					self.$el.addClass(self.options.classes.state.select);
					self.$overlay.data('params', [data.value.toLowerCase()]);
					self.$window.trigger('yota.router.check');
					setTimeout(function () {
						self.preventChange = false;
					}, 100);
				}
			}
		}, {
			key: 'find',
			value: function find(code) {
				var self = this;
				var find = code;
				var search = false;
				_jquery2.default.each(self.selectOptions, function (key, item) {
					if (item.value.toLowerCase() == find) {
						search = item.value;
					}
				});
				return search;
			}
		}, {
			key: 'update',
			value: function update() {
				var params = this.$overlay.data('params') || [];
				if (params.length) {
					var value = this.find(params[0]);
					if (value !== false) {
						this.onSelect(false, { value: value });
					}
				}
			}
		}, {
			key: 'activate',
			value: function activate() {
				var params = this.$overlay.data('params') || [];
				if (params.length) {
					var value = this.find(params[0]);
					if (value !== false) {
						this.onSelect(false, { value: value });
					}
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					if (yotaPortlets.international) {
						self.getDom();
						self.data = yotaPortlets.international;
						self.select = [];
						self.selectOptions = self.prepareOptions(self.data);
	
						var select = new _select2.default({ el: self.$select }).render();
						select.setOptions(self.selectOptions);
						self.select.push(select);
	
						self.$select.on('yota.select.change', self.onSelect.bind(self)).on('yota.select.clean', self.onClear.bind(self));
	
						self.overlay = new _overlay2.default({
							el: self.$overlay,
							callback: {
								close: self.onClose.bind(self)
							}
						});
	
						self.$overlay.on('yota.router.update', this.update.bind(this)).on('yota.router.activate', this.activate.bind(this)).trigger('yota.router.update').trigger('yota.router.activate');
					} else {
						console.error('The International portlet has no data, set data to "yotaPortlets.international"');
					}
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(4);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _questionOpener = __webpack_require__(76);
	
	var _questionOpener2 = _interopRequireDefault(_questionOpener);
	
	var _vote = __webpack_require__(77);
	
	var _vote2 = _interopRequireDefault(_vote);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#supportHelper',
				dom: {
					categories: '.js-helper-categories',
					category: '.js-helper-category',
					content: '.js-helper-content',
					vote: '.js-vote',
					questionTmpl: '#helperQuestionOpenerTemplate',
					categoryTmpl: '#helperQuestionCategoryTemplate'
				},
				classes: {
					category: {
						state: {
							active: 'b-helper__category_state_active'
						}
					}
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			this.init = false;
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$categories = this.$el.find(this.options.dom.categories);
				this.$content = this.$el.find(this.options.dom.content);
				this.$vote = this.$el.find(this.options.dom.vote);
				this.$questionTmpl = this.$el.find(this.options.dom.questionTmpl);
				this.questionTmpl = _underscore2.default.template(this.$questionTmpl.html().trim());
	
				this.$categoryTmpl = this.$el.find(this.options.dom.categoryTmpl);
				this.categoryTmpl = _underscore2.default.template(this.$categoryTmpl.html().trim());
			}
		}, {
			key: 'sortData',
			value: function sortData(items) {
				return items.sort(function (a, b) {
					return a.order - b.order;
				});
			}
		}, {
			key: 'setCategory',
			value: function setCategory(e) {
				var key = parseInt((0, _jquery2.default)(e.currentTarget).attr('data-key') || e);
	
				if (typeof yotaPortlets.helper[key] != 'undefined') {
					var $set = this.$category.eq(key);
					this.$category.not(':eq(' + key + ')').removeClass(this.options.classes.category.state.active);
					$set.addClass(this.options.classes.category.state.active);
					this.$content.empty();
					yotaPortlets.helper[key].items = this.sortData(yotaPortlets.helper[key].items);
					var questionHtml = this.questionTmpl({ data: yotaPortlets.helper[key] });
					this.$content.append(questionHtml);
					this.helperOpener = new _questionOpener2.default({ parent: this, base: $set.data('ancor') }).render();
					this.helperOpener.toggler(0);
					this.vote = new _vote2.default().render();
	
					if (this.init) {
						this.setHash([$set.data('ancor'), this.helperOpener.getAncor()]);
					}
				}
			}
		}, {
			key: 'categoryBuild',
			value: function categoryBuild() {
				yotaPortlets.helper = this.sortData(yotaPortlets.helper);
				var html = this.categoryTmpl({ data: yotaPortlets.helper });
				this.$categories.empty();
				this.$categories.append(html);
				this.$category = this.$categories.find(this.options.dom.category);
			}
		}, {
			key: 'setAncors',
			value: function setAncors() {
				for (var i = 0; i < yotaPortlets.helper.length; i++) {
					if (typeof yotaPortlets.helper[i].ancor == 'undefined') {
						yotaPortlets.helper[i].ancor = yotaPortlets.helper[i].category;
					}
					for (var j = 0; j < yotaPortlets.helper[i].items.length; j++) {
						if (typeof yotaPortlets.helper[i].items[j].ancor == 'undefined') {
							yotaPortlets.helper[i].items[j].ancor = yotaPortlets.helper[i].items[j].id;
						}
					}
				}
			}
		}, {
			key: 'getHash',
			value: function getHash() {
				var hash = location.hash.substr(1);
				if (hash.substring(0, 1) === '/') {
					hash = hash.substr(1);
				}
	
				var data = hash.split('/');
	
				return [data[0] ? data[0] : '', data[1] ? data[1] : ''];
			}
		}, {
			key: 'onPopState',
			value: function onPopState() {
				console.log(location.hash);
				if (location.hash != '#chat' && location.hash != '#') {
					var params = this.getHash();
					var $active = this.$category.filter('.' + this.options.classes.category.state.active);
					this.$el.data('params', params);
	
					if (params[0] != '') {
						var $activeHashed = this.$category.filter('[data-ancor="' + params[0] + '"]');
						if ($activeHashed.length) {
							$active = $activeHashed;
						}
					}
					$active.click();
					if (params[1] != '') {
						this.helperOpener.setAncor(params[1], true);
					}
				}
			}
		}, {
			key: 'onInit',
			value: function onInit() {
				var params = this.getHash();
				var $active = this.$category.filter('.' + this.options.classes.category.state.active);
	
				if (params[0] != '') {
					var $activeHashed = this.$category.filter('[data-ancor="' + params[0] + '"]');
					if ($activeHashed.length) {
						$active = $activeHashed;
					}
				}
				$active.click();
	
				if (params[1] != '') {
					this.helperOpener.setAncor(params[1], true);
				}
				this.init = true;
			}
		}, {
			key: 'setHash',
			value: function setHash(params) {
				var hash = '';
				if (typeof params != 'undefined') {
					hash = params.join('/');
				}
	
				if (history.state !== null) {
					if (history.state.hash !== hash) {
						window.history.replaceState({ hash: hash, params: params }, 'section', hash !== '' ? '#' + hash : ' ');
					}
				} else {
					window.history.replaceState({ hash: hash, params: params }, 'section', hash !== '' ? '#' + hash : ' ');
				}
				this.$el.data('params', params);
				return this;
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					if (yotaPortlets.helper) {
						this.getDom();
						this.setAncors();
						this.categoryBuild();
						this.$category.on('click', this.setCategory.bind(this));
						this.setCategory(0);
	
						if (window.history && window.history.pushState) {
							this.$window.on('popstate.helper hashchange.helper', this.onPopState.bind(this));
						} else {
							this.$window.on('hashchange.helper', this.onPopState.bind(this));
						}
	
						this.onInit();
					} else {
						console.error('The Helper portlet has no data, set data to "yotaPortlets.helper"');
					}
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-question-opener',
				dom: {
					toggler: '.js-question-opener-toggler',
					content: '.js-question-opener-content',
					text: '.js-question-opener-text',
					vote: '.js-question-opener-vote'
				},
				classes: {
					opener: {
						state: {
							open: 'b-question-opener_state_open'
						}
					}
				},
				parent: false,
				base: false
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$body = (0, _jquery2.default)(document.body);
			this.$html = (0, _jquery2.default)('html');
			this.$htmlBody = this.$body.add(this.$html);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$toggler = this.$el.find(this.options.dom.toggler);
				this.$content = this.$el.find(this.options.dom.content);
				this.$text = this.$el.find(this.options.dom.text);
				this.$vote = this.$el.find(this.options.dom.vote);
				return this;
			}
		}, {
			key: 'toggler',
			value: function toggler(e) {
				var $target = !isNaN(e) ? this.$el.eq(e) : (0, _jquery2.default)(e.target);
	
				if ($target.length) {
					var $thisOpener = $target.closest(this.options.el);
					var $thisContent = $thisOpener.find(this.options.dom.content);
					var $thisText = $thisOpener.find(this.options.dom.text);
					var $thisVote = $thisOpener.find(this.options.dom.vote);
	
					var heightAll = $thisText.outerHeight(true) + $thisVote.outerHeight(true);
					if ($thisOpener.hasClass(this.options.classes.opener.state.open)) {
						$thisContent.height(0);
						$thisOpener.removeClass(this.options.classes.opener.state.open);
						if (this.options.parent.init) {
							this.options.parent.setHash([this.options.base, this.getAncor()]);
						}
					} else {
						$thisContent.height(heightAll);
						$thisOpener.addClass(this.options.classes.opener.state.open);
	
						if (this.options.parent.init) {
							this.options.parent.setHash([this.options.base, $thisOpener.data('ancor')]);
						}
					}
				}
			}
		}, {
			key: 'getAncor',
			value: function getAncor() {
				var $active = this.$el.filter('.' + this.options.classes.opener.state.open).first();
				return $active.length ? $active.data('ancor') : '';
			}
		}, {
			key: 'setAncor',
			value: function setAncor(ancor) {
				var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				var self = this;
				var $target = self.$el.filter('[data-ancor="' + ancor + '"]');
				var $active = self.$el.filter('.' + self.options.classes.opener.state.open);
				$active.each(function () {
					self.toggler((0, _jquery2.default)(this).index());
				});
	
				if ($target.length) {
					self.toggler($target.index());
					if (isInit) {
						self.$htmlBody.animate({ scrollTop: $target.offset().top - 106 }, 500);
					}
				}
				return self;
			}
		}, {
			key: 'render',
			value: function render() {
				this.getDom();
				this.$toggler.on('click', this.toggler.bind(this));
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-vote',
				dom: {
					radio: '.js-vote-radio'
				},
				classes: {
					state: {
						thanks: 'b-vote_state_thanks',
						negative: 'b-vote_state_negative'
					}
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$radio = this.$el.find(this.options.dom.radio);
				return this;
			}
		}, {
			key: 'radioChange',
			value: function radioChange(e) {
				var $target = (0, _jquery2.default)(e.target);
				var $thisEl = $target.closest(this.options.el);
				var value = $target.val();
				if (value == 1) {
					this.setType($thisEl, this.options.classes.state.thanks);
					this.onSubmit($thisEl);
				}
				if (value == 0) {
					this.setType($thisEl, this.options.classes.state.negative);
					this.onSubmit($thisEl);
				}
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(el) {
				var $form = el;
				_jquery2.default.ajax({
					url: $form.attr('action'),
					type: $form.attr('method'),
					data: $form.serialize(),
					dataType: 'json',
					success: function success() /* data */{}
				});
			}
		}, {
			key: 'setType',
			value: function setType(el, type) {
				var $el = el;
				$el.addClass(type);
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom();
					this.$radio.on('change', this.radioChange.bind(this));
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _steps = __webpack_require__(79);
	
	var _steps2 = _interopRequireDefault(_steps);
	
	var _sim = __webpack_require__(80);
	
	var _sim2 = _interopRequireDefault(_sim);
	
	var _transfer = __webpack_require__(81);
	
	var _transfer2 = _interopRequireDefault(_transfer);
	
	var _info = __webpack_require__(82);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _documents = __webpack_require__(86);
	
	var _documents2 = _interopRequireDefault(_documents);
	
	var _thank = __webpack_require__(87);
	
	var _thank2 = _interopRequireDefault(_thank);
	
	var _tariffType = __webpack_require__(88);
	
	var _tariffType2 = _interopRequireDefault(_tariffType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaConnect',
				dom: {
					steps: '#yotaConnectSteps',
					transfer: '#yotaConnectTransfer',
					sim: '#yotaConnectSim',
					info: '#yotaConnectInfo',
					docs: '#yotaConnectDocuments',
					thank: '#yotaConnectThank',
					tariffType: '#yotaTariffType',
					next: '.js-connect-next',
					tostep: '.js-connect-tostep',
					finish: '.js-connect-finish'
				},
				classes: {
					load: 'b-connect_state_load'
				},
				TARIFF_TYPE_SNG: 'TARIFF_TYPE_SNG',
				TARIFF_TYPE_B2B: 'TARIFF_TYPE_B2B'
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.data = false;
			this.sended = false;
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$steps = this.$el.find(this.options.dom.steps);
				this.$sim = this.$el.find(this.options.dom.sim);
				this.$transfer = this.$el.find(this.options.dom.transfer);
				this.$info = this.$el.find(this.options.dom.info);
				this.$docs = this.$el.find(this.options.dom.docs);
				this.$thank = this.$el.find(this.options.dom.thank);
				this.$tariffType = this.$el.find(this.options.dom.tariffType);
	
				this.$next = this.$el.find(this.options.dom.next);
				this.$tostep = this.$el.find(this.options.dom.tostep);
				this.$finish = this.$el.find(this.options.dom.finish);
				return this;
			}
		}, {
			key: 'finish',
			value: function finish() {
				this.steps.update({
					sim: {
						active: true,
						complete: true
					},
					info: {
						active: true,
						complete: true
					},
					docs: {
						active: true,
						complete: true
					}
				});
			}
		}, {
			key: 'send',
			value: function send(backstep, event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
				var step = $target.data('step');
				var self = this;
	
				if (step === 'info' && backstep === false) {
					self.openTariffType();
					// $.ajax({
					// 	url: self.$el.data('check-sng'),
					// 	type: self.$el.data('method'),
					// 	data: $.param({inn: this.info.data.inn}),
					// 	dataType: 'json',
					// 	success: function (json) {
					// 		if (json && json.available) {
					// 			self.openTariffType();
					// 		} else {
					// 			self.checkData(step, backstep);
					// 		}
					// 	}
					// });
				} else {
					this.checkData(step, backstep);
				}
	
				return self;
			}
		}, {
			key: 'checkData',
			value: function checkData(step, backstep) {
				var data = {};
				data.step = step;
				data.backstep = backstep;
	
				if (this.sim) {
					data.sim = this.sim.get();
				}
				if (this.transfer) {
					data.transfer = this.transfer.get();
				}
				if (this.info) {
					data.info = this.info.get();
				}
	
				var self = this;
	
				if (!self.sended && data.transfer !== false) {
					self.$el.addClass(self.options.classes.load);
					self.sended = true;
					_jquery2.default.ajax({
						url: self.$el.data('action'),
						type: self.$el.data('method'),
						data: _jquery2.default.param(data),
						dataType: 'json',
						success: function success(json) {
							self.sended = false;
							if (json) {
								if (self.docs) {
									self.docs.update(json.docs);
								}
								if (self.steps) {
									self.steps.update(json.steps);
								}
								if (self.sim) {
									self.sim.update(json.sim);
								}
								if (self.info) {
									self.info.update(json.info);
								}
								if (self.thank) {
									self.thank.update(json.thank);
								}
							}
							self.$el.removeClass(self.options.classes.load);
							if (json && self.transfer) {
								self.transfer.update(json.transfer);
							}
						}
					});
				}
			}
		}, {
			key: 'openTariffType',
			value: function openTariffType() {
				this.tariffType.open({
					quantity: this.sim.data.quantity,
					mnp: this.sim.data.mnp,
					fields: this.transfer.fields
				});
				return this;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				if (this.$el.length) {
					if (yotaPortlets.connect) {
						this.data = yotaPortlets.connect;
						this.getDom();
	
						if (this.$steps.length) {
							this.steps = new _steps2.default({
								el: this.$steps,
								data: this.data.steps
							}).render();
						}
	
						if (this.$sim.length) {
							this.sim = new _sim2.default({
								el: this.$sim,
								data: this.data.sim
							}).render();
						}
	
						if (this.$transfer.length) {
							this.transfer = new _transfer2.default({
								el: this.$transfer,
								data: this.data.transfer,
								quantity: this.sim.data.quantity
							}).render();
						}
	
						if (this.$info.length) {
							this.info = new _info2.default({
								el: this.$info,
								data: this.data.info,
								types: this.data.types,
								masks: this.data.masks,
								cities: this.data.cities
							}).render();
						}
	
						if (this.$docs.length) {
							this.docs = new _documents2.default({
								el: this.$docs,
								data: this.data.docs
							}).render();
						}
	
						if (this.$thank.length) {
							this.thank = new _thank2.default({
								el: this.$thank,
								data: this.data.thank
							}).render();
						}
	
						if (this.$tariffType.length) {
							this.tariffType = new _tariffType2.default({
								TARIFF_TYPE_SNG: this.options.TARIFF_TYPE_SNG,
								TARIFF_TYPE_B2B: this.options.TARIFF_TYPE_B2B }).render();
						}
	
						this.$next.on('click', this.send.bind(this, false));
						this.$tostep.on('click', this.send.bind(this, true));
						this.$finish.on('click', this.finish.bind(this));
					} else {
						console.error('The connect portlet has no data, set data to "yotaPortlets.connect"');
					}
	
					this.$window.on('yota.connect.tariffType.submit', function (event, tariffType) {
						_this.info.setPackageType(tariffType);
	
						if (tariffType === _this.options.TARIFF_TYPE_SNG) {
							_this.sim.setQuantity(1);
						}
	
						_this.checkData('info', false);
					});
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaConnectSteps',
				dom: {
					portlet: '#yotaConnect',
					step: '.js-connect-steps-step',
					sim: '[data-step="sim"]',
					info: '[data-step="info"]',
					docs: '[data-step="docs"]'
				},
				classes: {
					active: 'b-connect-steps__step_state_active',
					complete: 'b-connect-steps__step_state_complete',
					steps: {
						sim: 'b-connect_state_sim',
						info: 'b-connect_state_info',
						docs: 'b-connect_state_docs',
						thank: 'b-connect_state_thank'
					}
				},
				data: {
					sim: {
						active: false,
						complete: false
					},
					info: {
						active: false,
						complete: false
					},
					docs: {
						active: false,
						complete: false
					}
				}
			};
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.data = this.options.data;
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$portlet = (0, _jquery2.default)(this.options.dom.portlet);
				this.$sim = this.$el.find(this.options.dom.step + this.options.dom.sim);
				this.$info = this.$el.find(this.options.dom.step + this.options.dom.info);
				this.$docs = this.$el.find(this.options.dom.step + this.options.dom.docs);
				return this;
			}
		}, {
			key: 'update',
			value: function update(data) {
				var self = this;
				if (typeof data !== 'undefined') {
					self.data = data;
				}
	
				var step = 'sim';
				_jquery2.default.each(self.data, function (name, options) {
					self['$' + name].toggleClass(self.options.classes.active, options.active).toggleClass(self.options.classes.complete, options.complete);
					if (options.active) {
						step = name;
						if (name === 'docs' && options.complete) {
							step = 'thank';
						}
					}
				});
				_jquery2.default.each(self.options.classes.steps, function (name, txt) {
					self.$portlet.toggleClass(txt, name == step);
				});
	
				return self;
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom().update();
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaConnectSim',
				dom: {
					form: '#yotaConnectSimForm',
					quantity: '#yotaConnectSimQuantity',
					mnp: '#yotaConnectSimMnp',
					transfer: '.js-connect-sim-transfer',
					transferBox: '.js-connect-sim-transfer-box'
	
				},
				classes: {
					mnp: 'b-connect-sim_state_mnp'
				},
				data: {
					quantity: 0,
					mnp: false
				}
			};
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.data = this.options.data;
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$form = this.$el.find(this.options.dom.form);
				this.$quantity = this.$el.find(this.options.dom.quantity);
				this.$mnp = this.$el.find(this.options.dom.mnp);
				this.$transfer = this.$el.find(this.options.dom.transfer);
				this.$transferBox = this.$el.find(this.options.dom.transferBox);
				return this;
			}
		}, {
			key: 'onQuantity',
			value: function onQuantity(event) {
				var _$quantity$data = this.$quantity.data(),
				    max = _$quantity$data.max,
				    min = _$quantity$data.min;
	
				var def = this.$quantity.data('default');
				var value = this.$quantity.val();
				var quantity = value.replace(/[^\d]/ig, '').replace(/^0/ig, '');
				if (quantity != '' && event.type != 'blur') {
					if (quantity > max) {
						quantity = max;
					}
					if (quantity < min) {
						quantity = min;
					}
				}
				if (quantity == '' && event.type == 'blur') {
					quantity = def;
				}
				if (quantity != value) {
					event.currentTarget.value = quantity;
				}
				if (['change', 'blur'].indexOf(event.type) >= 0) {
					this.data.quantity = parseInt(quantity);
					this.$window.trigger('yota.connect.transfer.quantity', this.data.quantity);
					this.toggle();
				}
				return this;
			}
		}, {
			key: 'onMnp',
			value: function onMnp() {
				this.data.mnp = this.$mnp.filter(':checked').length > 0;
				this.toggle();
				this.$window.trigger('yota.connect.transfer.quantity', this.data.mnp ? this.data.quantity : 0);
				return this;
			}
		}, {
			key: 'toggle',
			value: function toggle() {
				this.$el.toggleClass(this.options.classes.mnp, this.data.mnp && this.data.quantity > 0);
				this.onTransferResize();
				return this;
			}
		}, {
			key: 'get',
			value: function get() {
				var data = this.$form.serializeArray();
				var json = {};
				_jquery2.default.each(data, function (key, val) {
					json[val.name] = val.value;
				});
				return JSON.stringify(json);
			}
		}, {
			key: 'onTransferResize',
			value: function onTransferResize() {
				var height = 0;
				if (this.$el.hasClass(this.options.classes.mnp)) {
					height = this.$transferBox.outerHeight(true);
				}
				this.$transfer.css({ height: height });
				return this;
			}
		}, {
			key: 'update',
			value: function update(data) {
				if (typeof data !== 'undefined') {
					this.data = data;
				}
	
				this.$quantity.val(this.data.quantity !== 0 ? this.data.quantity : '');
				this.$mnp.prop('checked', this.data.mnp);
				this.$window.trigger('yota.connect.transfer.quantity', this.data.quantity);
				this.toggle();
				return this;
			}
		}, {
			key: 'setQuantity',
			value: function setQuantity(value) {
				this.$quantity.val(value);
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(event) {
				this.$quantity.blur();
				event.preventDefault();
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom().update();
	
					this.$quantity.on('input keyup paste change blur', this.onQuantity.bind(this));
					this.$mnp.on('change click', this.onMnp.bind(this));
					this.$window.on('yota.connect.transfer.resize', this.onTransferResize.bind(this));
					this.$form.on('submit', this.onSubmit.bind(this));
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(4);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _input = __webpack_require__(18);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _animation = __webpack_require__(9);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaConnectTransfer',
				dom: {
					list: '#yotaConnectTransferList',
					footer: '.js-connect-transfer-footer',
					template: '#yotaConnectTransferTemplate',
					phone: '.js-connect-transfer-phone',
					label: '.js-connect-transfer-label',
					input: '.js-connect-transfer-input',
					remove: '.js-connect-transfer-remove',
					add: '.js-connect-transfer-add',
					quantity: '#yotaConnectSimQuantity',
					mnpToggler: '#yotaConnectSimMnp',
					phoneField: '.js-field'
				},
				classes: {
					phone: {
						remove: 'b-connect-transfer__phone_state_remove',
						add: 'b-connect-transfer__phone_state_add',
						error: 'b-connect-transfer__phone_state_error'
					},
					field: {
						error: 'b-field_state_error'
					}
				},
				data: [],
				quantity: 0,
				ids: 'yotaConnectTransferFieldN'
			};
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.data = this.options.data;
			this.fields = [];
			this.quantity = this.options.quantity;
			this.isUpdate = false;
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			return this;
		}
	
		_createClass(_class, [{
			key: 'add',
			value: function add() {
				var self = this;
				var html = self.template({
					data: {
						id: self.options.ids + (self.fields.length + 1),
						label: '',
						value: ''
					}
				});
	
				self.$list.append(html);
				self.getDomFields();
				self.validate(self.fields[self.fields.length - 1], false);
				self.checkCount();
				self.checkQuantity();
			}
		}, {
			key: 'remove',
			value: function remove(data) {
				var self = this;
				var field = data;
				field.$el.empty().remove();
				self.getDomFields();
				self.validate(self.fields[self.fields.length - 1], false);
				self.checkCount();
				return self;
			}
		}, {
			key: 'checkCount',
			value: function checkCount() {
				this.$footer.attr('data-quantity', this.fields.length + ' ' + this.declOfNum(this.fields.length, ['SIM-карта', 'SIM-карты', 'SIM-карт']));
			}
		}, {
			key: 'checkQuantity',
			value: function checkQuantity() {
				var self = this;
				if (self.$mnpToggler.prop('checked') == true) {
					if (Number(self.$quantity.val()) < self.fields.length) {
						self.$quantity.val(self.fields.length);
					}
				}
			}
		}, {
			key: 'validate',
			value: function validate(data) {
				var self = this;
				var field = data;
				var validate = field.numbered.validate();
				var index = field.$el.index();
	
				self.$phoneField.removeClass(self.options.classes.field.error);
	
				self.fields[index].validate = validate > 0;
				self.fields[index].$el.data('validate', self.fields[index].validate);
				self.fields[index].validate = validate > 0;
				var validates = true;
				var server = true;
	
				var isOnce = self.fields.length == 1;
	
				_jquery2.default.each(self.fields, function (key, item) {
					if (item.validate === false) {
						validates = false;
					}
					if (item.server === false) {
						server = false;
					}
				});
	
				if (isOnce) {
					field.$el.removeClass(self.options.classes.phone.remove).toggleClass(self.options.classes.phone.add, validates && server).toggleClass(self.options.classes.phone.error, !self.fields[index].server && self.fields[index].label !== '');
				} else {
					_jquery2.default.each(self.fields, function (key, item) {
						var isLast = key + 1 == self.fields.length;
						if (isLast) {
							item.$el.toggleClass(self.options.classes.phone.remove, !validates || !server).toggleClass(self.options.classes.phone.add, validates && server).toggleClass(self.options.classes.phone.error, !item.server && item.label !== '');
						} else {
							item.$el.removeClass(self.options.classes.phone.add).addClass(self.options.classes.phone.remove).toggleClass(self.options.classes.phone.error, !item.server && item.label !== '');
						}
					});
				}
	
				if (self.fields[index].validate && self.fields[index].label == '') {
					var list = [];
					_jquery2.default.each(self.fields, function (key, item) {
						if (!item.$input.is(field.$input)) {
							list.push(item.$input.val());
						}
					});
	
					var transfertDataMapper = function transfertDataMapper(transfertData) {
						return {
							phone: transfertData.number || '',
							operator: {
								name: transfertData.orgName || '',
								id: transfertData.ownerId || ''
							},
							region: {
								name: transfertData.regionName || '',
								id: transfertData.regionCode || ''
							},
							error: transfertData.error || false
						};
					};
	
					_jquery2.default.ajax({
						url: self.$list.attr('action'),
						type: self.$list.attr('method'),
						data: {
							action: 'check',
							phone: field.$input.val(),
							other: list.join('|')
						},
						dataType: 'json',
						success: function success(json) {
							json = transfertDataMapper(json);
							if (typeof data[index] == 'undefined') {
								data[index] = json;
							}
							self.fields[index].server = !json.error;
	
							if (json.error !== false) {
								self.fields[index].label = json.error;
							} else {
								self.fields[index].label = [json.operator.name, json.region.name].join(', ');
							}
							self.fields[index].$label.html(self.fields[index].label);
							self.fields[index].operator = json.operator;
							self.fields[index].region = json.region;
						},
						error: function error() {
							self.fields[index].label = 'Невозможно перенести данную SIM-карту';
							self.fields[index].server = false;
							self.fields[index].operator = '';
							self.fields[index].region = '';
							self.fields[index].$label.html(self.fields[index].label);
						},
						complete: function complete() {
							self.fields[index].$el.data('server', self.fields[index].server).data('label', self.fields[index].label).data('operator', self.fields[index].operator).data('region', self.fields[index].region);
	
							self.validate(field, false);
						}
					});
				}
	
				if (validate <= 0) {
					self.fields[index].label = '';
					self.fields[index].server = false;
					self.fields[index].$label.html('');
				}
				self.$window.trigger('yota.connect.transfer.resize');
				return self;
			}
		}, {
			key: 'getDomFields',
			value: function getDomFields() {
				var self = this;
				var fields = [];
				self.$field = self.$el.find(self.options.dom.phone);
				self.$field.each(function () {
					var field = {};
					field.$el = (0, _jquery2.default)(this);
					field.$input = field.$el.find(self.options.dom.input);
					field.$label = field.$el.find(self.options.dom.label);
					field.$remove = field.$el.find(self.options.dom.remove);
					field.$add = field.$el.find(self.options.dom.add);
					if (field.$el.data('init') === true) {
						field.numbered = field.$el.data('numbered');
						field.label = field.$el.data('label');
						field.server = field.$el.data('server');
						field.animation = field.$el.data('animation');
						field.validate = field.$el.data('validate');
						field.operator = field.$el.data('operator');
						field.region = field.$el.data('region');
					} else {
						field.$el.data('init', true);
						field.label = '';
						field.server = false;
						field.validate = false;
						field.numbered = new _input2.default(field.$input);
						field.$input.on('focus keypress keydown blur change input focusin', self.validate.bind(self, field));
						field.$add.on('click', self.add.bind(self));
						field.$remove.on('click', self.remove.bind(self, field));
						field.animation = new _animation2.default({ el: field.$el });
						field.operator = {
							name: '',
							id: ''
						};
						field.region = {
							name: '',
							id: ''
						};
						field.$el.data('numbered', field.numbered).data('animation', field.animation).data('validate', field.validate).data('operator', field.validate).data('region', field.region);
					}
					fields.push(field);
				});
				self.fields = fields;
				self.$phoneField = self.$el.find(this.options.dom.phone).find(this.options.dom.phoneField);
			}
		}, {
			key: 'getDom',
			value: function getDom() {
				this.$list = this.$el.find(this.options.dom.list);
				this.$footer = this.$el.find(this.options.dom.footer);
				this.$quantity = (0, _jquery2.default)(this.options.dom.quantity);
				this.$template = this.$el.find(this.options.dom.template);
				this.template = _underscore2.default.template(this.$template.html().trim());
				this.$mnpToggler = (0, _jquery2.default)(this.options.dom.mnpToggler);
	
				return this;
			}
		}, {
			key: 'setData',
			value: function setData(data) {
				var self = this;
				self.getDomFields();
	
				if (self.fields.length > data.length && self.fields.length > 1) {
					while (self.fields.length > data.length && self.fields.length > 1) {
						self.remove(self.fields[self.fields.length - 1]);
					}
				}
				if (self.fields.length < data.length) {
					while (self.fields.length < data.length) {
						self.add();
					}
				}
				_jquery2.default.each(self.fields, function (index, field) {
					if (typeof data[index] != 'undefined') {
						var json = data[index];
						self.fields[index].server = !json.error;
	
						if (json.error !== false) {
							self.fields[index].label = json.error;
						} else {
							self.fields[index].label = [json.operator.name, json.region.name].join(', ');
						}
	
						field.numbered.setVal(json.phone);
						self.fields[index].$label.html(self.fields[index].label);
						self.fields[index].operator = json.operator;
						self.fields[index].region = json.region;
	
						self.fields[index].$el.data('server', self.fields[index].server).data('label', self.fields[index].label).data('operator', self.fields[index].operator).data('region', self.fields[index].region);
	
						self.validate(self.fields[index], false);
					}
				});
				return self;
			}
		}, {
			key: 'update',
			value: function update(data) {
				if (typeof data !== 'undefined') {
					this.data = data;
				}
				this.setData(this.data);
				this.checkCount();
				return this;
			}
		}, {
			key: 'declOfNum',
			value: function declOfNum(number, titles) {
				var cases = [2, 0, 1, 1, 1, 2];
				return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
			}
		}, {
			key: 'onQuantity',
			value: function onQuantity(event, quantity) {
				var self = this;
				self.quantity = quantity;
				self.checkCount();
				return self;
			}
		}, {
			key: 'onCheck',
			value: function onCheck() {
				var self = this;
				if (self.isUpdate !== true) {
					_jquery2.default.ajax({
						url: self.$list.attr('action'),
						type: self.$list.attr('method'),
						data: self.$list.serialize(),
						dataType: 'json',
						success: function success(json) {
							if (json) {
								self.update(json);
							}
						}
					});
				}
				return self;
			}
		}, {
			key: 'get',
			value: function get() {
				var self = this;
				var json = [];
				var error = false;
				var result = false;
				var isMnp = self.$mnpToggler.prop('checked') == true;
				_jquery2.default.each(self.fields, function (key, field) {
					if (field.$input.val().indexOf('_') != -1) {
						error = true;
						var $phoneBlock = field.$input.closest('.js-field');
						$phoneBlock.addClass(self.options.classes.field.error);
					} else {
						json.push({
							phone: field.$input.val(),
							operator: field.operator,
							region: field.region
						});
					}
				});
	
				if (!isMnp) {
					error = false;
					json = [];
					json.push({
						phone: '',
						operator: {
							name: '',
							id: ''
						},
						region: {
							name: '',
							id: ''
						}
					});
					result = JSON.stringify(json);
				}
	
				if (error) {
					result = false;
				} else {
					result = JSON.stringify(json);
				}
	
				return result;
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(event) {
				event.preventDefault();
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom().update();
	
					this.$window.on('yota.connect.transfer.quantity', this.onQuantity.bind(this));
					this.$window.on('yota.connect.transfer.check', this.onCheck.bind(this));
	
					this.$quantity.on('blur focus', this.checkQuantity.bind(this));
	
					if (this.fields.length === 0) {
						this.add();
					}
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	// import Numbered from 'input.numbered';
	
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _inn = __webpack_require__(83);
	
	var _inn2 = _interopRequireDefault(_inn);
	
	var _city = __webpack_require__(72);
	
	var _city2 = _interopRequireDefault(_city);
	
	var _select = __webpack_require__(62);
	
	var _select2 = _interopRequireDefault(_select);
	
	__webpack_require__(84);
	
	__webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaConnectInfo',
				dom: {
					inn: '.js-inn',
					city: '.js-city',
					date: '#yotaConnectInfoInnDate',
					form: '#yotaConnectInfoForm',
					entityType: '#yotaConnectInfoFieldEntityTypeSelect',
					documentType: '#yotaConnectInfoFieldDocumentTypeSelect',
					directorOffice: '#yotaConnectInfoFieldDirectorOfficeSelect',
					directorPowers: '#yotaConnectInfoFieldDirectorPowersSelect',
					contractCity: '#yotaConnectInfoFieldContractCitySelect',
					field: {
						entity: {
							type: '#yotaConnectInfoFieldEntityType',
							name: '#yotaConnectInfoFieldEntityName',
							inn: '#yotaConnectInfoFieldEntityInn',
							kpp: '#yotaConnectInfoFieldEntityKpp',
							ogrn: '#yotaConnectInfoFieldEntityOgrn',
							ogrnip: '#yotaConnectInfoFieldEntityOgrnip',
							date: '#yotaConnectInfoFieldEntityDate',
							address: '#yotaConnectInfoFieldEntityAddress'
						},
						document: {
							type: '#yotaConnectInfoFieldDocumentType',
							birthdate: '#yotaConnectInfoFieldDocumentBirthdate',
							number: '#yotaConnectInfoFieldDocumentNumber',
							date: '#yotaConnectInfoFieldDocumentDate',
							issued: '#yotaConnectInfoFieldDocumentIssued',
							issuedCode: '#yotaConnectInfoFieldDocumentIssuedCode'
						},
						director: {
							fio: '#yotaConnectInfoFieldDirectorFio',
							office: '#yotaConnectInfoFieldDirectorOffice',
							custom: '#yotaConnectInfoFieldDirectorOfficeCustom',
							powers: '#yotaConnectInfoFieldDirectorPowers',
							powersCustom: '#yotaConnectInfoFieldDirectorPowersCustom'
						},
						contract: {
							date: '#yotaConnectInfoFieldContractDate',
							city: '#yotaConnectInfoFieldContractCity',
							cityId: '#yotaConnectInfoFieldContractCityId'
						},
						user: {
							login: '#yotaConnectInfoFieldUserLogin'
						},
						package: {
							packageType: '#infoPackageType'
						}
					},
					error: '.js-connect-info-error'
				},
				classes: {
					type: {
						ooo: 'b-connect-info_type_ooo',
						ip: 'b-connect-info_type_ip'
					},
					director: {
						custom: 'b-connect-info_director_custom',
						powersCustom: 'b-connect-info_director_powers-custom'
					},
					inn: {
						find: 'b-connect-info_inn_find'
					},
					login: {
						valid: 'b-connect-info_login_valid'
					},
					error: {
						active: 'b-connect-info__error_state_active'
					},
					field: {
						error: 'b-field_state_error'
					}
				},
				types: [],
				data: {
					inn: '',
					date: '',
					entity: {
						type: '',
						name: '',
						inn: '',
						kpp: '',
						ogrn: '',
						ogrnip: '',
						date: '',
						address: ''
					},
					document: {
						type: '',
						birthdate: '',
						number: '',
						date: '',
						issued: '',
						issuedCode: ''
					},
					director: {
						fio: '',
						office: '',
						custom: '',
						powers: '',
						powersCustom: ''
					},
					contract: {
						date: '',
						city: ''
					},
					user: {
						login: '',
						valid: false
					},
					package: {
						packageType: ''
					},
					error: {}
				}
			};
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.data = this.options.data;
			this.masks = this.options.masks;
			this.iptypes = [];
			this.init = true;
			this.viewForm = false;
	
			/* eslint quote-props: 0 */
			this.maskConfig = {
				placeholder: ' ',
				definitions: {
					'Б': {
						validator: '[А-я]',
						cardinality: 1,
						casing: 'upper'
					},
					'S': {
						validator: '[A-zА-я0-9]',
						cardinality: 1,
						casing: 'upper'
					}
				}
			};
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$inn = this.$el.find(this.options.dom.inn);
				this.$date = this.$el.find(this.options.dom.date);
				this.$form = this.$el.find(this.options.dom.form);
	
				this.$city = this.$el.find(this.options.dom.city);
				this.$entityType = this.$el.find(this.options.dom.entityType);
				this.$documentType = this.$el.find(this.options.dom.documentType);
				this.$directorOffice = this.$el.find(this.options.dom.directorOffice);
				this.$directorPowers = this.$el.find(this.options.dom.directorPowers);
				this.$contractCity = this.$el.find(this.options.dom.contractCity);
	
				this.field = {
					entity: {
						$type: this.$el.find(this.options.dom.field.entity.type),
						$name: this.$el.find(this.options.dom.field.entity.name),
						$inn: this.$el.find(this.options.dom.field.entity.inn),
						$kpp: this.$el.find(this.options.dom.field.entity.kpp),
						$ogrn: this.$el.find(this.options.dom.field.entity.ogrn),
						$ogrnip: this.$el.find(this.options.dom.field.entity.ogrnip),
						$date: this.$el.find(this.options.dom.field.entity.date),
						$address: this.$el.find(this.options.dom.field.entity.address)
					},
					document: {
						$type: this.$el.find(this.options.dom.field.document.type),
						$birthdate: this.$el.find(this.options.dom.field.document.birthdate),
						$number: this.$el.find(this.options.dom.field.document.number),
						$date: this.$el.find(this.options.dom.field.document.date),
						$issued: this.$el.find(this.options.dom.field.document.issued),
						$issuedCode: this.$el.find(this.options.dom.field.document.issuedCode)
					},
					director: {
						$fio: this.$el.find(this.options.dom.field.director.fio),
						$office: this.$el.find(this.options.dom.field.director.office),
						$custom: this.$el.find(this.options.dom.field.director.custom),
						$powers: this.$el.find(this.options.dom.field.director.powers),
						$powersCustom: this.$el.find(this.options.dom.field.director.powersCustom)
					},
					contract: {
						$date: this.$el.find(this.options.dom.field.contract.date),
						$city: this.$el.find(this.options.dom.field.contract.city),
						$cityId: this.$el.find(this.options.dom.field.contract.cityId)
					},
					user: {
						$login: this.$el.find(this.options.dom.field.user.login)
					},
					package: {
						$packageType: this.$el.find(this.options.dom.field.package.packageType)
					}
				};
				this.$error = this.$el.find(this.options.dom.error);
	
				this.$fields = false;
				var self = this;
				_jquery2.default.each(self.field, function (groupKey, group) {
					_jquery2.default.each(group, function (fieldKey, $field) {
						if (self.$fields !== false) {
							self.$fields = self.$fields.add($field);
						} else {
							self.$fields = $field;
						}
						$field.data('group', groupKey).data('field', fieldKey.slice(1));
					});
				});
				return self;
			}
		}, {
			key: 'getIpTypes',
			value: function getIpTypes() {
				var self = this;
				_jquery2.default.each(self.options.types, function (key, type) {
					if (type.ip === true) {
						self.iptypes.push(type.value);
					}
				});
				return self;
			}
		}, {
			key: 'isIp',
			value: function isIp(value) {
				return this.iptypes.indexOf(value) >= 0;
			}
		}, {
			key: 'get',
			value: function get() {
				var data = this.$form.serializeArray();
				var json = {};
				_jquery2.default.each(data, function (key, val) {
					if (val.name != 'city-search' && val.name != 'query' && val.name != 'city' && val.name != 'type') {
						json[val.name] = val.value;
					}
				});
				json[this.field.user.$login.attr('name')] = this.field.user.$login.val();
				return JSON.stringify(json);
			}
		}, {
			key: 'update',
			value: function update(data) {
				if (typeof data !== 'undefined') {
					this.data = _jquery2.default.extend(false, {}, this.data, data);
				}
				if (this.data.inn != '') {
					this.viewForm = true;
				}
	
				this.inn.setValue(this.data.inn);
				this.$date.text(this.data.date);
				this.$el.toggleClass(this.options.classes.type.ip, this.data.date !== '');
	
				this.entityType.setValue(this.data.entity.type);
				this.field.entity.$type.val(this.data.entity.type);
				this.field.entity.$name.val(this.data.entity.name);
				this.field.entity.$inn.val(this.data.entity.inn);
				this.field.entity.$kpp.val(this.data.entity.kpp);
				this.field.entity.$ogrn.val(this.data.entity.ogrn);
				this.field.entity.$ogrnip.val(this.data.entity.ogrnip);
				this.field.entity.$date.val(this.data.entity.date).trigger('keyup');
				this.field.entity.$address.val(this.data.entity.address);
	
				var oldType = this.field.document.$type.val();
	
				this.field.document.$type.val(this.data.document.type);
				this.documentType.setValue(this.data.document.type);
	
				if ((oldType !== this.data.document.type || this.init) && this.data.document.type != '') {
					this.field.document.$number.data('type', this.data.document.type);
					this.init = false;
					this.field.document.$number.inputmask(this.masks[this.data.document.type], this.maskConfig);
				}
	
				this.field.document.$number.val(this.data.document.number);
				this.field.document.$birthdate.val(this.data.document.birthdate).trigger('keyup');
				this.field.document.$date.val(this.data.document.date).trigger('keyup');
				this.field.document.$issued.val(this.data.document.issued);
				this.field.document.$issuedCode.val(this.data.document.issuedCode);
	
				this.field.director.$fio.val(this.data.director.fio);
				this.directorOffice.setValue(this.data.director.office);
				this.field.director.$office.val(this.data.director.office);
				this.field.director.$custom.val(this.data.director.custom);
				this.directorPowers.setValue(this.data.director.powers);
				this.field.director.$powers.val(this.data.director.powers);
				this.field.director.$powersCustom.val(this.data.director.powersCustom);
	
				this.field.contract.$date.val(this.data.contract.date).trigger('keyup');
	
				if (this.data.contract.cityId) {
					this.field.contract.$cityId.val(this.data.contract.cityId);
					if (this.data.contract.cityId != '' && this.data.contract.city === true) {
						this.data.contract.city = this.getCityNameFromId(this.data.contract.cityId);
					}
					this.field.contract.$city.val(this.data.contract.city);
	
					this.city.set(this.data.contract.cityId, this.data.contract.city);
				}
	
				this.field.user.$login.val(this.data.user.login);
				this.field.package.$packageType.val(this.data.package.packageType);
	
				this.$el.toggleClass(this.options.classes.login.valid, this.data.user.valid);
				this.$el.toggleClass(this.options.classes.inn.find, this.data.date != '' && typeof this.data.date != 'undefined');
	
				this.states();
				return this;
			}
		}, {
			key: 'setPackageType',
			value: function setPackageType(type) {
				this.field.package.$packageType.val(type);
			}
		}, {
			key: 'onDocumentTypeChange',
			value: function onDocumentTypeChange() {
				var type = this.field.document.$type.val();
				var oldType = this.field.document.$number.data('lasttype');
				if (type !== oldType) {
					this.field.document.$number.data('type', type);
					this.field.document.$number.inputmask(this.masks[type], this.maskConfig);
					this.field.document.$number.val('');
				}
			}
		}, {
			key: 'onInnFind',
			value: function onInnFind(event, data, type) {
				this.viewForm = true;
				if (type) {
					var setType = this.iptypes[0];
					this.update({ entity: { type: setType } });
					this.$el.removeClass(this.options.classes.inn.find);
				} else {
					this.update(data);
				}
			}
		}, {
			key: 'onChange',
			value: function onChange(event) {
				var $field = (0, _jquery2.default)(event.currentTarget);
	
				var _$field$data = $field.data(),
				    group = _$field$data.group,
				    field = _$field$data.field;
	
				this.data[group][field] = $field.val();
	
				this.states();
				return this;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				var $field = (0, _jquery2.default)(event.currentTarget);
				delete this.data.error[$field.attr('name')];
				this.states();
				return this;
			}
		}, {
			key: 'states',
			value: function states() {
				var self = this;
				var entityType = self.field.entity.$type.val();
				var entityTypeIsIp = self.isIp(entityType) && self.viewForm;
				var entityTypeIsOoo = !self.isIp(entityType) && self.viewForm;
				var directorOffice = self.field.director.$office.val();
				var directorPowers = self.field.director.$powers.val();
	
				self.$el.toggleClass(self.options.classes.type.ip, entityTypeIsIp).toggleClass(self.options.classes.type.ooo, entityTypeIsOoo).toggleClass(self.options.classes.director.custom, entityTypeIsOoo && directorOffice === 'custom').toggleClass(self.options.classes.director.powersCustom, entityTypeIsOoo && directorPowers === 'custom');
	
				if (Object.keys(self.data.error).length) {
					self.$error.each(function () {
						var $error = (0, _jquery2.default)(this);
						var name = $error.data('name');
						var find = false;
						_jquery2.default.each(self.data.error, function (key, error) {
							if (name == key) {
								$error.html(error);
								find = true;
							}
						});
						$error.toggleClass(self.options.classes.error.active, find);
						self.$fields.filter('[name="' + name + '"]').parent().toggleClass(self.options.classes.field.error, find);
					});
				} else {
					self.$error.removeClass(self.options.classes.error.active).html('');
					self.$fields.parent().removeClass(self.options.classes.field.error);
				}
	
				self.onEntityInnInput();
				return self;
			}
		}, {
			key: 'onDirectorCustomInput',
			value: function onDirectorCustomInput(event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
				var value = $target.val();
				if (value.length > 15) {
					$target[0].value = value.substr(0, 15);
				}
			}
		}, {
			key: 'onDirectorPowersCustomInput',
			value: function onDirectorPowersCustomInput(event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
				var value = $target.val();
				if (value.length > 50) {
					$target[0].value = value.substr(0, 50);
				}
			}
		}, {
			key: 'onEntityInnInput',
			value: function onEntityInnInput() {
				var $target = this.field.entity.$inn;
				var entityType = this.field.entity.$type.val();
				var entityTypeIsIp = this.isIp(entityType) && this.viewForm;
	
				var value = $target.val();
				var correct = value;
				correct = correct.replace(/[^0-9]/gim, '');
				var max = 10;
				if (entityTypeIsIp) {
					max = 12;
				}
				if (correct.length > max) {
					correct = correct.substr(0, max);
				}
				if (correct != value) {
					$target[0].value = correct;
				}
			}
		}, {
			key: 'onEntityKppInput',
			value: function onEntityKppInput() {
				var $target = this.field.entity.$kpp;
				var value = $target.val();
				var correct = value;
				correct = correct.replace(/[^0-9]/gim, '');
				if (correct.length > 9) {
					correct = correct.substr(0, 9);
				}
				if (correct != value) {
					$target[0].value = correct;
				}
			}
		}, {
			key: 'onEntityOgrnInput',
			value: function onEntityOgrnInput() {
				var $target = this.field.entity.$ogrn;
				var value = $target.val();
				var correct = value;
				correct = correct.replace(/[^0-9]/gim, '');
				if (correct.length > 13) {
					correct = correct.substr(0, 13);
				}
				if (correct != value) {
					$target[0].value = correct;
				}
			}
		}, {
			key: 'onEntityOgrnipInput',
			value: function onEntityOgrnipInput() {
				var $target = this.field.entity.$ogrnip;
				var value = $target.val();
				var correct = value;
				correct = correct.replace(/[^0-9]/gim, '');
				if (correct.length > 15) {
					correct = correct.substr(0, 15);
				}
				if (correct != value) {
					$target[0].value = correct;
				}
			}
		}, {
			key: 'onCityChange',
			value: function onCityChange(data) {
				if (data) {
					this.field.contract.$city.val(data.name);
					this.field.contract.$cityId.val(data.id);
				} else {
					this.field.contract.$city.val('');
					this.field.contract.$cityId.val('');
				}
			}
		}, {
			key: 'getCityNameFromId',
			value: function getCityNameFromId(id) {
				var cityName = '';
				var cityId = id;
				if (yotaPortlets.city) {
					_jquery2.default.each(yotaPortlets.city.main, function (key, city) {
						if (cityId == city.id) {
							cityName = city.name;
						}
					});
					if (cityName == '') {
						_jquery2.default.each(yotaPortlets.city.all, function (key, city) {
							if (cityId == city.id) {
								cityName = city.name;
							}
						});
					}
				}
				return cityName;
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom();
					this.getIpTypes();
	
					this.entityType = new _select2.default({ el: this.$entityType }).render();
	
					this.entityType.setOptions(this.options.types);
	
					this.documentType = new _select2.default({ el: this.$documentType }).render();
					this.directorOffice = new _select2.default({ el: this.$directorOffice }).render();
					this.directorPowers = new _select2.default({ el: this.$directorPowers }).render();
					// this.contractCity = new Select({el: this.$contractCity}).render();
	
					// this.contractCity.setOptions(this.options.cities);
	
					this.inn = new _inn2.default({ el: this.$inn }).render();
					this.city = new _city2.default({
						el: this.$city,
						callback: {
							set: this.onCityChange.bind(this)
						}
					}).render();
	
					this.$documentType.on('change', this.onDocumentTypeChange.bind(this));
	
					// this.field.entity.$type.on('change', this.onSelectChange.bind(this));
					// this.field.director.$office.on('change', this.onSelectChange.bind(this));
	
					_jquery2.default.fn.datepicker.dates['ru'] = {
						days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
						daysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
						daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
						months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
						monthsShort: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
						today: 'Сегодня',
						clear: 'Очистить',
						format: 'mm/dd/yyyy',
						titleFormat: 'MM yyyy',
						weekStart: 1
					};
					this.field.entity.$date.datepicker({
						format: 'dd.mm.yyyy',
						language: 'ru',
						templates: {
							leftArrow: '&lt;',
							rightArrow: '&gt;'
						},
						autoclose: true,
						endDate: '0d'
					});
	
					this.field.document.$birthdate.datepicker({
						format: 'dd.mm.yyyy',
						language: 'ru',
						templates: {
							leftArrow: '&lt;',
							rightArrow: '&gt;'
						},
						autoclose: true,
						endDate: '0d'
					});
	
					this.field.document.$date.datepicker({
						format: 'dd.mm.yyyy',
						language: 'ru',
						templates: {
							leftArrow: '&lt;',
							rightArrow: '&gt;'
						},
						autoclose: true,
						endDate: '0d'
					});
					this.field.contract.$date.datepicker({
						format: 'dd.mm.yyyy',
						language: 'ru',
						templates: {
							leftArrow: '&lt;',
							rightArrow: '&gt;'
						},
						autoclose: true,
						startDate: '0d'
					});
	
					this.field.director.$custom.on('input change paste keydown', this.onDirectorCustomInput.bind(this));
					this.field.director.$powersCustom.on('input change paste keydown', this.onDirectorPowersCustomInput.bind(this));
	
					this.field.entity.$inn.on('input change paste keydown', this.onEntityInnInput.bind(this));
					this.field.entity.$kpp.on('input change paste keydown', this.onEntityKppInput.bind(this));
					this.field.entity.$ogrn.on('input change paste keydown', this.onEntityOgrnInput.bind(this));
					this.field.entity.$ogrnip.on('input change paste keydown', this.onEntityOgrnipInput.bind(this));
	
					this.field.document.$issuedCode.inputmask('999-999', this.maskConfig);
	
					// this.masked = new InputMask('AA 9{6,7}');
	
					// this.masked(this.field.document.$number);
	
					// this.documentNumber = new Numbered(this.field.document.$number, {mask: 'ББ #{6,7}'});
	
					// this.entityDate = new Numbered(this.field.entity.$date, {mask: '##.##.####'});
					// this.documentDate = new Numbered(this.field.document.$date, {mask: '##.##.####'});
					// this.contractDate = new Numbered(this.field.contract.$date, {mask: '##.##.####'});
	
					// this.field.entity.$date.on('change', this.onSelectChange.bind(this));
	
					this.$window.on('yota.connect.info.inn', this.onInnFind.bind(this));
	
					this.$fields.on('focusin', this.onFocus.bind(this)).on('change', this.onChange.bind(this));
	
					this.update();
				}
	
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(27);
	
	var _underscore = __webpack_require__(4);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(29)(_jquery2.default);
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-inn',
				dom: {
					input: '.js-inn-input',
					dropdown: '.js-inn-dropdown',
					list: '.js-inn-manual',
					search: '.js-inn-search',
					item: '.js-inn-item',
					template: {
						search: '.js-inn-template'
					},
					form: {
						search: {
							el: '.js-inn-form-search',
							query: '.js-inn-form-search-query'
						},
						set: {
							el: '.js-inn-form-set',
							id: '.js-inn-form-set-id'
						}
					}
				},
				classes: {
					state: {
						open: 'b-inn_state_open',
						search: 'b-inn_state_search',
						empty: 'b-inn_state_empty',
						load: 'b-inn_state_load',
						error: 'b-inn_state_error'
					},
					item: {
						state: {
							active: 'b-inn__item_state_active',
							hidden: 'b-inn__item_state_hidden'
						}
					}
				},
				size: {
					height: 34,
					count: 7
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.searchQuery = '';
			this.preventSearch = false;
			this.searchInputDebounced = false;
			this.searchInputDebounce = false;
			this.searchLoadDebounce = false;
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.$document = (0, _jquery2.default)(document);
			this.$window = (0, _jquery2.default)(window);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$input = this.$el.find(this.options.dom.input);
				this.$dropdown = this.$el.find(this.options.dom.dropdown);
				this.$list = this.$el.find(this.options.dom.list);
				this.$listItems = this.$list.find(this.options.dom.item);
				this.$search = this.$el.find(this.options.dom.search);
				this.$searchItems = this.$search.find(this.options.dom.item);
				this.$templateSearch = this.$el.find(this.options.dom.template.search);
				this.templateSearch = _underscore2.default.template(this.$templateSearch.html().trim());
				this.$fromSearch = this.$el.find(this.options.dom.form.search.el);
				this.$fromSearchQuery = this.$el.find(this.options.dom.form.search.query);
				this.$fromSet = this.$el.find(this.options.dom.form.set.el);
				this.$fromSetId = this.$el.find(this.options.dom.form.set.id);
				return this;
			}
		}, {
			key: 'setSearchOptions',
			value: function setSearchOptions(options) {
				var isError = false;
				if (_typeof(options[0]) == 'object') {
					isError = options[0].error === true;
				}
				this.$search.html(this.templateSearch({ data: isError ? [] : options }));
				this.$searchItems = this.$search.find(this.options.dom.item);
				this.$items = this.$searchItems;
				this.$el.toggleClass(this.options.classes.state.empty, this.$items.length === 0 && !isError);
				this.$el.toggleClass(this.options.classes.state.error, isError === true);
				this.$el.addClass(this.options.classes.state.search, !isError);
				return this;
			}
		}, {
			key: 'search',
			value: function search(query) {
				var self = this;
				var thisQuery = query;
				self.searchQuery = thisQuery;
				self.$fromSearchQuery.val(thisQuery);
				_jquery2.default.ajax({
					url: self.$fromSearch.attr('action'),
					type: self.$fromSearch.attr('method'),
					data: self.$fromSearch.serialize(),
					dataType: 'json',
					success: function success(json) {
						if (thisQuery === self.searchQuery) {
							self.find(json);
						}
					}
				});
			}
		}, {
			key: 'find',
			value: function find(data) {
				clearTimeout(this.searchLoadDebounce);
				this.setSearchOptions(data);
				this.$el.removeClass(this.options.classes.state.load);
			}
		}, {
			key: 'set',
			value: function set(id) {
				var self = this;
				if (id !== '') {
					self.$fromSetId.val(id);
					_jquery2.default.ajax({
						url: self.$fromSet.attr('action'),
						type: self.$fromSet.attr('method'),
						data: self.$fromSet.serialize(),
						dataType: 'json',
						success: function success(json) {
							self.$window.trigger('yota.connect.info.inn', [json, false]);
						}
					});
				} else {
					self.$window.trigger('yota.connect.info.inn', [{}, true]);
				}
			}
		}, {
			key: 'setValue',
			value: function setValue(val) {
				this.$input.val(val);
			}
		}, {
			key: 'filter',
			value: function filter(query) {
				var self = this;
				var thisQuery = query;
	
				clearTimeout(self.searchInputDebounce);
				clearTimeout(self.searchLoadDebounce);
	
				if (query.length >= 4) {
					self.searchInputDebounce = setTimeout(function () {
						self.searchInputDebounced = false;
						self.searchLoadDebounce = setTimeout(function () {
							self.$el.addClass(self.options.classes.state.load);
						}, self.$searchItems.length > 0 ? 1000 : 50);
						self.search(thisQuery);
					}, self.searchInputDebounced ? 0 : 300);
					self.searchInputDebounced = true;
				} else {
					self.searchQuery = '';
					self.$items = self.$listItems;
					self.$el.removeClass(self.options.classes.state.search).removeClass(self.options.classes.state.empty).removeClass(self.options.classes.state.load);
				}
				return self;
			}
		}, {
			key: 'clear',
			value: function clear() {
				// this.filter('');
				// this.$input.val('');
				return this;
			}
		}, {
			key: 'open',
			value: function open() {
				this.$el.removeClass(this.options.classes.state.search).removeClass(this.options.classes.state.empty).removeClass(this.options.classes.state.load).removeClass(this.options.classes.state.error).addClass(this.options.classes.state.open);
				this.$el.find(this.options.dom.item).removeClass(this.options.classes.item.state.active);
				this.$dropdown.data('position', 0);
				this.$dropdown.mNCustomScrollbar('scrollTo', 0);
				this.$el.trigger('yota.region.open');
				return this;
			}
		}, {
			key: 'close',
			value: function close() {
				this.$el.removeClass(this.options.classes.state.search).removeClass(this.options.classes.state.empty).removeClass(this.options.classes.state.load).removeClass(this.options.classes.state.error).removeClass(this.options.classes.state.open);
	
				this.$el.trigger('yota.region.close');
				return this;
			}
		}, {
			key: 'onFocusIn',
			value: function onFocusIn() {
				this.clear().open();
			}
		}, {
			key: 'onDocumentClick',
			value: function onDocumentClick(event) {
				var $target = (0, _jquery2.default)(event.target);
				if (this.$el.hasClass(this.options.classes.state.open)) {
					if (!$target.is(this.$el) && !$target.closest(this.$el).length) {
						this.clear().close();
					}
				}
			}
		}, {
			key: 'selectActive',
			value: function selectActive() {
				var $active = this.getActive();
				if ($active !== false) {
					$active.trigger('click');
					this.$input.blur();
				}
				return this;
			}
		}, {
			key: 'getActive',
			value: function getActive() {
				var $visible = this.$items.filter(this.options.dom.item + ':not(.' + this.options.classes.item.state.hidden + ')');
				var $active = $visible.filter('.' + this.options.classes.item.state.active).eq(0);
				this.$items.not($active).removeClass(this.options.classes.item.state.active);
				if (!$active.length) {
					$visible.first().addClass(this.options.classes.item.state.active);
					return false;
				}
				return $active;
			}
		}, {
			key: 'scrollToItem',
			value: function scrollToItem($active) {
				var itemHeight = $active.outerHeight(true);
				var itemTop = $active.position().top;
				var scrollTop = this.$dropdown.data('position');
				var scrollHeight = this.$dropdown.outerHeight(true);
				var scrollTo = false;
				if (itemTop < scrollTop) {
					scrollTo = itemTop;
				}
				if (itemTop + itemHeight - scrollHeight > scrollTop) {
					scrollTo = itemTop + itemHeight - scrollHeight;
				}
				if (scrollTo !== false) {
					this.$dropdown.mNCustomScrollbar('scrollTo', scrollTo);
				}
				return this;
			}
		}, {
			key: 'moveActive',
			value: function moveActive(direction) {
				var $active = this.getActive();
				if ($active !== false) {
					var $set = $active[direction ? 'nextAll' : 'prevAll'](this.options.dom.item + ':not(.' + this.options.classes.item.state.hidden + ')').eq(0);
					if (!$set.length) {
						$set = this.$items.filter(':not(.' + this.options.classes.item.state.hidden + ')')[direction ? 'first' : 'last']();
					}
					this.$items.not($set).removeClass(this.options.classes.item.state.active);
					$set.addClass(this.options.classes.item.state.active);
					this.scrollToItem($set);
				}
				return this;
			}
		}, {
			key: 'onInput',
			value: function onInput(event) {
				var code = event.which;
				var codeUp = code === 38;
				var codeDown = code === 40;
				var codeEnter = code === 13;
	
				if (codeUp || codeDown || codeEnter) {
					event.preventDefault();
					if (codeEnter) {
						this.selectActive();
					} else {
						this.moveActive(codeDown);
					}
				} else if (!this.preventSearch) {
					var filter = this.$input.val().trim();
					this.filter(filter);
				}
			}
		}, {
			key: 'onClick',
			value: function onClick(event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
				this.preventSearch = true;
				this.set($target.data('value'));
				this.$input.val($target.data('value'));
				this.close();
				this.preventSearch = false;
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
	
					self.getDom();
	
					self.$dropdown.mNCustomScrollbar({
						autoDraggerLength: false,
						mouseWheel: {
							enable: true,
							preventDefault: true
						},
						contentTouchScroll: self.options.size.height * 2,
						mouseWheelPixels: self.options.size.height * 2,
						scrollButtons: false,
						scrollInertia: self.options.size.height * self.options.size.count,
						theme: '',
						callbacks: {
							onCreate: function onCreate() {
								self.$dropdown.data('position', 0);
							},
							onUpdate: function onUpdate() {
								if (this.mncs) {
									self.$dropdown.data('position', this.mncs.top < 0 ? -this.mncs.top : 0);
								}
							},
							whileScrolling: function whileScrolling() {
								if (this.mncs) {
									self.$dropdown.data('position', this.mncs.top < 0 ? -this.mncs.top : 0);
								}
							}
						}
					});
	
					self.$el.on('focusin.region', self.options.dom.input, self.onFocusIn.bind(self)).on('input.region paste.region keydown.region', self.options.dom.input, self.onInput.bind(self)).on('click.region', self.options.dom.item, self.onClick.bind(self));
	
					self.$document.on('click.region', self.onDocumentClick.bind(self));
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	* jquery.inputmask.bundle.js
	* https://github.com/RobinHerbots/jquery.inputmask
	* Copyright (c) 2010 - 2016 Robin Herbots
	* Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php)
	* Version: 3.3.4
	*/
	!function($) {
	    function Inputmask(alias, options) {
	        return this instanceof Inputmask ? ($.isPlainObject(alias) ? options = alias : (options = options || {}, 
	        options.alias = alias), this.el = void 0, this.opts = $.extend(!0, {}, this.defaults, options), 
	        this.maskset = void 0, this.noMasksCache = options && void 0 !== options.definitions, 
	        this.userOptions = options || {}, this.events = {}, this.dataAttribute = "data-inputmask", 
	        this.isRTL = this.opts.numericInput, void resolveAlias(this.opts.alias, options, this.opts)) : new Inputmask(alias, options);
	    }
	    function resolveAlias(aliasStr, options, opts) {
	        var aliasDefinition = opts.aliases[aliasStr];
	        return aliasDefinition ? (aliasDefinition.alias && resolveAlias(aliasDefinition.alias, void 0, opts), 
	        $.extend(!0, opts, aliasDefinition), $.extend(!0, opts, options), !0) : (null === opts.mask && (opts.mask = aliasStr), 
	        !1);
	    }
	    function generateMaskSet(opts, nocache) {
	        function generateMask(mask, metadata, opts) {
	            if (null !== mask && "" !== mask) {
	                if (1 === mask.length && opts.greedy === !1 && 0 !== opts.repeat && (opts.placeholder = ""), 
	                opts.repeat > 0 || "*" === opts.repeat || "+" === opts.repeat) {
	                    var repeatStart = "*" === opts.repeat ? 0 : "+" === opts.repeat ? 1 : opts.repeat;
	                    mask = opts.groupmarker.start + mask + opts.groupmarker.end + opts.quantifiermarker.start + repeatStart + "," + opts.repeat + opts.quantifiermarker.end;
	                }
	                var masksetDefinition;
	                return void 0 === Inputmask.prototype.masksCache[mask] || nocache === !0 ? (masksetDefinition = {
	                    mask: mask,
	                    maskToken: Inputmask.prototype.analyseMask(mask, opts),
	                    validPositions: {},
	                    _buffer: void 0,
	                    buffer: void 0,
	                    tests: {},
	                    metadata: metadata,
	                    maskLength: void 0
	                }, nocache !== !0 && (Inputmask.prototype.masksCache[opts.numericInput ? mask.split("").reverse().join("") : mask] = masksetDefinition, 
	                masksetDefinition = $.extend(!0, {}, Inputmask.prototype.masksCache[opts.numericInput ? mask.split("").reverse().join("") : mask]))) : masksetDefinition = $.extend(!0, {}, Inputmask.prototype.masksCache[opts.numericInput ? mask.split("").reverse().join("") : mask]), 
	                masksetDefinition;
	            }
	        }
	        var ms;
	        if ($.isFunction(opts.mask) && (opts.mask = opts.mask(opts)), $.isArray(opts.mask)) {
	            if (opts.mask.length > 1) {
	                opts.keepStatic = null === opts.keepStatic || opts.keepStatic;
	                var altMask = opts.groupmarker.start;
	                return $.each(opts.numericInput ? opts.mask.reverse() : opts.mask, function(ndx, msk) {
	                    altMask.length > 1 && (altMask += opts.groupmarker.end + opts.alternatormarker + opts.groupmarker.start), 
	                    altMask += void 0 === msk.mask || $.isFunction(msk.mask) ? msk : msk.mask;
	                }), altMask += opts.groupmarker.end, generateMask(altMask, opts.mask, opts);
	            }
	            opts.mask = opts.mask.pop();
	        }
	        return opts.mask && (ms = void 0 === opts.mask.mask || $.isFunction(opts.mask.mask) ? generateMask(opts.mask, opts.mask, opts) : generateMask(opts.mask.mask, opts.mask, opts)), 
	        ms;
	    }
	    function maskScope(actionObj, maskset, opts) {
	        function getMaskTemplate(baseOnInput, minimalPos, includeMode) {
	            minimalPos = minimalPos || 0;
	            var ndxIntlzr, test, testPos, maskTemplate = [], pos = 0, lvp = getLastValidPosition();
	            maxLength = void 0 !== el ? el.maxLength : void 0, maxLength === -1 && (maxLength = void 0);
	            do baseOnInput === !0 && getMaskSet().validPositions[pos] ? (testPos = getMaskSet().validPositions[pos], 
	            test = testPos.match, ndxIntlzr = testPos.locator.slice(), maskTemplate.push(includeMode === !0 ? testPos.input : includeMode === !1 ? test.nativeDef : getPlaceholder(pos, test))) : (testPos = getTestTemplate(pos, ndxIntlzr, pos - 1), 
	            test = testPos.match, ndxIntlzr = testPos.locator.slice(), (opts.jitMasking === !1 || pos < lvp || "number" == typeof opts.jitMasking && isFinite(opts.jitMasking) && opts.jitMasking > pos) && maskTemplate.push(includeMode === !1 ? test.nativeDef : getPlaceholder(pos, test))), 
	            pos++; while ((void 0 === maxLength || pos < maxLength) && (null !== test.fn || "" !== test.def) || minimalPos > pos);
	            return "" === maskTemplate[maskTemplate.length - 1] && maskTemplate.pop(), getMaskSet().maskLength = pos + 1, 
	            maskTemplate;
	        }
	        function getMaskSet() {
	            return maskset;
	        }
	        function resetMaskSet(soft) {
	            var maskset = getMaskSet();
	            maskset.buffer = void 0, soft !== !0 && (maskset._buffer = void 0, maskset.validPositions = {}, 
	            maskset.p = 0);
	        }
	        function getLastValidPosition(closestTo, strict, validPositions) {
	            var before = -1, after = -1, valids = validPositions || getMaskSet().validPositions;
	            void 0 === closestTo && (closestTo = -1);
	            for (var posNdx in valids) {
	                var psNdx = parseInt(posNdx);
	                valids[psNdx] && (strict || null !== valids[psNdx].match.fn) && (psNdx <= closestTo && (before = psNdx), 
	                psNdx >= closestTo && (after = psNdx));
	            }
	            return before !== -1 && closestTo - before > 1 || after < closestTo ? before : after;
	        }
	        function stripValidPositions(start, end, nocheck, strict) {
	            function IsEnclosedStatic(pos) {
	                var posMatch = getMaskSet().validPositions[pos];
	                if (void 0 !== posMatch && null === posMatch.match.fn) {
	                    var prevMatch = getMaskSet().validPositions[pos - 1], nextMatch = getMaskSet().validPositions[pos + 1];
	                    return void 0 !== prevMatch && void 0 !== nextMatch;
	                }
	                return !1;
	            }
	            var i, startPos = start, positionsClone = $.extend(!0, {}, getMaskSet().validPositions), needsValidation = !1;
	            for (getMaskSet().p = start, i = end - 1; i >= startPos; i--) void 0 !== getMaskSet().validPositions[i] && (nocheck !== !0 && (!getMaskSet().validPositions[i].match.optionality && IsEnclosedStatic(i) || opts.canClearPosition(getMaskSet(), i, getLastValidPosition(), strict, opts) === !1) || delete getMaskSet().validPositions[i]);
	            for (resetMaskSet(!0), i = startPos + 1; i <= getLastValidPosition(); ) {
	                for (;void 0 !== getMaskSet().validPositions[startPos]; ) startPos++;
	                if (i < startPos && (i = startPos + 1), void 0 === getMaskSet().validPositions[i] && isMask(i)) i++; else {
	                    var t = getTestTemplate(i);
	                    needsValidation === !1 && positionsClone[startPos] && positionsClone[startPos].match.def === t.match.def ? (getMaskSet().validPositions[startPos] = $.extend(!0, {}, positionsClone[startPos]), 
	                    getMaskSet().validPositions[startPos].input = t.input, delete getMaskSet().validPositions[i], 
	                    i++) : positionCanMatchDefinition(startPos, t.match.def) ? isValid(startPos, t.input || getPlaceholder(i), !0) !== !1 && (delete getMaskSet().validPositions[i], 
	                    i++, needsValidation = !0) : isMask(i) || (i++, startPos--), startPos++;
	                }
	            }
	            resetMaskSet(!0);
	        }
	        function determineTestTemplate(tests, guessNextBest) {
	            for (var testPos, testPositions = tests, lvp = getLastValidPosition(), lvTest = getMaskSet().validPositions[lvp] || getTests(0)[0], lvTestAltArr = void 0 !== lvTest.alternation ? lvTest.locator[lvTest.alternation].toString().split(",") : [], ndx = 0; ndx < testPositions.length && (testPos = testPositions[ndx], 
	            !(testPos.match && (opts.greedy && testPos.match.optionalQuantifier !== !0 || (testPos.match.optionality === !1 || testPos.match.newBlockMarker === !1) && testPos.match.optionalQuantifier !== !0) && (void 0 === lvTest.alternation || lvTest.alternation !== testPos.alternation || void 0 !== testPos.locator[lvTest.alternation] && checkAlternationMatch(testPos.locator[lvTest.alternation].toString().split(","), lvTestAltArr))) || guessNextBest === !0 && (null !== testPos.match.fn || /[0-9a-bA-Z]/.test(testPos.match.def))); ndx++) ;
	            return testPos;
	        }
	        function getTestTemplate(pos, ndxIntlzr, tstPs) {
	            return getMaskSet().validPositions[pos] || determineTestTemplate(getTests(pos, ndxIntlzr ? ndxIntlzr.slice() : ndxIntlzr, tstPs));
	        }
	        function getTest(pos) {
	            return getMaskSet().validPositions[pos] ? getMaskSet().validPositions[pos] : getTests(pos)[0];
	        }
	        function positionCanMatchDefinition(pos, def) {
	            for (var valid = !1, tests = getTests(pos), tndx = 0; tndx < tests.length; tndx++) if (tests[tndx].match && tests[tndx].match.def === def) {
	                valid = !0;
	                break;
	            }
	            return valid;
	        }
	        function getTests(pos, ndxIntlzr, tstPs) {
	            function resolveTestFromToken(maskToken, ndxInitializer, loopNdx, quantifierRecurse) {
	                function handleMatch(match, loopNdx, quantifierRecurse) {
	                    function isFirstMatch(latestMatch, tokenGroup) {
	                        var firstMatch = 0 === $.inArray(latestMatch, tokenGroup.matches);
	                        return firstMatch || $.each(tokenGroup.matches, function(ndx, match) {
	                            if (match.isQuantifier === !0 && (firstMatch = isFirstMatch(latestMatch, tokenGroup.matches[ndx - 1]))) return !1;
	                        }), firstMatch;
	                    }
	                    function resolveNdxInitializer(pos, alternateNdx, targetAlternation) {
	                        var bestMatch, indexPos;
	                        return (getMaskSet().tests[pos] || getMaskSet().validPositions[pos]) && $.each(getMaskSet().tests[pos] || [ getMaskSet().validPositions[pos] ], function(ndx, lmnt) {
	                            var alternation = void 0 !== targetAlternation ? targetAlternation : lmnt.alternation, ndxPos = void 0 !== lmnt.locator[alternation] ? lmnt.locator[alternation].toString().indexOf(alternateNdx) : -1;
	                            (void 0 === indexPos || ndxPos < indexPos) && ndxPos !== -1 && (bestMatch = lmnt, 
	                            indexPos = ndxPos);
	                        }), bestMatch ? bestMatch.locator.slice((void 0 !== targetAlternation ? targetAlternation : bestMatch.alternation) + 1) : void 0 !== targetAlternation ? resolveNdxInitializer(pos, alternateNdx) : void 0;
	                    }
	                    function staticCanMatchDefinition(source, target) {
	                        return null === source.match.fn && null !== target.match.fn && target.match.fn.test(source.match.def, getMaskSet(), pos, !1, opts, !1);
	                    }
	                    if (testPos > 1e4) throw "Inputmask: There is probably an error in your mask definition or in the code. Create an issue on github with an example of the mask you are using. " + getMaskSet().mask;
	                    if (testPos === pos && void 0 === match.matches) return matches.push({
	                        match: match,
	                        locator: loopNdx.reverse(),
	                        cd: cacheDependency
	                    }), !0;
	                    if (void 0 !== match.matches) {
	                        if (match.isGroup && quantifierRecurse !== match) {
	                            if (match = handleMatch(maskToken.matches[$.inArray(match, maskToken.matches) + 1], loopNdx)) return !0;
	                        } else if (match.isOptional) {
	                            var optionalToken = match;
	                            if (match = resolveTestFromToken(match, ndxInitializer, loopNdx, quantifierRecurse)) {
	                                if (latestMatch = matches[matches.length - 1].match, !isFirstMatch(latestMatch, optionalToken)) return !0;
	                                insertStop = !0, testPos = pos;
	                            }
	                        } else if (match.isAlternator) {
	                            var maltMatches, alternateToken = match, malternateMatches = [], currentMatches = matches.slice(), loopNdxCnt = loopNdx.length, altIndex = ndxInitializer.length > 0 ? ndxInitializer.shift() : -1;
	                            if (altIndex === -1 || "string" == typeof altIndex) {
	                                var amndx, currentPos = testPos, ndxInitializerClone = ndxInitializer.slice(), altIndexArr = [];
	                                if ("string" == typeof altIndex) altIndexArr = altIndex.split(","); else for (amndx = 0; amndx < alternateToken.matches.length; amndx++) altIndexArr.push(amndx);
	                                for (var ndx = 0; ndx < altIndexArr.length; ndx++) {
	                                    if (amndx = parseInt(altIndexArr[ndx]), matches = [], ndxInitializer = resolveNdxInitializer(testPos, amndx, loopNdxCnt) || ndxInitializerClone.slice(), 
	                                    match = handleMatch(alternateToken.matches[amndx] || maskToken.matches[amndx], [ amndx ].concat(loopNdx), quantifierRecurse) || match, 
	                                    match !== !0 && void 0 !== match && altIndexArr[altIndexArr.length - 1] < alternateToken.matches.length) {
	                                        var ntndx = $.inArray(match, maskToken.matches) + 1;
	                                        maskToken.matches.length > ntndx && (match = handleMatch(maskToken.matches[ntndx], [ ntndx ].concat(loopNdx.slice(1, loopNdx.length)), quantifierRecurse), 
	                                        match && (altIndexArr.push(ntndx.toString()), $.each(matches, function(ndx, lmnt) {
	                                            lmnt.alternation = loopNdx.length - 1;
	                                        })));
	                                    }
	                                    maltMatches = matches.slice(), testPos = currentPos, matches = [];
	                                    for (var ndx1 = 0; ndx1 < maltMatches.length; ndx1++) {
	                                        var altMatch = maltMatches[ndx1], hasMatch = !1;
	                                        altMatch.alternation = altMatch.alternation || loopNdxCnt;
	                                        for (var ndx2 = 0; ndx2 < malternateMatches.length; ndx2++) {
	                                            var altMatch2 = malternateMatches[ndx2];
	                                            if (("string" != typeof altIndex || $.inArray(altMatch.locator[altMatch.alternation].toString(), altIndexArr) !== -1) && (altMatch.match.def === altMatch2.match.def || staticCanMatchDefinition(altMatch, altMatch2))) {
	                                                hasMatch = altMatch.match.nativeDef === altMatch2.match.nativeDef, altMatch.alternation == altMatch2.alternation && altMatch2.locator[altMatch2.alternation].toString().indexOf(altMatch.locator[altMatch.alternation]) === -1 && (altMatch2.locator[altMatch2.alternation] = altMatch2.locator[altMatch2.alternation] + "," + altMatch.locator[altMatch.alternation], 
	                                                altMatch2.alternation = altMatch.alternation, null == altMatch.match.fn && (altMatch2.na = altMatch2.na || altMatch.locator[altMatch.alternation].toString(), 
	                                                altMatch2.na.indexOf(altMatch.locator[altMatch.alternation]) === -1 && (altMatch2.na = altMatch2.na + "," + altMatch.locator[altMatch.alternation])));
	                                                break;
	                                            }
	                                        }
	                                        hasMatch || malternateMatches.push(altMatch);
	                                    }
	                                }
	                                "string" == typeof altIndex && (malternateMatches = $.map(malternateMatches, function(lmnt, ndx) {
	                                    if (isFinite(ndx)) {
	                                        var mamatch, alternation = lmnt.alternation, altLocArr = lmnt.locator[alternation].toString().split(",");
	                                        lmnt.locator[alternation] = void 0, lmnt.alternation = void 0;
	                                        for (var alndx = 0; alndx < altLocArr.length; alndx++) mamatch = $.inArray(altLocArr[alndx], altIndexArr) !== -1, 
	                                        mamatch && (void 0 !== lmnt.locator[alternation] ? (lmnt.locator[alternation] += ",", 
	                                        lmnt.locator[alternation] += altLocArr[alndx]) : lmnt.locator[alternation] = parseInt(altLocArr[alndx]), 
	                                        lmnt.alternation = alternation);
	                                        if (void 0 !== lmnt.locator[alternation]) return lmnt;
	                                    }
	                                })), matches = currentMatches.concat(malternateMatches), testPos = pos, insertStop = matches.length > 0, 
	                                ndxInitializer = ndxInitializerClone.slice();
	                            } else match = handleMatch(alternateToken.matches[altIndex] || maskToken.matches[altIndex], [ altIndex ].concat(loopNdx), quantifierRecurse);
	                            if (match) return !0;
	                        } else if (match.isQuantifier && quantifierRecurse !== maskToken.matches[$.inArray(match, maskToken.matches) - 1]) for (var qt = match, qndx = ndxInitializer.length > 0 ? ndxInitializer.shift() : 0; qndx < (isNaN(qt.quantifier.max) ? qndx + 1 : qt.quantifier.max) && testPos <= pos; qndx++) {
	                            var tokenGroup = maskToken.matches[$.inArray(qt, maskToken.matches) - 1];
	                            if (match = handleMatch(tokenGroup, [ qndx ].concat(loopNdx), tokenGroup)) {
	                                if (latestMatch = matches[matches.length - 1].match, latestMatch.optionalQuantifier = qndx > qt.quantifier.min - 1, 
	                                isFirstMatch(latestMatch, tokenGroup)) {
	                                    if (qndx > qt.quantifier.min - 1) {
	                                        insertStop = !0, testPos = pos;
	                                        break;
	                                    }
	                                    return !0;
	                                }
	                                return !0;
	                            }
	                        } else if (match = resolveTestFromToken(match, ndxInitializer, loopNdx, quantifierRecurse)) return !0;
	                    } else testPos++;
	                }
	                for (var tndx = ndxInitializer.length > 0 ? ndxInitializer.shift() : 0; tndx < maskToken.matches.length; tndx++) if (maskToken.matches[tndx].isQuantifier !== !0) {
	                    var match = handleMatch(maskToken.matches[tndx], [ tndx ].concat(loopNdx), quantifierRecurse);
	                    if (match && testPos === pos) return match;
	                    if (testPos > pos) break;
	                }
	            }
	            function mergeLocators(tests) {
	                var locator = [];
	                return $.isArray(tests) || (tests = [ tests ]), tests.length > 0 && (void 0 === tests[0].alternation ? (locator = determineTestTemplate(tests.slice()).locator.slice(), 
	                0 === locator.length && (locator = tests[0].locator.slice())) : $.each(tests, function(ndx, tst) {
	                    if ("" !== tst.def) if (0 === locator.length) locator = tst.locator.slice(); else for (var i = 0; i < locator.length; i++) tst.locator[i] && locator[i].toString().indexOf(tst.locator[i]) === -1 && (locator[i] += "," + tst.locator[i]);
	                })), locator;
	            }
	            function filterTests(tests) {
	                return opts.keepStatic && pos > 0 && tests.length > 1 + ("" === tests[tests.length - 1].match.def ? 1 : 0) && tests[0].match.optionality !== !0 && tests[0].match.optionalQuantifier !== !0 && null === tests[0].match.fn && !/[0-9a-bA-Z]/.test(tests[0].match.def) ? [ determineTestTemplate(tests) ] : tests;
	            }
	            var latestMatch, maskTokens = getMaskSet().maskToken, testPos = ndxIntlzr ? tstPs : 0, ndxInitializer = ndxIntlzr ? ndxIntlzr.slice() : [ 0 ], matches = [], insertStop = !1, cacheDependency = ndxIntlzr ? ndxIntlzr.join("") : "";
	            if (pos > -1) {
	                if (void 0 === ndxIntlzr) {
	                    for (var test, previousPos = pos - 1; void 0 === (test = getMaskSet().validPositions[previousPos] || getMaskSet().tests[previousPos]) && previousPos > -1; ) previousPos--;
	                    void 0 !== test && previousPos > -1 && (ndxInitializer = mergeLocators(test), cacheDependency = ndxInitializer.join(""), 
	                    testPos = previousPos);
	                }
	                if (getMaskSet().tests[pos] && getMaskSet().tests[pos][0].cd === cacheDependency) return filterTests(getMaskSet().tests[pos]);
	                for (var mtndx = ndxInitializer.shift(); mtndx < maskTokens.length; mtndx++) {
	                    var match = resolveTestFromToken(maskTokens[mtndx], ndxInitializer, [ mtndx ]);
	                    if (match && testPos === pos || testPos > pos) break;
	                }
	            }
	            return (0 === matches.length || insertStop) && matches.push({
	                match: {
	                    fn: null,
	                    cardinality: 0,
	                    optionality: !0,
	                    casing: null,
	                    def: "",
	                    placeholder: ""
	                },
	                locator: [],
	                cd: cacheDependency
	            }), void 0 !== ndxIntlzr && getMaskSet().tests[pos] ? filterTests($.extend(!0, [], matches)) : (getMaskSet().tests[pos] = $.extend(!0, [], matches), 
	            filterTests(getMaskSet().tests[pos]));
	        }
	        function getBufferTemplate() {
	            return void 0 === getMaskSet()._buffer && (getMaskSet()._buffer = getMaskTemplate(!1, 1), 
	            void 0 === getMaskSet().buffer && getMaskSet()._buffer.slice()), getMaskSet()._buffer;
	        }
	        function getBuffer(noCache) {
	            return void 0 !== getMaskSet().buffer && noCache !== !0 || (getMaskSet().buffer = getMaskTemplate(!0, getLastValidPosition(), !0)), 
	            getMaskSet().buffer;
	        }
	        function refreshFromBuffer(start, end, buffer) {
	            var i;
	            if (start === !0) resetMaskSet(), start = 0, end = buffer.length; else for (i = start; i < end; i++) delete getMaskSet().validPositions[i];
	            for (i = start; i < end; i++) resetMaskSet(!0), buffer[i] !== opts.skipOptionalPartCharacter && isValid(i, buffer[i], !0, !0);
	        }
	        function casing(elem, test, pos) {
	            switch (opts.casing || test.casing) {
	              case "upper":
	                elem = elem.toUpperCase();
	                break;
	
	              case "lower":
	                elem = elem.toLowerCase();
	                break;
	
	              case "title":
	                var posBefore = getMaskSet().validPositions[pos - 1];
	                elem = 0 === pos || posBefore && posBefore.input === String.fromCharCode(Inputmask.keyCode.SPACE) ? elem.toUpperCase() : elem.toLowerCase();
	            }
	            return elem;
	        }
	        function checkAlternationMatch(altArr1, altArr2) {
	            for (var altArrC = opts.greedy ? altArr2 : altArr2.slice(0, 1), isMatch = !1, alndx = 0; alndx < altArr1.length; alndx++) if ($.inArray(altArr1[alndx], altArrC) !== -1) {
	                isMatch = !0;
	                break;
	            }
	            return isMatch;
	        }
	        function isValid(pos, c, strict, fromSetValid, fromAlternate) {
	            function isSelection(posObj) {
	                var selection = isRTL ? posObj.begin - posObj.end > 1 || posObj.begin - posObj.end === 1 && opts.insertMode : posObj.end - posObj.begin > 1 || posObj.end - posObj.begin === 1 && opts.insertMode;
	                return selection && 0 === posObj.begin && posObj.end === getMaskSet().maskLength ? "full" : selection;
	            }
	            function _isValid(position, c, strict) {
	                var rslt = !1;
	                return $.each(getTests(position), function(ndx, tst) {
	                    for (var test = tst.match, loopend = c ? 1 : 0, chrs = "", i = test.cardinality; i > loopend; i--) chrs += getBufferElement(position - (i - 1));
	                    if (c && (chrs += c), getBuffer(!0), rslt = null != test.fn ? test.fn.test(chrs, getMaskSet(), position, strict, opts, isSelection(pos)) : (c === test.def || c === opts.skipOptionalPartCharacter) && "" !== test.def && {
	                        c: test.placeholder || test.def,
	                        pos: position
	                    }, rslt !== !1) {
	                        var elem = void 0 !== rslt.c ? rslt.c : c;
	                        elem = elem === opts.skipOptionalPartCharacter && null === test.fn ? test.placeholder || test.def : elem;
	                        var validatedPos = position, possibleModifiedBuffer = getBuffer();
	                        if (void 0 !== rslt.remove && ($.isArray(rslt.remove) || (rslt.remove = [ rslt.remove ]), 
	                        $.each(rslt.remove.sort(function(a, b) {
	                            return b - a;
	                        }), function(ndx, lmnt) {
	                            stripValidPositions(lmnt, lmnt + 1, !0);
	                        })), void 0 !== rslt.insert && ($.isArray(rslt.insert) || (rslt.insert = [ rslt.insert ]), 
	                        $.each(rslt.insert.sort(function(a, b) {
	                            return a - b;
	                        }), function(ndx, lmnt) {
	                            isValid(lmnt.pos, lmnt.c, !0, fromSetValid);
	                        })), rslt.refreshFromBuffer) {
	                            var refresh = rslt.refreshFromBuffer;
	                            if (strict = !0, refreshFromBuffer(refresh === !0 ? refresh : refresh.start, refresh.end, possibleModifiedBuffer), 
	                            void 0 === rslt.pos && void 0 === rslt.c) return rslt.pos = getLastValidPosition(), 
	                            !1;
	                            if (validatedPos = void 0 !== rslt.pos ? rslt.pos : position, validatedPos !== position) return rslt = $.extend(rslt, isValid(validatedPos, elem, !0, fromSetValid)), 
	                            !1;
	                        } else if (rslt !== !0 && void 0 !== rslt.pos && rslt.pos !== position && (validatedPos = rslt.pos, 
	                        refreshFromBuffer(position, validatedPos, getBuffer().slice()), validatedPos !== position)) return rslt = $.extend(rslt, isValid(validatedPos, elem, !0)), 
	                        !1;
	                        return (rslt === !0 || void 0 !== rslt.pos || void 0 !== rslt.c) && (ndx > 0 && resetMaskSet(!0), 
	                        setValidPosition(validatedPos, $.extend({}, tst, {
	                            input: casing(elem, test, validatedPos)
	                        }), fromSetValid, isSelection(pos)) || (rslt = !1), !1);
	                    }
	                }), rslt;
	            }
	            function alternate(pos, c, strict) {
	                var lastAlt, alternation, altPos, prevAltPos, i, validPos, altNdxs, decisionPos, validPsClone = $.extend(!0, {}, getMaskSet().validPositions), isValidRslt = !1, lAltPos = getLastValidPosition();
	                for (prevAltPos = getMaskSet().validPositions[lAltPos]; lAltPos >= 0; lAltPos--) if (altPos = getMaskSet().validPositions[lAltPos], 
	                altPos && void 0 !== altPos.alternation) {
	                    if (lastAlt = lAltPos, alternation = getMaskSet().validPositions[lastAlt].alternation, 
	                    prevAltPos.locator[altPos.alternation] !== altPos.locator[altPos.alternation]) break;
	                    prevAltPos = altPos;
	                }
	                if (void 0 !== alternation) {
	                    decisionPos = parseInt(lastAlt);
	                    var decisionTaker = void 0 !== prevAltPos.locator[prevAltPos.alternation || alternation] ? prevAltPos.locator[prevAltPos.alternation || alternation] : altNdxs[0];
	                    decisionTaker.length > 0 && (decisionTaker = decisionTaker.split(",")[0]);
	                    var possibilityPos = getMaskSet().validPositions[decisionPos], prevPos = getMaskSet().validPositions[decisionPos - 1];
	                    $.each(getTests(decisionPos, prevPos ? prevPos.locator : void 0, decisionPos - 1), function(ndx, test) {
	                        altNdxs = test.locator[alternation] ? test.locator[alternation].toString().split(",") : [];
	                        for (var mndx = 0; mndx < altNdxs.length; mndx++) {
	                            var validInputs = [], staticInputsBeforePos = 0, staticInputsBeforePosAlternate = 0, verifyValidInput = !1;
	                            if (decisionTaker < altNdxs[mndx] && (void 0 === test.na || $.inArray(altNdxs[mndx], test.na.split(",")) === -1)) {
	                                getMaskSet().validPositions[decisionPos] = $.extend(!0, {}, test);
	                                var possibilities = getMaskSet().validPositions[decisionPos].locator;
	                                for (getMaskSet().validPositions[decisionPos].locator[alternation] = parseInt(altNdxs[mndx]), 
	                                null == test.match.fn ? (possibilityPos.input !== test.match.def && (verifyValidInput = !0, 
	                                possibilityPos.generatedInput !== !0 && validInputs.push(possibilityPos.input)), 
	                                staticInputsBeforePosAlternate++, getMaskSet().validPositions[decisionPos].generatedInput = !/[0-9a-bA-Z]/.test(test.match.def), 
	                                getMaskSet().validPositions[decisionPos].input = test.match.def) : getMaskSet().validPositions[decisionPos].input = possibilityPos.input, 
	                                i = decisionPos + 1; i < getLastValidPosition(void 0, !0) + 1; i++) validPos = getMaskSet().validPositions[i], 
	                                validPos && validPos.generatedInput !== !0 && /[0-9a-bA-Z]/.test(validPos.input) ? validInputs.push(validPos.input) : i < pos && staticInputsBeforePos++, 
	                                delete getMaskSet().validPositions[i];
	                                for (verifyValidInput && validInputs[0] === test.match.def && validInputs.shift(), 
	                                resetMaskSet(!0), isValidRslt = !0; validInputs.length > 0; ) {
	                                    var input = validInputs.shift();
	                                    if (input !== opts.skipOptionalPartCharacter && !(isValidRslt = isValid(getLastValidPosition(void 0, !0) + 1, input, !1, fromSetValid, !0))) break;
	                                }
	                                if (isValidRslt) {
	                                    getMaskSet().validPositions[decisionPos].locator = possibilities;
	                                    var targetLvp = getLastValidPosition(pos) + 1;
	                                    for (i = decisionPos + 1; i < getLastValidPosition() + 1; i++) validPos = getMaskSet().validPositions[i], 
	                                    (void 0 === validPos || null == validPos.match.fn) && i < pos + (staticInputsBeforePosAlternate - staticInputsBeforePos) && staticInputsBeforePosAlternate++;
	                                    pos += staticInputsBeforePosAlternate - staticInputsBeforePos, isValidRslt = isValid(pos > targetLvp ? targetLvp : pos, c, strict, fromSetValid, !0);
	                                }
	                                if (isValidRslt) return !1;
	                                resetMaskSet(), getMaskSet().validPositions = $.extend(!0, {}, validPsClone);
	                            }
	                        }
	                    });
	                }
	                return isValidRslt;
	            }
	            function trackbackAlternations(originalPos, newPos) {
	                var vp = getMaskSet().validPositions[newPos];
	                if (vp) for (var targetLocator = vp.locator, tll = targetLocator.length, ps = originalPos; ps < newPos; ps++) if (void 0 === getMaskSet().validPositions[ps] && !isMask(ps, !0)) {
	                    var tests = getTests(ps), bestMatch = tests[0], equality = -1;
	                    $.each(tests, function(ndx, tst) {
	                        for (var i = 0; i < tll && (void 0 !== tst.locator[i] && checkAlternationMatch(tst.locator[i].toString().split(","), targetLocator[i].toString().split(","))); i++) equality < i && (equality = i, 
	                        bestMatch = tst);
	                    }), setValidPosition(ps, $.extend({}, bestMatch, {
	                        input: bestMatch.match.placeholder || bestMatch.match.def
	                    }), !0);
	                }
	            }
	            function setValidPosition(pos, validTest, fromSetValid, isSelection) {
	                if (isSelection || opts.insertMode && void 0 !== getMaskSet().validPositions[pos] && void 0 === fromSetValid) {
	                    var i, positionsClone = $.extend(!0, {}, getMaskSet().validPositions), lvp = getLastValidPosition(void 0, !0);
	                    for (i = pos; i <= lvp; i++) delete getMaskSet().validPositions[i];
	                    getMaskSet().validPositions[pos] = $.extend(!0, {}, validTest);
	                    var j, valid = !0, vps = getMaskSet().validPositions, needsValidation = !1, initialLength = getMaskSet().maskLength;
	                    for (i = j = pos; i <= lvp; i++) {
	                        var t = positionsClone[i];
	                        if (void 0 !== t) for (var posMatch = j; posMatch < getMaskSet().maskLength && (null === t.match.fn && vps[i] && (vps[i].match.optionalQuantifier === !0 || vps[i].match.optionality === !0) || null != t.match.fn); ) {
	                            if (posMatch++, needsValidation === !1 && positionsClone[posMatch] && positionsClone[posMatch].match.def === t.match.def) getMaskSet().validPositions[posMatch] = $.extend(!0, {}, positionsClone[posMatch]), 
	                            getMaskSet().validPositions[posMatch].input = t.input, fillMissingNonMask(posMatch), 
	                            j = posMatch, valid = !0; else if (positionCanMatchDefinition(posMatch, t.match.def)) {
	                                var result = isValid(posMatch, t.input, !0, !0);
	                                valid = result !== !1, j = result.caret || result.insert ? getLastValidPosition() : posMatch, 
	                                needsValidation = !0;
	                            } else valid = t.generatedInput === !0;
	                            if (getMaskSet().maskLength < initialLength && (getMaskSet().maskLength = initialLength), 
	                            valid) break;
	                        }
	                        if (!valid) break;
	                    }
	                    if (!valid) return getMaskSet().validPositions = $.extend(!0, {}, positionsClone), 
	                    resetMaskSet(!0), !1;
	                } else getMaskSet().validPositions[pos] = $.extend(!0, {}, validTest);
	                return resetMaskSet(!0), !0;
	            }
	            function fillMissingNonMask(maskPos) {
	                for (var pndx = maskPos - 1; pndx > -1 && !getMaskSet().validPositions[pndx]; pndx--) ;
	                var testTemplate, testsFromPos;
	                for (pndx++; pndx < maskPos; pndx++) void 0 === getMaskSet().validPositions[pndx] && (opts.jitMasking === !1 || opts.jitMasking > pndx) && (testsFromPos = getTests(pndx, getTestTemplate(pndx - 1).locator, pndx - 1).slice(), 
	                "" === testsFromPos[testsFromPos.length - 1].match.def && testsFromPos.pop(), testTemplate = determineTestTemplate(testsFromPos), 
	                testTemplate && (testTemplate.match.def === opts.radixPointDefinitionSymbol || !isMask(pndx, !0) || $.inArray(opts.radixPoint, getBuffer()) < pndx && testTemplate.match.fn && testTemplate.match.fn.test(getPlaceholder(pndx), getMaskSet(), pndx, !1, opts)) && (result = _isValid(pndx, testTemplate.match.placeholder || (null == testTemplate.match.fn ? testTemplate.match.def : "" !== getPlaceholder(pndx) ? getPlaceholder(pndx) : getBuffer()[pndx]), !0), 
	                result !== !1 && (getMaskSet().validPositions[result.pos || pndx].generatedInput = !0)));
	            }
	            strict = strict === !0;
	            var maskPos = pos;
	            void 0 !== pos.begin && (maskPos = isRTL && !isSelection(pos) ? pos.end : pos.begin);
	            var result = !1, positionsClone = $.extend(!0, {}, getMaskSet().validPositions);
	            if (fillMissingNonMask(maskPos), isSelection(pos) && (handleRemove(void 0, Inputmask.keyCode.DELETE, pos), 
	            maskPos = getMaskSet().p), maskPos < getMaskSet().maskLength && (result = _isValid(maskPos, c, strict), 
	            (!strict || fromSetValid === !0) && result === !1)) {
	                var currentPosValid = getMaskSet().validPositions[maskPos];
	                if (!currentPosValid || null !== currentPosValid.match.fn || currentPosValid.match.def !== c && c !== opts.skipOptionalPartCharacter) {
	                    if ((opts.insertMode || void 0 === getMaskSet().validPositions[seekNext(maskPos)]) && !isMask(maskPos, !0)) {
	                        var testsFromPos = getTests(maskPos).slice();
	                        "" === testsFromPos[testsFromPos.length - 1].match.def && testsFromPos.pop();
	                        var staticChar = determineTestTemplate(testsFromPos, !0);
	                        staticChar && null === staticChar.match.fn && (staticChar = staticChar.match.placeholder || staticChar.match.def, 
	                        _isValid(maskPos, staticChar, strict), getMaskSet().validPositions[maskPos].generatedInput = !0);
	                        for (var nPos = maskPos + 1, snPos = seekNext(maskPos); nPos <= snPos; nPos++) if (result = _isValid(nPos, c, strict), 
	                        result !== !1) {
	                            trackbackAlternations(maskPos, void 0 !== result.pos ? result.pos : nPos), maskPos = nPos;
	                            break;
	                        }
	                    }
	                } else result = {
	                    caret: seekNext(maskPos)
	                };
	            }
	            return result === !1 && opts.keepStatic && !strict && fromAlternate !== !0 && (result = alternate(maskPos, c, strict)), 
	            result === !0 && (result = {
	                pos: maskPos
	            }), $.isFunction(opts.postValidation) && result !== !1 && !strict && fromSetValid !== !0 && (result = !!opts.postValidation(getBuffer(!0), result, opts) && result), 
	            void 0 === result.pos && (result.pos = maskPos), result === !1 && (resetMaskSet(!0), 
	            getMaskSet().validPositions = $.extend(!0, {}, positionsClone)), result;
	        }
	        function isMask(pos, strict) {
	            var test;
	            if (strict ? (test = getTestTemplate(pos).match, "" === test.def && (test = getTest(pos).match)) : test = getTest(pos).match, 
	            null != test.fn) return test.fn;
	            if (strict !== !0 && pos > -1) {
	                var tests = getTests(pos);
	                return tests.length > 1 + ("" === tests[tests.length - 1].match.def ? 1 : 0);
	            }
	            return !1;
	        }
	        function seekNext(pos, newBlock) {
	            var maskL = getMaskSet().maskLength;
	            if (pos >= maskL) return maskL;
	            for (var position = pos; ++position < maskL && (newBlock === !0 && (getTest(position).match.newBlockMarker !== !0 || !isMask(position)) || newBlock !== !0 && !isMask(position)); ) ;
	            return position;
	        }
	        function seekPrevious(pos, newBlock) {
	            var tests, position = pos;
	            if (position <= 0) return 0;
	            for (;--position > 0 && (newBlock === !0 && getTest(position).match.newBlockMarker !== !0 || newBlock !== !0 && !isMask(position) && (tests = getTests(position), 
	            tests.length < 2 || 2 === tests.length && "" === tests[1].match.def)); ) ;
	            return position;
	        }
	        function getBufferElement(position) {
	            return void 0 === getMaskSet().validPositions[position] ? getPlaceholder(position) : getMaskSet().validPositions[position].input;
	        }
	        function writeBuffer(input, buffer, caretPos, event, triggerInputEvent) {
	            if (event && $.isFunction(opts.onBeforeWrite)) {
	                var result = opts.onBeforeWrite(event, buffer, caretPos, opts);
	                if (result) {
	                    if (result.refreshFromBuffer) {
	                        var refresh = result.refreshFromBuffer;
	                        refreshFromBuffer(refresh === !0 ? refresh : refresh.start, refresh.end, result.buffer || buffer), 
	                        buffer = getBuffer(!0);
	                    }
	                    void 0 !== caretPos && (caretPos = void 0 !== result.caret ? result.caret : caretPos);
	                }
	            }
	            input.inputmask._valueSet(buffer.join("")), void 0 === caretPos || void 0 !== event && "blur" === event.type ? renderColorMask(input, buffer, caretPos) : caret(input, caretPos), 
	            triggerInputEvent === !0 && (skipInputEvent = !0, $(input).trigger("input"));
	        }
	        function getPlaceholder(pos, test) {
	            if (test = test || getTest(pos).match, void 0 !== test.placeholder) return test.placeholder;
	            if (null === test.fn) {
	                if (pos > -1 && void 0 === getMaskSet().validPositions[pos]) {
	                    var prevTest, tests = getTests(pos), staticAlternations = [];
	                    if (tests.length > 1 + ("" === tests[tests.length - 1].match.def ? 1 : 0)) for (var i = 0; i < tests.length; i++) if (tests[i].match.optionality !== !0 && tests[i].match.optionalQuantifier !== !0 && (null === tests[i].match.fn || void 0 === prevTest || tests[i].match.fn.test(prevTest.match.def, getMaskSet(), pos, !0, opts) !== !1) && (staticAlternations.push(tests[i]), 
	                    null === tests[i].match.fn && (prevTest = tests[i]), staticAlternations.length > 1 && /[0-9a-bA-Z]/.test(staticAlternations[0].match.def))) return opts.placeholder.charAt(pos % opts.placeholder.length);
	                }
	                return test.def;
	            }
	            return opts.placeholder.charAt(pos % opts.placeholder.length);
	        }
	        function checkVal(input, writeOut, strict, nptvl, initiatingEvent, stickyCaret) {
	            function isTemplateMatch() {
	                var isMatch = !1, charCodeNdx = getBufferTemplate().slice(initialNdx, seekNext(initialNdx)).join("").indexOf(charCodes);
	                if (charCodeNdx !== -1 && !isMask(initialNdx)) {
	                    isMatch = !0;
	                    for (var bufferTemplateArr = getBufferTemplate().slice(initialNdx, initialNdx + charCodeNdx), i = 0; i < bufferTemplateArr.length; i++) if (" " !== bufferTemplateArr[i]) {
	                        isMatch = !1;
	                        break;
	                    }
	                }
	                return isMatch;
	            }
	            var inputValue = nptvl.slice(), charCodes = "", initialNdx = 0, result = void 0;
	            if (resetMaskSet(), getMaskSet().p = seekNext(-1), !strict) if (opts.autoUnmask !== !0) {
	                var staticInput = getBufferTemplate().slice(0, seekNext(-1)).join(""), matches = inputValue.join("").match(new RegExp("^" + Inputmask.escapeRegex(staticInput), "g"));
	                matches && matches.length > 0 && (inputValue.splice(0, matches.length * staticInput.length), 
	                initialNdx = seekNext(initialNdx));
	            } else initialNdx = seekNext(initialNdx);
	            if ($.each(inputValue, function(ndx, charCode) {
	                if (void 0 !== charCode) {
	                    var keypress = new $.Event("keypress");
	                    keypress.which = charCode.charCodeAt(0), charCodes += charCode;
	                    var lvp = getLastValidPosition(void 0, !0), lvTest = getMaskSet().validPositions[lvp], nextTest = getTestTemplate(lvp + 1, lvTest ? lvTest.locator.slice() : void 0, lvp);
	                    if (!isTemplateMatch() || strict || opts.autoUnmask) {
	                        var pos = strict ? ndx : null == nextTest.match.fn && nextTest.match.optionality && lvp + 1 < getMaskSet().p ? lvp + 1 : getMaskSet().p;
	                        result = EventHandlers.keypressEvent.call(input, keypress, !0, !1, strict, pos), 
	                        initialNdx = pos + 1, charCodes = "";
	                    } else result = EventHandlers.keypressEvent.call(input, keypress, !0, !1, !0, lvp + 1);
	                    if (!strict && $.isFunction(opts.onBeforeWrite) && (result = opts.onBeforeWrite(keypress, getBuffer(), result.forwardPosition, opts), 
	                    result && result.refreshFromBuffer)) {
	                        var refresh = result.refreshFromBuffer;
	                        refreshFromBuffer(refresh === !0 ? refresh : refresh.start, refresh.end, result.buffer), 
	                        resetMaskSet(!0), result.caret && (getMaskSet().p = result.caret);
	                    }
	                }
	            }), writeOut) {
	                var caretPos = void 0, lvp = getLastValidPosition();
	                document.activeElement === input && (initiatingEvent || result) && (caretPos = caret(input).begin, 
	                initiatingEvent && result === !1 && (caretPos = seekNext(getLastValidPosition(caretPos))), 
	                result && stickyCaret !== !0 && (caretPos < lvp + 1 || lvp === -1) && (caretPos = opts.numericInput && void 0 === result.caret ? seekPrevious(result.forwardPosition) : result.forwardPosition)), 
	                writeBuffer(input, getBuffer(), caretPos, initiatingEvent || new $.Event("checkval"));
	            }
	        }
	        function unmaskedvalue(input) {
	            if (input && void 0 === input.inputmask) return input.value;
	            var umValue = [], vps = getMaskSet().validPositions;
	            for (var pndx in vps) vps[pndx].match && null != vps[pndx].match.fn && umValue.push(vps[pndx].input);
	            var unmaskedValue = 0 === umValue.length ? "" : (isRTL ? umValue.reverse() : umValue).join("");
	            if ($.isFunction(opts.onUnMask)) {
	                var bufferValue = (isRTL ? getBuffer().slice().reverse() : getBuffer()).join("");
	                unmaskedValue = opts.onUnMask(bufferValue, unmaskedValue, opts) || unmaskedValue;
	            }
	            return unmaskedValue;
	        }
	        function caret(input, begin, end, notranslate) {
	            function translatePosition(pos) {
	                if (notranslate !== !0 && isRTL && "number" == typeof pos && (!opts.greedy || "" !== opts.placeholder)) {
	                    var bffrLght = getBuffer().join("").length;
	                    pos = bffrLght - pos;
	                }
	                return pos;
	            }
	            var range;
	            if ("number" != typeof begin) return input.setSelectionRange ? (begin = input.selectionStart, 
	            end = input.selectionEnd) : window.getSelection ? (range = window.getSelection().getRangeAt(0), 
	            range.commonAncestorContainer.parentNode !== input && range.commonAncestorContainer !== input || (begin = range.startOffset, 
	            end = range.endOffset)) : document.selection && document.selection.createRange && (range = document.selection.createRange(), 
	            begin = 0 - range.duplicate().moveStart("character", -input.inputmask._valueGet().length), 
	            end = begin + range.text.length), {
	                begin: translatePosition(begin),
	                end: translatePosition(end)
	            };
	            begin = translatePosition(begin), end = translatePosition(end), end = "number" == typeof end ? end : begin;
	            var scrollCalc = parseInt(((input.ownerDocument.defaultView || window).getComputedStyle ? (input.ownerDocument.defaultView || window).getComputedStyle(input, null) : input.currentStyle).fontSize) * end;
	            if (input.scrollLeft = scrollCalc > input.scrollWidth ? scrollCalc : 0, mobile || opts.insertMode !== !1 || begin !== end || end++, 
	            input.setSelectionRange) input.selectionStart = begin, input.selectionEnd = end; else if (window.getSelection) {
	                if (range = document.createRange(), void 0 === input.firstChild || null === input.firstChild) {
	                    var textNode = document.createTextNode("");
	                    input.appendChild(textNode);
	                }
	                range.setStart(input.firstChild, begin < input.inputmask._valueGet().length ? begin : input.inputmask._valueGet().length), 
	                range.setEnd(input.firstChild, end < input.inputmask._valueGet().length ? end : input.inputmask._valueGet().length), 
	                range.collapse(!0);
	                var sel = window.getSelection();
	                sel.removeAllRanges(), sel.addRange(range);
	            } else input.createTextRange && (range = input.createTextRange(), range.collapse(!0), 
	            range.moveEnd("character", end), range.moveStart("character", begin), range.select());
	            renderColorMask(input, void 0, {
	                begin: begin,
	                end: end
	            });
	        }
	        function determineLastRequiredPosition(returnDefinition) {
	            var pos, testPos, buffer = getBuffer(), bl = buffer.length, lvp = getLastValidPosition(), positions = {}, lvTest = getMaskSet().validPositions[lvp], ndxIntlzr = void 0 !== lvTest ? lvTest.locator.slice() : void 0;
	            for (pos = lvp + 1; pos < buffer.length; pos++) testPos = getTestTemplate(pos, ndxIntlzr, pos - 1), 
	            ndxIntlzr = testPos.locator.slice(), positions[pos] = $.extend(!0, {}, testPos);
	            var lvTestAlt = lvTest && void 0 !== lvTest.alternation ? lvTest.locator[lvTest.alternation] : void 0;
	            for (pos = bl - 1; pos > lvp && (testPos = positions[pos], (testPos.match.optionality || testPos.match.optionalQuantifier || lvTestAlt && (lvTestAlt !== positions[pos].locator[lvTest.alternation] && null != testPos.match.fn || null === testPos.match.fn && testPos.locator[lvTest.alternation] && checkAlternationMatch(testPos.locator[lvTest.alternation].toString().split(","), lvTestAlt.toString().split(",")) && "" !== getTests(pos)[0].def)) && buffer[pos] === getPlaceholder(pos, testPos.match)); pos--) bl--;
	            return returnDefinition ? {
	                l: bl,
	                def: positions[bl] ? positions[bl].match : void 0
	            } : bl;
	        }
	        function clearOptionalTail(buffer) {
	            for (var rl = determineLastRequiredPosition(), lmib = buffer.length - 1; lmib > rl && !isMask(lmib); lmib--) ;
	            return buffer.splice(rl, lmib + 1 - rl), buffer;
	        }
	        function isComplete(buffer) {
	            if ($.isFunction(opts.isComplete)) return opts.isComplete(buffer, opts);
	            if ("*" !== opts.repeat) {
	                var complete = !1, lrp = determineLastRequiredPosition(!0), aml = seekPrevious(lrp.l);
	                if (void 0 === lrp.def || lrp.def.newBlockMarker || lrp.def.optionality || lrp.def.optionalQuantifier) {
	                    complete = !0;
	                    for (var i = 0; i <= aml; i++) {
	                        var test = getTestTemplate(i).match;
	                        if (null !== test.fn && void 0 === getMaskSet().validPositions[i] && test.optionality !== !0 && test.optionalQuantifier !== !0 || null === test.fn && buffer[i] !== getPlaceholder(i, test)) {
	                            complete = !1;
	                            break;
	                        }
	                    }
	                }
	                return complete;
	            }
	        }
	        function handleRemove(input, k, pos, strict) {
	            function generalize() {
	                if (opts.keepStatic) {
	                    for (var validInputs = [], lastAlt = getLastValidPosition(-1, !0), positionsClone = $.extend(!0, {}, getMaskSet().validPositions), prevAltPos = getMaskSet().validPositions[lastAlt]; lastAlt >= 0; lastAlt--) {
	                        var altPos = getMaskSet().validPositions[lastAlt];
	                        if (altPos) {
	                            if (altPos.generatedInput !== !0 && /[0-9a-bA-Z]/.test(altPos.input) && validInputs.push(altPos.input), 
	                            delete getMaskSet().validPositions[lastAlt], void 0 !== altPos.alternation && altPos.locator[altPos.alternation] !== prevAltPos.locator[altPos.alternation]) break;
	                            prevAltPos = altPos;
	                        }
	                    }
	                    if (lastAlt > -1) for (getMaskSet().p = seekNext(getLastValidPosition(-1, !0)); validInputs.length > 0; ) {
	                        var keypress = new $.Event("keypress");
	                        keypress.which = validInputs.pop().charCodeAt(0), EventHandlers.keypressEvent.call(input, keypress, !0, !1, !1, getMaskSet().p);
	                    } else getMaskSet().validPositions = $.extend(!0, {}, positionsClone);
	                }
	            }
	            if ((opts.numericInput || isRTL) && (k === Inputmask.keyCode.BACKSPACE ? k = Inputmask.keyCode.DELETE : k === Inputmask.keyCode.DELETE && (k = Inputmask.keyCode.BACKSPACE), 
	            isRTL)) {
	                var pend = pos.end;
	                pos.end = pos.begin, pos.begin = pend;
	            }
	            k === Inputmask.keyCode.BACKSPACE && (pos.end - pos.begin < 1 || opts.insertMode === !1) ? (pos.begin = seekPrevious(pos.begin), 
	            void 0 === getMaskSet().validPositions[pos.begin] || getMaskSet().validPositions[pos.begin].input !== opts.groupSeparator && getMaskSet().validPositions[pos.begin].input !== opts.radixPoint || pos.begin--) : k === Inputmask.keyCode.DELETE && pos.begin === pos.end && (pos.end = isMask(pos.end, !0) ? pos.end + 1 : seekNext(pos.end) + 1, 
	            void 0 === getMaskSet().validPositions[pos.begin] || getMaskSet().validPositions[pos.begin].input !== opts.groupSeparator && getMaskSet().validPositions[pos.begin].input !== opts.radixPoint || pos.end++), 
	            stripValidPositions(pos.begin, pos.end, !1, strict), strict !== !0 && generalize();
	            var lvp = getLastValidPosition(pos.begin, !0);
	            lvp < pos.begin ? getMaskSet().p = seekNext(lvp) : strict !== !0 && (getMaskSet().p = pos.begin);
	        }
	        function initializeColorMask(input) {
	            function findCaretPos(clientx) {
	                var caretPos, e = document.createElement("span");
	                for (var style in computedStyle) isNaN(style) && style.indexOf("font") !== -1 && (e.style[style] = computedStyle[style]);
	                e.style.textTransform = computedStyle.textTransform, e.style.letterSpacing = computedStyle.letterSpacing, 
	                e.style.position = "absolute", e.style.height = "auto", e.style.width = "auto", 
	                e.style.visibility = "hidden", e.style.whiteSpace = "nowrap", document.body.appendChild(e);
	                var itl, inputText = input.inputmask._valueGet(), previousWidth = 0;
	                for (caretPos = 0, itl = inputText.length; caretPos <= itl; caretPos++) {
	                    if (e.innerHTML += inputText.charAt(caretPos) || "_", e.offsetWidth >= clientx) {
	                        var offset1 = clientx - previousWidth, offset2 = e.offsetWidth - clientx;
	                        e.innerHTML = inputText.charAt(caretPos), offset1 -= e.offsetWidth / 3, caretPos = offset1 < offset2 ? caretPos - 1 : caretPos;
	                        break;
	                    }
	                    previousWidth = e.offsetWidth;
	                }
	                return document.body.removeChild(e), caretPos;
	            }
	            function position() {
	                colorMask.style.position = "absolute", colorMask.style.top = offset.top + "px", 
	                colorMask.style.left = offset.left + "px", colorMask.style.width = parseInt(input.offsetWidth) - parseInt(computedStyle.paddingLeft) - parseInt(computedStyle.paddingRight) - parseInt(computedStyle.borderLeftWidth) - parseInt(computedStyle.borderRightWidth) + "px", 
	                colorMask.style.height = parseInt(input.offsetHeight) - parseInt(computedStyle.paddingTop) - parseInt(computedStyle.paddingBottom) - parseInt(computedStyle.borderTopWidth) - parseInt(computedStyle.borderBottomWidth) + "px", 
	                colorMask.style.lineHeight = colorMask.style.height, colorMask.style.zIndex = isNaN(computedStyle.zIndex) ? -1 : computedStyle.zIndex - 1, 
	                colorMask.style.webkitAppearance = "textfield", colorMask.style.mozAppearance = "textfield", 
	                colorMask.style.Appearance = "textfield";
	            }
	            var offset = $(input).position(), computedStyle = (input.ownerDocument.defaultView || window).getComputedStyle(input, null);
	            input.parentNode;
	            colorMask = document.createElement("div"), document.body.appendChild(colorMask);
	            for (var style in computedStyle) isNaN(style) && "cssText" !== style && style.indexOf("webkit") == -1 && (colorMask.style[style] = computedStyle[style]);
	            input.style.backgroundColor = "transparent", input.style.color = "transparent", 
	            input.style.webkitAppearance = "caret", input.style.mozAppearance = "caret", input.style.Appearance = "caret", 
	            position(), $(window).on("resize", function(e) {
	                offset = $(input).position(), computedStyle = (input.ownerDocument.defaultView || window).getComputedStyle(input, null), 
	                position();
	            }), $(input).on("click", function(e) {
	                return caret(input, findCaretPos(e.clientX)), EventHandlers.clickEvent.call(this, [ e ]);
	            }), $(input).on("keydown", function(e) {
	                e.shiftKey || opts.insertMode === !1 || setTimeout(function() {
	                    renderColorMask(input);
	                }, 0);
	            });
	        }
	        function renderColorMask(input, buffer, caretPos) {
	            function handleStatic() {
	                static || null !== test.fn && void 0 !== testPos.input ? static && null !== test.fn && void 0 !== testPos.input && (static = !1, 
	                maskTemplate += "</span>") : (static = !0, maskTemplate += "<span class='im-static''>");
	            }
	            if (void 0 !== colorMask) {
	                buffer = buffer || getBuffer(), void 0 === caretPos ? caretPos = caret(input) : void 0 === caretPos.begin && (caretPos = {
	                    begin: caretPos,
	                    end: caretPos
	                });
	                var maskTemplate = "", static = !1;
	                if ("" != buffer) {
	                    var ndxIntlzr, test, testPos, pos = 0, lvp = getLastValidPosition();
	                    do pos === caretPos.begin && document.activeElement === input && (maskTemplate += "<span class='im-caret' style='border-right-width: 1px;border-right-style: solid;'></span>"), 
	                    getMaskSet().validPositions[pos] ? (testPos = getMaskSet().validPositions[pos], 
	                    test = testPos.match, ndxIntlzr = testPos.locator.slice(), handleStatic(), maskTemplate += testPos.input) : (testPos = getTestTemplate(pos, ndxIntlzr, pos - 1), 
	                    test = testPos.match, ndxIntlzr = testPos.locator.slice(), (opts.jitMasking === !1 || pos < lvp || "number" == typeof opts.jitMasking && isFinite(opts.jitMasking) && opts.jitMasking > pos) && (handleStatic(), 
	                    maskTemplate += getPlaceholder(pos, test))), pos++; while ((void 0 === maxLength || pos < maxLength) && (null !== test.fn || "" !== test.def) || lvp > pos);
	                }
	                colorMask.innerHTML = maskTemplate;
	            }
	        }
	        function mask(elem) {
	            function isElementTypeSupported(input, opts) {
	                function patchValueProperty(npt) {
	                    function patchValhook(type) {
	                        if ($.valHooks && (void 0 === $.valHooks[type] || $.valHooks[type].inputmaskpatch !== !0)) {
	                            var valhookGet = $.valHooks[type] && $.valHooks[type].get ? $.valHooks[type].get : function(elem) {
	                                return elem.value;
	                            }, valhookSet = $.valHooks[type] && $.valHooks[type].set ? $.valHooks[type].set : function(elem, value) {
	                                return elem.value = value, elem;
	                            };
	                            $.valHooks[type] = {
	                                get: function(elem) {
	                                    if (elem.inputmask) {
	                                        if (elem.inputmask.opts.autoUnmask) return elem.inputmask.unmaskedvalue();
	                                        var result = valhookGet(elem);
	                                        return getLastValidPosition(void 0, void 0, elem.inputmask.maskset.validPositions) !== -1 || opts.nullable !== !0 ? result : "";
	                                    }
	                                    return valhookGet(elem);
	                                },
	                                set: function(elem, value) {
	                                    var result, $elem = $(elem);
	                                    return result = valhookSet(elem, value), elem.inputmask && $elem.trigger("setvalue"), 
	                                    result;
	                                },
	                                inputmaskpatch: !0
	                            };
	                        }
	                    }
	                    function getter() {
	                        return this.inputmask ? this.inputmask.opts.autoUnmask ? this.inputmask.unmaskedvalue() : getLastValidPosition() !== -1 || opts.nullable !== !0 ? document.activeElement === this && opts.clearMaskOnLostFocus ? (isRTL ? clearOptionalTail(getBuffer().slice()).reverse() : clearOptionalTail(getBuffer().slice())).join("") : valueGet.call(this) : "" : valueGet.call(this);
	                    }
	                    function setter(value) {
	                        valueSet.call(this, value), this.inputmask && $(this).trigger("setvalue");
	                    }
	                    function installNativeValueSetFallback(npt) {
	                        EventRuler.on(npt, "mouseenter", function(event) {
	                            var $input = $(this), input = this, value = input.inputmask._valueGet();
	                            value !== getBuffer().join("") && $input.trigger("setvalue");
	                        });
	                    }
	                    var valueGet, valueSet;
	                    if (!npt.inputmask.__valueGet) {
	                        if (opts.noValuePatching !== !0) {
	                            if (Object.getOwnPropertyDescriptor) {
	                                "function" != typeof Object.getPrototypeOf && (Object.getPrototypeOf = "object" == typeof "test".__proto__ ? function(object) {
	                                    return object.__proto__;
	                                } : function(object) {
	                                    return object.constructor.prototype;
	                                });
	                                var valueProperty = Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(npt), "value") : void 0;
	                                valueProperty && valueProperty.get && valueProperty.set ? (valueGet = valueProperty.get, 
	                                valueSet = valueProperty.set, Object.defineProperty(npt, "value", {
	                                    get: getter,
	                                    set: setter,
	                                    configurable: !0
	                                })) : "INPUT" !== npt.tagName && (valueGet = function() {
	                                    return this.textContent;
	                                }, valueSet = function(value) {
	                                    this.textContent = value;
	                                }, Object.defineProperty(npt, "value", {
	                                    get: getter,
	                                    set: setter,
	                                    configurable: !0
	                                }));
	                            } else document.__lookupGetter__ && npt.__lookupGetter__("value") && (valueGet = npt.__lookupGetter__("value"), 
	                            valueSet = npt.__lookupSetter__("value"), npt.__defineGetter__("value", getter), 
	                            npt.__defineSetter__("value", setter));
	                            npt.inputmask.__valueGet = valueGet, npt.inputmask.__valueSet = valueSet;
	                        }
	                        npt.inputmask._valueGet = function(overruleRTL) {
	                            return isRTL && overruleRTL !== !0 ? valueGet.call(this.el).split("").reverse().join("") : valueGet.call(this.el);
	                        }, npt.inputmask._valueSet = function(value, overruleRTL) {
	                            valueSet.call(this.el, null === value || void 0 === value ? "" : overruleRTL !== !0 && isRTL ? value.split("").reverse().join("") : value);
	                        }, void 0 === valueGet && (valueGet = function() {
	                            return this.value;
	                        }, valueSet = function(value) {
	                            this.value = value;
	                        }, patchValhook(npt.type), installNativeValueSetFallback(npt));
	                    }
	                }
	                var elementType = input.getAttribute("type"), isSupported = "INPUT" === input.tagName && $.inArray(elementType, opts.supportsInputType) !== -1 || input.isContentEditable || "TEXTAREA" === input.tagName;
	                if (!isSupported) if ("INPUT" === input.tagName) {
	                    var el = document.createElement("input");
	                    el.setAttribute("type", elementType), isSupported = "text" === el.type, el = null;
	                } else isSupported = "partial";
	                return isSupported !== !1 && patchValueProperty(input), isSupported;
	            }
	            var isSupported = isElementTypeSupported(elem, opts);
	            if (isSupported !== !1 && (el = elem, $el = $(el), ("rtl" === el.dir || opts.rightAlign) && (el.style.textAlign = "right"), 
	            ("rtl" === el.dir || opts.numericInput) && (el.dir = "ltr", el.removeAttribute("dir"), 
	            el.inputmask.isRTL = !0, isRTL = !0), opts.colorMask === !0 && initializeColorMask(el), 
	            android && (el.hasOwnProperty("inputmode") && (el.inputmode = opts.inputmode, el.setAttribute("inputmode", opts.inputmode)), 
	            "rtfm" === opts.androidHack && (opts.colorMask !== !0 && initializeColorMask(el), 
	            el.type = "password")), EventRuler.off(el), isSupported === !0 && (EventRuler.on(el, "submit", EventHandlers.submitEvent), 
	            EventRuler.on(el, "reset", EventHandlers.resetEvent), EventRuler.on(el, "mouseenter", EventHandlers.mouseenterEvent), 
	            EventRuler.on(el, "blur", EventHandlers.blurEvent), EventRuler.on(el, "focus", EventHandlers.focusEvent), 
	            EventRuler.on(el, "mouseleave", EventHandlers.mouseleaveEvent), opts.colorMask !== !0 && EventRuler.on(el, "click", EventHandlers.clickEvent), 
	            EventRuler.on(el, "dblclick", EventHandlers.dblclickEvent), EventRuler.on(el, "paste", EventHandlers.pasteEvent), 
	            EventRuler.on(el, "dragdrop", EventHandlers.pasteEvent), EventRuler.on(el, "drop", EventHandlers.pasteEvent), 
	            EventRuler.on(el, "cut", EventHandlers.cutEvent), EventRuler.on(el, "complete", opts.oncomplete), 
	            EventRuler.on(el, "incomplete", opts.onincomplete), EventRuler.on(el, "cleared", opts.oncleared), 
	            opts.inputEventOnly !== !0 && (EventRuler.on(el, "keydown", EventHandlers.keydownEvent), 
	            EventRuler.on(el, "keypress", EventHandlers.keypressEvent)), EventRuler.on(el, "compositionstart", $.noop), 
	            EventRuler.on(el, "compositionupdate", $.noop), EventRuler.on(el, "compositionend", $.noop), 
	            EventRuler.on(el, "keyup", $.noop), EventRuler.on(el, "input", EventHandlers.inputFallBackEvent)), 
	            EventRuler.on(el, "setvalue", EventHandlers.setValueEvent), getBufferTemplate(), 
	            "" !== el.inputmask._valueGet() || opts.clearMaskOnLostFocus === !1 || document.activeElement === el)) {
	                var initialValue = $.isFunction(opts.onBeforeMask) ? opts.onBeforeMask(el.inputmask._valueGet(), opts) || el.inputmask._valueGet() : el.inputmask._valueGet();
	                checkVal(el, !0, !1, initialValue.split(""));
	                var buffer = getBuffer().slice();
	                undoValue = buffer.join(""), isComplete(buffer) === !1 && opts.clearIncomplete && resetMaskSet(), 
	                opts.clearMaskOnLostFocus && document.activeElement !== el && (getLastValidPosition() === -1 ? buffer = [] : clearOptionalTail(buffer)), 
	                writeBuffer(el, buffer), document.activeElement === el && caret(el, seekNext(getLastValidPosition()));
	            }
	        }
	        maskset = maskset || this.maskset, opts = opts || this.opts;
	        var undoValue, $el, maxLength, colorMask, valueBuffer, el = this.el, isRTL = this.isRTL, skipKeyPressEvent = !1, skipInputEvent = !1, ignorable = !1, mouseEnter = !1, EventRuler = {
	            on: function(input, eventName, eventHandler) {
	                var ev = function(e) {
	                    if (void 0 === this.inputmask && "FORM" !== this.nodeName) {
	                        var imOpts = $.data(this, "_inputmask_opts");
	                        imOpts ? new Inputmask(imOpts).mask(this) : EventRuler.off(this);
	                    } else {
	                        if ("setvalue" === e.type || !(this.disabled || this.readOnly && !("keydown" === e.type && e.ctrlKey && 67 === e.keyCode || opts.tabThrough === !1 && e.keyCode === Inputmask.keyCode.TAB))) {
	                            switch (e.type) {
	                              case "input":
	                                if (skipInputEvent === !0) return skipInputEvent = !1, e.preventDefault();
	                                break;
	
	                              case "keydown":
	                                skipKeyPressEvent = !1, skipInputEvent = !1;
	                                break;
	
	                              case "keypress":
	                                if (skipKeyPressEvent === !0) return e.preventDefault();
	                                skipKeyPressEvent = !0;
	                                break;
	
	                              case "click":
	                                if (iemobile || iphone) {
	                                    var that = this, args = arguments;
	                                    return setTimeout(function() {
	                                        eventHandler.apply(that, args);
	                                    }, 0), !1;
	                                }
	                            }
	                            var returnVal = eventHandler.apply(this, arguments);
	                            return returnVal === !1 && (e.preventDefault(), e.stopPropagation()), returnVal;
	                        }
	                        e.preventDefault();
	                    }
	                };
	                input.inputmask.events[eventName] = input.inputmask.events[eventName] || [], input.inputmask.events[eventName].push(ev), 
	                $.inArray(eventName, [ "submit", "reset" ]) !== -1 ? null != input.form && $(input.form).on(eventName, ev) : $(input).on(eventName, ev);
	            },
	            off: function(input, event) {
	                if (input.inputmask && input.inputmask.events) {
	                    var events;
	                    event ? (events = [], events[event] = input.inputmask.events[event]) : events = input.inputmask.events, 
	                    $.each(events, function(eventName, evArr) {
	                        for (;evArr.length > 0; ) {
	                            var ev = evArr.pop();
	                            $.inArray(eventName, [ "submit", "reset" ]) !== -1 ? null != input.form && $(input.form).off(eventName, ev) : $(input).off(eventName, ev);
	                        }
	                        delete input.inputmask.events[eventName];
	                    });
	                }
	            }
	        }, EventHandlers = {
	            keydownEvent: function(e) {
	                function isInputEventSupported(eventName) {
	                    var el = document.createElement("input"), evName = "on" + eventName, isSupported = evName in el;
	                    return isSupported || (el.setAttribute(evName, "return;"), isSupported = "function" == typeof el[evName]), 
	                    el = null, isSupported;
	                }
	                var input = this, $input = $(input), k = e.keyCode, pos = caret(input);
	                if (k === Inputmask.keyCode.BACKSPACE || k === Inputmask.keyCode.DELETE || iphone && k === Inputmask.keyCode.BACKSPACE_SAFARI || e.ctrlKey && k === Inputmask.keyCode.X && !isInputEventSupported("cut")) e.preventDefault(), 
	                handleRemove(input, k, pos), writeBuffer(input, getBuffer(!0), getMaskSet().p, e, input.inputmask._valueGet() !== getBuffer().join("")), 
	                input.inputmask._valueGet() === getBufferTemplate().join("") ? $input.trigger("cleared") : isComplete(getBuffer()) === !0 && $input.trigger("complete"); else if (k === Inputmask.keyCode.END || k === Inputmask.keyCode.PAGE_DOWN) {
	                    e.preventDefault();
	                    var caretPos = seekNext(getLastValidPosition());
	                    opts.insertMode || caretPos !== getMaskSet().maskLength || e.shiftKey || caretPos--, 
	                    caret(input, e.shiftKey ? pos.begin : caretPos, caretPos, !0);
	                } else k === Inputmask.keyCode.HOME && !e.shiftKey || k === Inputmask.keyCode.PAGE_UP ? (e.preventDefault(), 
	                caret(input, 0, e.shiftKey ? pos.begin : 0, !0)) : (opts.undoOnEscape && k === Inputmask.keyCode.ESCAPE || 90 === k && e.ctrlKey) && e.altKey !== !0 ? (checkVal(input, !0, !1, undoValue.split("")), 
	                $input.trigger("click")) : k !== Inputmask.keyCode.INSERT || e.shiftKey || e.ctrlKey ? opts.tabThrough === !0 && k === Inputmask.keyCode.TAB ? (e.shiftKey === !0 ? (null === getTest(pos.begin).match.fn && (pos.begin = seekNext(pos.begin)), 
	                pos.end = seekPrevious(pos.begin, !0), pos.begin = seekPrevious(pos.end, !0)) : (pos.begin = seekNext(pos.begin, !0), 
	                pos.end = seekNext(pos.begin, !0), pos.end < getMaskSet().maskLength && pos.end--), 
	                pos.begin < getMaskSet().maskLength && (e.preventDefault(), caret(input, pos.begin, pos.end))) : e.shiftKey || opts.insertMode === !1 && (k === Inputmask.keyCode.RIGHT ? setTimeout(function() {
	                    var caretPos = caret(input);
	                    caret(input, caretPos.begin);
	                }, 0) : k === Inputmask.keyCode.LEFT && setTimeout(function() {
	                    var caretPos = caret(input);
	                    caret(input, isRTL ? caretPos.begin + 1 : caretPos.begin - 1);
	                }, 0)) : (opts.insertMode = !opts.insertMode, caret(input, opts.insertMode || pos.begin !== getMaskSet().maskLength ? pos.begin : pos.begin - 1));
	                opts.onKeyDown.call(this, e, getBuffer(), caret(input).begin, opts), ignorable = $.inArray(k, opts.ignorables) !== -1;
	            },
	            keypressEvent: function(e, checkval, writeOut, strict, ndx) {
	                var input = this, $input = $(input), k = e.which || e.charCode || e.keyCode;
	                if (!(checkval === !0 || e.ctrlKey && e.altKey) && (e.ctrlKey || e.metaKey || ignorable)) return k === Inputmask.keyCode.ENTER && undoValue !== getBuffer().join("") && (undoValue = getBuffer().join(""), 
	                setTimeout(function() {
	                    $input.trigger("change");
	                }, 0)), !0;
	                if (k) {
	                    46 === k && e.shiftKey === !1 && "," === opts.radixPoint && (k = 44);
	                    var forwardPosition, pos = checkval ? {
	                        begin: ndx,
	                        end: ndx
	                    } : caret(input), c = String.fromCharCode(k);
	                    getMaskSet().writeOutBuffer = !0;
	                    var valResult = isValid(pos, c, strict);
	                    if (valResult !== !1 && (resetMaskSet(!0), forwardPosition = void 0 !== valResult.caret ? valResult.caret : checkval ? valResult.pos + 1 : seekNext(valResult.pos), 
	                    getMaskSet().p = forwardPosition), writeOut !== !1) {
	                        var self = this;
	                        if (setTimeout(function() {
	                            opts.onKeyValidation.call(self, k, valResult, opts);
	                        }, 0), getMaskSet().writeOutBuffer && valResult !== !1) {
	                            var buffer = getBuffer();
	                            writeBuffer(input, buffer, opts.numericInput && void 0 === valResult.caret ? seekPrevious(forwardPosition) : forwardPosition, e, checkval !== !0), 
	                            checkval !== !0 && setTimeout(function() {
	                                isComplete(buffer) === !0 && $input.trigger("complete");
	                            }, 0);
	                        }
	                    }
	                    if (e.preventDefault(), checkval) return valResult.forwardPosition = forwardPosition, 
	                    valResult;
	                }
	            },
	            pasteEvent: function(e) {
	                var tempValue, input = this, ev = e.originalEvent || e, $input = $(input), inputValue = input.inputmask._valueGet(!0), caretPos = caret(input);
	                isRTL && (tempValue = caretPos.end, caretPos.end = caretPos.begin, caretPos.begin = tempValue);
	                var valueBeforeCaret = inputValue.substr(0, caretPos.begin), valueAfterCaret = inputValue.substr(caretPos.end, inputValue.length);
	                if (valueBeforeCaret === (isRTL ? getBufferTemplate().reverse() : getBufferTemplate()).slice(0, caretPos.begin).join("") && (valueBeforeCaret = ""), 
	                valueAfterCaret === (isRTL ? getBufferTemplate().reverse() : getBufferTemplate()).slice(caretPos.end).join("") && (valueAfterCaret = ""), 
	                isRTL && (tempValue = valueBeforeCaret, valueBeforeCaret = valueAfterCaret, valueAfterCaret = tempValue), 
	                window.clipboardData && window.clipboardData.getData) inputValue = valueBeforeCaret + window.clipboardData.getData("Text") + valueAfterCaret; else {
	                    if (!ev.clipboardData || !ev.clipboardData.getData) return !0;
	                    inputValue = valueBeforeCaret + ev.clipboardData.getData("text/plain") + valueAfterCaret;
	                }
	                var pasteValue = inputValue;
	                if ($.isFunction(opts.onBeforePaste)) {
	                    if (pasteValue = opts.onBeforePaste(inputValue, opts), pasteValue === !1) return e.preventDefault();
	                    pasteValue || (pasteValue = inputValue);
	                }
	                return checkVal(input, !1, !1, isRTL ? pasteValue.split("").reverse() : pasteValue.toString().split("")), 
	                writeBuffer(input, getBuffer(), seekNext(getLastValidPosition()), e, undoValue !== getBuffer().join("")), 
	                isComplete(getBuffer()) === !0 && $input.trigger("complete"), e.preventDefault();
	            },
	            inputFallBackEvent: function(e) {
	                var input = this, inputValue = input.inputmask._valueGet();
	                if (getBuffer().join("") !== inputValue) {
	                    var caretPos = caret(input);
	                    if (inputValue = inputValue.replace(new RegExp("(" + Inputmask.escapeRegex(getBufferTemplate().join("")) + ")*"), ""), 
	                    iemobile) {
	                        var inputChar = inputValue.replace(getBuffer().join(""), "");
	                        if (1 === inputChar.length) {
	                            var keypress = new $.Event("keypress");
	                            return keypress.which = inputChar.charCodeAt(0), EventHandlers.keypressEvent.call(input, keypress, !0, !0, !1, getMaskSet().validPositions[caretPos.begin - 1] ? caretPos.begin : caretPos.begin - 1), 
	                            !1;
	                        }
	                    }
	                    if (caretPos.begin > inputValue.length && (caret(input, inputValue.length), caretPos = caret(input)), 
	                    getBuffer().length - inputValue.length !== 1 || inputValue.charAt(caretPos.begin) === getBuffer()[caretPos.begin] || inputValue.charAt(caretPos.begin + 1) === getBuffer()[caretPos.begin] || isMask(caretPos.begin)) {
	                        for (var lvp = getLastValidPosition() + 1, bufferTemplate = getBufferTemplate().join(""); null === inputValue.match(Inputmask.escapeRegex(bufferTemplate) + "$"); ) bufferTemplate = bufferTemplate.slice(1);
	                        inputValue = inputValue.replace(bufferTemplate, ""), inputValue = inputValue.split(""), 
	                        checkVal(input, !0, !1, inputValue, e, caretPos.begin < lvp), isComplete(getBuffer()) === !0 && $(input).trigger("complete");
	                    } else e.keyCode = Inputmask.keyCode.BACKSPACE, EventHandlers.keydownEvent.call(input, e);
	                    e.preventDefault();
	                }
	            },
	            setValueEvent: function(e) {
	                var input = this, value = input.inputmask._valueGet();
	                checkVal(input, !0, !1, ($.isFunction(opts.onBeforeMask) ? opts.onBeforeMask(value, opts) || value : value).split("")), 
	                undoValue = getBuffer().join(""), (opts.clearMaskOnLostFocus || opts.clearIncomplete) && input.inputmask._valueGet() === getBufferTemplate().join("") && input.inputmask._valueSet("");
	            },
	            focusEvent: function(e) {
	                var input = this, nptValue = input.inputmask._valueGet();
	                opts.showMaskOnFocus && (!opts.showMaskOnHover || opts.showMaskOnHover && "" === nptValue) && (input.inputmask._valueGet() !== getBuffer().join("") ? writeBuffer(input, getBuffer(), seekNext(getLastValidPosition())) : mouseEnter === !1 && caret(input, seekNext(getLastValidPosition()))), 
	                opts.positionCaretOnTab === !0 && EventHandlers.clickEvent.apply(input, [ e, !0 ]), 
	                undoValue = getBuffer().join("");
	            },
	            mouseleaveEvent: function(e) {
	                var input = this;
	                if (mouseEnter = !1, opts.clearMaskOnLostFocus && document.activeElement !== input) {
	                    var buffer = getBuffer().slice(), nptValue = input.inputmask._valueGet();
	                    nptValue !== input.getAttribute("placeholder") && "" !== nptValue && (getLastValidPosition() === -1 && nptValue === getBufferTemplate().join("") ? buffer = [] : clearOptionalTail(buffer), 
	                    writeBuffer(input, buffer));
	                }
	            },
	            clickEvent: function(e, tabbed) {
	                function doRadixFocus(clickPos) {
	                    if ("" !== opts.radixPoint) {
	                        var vps = getMaskSet().validPositions;
	                        if (void 0 === vps[clickPos] || vps[clickPos].input === getPlaceholder(clickPos)) {
	                            if (clickPos < seekNext(-1)) return !0;
	                            var radixPos = $.inArray(opts.radixPoint, getBuffer());
	                            if (radixPos !== -1) {
	                                for (var vp in vps) if (radixPos < vp && vps[vp].input !== getPlaceholder(vp)) return !1;
	                                return !0;
	                            }
	                        }
	                    }
	                    return !1;
	                }
	                var input = this;
	                setTimeout(function() {
	                    if (document.activeElement === input) {
	                        var selectedCaret = caret(input);
	                        if (tabbed && (selectedCaret.begin = selectedCaret.end), selectedCaret.begin === selectedCaret.end) switch (opts.positionCaretOnClick) {
	                          case "none":
	                            break;
	
	                          case "radixFocus":
	                            if (doRadixFocus(selectedCaret.begin)) {
	                                var radixPos = $.inArray(opts.radixPoint, getBuffer().join(""));
	                                caret(input, opts.numericInput ? seekNext(radixPos) : radixPos);
	                                break;
	                            }
	
	                          default:
	                            var clickPosition = selectedCaret.begin, lvclickPosition = getLastValidPosition(clickPosition, !0), lastPosition = seekNext(lvclickPosition);
	                            if (clickPosition < lastPosition) caret(input, isMask(clickPosition) || isMask(clickPosition - 1) ? clickPosition : seekNext(clickPosition)); else {
	                                var placeholder = getPlaceholder(lastPosition);
	                                ("" !== placeholder && getBuffer()[lastPosition] !== placeholder && getTest(lastPosition).match.optionalQuantifier !== !0 || !isMask(lastPosition) && getTest(lastPosition).match.def === placeholder) && (lastPosition = seekNext(lastPosition)), 
	                                caret(input, lastPosition);
	                            }
	                        }
	                    }
	                }, 0);
	            },
	            dblclickEvent: function(e) {
	                var input = this;
	                setTimeout(function() {
	                    caret(input, 0, seekNext(getLastValidPosition()));
	                }, 0);
	            },
	            cutEvent: function(e) {
	                var input = this, $input = $(input), pos = caret(input), ev = e.originalEvent || e, clipboardData = window.clipboardData || ev.clipboardData, clipData = isRTL ? getBuffer().slice(pos.end, pos.begin) : getBuffer().slice(pos.begin, pos.end);
	                clipboardData.setData("text", isRTL ? clipData.reverse().join("") : clipData.join("")), 
	                document.execCommand && document.execCommand("copy"), handleRemove(input, Inputmask.keyCode.DELETE, pos), 
	                writeBuffer(input, getBuffer(), getMaskSet().p, e, undoValue !== getBuffer().join("")), 
	                input.inputmask._valueGet() === getBufferTemplate().join("") && $input.trigger("cleared");
	            },
	            blurEvent: function(e) {
	                var $input = $(this), input = this;
	                if (input.inputmask) {
	                    var nptValue = input.inputmask._valueGet(), buffer = getBuffer().slice();
	                    undoValue !== buffer.join("") && setTimeout(function() {
	                        $input.trigger("change"), undoValue = buffer.join("");
	                    }, 0), "" !== nptValue && (opts.clearMaskOnLostFocus && (getLastValidPosition() === -1 && nptValue === getBufferTemplate().join("") ? buffer = [] : clearOptionalTail(buffer)), 
	                    isComplete(buffer) === !1 && (setTimeout(function() {
	                        $input.trigger("incomplete");
	                    }, 0), opts.clearIncomplete && (resetMaskSet(), buffer = opts.clearMaskOnLostFocus ? [] : getBufferTemplate().slice())), 
	                    writeBuffer(input, buffer, void 0, e));
	                }
	            },
	            mouseenterEvent: function(e) {
	                var input = this;
	                mouseEnter = !0, document.activeElement !== input && opts.showMaskOnHover && input.inputmask._valueGet() !== getBuffer().join("") && writeBuffer(input, getBuffer());
	            },
	            submitEvent: function(e) {
	                undoValue !== getBuffer().join("") && $el.trigger("change"), opts.clearMaskOnLostFocus && getLastValidPosition() === -1 && el.inputmask._valueGet && el.inputmask._valueGet() === getBufferTemplate().join("") && el.inputmask._valueSet(""), 
	                opts.removeMaskOnSubmit && (el.inputmask._valueSet(el.inputmask.unmaskedvalue(), !0), 
	                setTimeout(function() {
	                    writeBuffer(el, getBuffer());
	                }, 0));
	            },
	            resetEvent: function(e) {
	                setTimeout(function() {
	                    $el.trigger("setvalue");
	                }, 0);
	            }
	        };
	        if (void 0 !== actionObj) switch (actionObj.action) {
	          case "isComplete":
	            return el = actionObj.el, isComplete(getBuffer());
	
	          case "unmaskedvalue":
	            return void 0 !== el && void 0 === actionObj.value || (valueBuffer = actionObj.value, 
	            valueBuffer = ($.isFunction(opts.onBeforeMask) ? opts.onBeforeMask(valueBuffer, opts) || valueBuffer : valueBuffer).split(""), 
	            checkVal(void 0, !1, !1, isRTL ? valueBuffer.reverse() : valueBuffer), $.isFunction(opts.onBeforeWrite) && opts.onBeforeWrite(void 0, getBuffer(), 0, opts)), 
	            unmaskedvalue(el);
	
	          case "mask":
	            mask(el);
	            break;
	
	          case "format":
	            return valueBuffer = ($.isFunction(opts.onBeforeMask) ? opts.onBeforeMask(actionObj.value, opts) || actionObj.value : actionObj.value).split(""), 
	            checkVal(void 0, !1, !1, isRTL ? valueBuffer.reverse() : valueBuffer), $.isFunction(opts.onBeforeWrite) && opts.onBeforeWrite(void 0, getBuffer(), 0, opts), 
	            actionObj.metadata ? {
	                value: isRTL ? getBuffer().slice().reverse().join("") : getBuffer().join(""),
	                metadata: maskScope.call(this, {
	                    action: "getmetadata"
	                }, maskset, opts)
	            } : isRTL ? getBuffer().slice().reverse().join("") : getBuffer().join("");
	
	          case "isValid":
	            actionObj.value ? (valueBuffer = actionObj.value.split(""), checkVal(void 0, !1, !0, isRTL ? valueBuffer.reverse() : valueBuffer)) : actionObj.value = getBuffer().join("");
	            for (var buffer = getBuffer(), rl = determineLastRequiredPosition(), lmib = buffer.length - 1; lmib > rl && !isMask(lmib); lmib--) ;
	            return buffer.splice(rl, lmib + 1 - rl), isComplete(buffer) && actionObj.value === getBuffer().join("");
	
	          case "getemptymask":
	            return getBufferTemplate().join("");
	
	          case "remove":
	            if (el) {
	                $el = $(el), el.inputmask._valueSet(unmaskedvalue(el)), EventRuler.off(el);
	                var valueProperty;
	                Object.getOwnPropertyDescriptor && Object.getPrototypeOf ? (valueProperty = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(el), "value"), 
	                valueProperty && el.inputmask.__valueGet && Object.defineProperty(el, "value", {
	                    get: el.inputmask.__valueGet,
	                    set: el.inputmask.__valueSet,
	                    configurable: !0
	                })) : document.__lookupGetter__ && el.__lookupGetter__("value") && el.inputmask.__valueGet && (el.__defineGetter__("value", el.inputmask.__valueGet), 
	                el.__defineSetter__("value", el.inputmask.__valueSet)), el.inputmask = void 0;
	            }
	            return el;
	
	          case "getmetadata":
	            if ($.isArray(maskset.metadata)) {
	                var maskTarget = getMaskTemplate(!0, 0, !1).join("");
	                return $.each(maskset.metadata, function(ndx, mtdt) {
	                    if (mtdt.mask === maskTarget) return maskTarget = mtdt, !1;
	                }), maskTarget;
	            }
	            return maskset.metadata;
	        }
	    }
	    var ua = navigator.userAgent, mobile = /mobile/i.test(ua), iemobile = /iemobile/i.test(ua), iphone = /iphone/i.test(ua) && !iemobile, android = /android/i.test(ua) && !iemobile;
	    return Inputmask.prototype = {
	        defaults: {
	            placeholder: "_",
	            optionalmarker: {
	                start: "[",
	                end: "]"
	            },
	            quantifiermarker: {
	                start: "{",
	                end: "}"
	            },
	            groupmarker: {
	                start: "(",
	                end: ")"
	            },
	            alternatormarker: "|",
	            escapeChar: "\\",
	            mask: null,
	            oncomplete: $.noop,
	            onincomplete: $.noop,
	            oncleared: $.noop,
	            repeat: 0,
	            greedy: !0,
	            autoUnmask: !1,
	            removeMaskOnSubmit: !1,
	            clearMaskOnLostFocus: !0,
	            insertMode: !0,
	            clearIncomplete: !1,
	            aliases: {},
	            alias: null,
	            onKeyDown: $.noop,
	            onBeforeMask: null,
	            onBeforePaste: function(pastedValue, opts) {
	                return $.isFunction(opts.onBeforeMask) ? opts.onBeforeMask(pastedValue, opts) : pastedValue;
	            },
	            onBeforeWrite: null,
	            onUnMask: null,
	            showMaskOnFocus: !0,
	            showMaskOnHover: !0,
	            onKeyValidation: $.noop,
	            skipOptionalPartCharacter: " ",
	            numericInput: !1,
	            rightAlign: !1,
	            undoOnEscape: !0,
	            radixPoint: "",
	            radixPointDefinitionSymbol: void 0,
	            groupSeparator: "",
	            keepStatic: null,
	            positionCaretOnTab: !0,
	            tabThrough: !1,
	            supportsInputType: [ "text", "tel", "password" ],
	            definitions: {
	                "9": {
	                    validator: "[0-9]",
	                    cardinality: 1,
	                    definitionSymbol: "*"
	                },
	                a: {
	                    validator: "[A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]",
	                    cardinality: 1,
	                    definitionSymbol: "*"
	                },
	                "*": {
	                    validator: "[0-9A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]",
	                    cardinality: 1
	                }
	            },
	            ignorables: [ 8, 9, 13, 19, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 93, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123 ],
	            isComplete: null,
	            canClearPosition: $.noop,
	            postValidation: null,
	            staticDefinitionSymbol: void 0,
	            jitMasking: !1,
	            nullable: !0,
	            inputEventOnly: !1,
	            noValuePatching: !1,
	            positionCaretOnClick: "lvp",
	            casing: null,
	            inputmode: "verbatim",
	            colorMask: !1,
	            androidHack: !1
	        },
	        masksCache: {},
	        mask: function(elems) {
	            function importAttributeOptions(npt, opts, userOptions, dataAttribute) {
	                function importOption(option, optionData) {
	                    optionData = void 0 !== optionData ? optionData : npt.getAttribute(dataAttribute + "-" + option), 
	                    null !== optionData && ("string" == typeof optionData && (0 === option.indexOf("on") ? optionData = window[optionData] : "false" === optionData ? optionData = !1 : "true" === optionData && (optionData = !0)), 
	                    userOptions[option] = optionData);
	                }
	                var option, dataoptions, optionData, p, attrOptions = npt.getAttribute(dataAttribute);
	                if (attrOptions && "" !== attrOptions && (attrOptions = attrOptions.replace(new RegExp("'", "g"), '"'), 
	                dataoptions = JSON.parse("{" + attrOptions + "}")), dataoptions) {
	                    optionData = void 0;
	                    for (p in dataoptions) if ("alias" === p.toLowerCase()) {
	                        optionData = dataoptions[p];
	                        break;
	                    }
	                }
	                importOption("alias", optionData), userOptions.alias && resolveAlias(userOptions.alias, userOptions, opts);
	                for (option in opts) {
	                    if (dataoptions) {
	                        optionData = void 0;
	                        for (p in dataoptions) if (p.toLowerCase() === option.toLowerCase()) {
	                            optionData = dataoptions[p];
	                            break;
	                        }
	                    }
	                    importOption(option, optionData);
	                }
	                return $.extend(!0, opts, userOptions), opts;
	            }
	            var that = this;
	            return "string" == typeof elems && (elems = document.getElementById(elems) || document.querySelectorAll(elems)), 
	            elems = elems.nodeName ? [ elems ] : elems, $.each(elems, function(ndx, el) {
	                var scopedOpts = $.extend(!0, {}, that.opts);
	                importAttributeOptions(el, scopedOpts, $.extend(!0, {}, that.userOptions), that.dataAttribute);
	                var maskset = generateMaskSet(scopedOpts, that.noMasksCache);
	                void 0 !== maskset && (void 0 !== el.inputmask && el.inputmask.remove(), el.inputmask = new Inputmask(), 
	                el.inputmask.opts = scopedOpts, el.inputmask.noMasksCache = that.noMasksCache, el.inputmask.userOptions = $.extend(!0, {}, that.userOptions), 
	                el.inputmask.el = el, el.inputmask.maskset = maskset, $.data(el, "_inputmask_opts", scopedOpts), 
	                maskScope.call(el.inputmask, {
	                    action: "mask"
	                }));
	            }), elems && elems[0] ? elems[0].inputmask || this : this;
	        },
	        option: function(options, noremask) {
	            return "string" == typeof options ? this.opts[options] : "object" == typeof options ? ($.extend(this.userOptions, options), 
	            this.el && noremask !== !0 && this.mask(this.el), this) : void 0;
	        },
	        unmaskedvalue: function(value) {
	            return this.maskset = this.maskset || generateMaskSet(this.opts, this.noMasksCache), 
	            maskScope.call(this, {
	                action: "unmaskedvalue",
	                value: value
	            });
	        },
	        remove: function() {
	            return maskScope.call(this, {
	                action: "remove"
	            });
	        },
	        getemptymask: function() {
	            return this.maskset = this.maskset || generateMaskSet(this.opts, this.noMasksCache), 
	            maskScope.call(this, {
	                action: "getemptymask"
	            });
	        },
	        hasMaskedValue: function() {
	            return !this.opts.autoUnmask;
	        },
	        isComplete: function() {
	            return this.maskset = this.maskset || generateMaskSet(this.opts, this.noMasksCache), 
	            maskScope.call(this, {
	                action: "isComplete"
	            });
	        },
	        getmetadata: function() {
	            return this.maskset = this.maskset || generateMaskSet(this.opts, this.noMasksCache), 
	            maskScope.call(this, {
	                action: "getmetadata"
	            });
	        },
	        isValid: function(value) {
	            return this.maskset = this.maskset || generateMaskSet(this.opts, this.noMasksCache), 
	            maskScope.call(this, {
	                action: "isValid",
	                value: value
	            });
	        },
	        format: function(value, metadata) {
	            return this.maskset = this.maskset || generateMaskSet(this.opts, this.noMasksCache), 
	            maskScope.call(this, {
	                action: "format",
	                value: value,
	                metadata: metadata
	            });
	        },
	        analyseMask: function(mask, opts) {
	            function MaskToken(isGroup, isOptional, isQuantifier, isAlternator) {
	                this.matches = [], this.openGroup = isGroup || !1, this.isGroup = isGroup || !1, 
	                this.isOptional = isOptional || !1, this.isQuantifier = isQuantifier || !1, this.isAlternator = isAlternator || !1, 
	                this.quantifier = {
	                    min: 1,
	                    max: 1
	                };
	            }
	            function insertTestDefinition(mtoken, element, position) {
	                var maskdef = opts.definitions[element];
	                position = void 0 !== position ? position : mtoken.matches.length;
	                var prevMatch = mtoken.matches[position - 1];
	                if (maskdef && !escaped) {
	                    maskdef.placeholder = $.isFunction(maskdef.placeholder) ? maskdef.placeholder(opts) : maskdef.placeholder;
	                    for (var prevalidators = maskdef.prevalidator, prevalidatorsL = prevalidators ? prevalidators.length : 0, i = 1; i < maskdef.cardinality; i++) {
	                        var prevalidator = prevalidatorsL >= i ? prevalidators[i - 1] : [], validator = prevalidator.validator, cardinality = prevalidator.cardinality;
	                        mtoken.matches.splice(position++, 0, {
	                            fn: validator ? "string" == typeof validator ? new RegExp(validator) : new function() {
	                                this.test = validator;
	                            }() : new RegExp("."),
	                            cardinality: cardinality ? cardinality : 1,
	                            optionality: mtoken.isOptional,
	                            newBlockMarker: void 0 === prevMatch || prevMatch.def !== (maskdef.definitionSymbol || element),
	                            casing: maskdef.casing,
	                            def: maskdef.definitionSymbol || element,
	                            placeholder: maskdef.placeholder,
	                            nativeDef: element
	                        }), prevMatch = mtoken.matches[position - 1];
	                    }
	                    mtoken.matches.splice(position++, 0, {
	                        fn: maskdef.validator ? "string" == typeof maskdef.validator ? new RegExp(maskdef.validator) : new function() {
	                            this.test = maskdef.validator;
	                        }() : new RegExp("."),
	                        cardinality: maskdef.cardinality,
	                        optionality: mtoken.isOptional,
	                        newBlockMarker: void 0 === prevMatch || prevMatch.def !== (maskdef.definitionSymbol || element),
	                        casing: maskdef.casing,
	                        def: maskdef.definitionSymbol || element,
	                        placeholder: maskdef.placeholder,
	                        nativeDef: element
	                    });
	                } else mtoken.matches.splice(position++, 0, {
	                    fn: null,
	                    cardinality: 0,
	                    optionality: mtoken.isOptional,
	                    newBlockMarker: void 0 === prevMatch || prevMatch.def !== element,
	                    casing: null,
	                    def: opts.staticDefinitionSymbol || element,
	                    placeholder: void 0 !== opts.staticDefinitionSymbol ? element : void 0,
	                    nativeDef: element
	                }), escaped = !1;
	            }
	            function verifyGroupMarker(maskToken) {
	                maskToken && maskToken.matches && $.each(maskToken.matches, function(ndx, token) {
	                    var nextToken = maskToken.matches[ndx + 1];
	                    (void 0 === nextToken || void 0 === nextToken.matches || nextToken.isQuantifier === !1) && token && token.isGroup && (token.isGroup = !1, 
	                    insertTestDefinition(token, opts.groupmarker.start, 0), token.openGroup !== !0 && insertTestDefinition(token, opts.groupmarker.end)), 
	                    verifyGroupMarker(token);
	                });
	            }
	            function defaultCase() {
	                if (openenings.length > 0) {
	                    if (currentOpeningToken = openenings[openenings.length - 1], insertTestDefinition(currentOpeningToken, m), 
	                    currentOpeningToken.isAlternator) {
	                        alternator = openenings.pop();
	                        for (var mndx = 0; mndx < alternator.matches.length; mndx++) alternator.matches[mndx].isGroup = !1;
	                        openenings.length > 0 ? (currentOpeningToken = openenings[openenings.length - 1], 
	                        currentOpeningToken.matches.push(alternator)) : currentToken.matches.push(alternator);
	                    }
	                } else insertTestDefinition(currentToken, m);
	            }
	            function reverseTokens(maskToken) {
	                function reverseStatic(st) {
	                    return st === opts.optionalmarker.start ? st = opts.optionalmarker.end : st === opts.optionalmarker.end ? st = opts.optionalmarker.start : st === opts.groupmarker.start ? st = opts.groupmarker.end : st === opts.groupmarker.end && (st = opts.groupmarker.start), 
	                    st;
	                }
	                maskToken.matches = maskToken.matches.reverse();
	                for (var match in maskToken.matches) {
	                    var intMatch = parseInt(match);
	                    if (maskToken.matches[match].isQuantifier && maskToken.matches[intMatch + 1] && maskToken.matches[intMatch + 1].isGroup) {
	                        var qt = maskToken.matches[match];
	                        maskToken.matches.splice(match, 1), maskToken.matches.splice(intMatch + 1, 0, qt);
	                    }
	                    void 0 !== maskToken.matches[match].matches ? maskToken.matches[match] = reverseTokens(maskToken.matches[match]) : maskToken.matches[match] = reverseStatic(maskToken.matches[match]);
	                }
	                return maskToken;
	            }
	            for (var match, m, openingToken, currentOpeningToken, alternator, lastMatch, groupToken, tokenizer = /(?:[?*+]|\{[0-9\+\*]+(?:,[0-9\+\*]*)?\})|[^.?*+^${[]()|\\]+|./g, escaped = !1, currentToken = new MaskToken(), openenings = [], maskTokens = []; match = tokenizer.exec(mask); ) if (m = match[0], 
	            escaped) defaultCase(); else switch (m.charAt(0)) {
	              case opts.escapeChar:
	                escaped = !0;
	                break;
	
	              case opts.optionalmarker.end:
	              case opts.groupmarker.end:
	                if (openingToken = openenings.pop(), openingToken.openGroup = !1, void 0 !== openingToken) if (openenings.length > 0) {
	                    if (currentOpeningToken = openenings[openenings.length - 1], currentOpeningToken.matches.push(openingToken), 
	                    currentOpeningToken.isAlternator) {
	                        alternator = openenings.pop();
	                        for (var mndx = 0; mndx < alternator.matches.length; mndx++) alternator.matches[mndx].isGroup = !1;
	                        openenings.length > 0 ? (currentOpeningToken = openenings[openenings.length - 1], 
	                        currentOpeningToken.matches.push(alternator)) : currentToken.matches.push(alternator);
	                    }
	                } else currentToken.matches.push(openingToken); else defaultCase();
	                break;
	
	              case opts.optionalmarker.start:
	                openenings.push(new MaskToken((!1), (!0)));
	                break;
	
	              case opts.groupmarker.start:
	                openenings.push(new MaskToken((!0)));
	                break;
	
	              case opts.quantifiermarker.start:
	                var quantifier = new MaskToken((!1), (!1), (!0));
	                m = m.replace(/[{}]/g, "");
	                var mq = m.split(","), mq0 = isNaN(mq[0]) ? mq[0] : parseInt(mq[0]), mq1 = 1 === mq.length ? mq0 : isNaN(mq[1]) ? mq[1] : parseInt(mq[1]);
	                if ("*" !== mq1 && "+" !== mq1 || (mq0 = "*" === mq1 ? 0 : 1), quantifier.quantifier = {
	                    min: mq0,
	                    max: mq1
	                }, openenings.length > 0) {
	                    var matches = openenings[openenings.length - 1].matches;
	                    match = matches.pop(), match.isGroup || (groupToken = new MaskToken((!0)), groupToken.matches.push(match), 
	                    match = groupToken), matches.push(match), matches.push(quantifier);
	                } else match = currentToken.matches.pop(), match.isGroup || (groupToken = new MaskToken((!0)), 
	                groupToken.matches.push(match), match = groupToken), currentToken.matches.push(match), 
	                currentToken.matches.push(quantifier);
	                break;
	
	              case opts.alternatormarker:
	                openenings.length > 0 ? (currentOpeningToken = openenings[openenings.length - 1], 
	                lastMatch = currentOpeningToken.matches.pop()) : lastMatch = currentToken.matches.pop(), 
	                lastMatch.isAlternator ? openenings.push(lastMatch) : (alternator = new MaskToken((!1), (!1), (!1), (!0)), 
	                alternator.matches.push(lastMatch), openenings.push(alternator));
	                break;
	
	              default:
	                defaultCase();
	            }
	            for (;openenings.length > 0; ) openingToken = openenings.pop(), currentToken.matches.push(openingToken);
	            return currentToken.matches.length > 0 && (verifyGroupMarker(currentToken), maskTokens.push(currentToken)), 
	            opts.numericInput && reverseTokens(maskTokens[0]), maskTokens;
	        }
	    }, Inputmask.extendDefaults = function(options) {
	        $.extend(!0, Inputmask.prototype.defaults, options);
	    }, Inputmask.extendDefinitions = function(definition) {
	        $.extend(!0, Inputmask.prototype.defaults.definitions, definition);
	    }, Inputmask.extendAliases = function(alias) {
	        $.extend(!0, Inputmask.prototype.defaults.aliases, alias);
	    }, Inputmask.format = function(value, options, metadata) {
	        return Inputmask(options).format(value, metadata);
	    }, Inputmask.unmask = function(value, options) {
	        return Inputmask(options).unmaskedvalue(value);
	    }, Inputmask.isValid = function(value, options) {
	        return Inputmask(options).isValid(value);
	    }, Inputmask.remove = function(elems) {
	        $.each(elems, function(ndx, el) {
	            el.inputmask && el.inputmask.remove();
	        });
	    }, Inputmask.escapeRegex = function(str) {
	        var specials = [ "/", ".", "*", "+", "?", "|", "(", ")", "[", "]", "{", "}", "\\", "$", "^" ];
	        return str.replace(new RegExp("(\\" + specials.join("|\\") + ")", "gim"), "\\$1");
	    }, Inputmask.keyCode = {
	        ALT: 18,
	        BACKSPACE: 8,
	        BACKSPACE_SAFARI: 127,
	        CAPS_LOCK: 20,
	        COMMA: 188,
	        COMMAND: 91,
	        COMMAND_LEFT: 91,
	        COMMAND_RIGHT: 93,
	        CONTROL: 17,
	        DELETE: 46,
	        DOWN: 40,
	        END: 35,
	        ENTER: 13,
	        ESCAPE: 27,
	        HOME: 36,
	        INSERT: 45,
	        LEFT: 37,
	        MENU: 93,
	        NUMPAD_ADD: 107,
	        NUMPAD_DECIMAL: 110,
	        NUMPAD_DIVIDE: 111,
	        NUMPAD_ENTER: 108,
	        NUMPAD_MULTIPLY: 106,
	        NUMPAD_SUBTRACT: 109,
	        PAGE_DOWN: 34,
	        PAGE_UP: 33,
	        PERIOD: 190,
	        RIGHT: 39,
	        SHIFT: 16,
	        SPACE: 32,
	        TAB: 9,
	        UP: 38,
	        WINDOWS: 91,
	        X: 88
	    }, window.Inputmask = Inputmask, Inputmask;
	}(jQuery), function($, Inputmask) {
	    return void 0 === $.fn.inputmask && ($.fn.inputmask = function(fn, options) {
	        var nptmask, input = this[0];
	        if (void 0 === options && (options = {}), "string" == typeof fn) switch (fn) {
	          case "unmaskedvalue":
	            return input && input.inputmask ? input.inputmask.unmaskedvalue() : $(input).val();
	
	          case "remove":
	            return this.each(function() {
	                this.inputmask && this.inputmask.remove();
	            });
	
	          case "getemptymask":
	            return input && input.inputmask ? input.inputmask.getemptymask() : "";
	
	          case "hasMaskedValue":
	            return !(!input || !input.inputmask) && input.inputmask.hasMaskedValue();
	
	          case "isComplete":
	            return !input || !input.inputmask || input.inputmask.isComplete();
	
	          case "getmetadata":
	            return input && input.inputmask ? input.inputmask.getmetadata() : void 0;
	
	          case "setvalue":
	            $(input).val(options), input && void 0 === input.inputmask && $(input).triggerHandler("setvalue");
	            break;
	
	          case "option":
	            if ("string" != typeof options) return this.each(function() {
	                if (void 0 !== this.inputmask) return this.inputmask.option(options);
	            });
	            if (input && void 0 !== input.inputmask) return input.inputmask.option(options);
	            break;
	
	          default:
	            return options.alias = fn, nptmask = new Inputmask(options), this.each(function() {
	                nptmask.mask(this);
	            });
	        } else {
	            if ("object" == typeof fn) return nptmask = new Inputmask(fn), void 0 === fn.mask && void 0 === fn.alias ? this.each(function() {
	                return void 0 !== this.inputmask ? this.inputmask.option(fn) : void nptmask.mask(this);
	            }) : this.each(function() {
	                nptmask.mask(this);
	            });
	            if (void 0 === fn) return this.each(function() {
	                nptmask = new Inputmask(options), nptmask.mask(this);
	            });
	        }
	    }), $.fn.inputmask;
	}(jQuery, Inputmask), function($, Inputmask) {}(jQuery, Inputmask), function($, Inputmask) {
	    function isLeapYear(year) {
	        return isNaN(year) || 29 === new Date(year, 2, 0).getDate();
	    }
	    return Inputmask.extendAliases({
	        "dd/mm/yyyy": {
	            mask: "1/2/y",
	            placeholder: "dd/mm/yyyy",
	            regex: {
	                val1pre: new RegExp("[0-3]"),
	                val1: new RegExp("0[1-9]|[12][0-9]|3[01]"),
	                val2pre: function(separator) {
	                    var escapedSeparator = Inputmask.escapeRegex.call(this, separator);
	                    return new RegExp("((0[1-9]|[12][0-9]|3[01])" + escapedSeparator + "[01])");
	                },
	                val2: function(separator) {
	                    var escapedSeparator = Inputmask.escapeRegex.call(this, separator);
	                    return new RegExp("((0[1-9]|[12][0-9])" + escapedSeparator + "(0[1-9]|1[012]))|(30" + escapedSeparator + "(0[13-9]|1[012]))|(31" + escapedSeparator + "(0[13578]|1[02]))");
	                }
	            },
	            leapday: "29/02/",
	            separator: "/",
	            yearrange: {
	                minyear: 1900,
	                maxyear: 2099
	            },
	            isInYearRange: function(chrs, minyear, maxyear) {
	                if (isNaN(chrs)) return !1;
	                var enteredyear = parseInt(chrs.concat(minyear.toString().slice(chrs.length))), enteredyear2 = parseInt(chrs.concat(maxyear.toString().slice(chrs.length)));
	                return !isNaN(enteredyear) && (minyear <= enteredyear && enteredyear <= maxyear) || !isNaN(enteredyear2) && (minyear <= enteredyear2 && enteredyear2 <= maxyear);
	            },
	            determinebaseyear: function(minyear, maxyear, hint) {
	                var currentyear = new Date().getFullYear();
	                if (minyear > currentyear) return minyear;
	                if (maxyear < currentyear) {
	                    for (var maxYearPrefix = maxyear.toString().slice(0, 2), maxYearPostfix = maxyear.toString().slice(2, 4); maxyear < maxYearPrefix + hint; ) maxYearPrefix--;
	                    var maxxYear = maxYearPrefix + maxYearPostfix;
	                    return minyear > maxxYear ? minyear : maxxYear;
	                }
	                if (minyear <= currentyear && currentyear <= maxyear) {
	                    for (var currentYearPrefix = currentyear.toString().slice(0, 2); maxyear < currentYearPrefix + hint; ) currentYearPrefix--;
	                    var currentYearAndHint = currentYearPrefix + hint;
	                    return currentYearAndHint < minyear ? minyear : currentYearAndHint;
	                }
	                return currentyear;
	            },
	            onKeyDown: function(e, buffer, caretPos, opts) {
	                var $input = $(this);
	                if (e.ctrlKey && e.keyCode === Inputmask.keyCode.RIGHT) {
	                    var today = new Date();
	                    $input.val(today.getDate().toString() + (today.getMonth() + 1).toString() + today.getFullYear().toString()), 
	                    $input.trigger("setvalue");
	                }
	            },
	            getFrontValue: function(mask, buffer, opts) {
	                for (var start = 0, length = 0, i = 0; i < mask.length && "2" !== mask.charAt(i); i++) {
	                    var definition = opts.definitions[mask.charAt(i)];
	                    definition ? (start += length, length = definition.cardinality) : length++;
	                }
	                return buffer.join("").substr(start, length);
	            },
	            postValidation: function(buffer, currentResult, opts) {
	                var dayMonthValue, year, bufferStr = buffer.join("");
	                return 0 === opts.mask.indexOf("y") ? (year = bufferStr.substr(0, 4), dayMonthValue = bufferStr.substr(4, 11)) : (year = bufferStr.substr(6, 11), 
	                dayMonthValue = bufferStr.substr(0, 6)), currentResult && (dayMonthValue !== opts.leapday || isLeapYear(year));
	            },
	            definitions: {
	                "1": {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        var isValid = opts.regex.val1.test(chrs);
	                        return strict || isValid || chrs.charAt(1) !== opts.separator && "-./".indexOf(chrs.charAt(1)) === -1 || !(isValid = opts.regex.val1.test("0" + chrs.charAt(0))) ? isValid : (maskset.buffer[pos - 1] = "0", 
	                        {
	                            refreshFromBuffer: {
	                                start: pos - 1,
	                                end: pos
	                            },
	                            pos: pos,
	                            c: chrs.charAt(0)
	                        });
	                    },
	                    cardinality: 2,
	                    prevalidator: [ {
	                        validator: function(chrs, maskset, pos, strict, opts) {
	                            var pchrs = chrs;
	                            isNaN(maskset.buffer[pos + 1]) || (pchrs += maskset.buffer[pos + 1]);
	                            var isValid = 1 === pchrs.length ? opts.regex.val1pre.test(pchrs) : opts.regex.val1.test(pchrs);
	                            if (!strict && !isValid) {
	                                if (isValid = opts.regex.val1.test(chrs + "0")) return maskset.buffer[pos] = chrs, 
	                                maskset.buffer[++pos] = "0", {
	                                    pos: pos,
	                                    c: "0"
	                                };
	                                if (isValid = opts.regex.val1.test("0" + chrs)) return maskset.buffer[pos] = "0", 
	                                pos++, {
	                                    pos: pos
	                                };
	                            }
	                            return isValid;
	                        },
	                        cardinality: 1
	                    } ]
	                },
	                "2": {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        var frontValue = opts.getFrontValue(maskset.mask, maskset.buffer, opts);
	                        frontValue.indexOf(opts.placeholder[0]) !== -1 && (frontValue = "01" + opts.separator);
	                        var isValid = opts.regex.val2(opts.separator).test(frontValue + chrs);
	                        return strict || isValid || chrs.charAt(1) !== opts.separator && "-./".indexOf(chrs.charAt(1)) === -1 || !(isValid = opts.regex.val2(opts.separator).test(frontValue + "0" + chrs.charAt(0))) ? isValid : (maskset.buffer[pos - 1] = "0", 
	                        {
	                            refreshFromBuffer: {
	                                start: pos - 1,
	                                end: pos
	                            },
	                            pos: pos,
	                            c: chrs.charAt(0)
	                        });
	                    },
	                    cardinality: 2,
	                    prevalidator: [ {
	                        validator: function(chrs, maskset, pos, strict, opts) {
	                            isNaN(maskset.buffer[pos + 1]) || (chrs += maskset.buffer[pos + 1]);
	                            var frontValue = opts.getFrontValue(maskset.mask, maskset.buffer, opts);
	                            frontValue.indexOf(opts.placeholder[0]) !== -1 && (frontValue = "01" + opts.separator);
	                            var isValid = 1 === chrs.length ? opts.regex.val2pre(opts.separator).test(frontValue + chrs) : opts.regex.val2(opts.separator).test(frontValue + chrs);
	                            return strict || isValid || !(isValid = opts.regex.val2(opts.separator).test(frontValue + "0" + chrs)) ? isValid : (maskset.buffer[pos] = "0", 
	                            pos++, {
	                                pos: pos
	                            });
	                        },
	                        cardinality: 1
	                    } ]
	                },
	                y: {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        return opts.isInYearRange(chrs, opts.yearrange.minyear, opts.yearrange.maxyear);
	                    },
	                    cardinality: 4,
	                    prevalidator: [ {
	                        validator: function(chrs, maskset, pos, strict, opts) {
	                            var isValid = opts.isInYearRange(chrs, opts.yearrange.minyear, opts.yearrange.maxyear);
	                            if (!strict && !isValid) {
	                                var yearPrefix = opts.determinebaseyear(opts.yearrange.minyear, opts.yearrange.maxyear, chrs + "0").toString().slice(0, 1);
	                                if (isValid = opts.isInYearRange(yearPrefix + chrs, opts.yearrange.minyear, opts.yearrange.maxyear)) return maskset.buffer[pos++] = yearPrefix.charAt(0), 
	                                {
	                                    pos: pos
	                                };
	                                if (yearPrefix = opts.determinebaseyear(opts.yearrange.minyear, opts.yearrange.maxyear, chrs + "0").toString().slice(0, 2), 
	                                isValid = opts.isInYearRange(yearPrefix + chrs, opts.yearrange.minyear, opts.yearrange.maxyear)) return maskset.buffer[pos++] = yearPrefix.charAt(0), 
	                                maskset.buffer[pos++] = yearPrefix.charAt(1), {
	                                    pos: pos
	                                };
	                            }
	                            return isValid;
	                        },
	                        cardinality: 1
	                    }, {
	                        validator: function(chrs, maskset, pos, strict, opts) {
	                            var isValid = opts.isInYearRange(chrs, opts.yearrange.minyear, opts.yearrange.maxyear);
	                            if (!strict && !isValid) {
	                                var yearPrefix = opts.determinebaseyear(opts.yearrange.minyear, opts.yearrange.maxyear, chrs).toString().slice(0, 2);
	                                if (isValid = opts.isInYearRange(chrs[0] + yearPrefix[1] + chrs[1], opts.yearrange.minyear, opts.yearrange.maxyear)) return maskset.buffer[pos++] = yearPrefix.charAt(1), 
	                                {
	                                    pos: pos
	                                };
	                                if (yearPrefix = opts.determinebaseyear(opts.yearrange.minyear, opts.yearrange.maxyear, chrs).toString().slice(0, 2), 
	                                isValid = opts.isInYearRange(yearPrefix + chrs, opts.yearrange.minyear, opts.yearrange.maxyear)) return maskset.buffer[pos - 1] = yearPrefix.charAt(0), 
	                                maskset.buffer[pos++] = yearPrefix.charAt(1), maskset.buffer[pos++] = chrs.charAt(0), 
	                                {
	                                    refreshFromBuffer: {
	                                        start: pos - 3,
	                                        end: pos
	                                    },
	                                    pos: pos
	                                };
	                            }
	                            return isValid;
	                        },
	                        cardinality: 2
	                    }, {
	                        validator: function(chrs, maskset, pos, strict, opts) {
	                            return opts.isInYearRange(chrs, opts.yearrange.minyear, opts.yearrange.maxyear);
	                        },
	                        cardinality: 3
	                    } ]
	                }
	            },
	            insertMode: !1,
	            autoUnmask: !1
	        },
	        "mm/dd/yyyy": {
	            placeholder: "mm/dd/yyyy",
	            alias: "dd/mm/yyyy",
	            regex: {
	                val2pre: function(separator) {
	                    var escapedSeparator = Inputmask.escapeRegex.call(this, separator);
	                    return new RegExp("((0[13-9]|1[012])" + escapedSeparator + "[0-3])|(02" + escapedSeparator + "[0-2])");
	                },
	                val2: function(separator) {
	                    var escapedSeparator = Inputmask.escapeRegex.call(this, separator);
	                    return new RegExp("((0[1-9]|1[012])" + escapedSeparator + "(0[1-9]|[12][0-9]))|((0[13-9]|1[012])" + escapedSeparator + "30)|((0[13578]|1[02])" + escapedSeparator + "31)");
	                },
	                val1pre: new RegExp("[01]"),
	                val1: new RegExp("0[1-9]|1[012]")
	            },
	            leapday: "02/29/",
	            onKeyDown: function(e, buffer, caretPos, opts) {
	                var $input = $(this);
	                if (e.ctrlKey && e.keyCode === Inputmask.keyCode.RIGHT) {
	                    var today = new Date();
	                    $input.val((today.getMonth() + 1).toString() + today.getDate().toString() + today.getFullYear().toString()), 
	                    $input.trigger("setvalue");
	                }
	            }
	        },
	        "yyyy/mm/dd": {
	            mask: "y/1/2",
	            placeholder: "yyyy/mm/dd",
	            alias: "mm/dd/yyyy",
	            leapday: "/02/29",
	            onKeyDown: function(e, buffer, caretPos, opts) {
	                var $input = $(this);
	                if (e.ctrlKey && e.keyCode === Inputmask.keyCode.RIGHT) {
	                    var today = new Date();
	                    $input.val(today.getFullYear().toString() + (today.getMonth() + 1).toString() + today.getDate().toString()), 
	                    $input.trigger("setvalue");
	                }
	            }
	        },
	        "dd.mm.yyyy": {
	            mask: "1.2.y",
	            placeholder: "dd.mm.yyyy",
	            leapday: "29.02.",
	            separator: ".",
	            alias: "dd/mm/yyyy"
	        },
	        "dd-mm-yyyy": {
	            mask: "1-2-y",
	            placeholder: "dd-mm-yyyy",
	            leapday: "29-02-",
	            separator: "-",
	            alias: "dd/mm/yyyy"
	        },
	        "mm.dd.yyyy": {
	            mask: "1.2.y",
	            placeholder: "mm.dd.yyyy",
	            leapday: "02.29.",
	            separator: ".",
	            alias: "mm/dd/yyyy"
	        },
	        "mm-dd-yyyy": {
	            mask: "1-2-y",
	            placeholder: "mm-dd-yyyy",
	            leapday: "02-29-",
	            separator: "-",
	            alias: "mm/dd/yyyy"
	        },
	        "yyyy.mm.dd": {
	            mask: "y.1.2",
	            placeholder: "yyyy.mm.dd",
	            leapday: ".02.29",
	            separator: ".",
	            alias: "yyyy/mm/dd"
	        },
	        "yyyy-mm-dd": {
	            mask: "y-1-2",
	            placeholder: "yyyy-mm-dd",
	            leapday: "-02-29",
	            separator: "-",
	            alias: "yyyy/mm/dd"
	        },
	        datetime: {
	            mask: "1/2/y h:s",
	            placeholder: "dd/mm/yyyy hh:mm",
	            alias: "dd/mm/yyyy",
	            regex: {
	                hrspre: new RegExp("[012]"),
	                hrs24: new RegExp("2[0-4]|1[3-9]"),
	                hrs: new RegExp("[01][0-9]|2[0-4]"),
	                ampm: new RegExp("^[a|p|A|P][m|M]"),
	                mspre: new RegExp("[0-5]"),
	                ms: new RegExp("[0-5][0-9]")
	            },
	            timeseparator: ":",
	            hourFormat: "24",
	            definitions: {
	                h: {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        if ("24" === opts.hourFormat && 24 === parseInt(chrs, 10)) return maskset.buffer[pos - 1] = "0", 
	                        maskset.buffer[pos] = "0", {
	                            refreshFromBuffer: {
	                                start: pos - 1,
	                                end: pos
	                            },
	                            c: "0"
	                        };
	                        var isValid = opts.regex.hrs.test(chrs);
	                        if (!strict && !isValid && (chrs.charAt(1) === opts.timeseparator || "-.:".indexOf(chrs.charAt(1)) !== -1) && (isValid = opts.regex.hrs.test("0" + chrs.charAt(0)))) return maskset.buffer[pos - 1] = "0", 
	                        maskset.buffer[pos] = chrs.charAt(0), pos++, {
	                            refreshFromBuffer: {
	                                start: pos - 2,
	                                end: pos
	                            },
	                            pos: pos,
	                            c: opts.timeseparator
	                        };
	                        if (isValid && "24" !== opts.hourFormat && opts.regex.hrs24.test(chrs)) {
	                            var tmp = parseInt(chrs, 10);
	                            return 24 === tmp ? (maskset.buffer[pos + 5] = "a", maskset.buffer[pos + 6] = "m") : (maskset.buffer[pos + 5] = "p", 
	                            maskset.buffer[pos + 6] = "m"), tmp -= 12, tmp < 10 ? (maskset.buffer[pos] = tmp.toString(), 
	                            maskset.buffer[pos - 1] = "0") : (maskset.buffer[pos] = tmp.toString().charAt(1), 
	                            maskset.buffer[pos - 1] = tmp.toString().charAt(0)), {
	                                refreshFromBuffer: {
	                                    start: pos - 1,
	                                    end: pos + 6
	                                },
	                                c: maskset.buffer[pos]
	                            };
	                        }
	                        return isValid;
	                    },
	                    cardinality: 2,
	                    prevalidator: [ {
	                        validator: function(chrs, maskset, pos, strict, opts) {
	                            var isValid = opts.regex.hrspre.test(chrs);
	                            return strict || isValid || !(isValid = opts.regex.hrs.test("0" + chrs)) ? isValid : (maskset.buffer[pos] = "0", 
	                            pos++, {
	                                pos: pos
	                            });
	                        },
	                        cardinality: 1
	                    } ]
	                },
	                s: {
	                    validator: "[0-5][0-9]",
	                    cardinality: 2,
	                    prevalidator: [ {
	                        validator: function(chrs, maskset, pos, strict, opts) {
	                            var isValid = opts.regex.mspre.test(chrs);
	                            return strict || isValid || !(isValid = opts.regex.ms.test("0" + chrs)) ? isValid : (maskset.buffer[pos] = "0", 
	                            pos++, {
	                                pos: pos
	                            });
	                        },
	                        cardinality: 1
	                    } ]
	                },
	                t: {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        return opts.regex.ampm.test(chrs + "m");
	                    },
	                    casing: "lower",
	                    cardinality: 1
	                }
	            },
	            insertMode: !1,
	            autoUnmask: !1
	        },
	        datetime12: {
	            mask: "1/2/y h:s t\\m",
	            placeholder: "dd/mm/yyyy hh:mm xm",
	            alias: "datetime",
	            hourFormat: "12"
	        },
	        "mm/dd/yyyy hh:mm xm": {
	            mask: "1/2/y h:s t\\m",
	            placeholder: "mm/dd/yyyy hh:mm xm",
	            alias: "datetime12",
	            regex: {
	                val2pre: function(separator) {
	                    var escapedSeparator = Inputmask.escapeRegex.call(this, separator);
	                    return new RegExp("((0[13-9]|1[012])" + escapedSeparator + "[0-3])|(02" + escapedSeparator + "[0-2])");
	                },
	                val2: function(separator) {
	                    var escapedSeparator = Inputmask.escapeRegex.call(this, separator);
	                    return new RegExp("((0[1-9]|1[012])" + escapedSeparator + "(0[1-9]|[12][0-9]))|((0[13-9]|1[012])" + escapedSeparator + "30)|((0[13578]|1[02])" + escapedSeparator + "31)");
	                },
	                val1pre: new RegExp("[01]"),
	                val1: new RegExp("0[1-9]|1[012]")
	            },
	            leapday: "02/29/",
	            onKeyDown: function(e, buffer, caretPos, opts) {
	                var $input = $(this);
	                if (e.ctrlKey && e.keyCode === Inputmask.keyCode.RIGHT) {
	                    var today = new Date();
	                    $input.val((today.getMonth() + 1).toString() + today.getDate().toString() + today.getFullYear().toString()), 
	                    $input.trigger("setvalue");
	                }
	            }
	        },
	        "hh:mm t": {
	            mask: "h:s t\\m",
	            placeholder: "hh:mm xm",
	            alias: "datetime",
	            hourFormat: "12"
	        },
	        "h:s t": {
	            mask: "h:s t\\m",
	            placeholder: "hh:mm xm",
	            alias: "datetime",
	            hourFormat: "12"
	        },
	        "hh:mm:ss": {
	            mask: "h:s:s",
	            placeholder: "hh:mm:ss",
	            alias: "datetime",
	            autoUnmask: !1
	        },
	        "hh:mm": {
	            mask: "h:s",
	            placeholder: "hh:mm",
	            alias: "datetime",
	            autoUnmask: !1
	        },
	        date: {
	            alias: "dd/mm/yyyy"
	        },
	        "mm/yyyy": {
	            mask: "1/y",
	            placeholder: "mm/yyyy",
	            leapday: "donotuse",
	            separator: "/",
	            alias: "mm/dd/yyyy"
	        },
	        shamsi: {
	            regex: {
	                val2pre: function(separator) {
	                    var escapedSeparator = Inputmask.escapeRegex.call(this, separator);
	                    return new RegExp("((0[1-9]|1[012])" + escapedSeparator + "[0-3])");
	                },
	                val2: function(separator) {
	                    var escapedSeparator = Inputmask.escapeRegex.call(this, separator);
	                    return new RegExp("((0[1-9]|1[012])" + escapedSeparator + "(0[1-9]|[12][0-9]))|((0[1-9]|1[012])" + escapedSeparator + "30)|((0[1-6])" + escapedSeparator + "31)");
	                },
	                val1pre: new RegExp("[01]"),
	                val1: new RegExp("0[1-9]|1[012]")
	            },
	            yearrange: {
	                minyear: 1300,
	                maxyear: 1499
	            },
	            mask: "y/1/2",
	            leapday: "/12/30",
	            placeholder: "yyyy/mm/dd",
	            alias: "mm/dd/yyyy",
	            clearIncomplete: !0
	        }
	    }), Inputmask;
	}(jQuery, Inputmask), function($, Inputmask) {
	    return Inputmask.extendDefinitions({
	        A: {
	            validator: "[A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]",
	            cardinality: 1,
	            casing: "upper"
	        },
	        "&": {
	            validator: "[0-9A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]",
	            cardinality: 1,
	            casing: "upper"
	        },
	        "#": {
	            validator: "[0-9A-Fa-f]",
	            cardinality: 1,
	            casing: "upper"
	        }
	    }), Inputmask.extendAliases({
	        url: {
	            definitions: {
	                i: {
	                    validator: ".",
	                    cardinality: 1
	                }
	            },
	            mask: "(\\http://)|(\\http\\s://)|(ftp://)|(ftp\\s://)i{+}",
	            insertMode: !1,
	            autoUnmask: !1,
	            inputmode: "url"
	        },
	        ip: {
	            mask: "i[i[i]].i[i[i]].i[i[i]].i[i[i]]",
	            definitions: {
	                i: {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        return pos - 1 > -1 && "." !== maskset.buffer[pos - 1] ? (chrs = maskset.buffer[pos - 1] + chrs, 
	                        chrs = pos - 2 > -1 && "." !== maskset.buffer[pos - 2] ? maskset.buffer[pos - 2] + chrs : "0" + chrs) : chrs = "00" + chrs, 
	                        new RegExp("25[0-5]|2[0-4][0-9]|[01][0-9][0-9]").test(chrs);
	                    },
	                    cardinality: 1
	                }
	            },
	            onUnMask: function(maskedValue, unmaskedValue, opts) {
	                return maskedValue;
	            },
	            inputmode: "numeric"
	        },
	        email: {
	            mask: "*{1,64}[.*{1,64}][.*{1,64}][.*{1,63}]@-{1,63}.-{1,63}[.-{1,63}][.-{1,63}]",
	            greedy: !1,
	            onBeforePaste: function(pastedValue, opts) {
	                return pastedValue = pastedValue.toLowerCase(), pastedValue.replace("mailto:", "");
	            },
	            definitions: {
	                "*": {
	                    validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~-]",
	                    cardinality: 1,
	                    casing: "lower"
	                },
	                "-": {
	                    validator: "[0-9A-Za-z-]",
	                    cardinality: 1,
	                    casing: "lower"
	                }
	            },
	            onUnMask: function(maskedValue, unmaskedValue, opts) {
	                return maskedValue;
	            },
	            inputmode: "email"
	        },
	        mac: {
	            mask: "##:##:##:##:##:##"
	        },
	        vin: {
	            mask: "V{13}9{4}",
	            definitions: {
	                V: {
	                    validator: "[A-HJ-NPR-Za-hj-npr-z\\d]",
	                    cardinality: 1,
	                    casing: "upper"
	                }
	            },
	            clearIncomplete: !0,
	            autoUnmask: !0
	        }
	    }), Inputmask;
	}(jQuery, Inputmask), function($, Inputmask) {
	    return Inputmask.extendAliases({
	        numeric: {
	            mask: function(opts) {
	                function autoEscape(txt) {
	                    for (var escapedTxt = "", i = 0; i < txt.length; i++) escapedTxt += opts.definitions[txt.charAt(i)] || opts.optionalmarker.start === txt.charAt(i) || opts.optionalmarker.end === txt.charAt(i) || opts.quantifiermarker.start === txt.charAt(i) || opts.quantifiermarker.end === txt.charAt(i) || opts.groupmarker.start === txt.charAt(i) || opts.groupmarker.end === txt.charAt(i) || opts.alternatormarker === txt.charAt(i) ? "\\" + txt.charAt(i) : txt.charAt(i);
	                    return escapedTxt;
	                }
	                if (0 !== opts.repeat && isNaN(opts.integerDigits) && (opts.integerDigits = opts.repeat), 
	                opts.repeat = 0, opts.groupSeparator === opts.radixPoint && ("." === opts.radixPoint ? opts.groupSeparator = "," : "," === opts.radixPoint ? opts.groupSeparator = "." : opts.groupSeparator = ""), 
	                " " === opts.groupSeparator && (opts.skipOptionalPartCharacter = void 0), opts.autoGroup = opts.autoGroup && "" !== opts.groupSeparator, 
	                opts.autoGroup && ("string" == typeof opts.groupSize && isFinite(opts.groupSize) && (opts.groupSize = parseInt(opts.groupSize)), 
	                isFinite(opts.integerDigits))) {
	                    var seps = Math.floor(opts.integerDigits / opts.groupSize), mod = opts.integerDigits % opts.groupSize;
	                    opts.integerDigits = parseInt(opts.integerDigits) + (0 === mod ? seps - 1 : seps), 
	                    opts.integerDigits < 1 && (opts.integerDigits = "*");
	                }
	                opts.placeholder.length > 1 && (opts.placeholder = opts.placeholder.charAt(0)), 
	                "radixFocus" === opts.positionCaretOnClick && "" === opts.placeholder && opts.integerOptional === !1 && (opts.positionCaretOnClick = "lvp"), 
	                opts.definitions[";"] = opts.definitions["~"], opts.definitions[";"].definitionSymbol = "~", 
	                opts.numericInput === !0 && (opts.positionCaretOnClick = "radixFocus" === opts.positionCaretOnClick ? "lvp" : opts.positionCaretOnClick, 
	                opts.digitsOptional = !1, isNaN(opts.digits) && (opts.digits = 2), opts.decimalProtect = !1);
	                var mask = "[+]";
	                if (mask += autoEscape(opts.prefix), mask += opts.integerOptional === !0 ? "~{1," + opts.integerDigits + "}" : "~{" + opts.integerDigits + "}", 
	                void 0 !== opts.digits) {
	                    opts.decimalProtect && (opts.radixPointDefinitionSymbol = ":");
	                    var dq = opts.digits.toString().split(",");
	                    isFinite(dq[0] && dq[1] && isFinite(dq[1])) ? mask += (opts.decimalProtect ? ":" : opts.radixPoint) + ";{" + opts.digits + "}" : (isNaN(opts.digits) || parseInt(opts.digits) > 0) && (mask += opts.digitsOptional ? "[" + (opts.decimalProtect ? ":" : opts.radixPoint) + ";{1," + opts.digits + "}]" : (opts.decimalProtect ? ":" : opts.radixPoint) + ";{" + opts.digits + "}");
	                }
	                return mask += autoEscape(opts.suffix), mask += "[-]", opts.greedy = !1, null !== opts.min && (opts.min = opts.min.toString().replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                "," === opts.radixPoint && (opts.min = opts.min.replace(opts.radixPoint, "."))), 
	                null !== opts.max && (opts.max = opts.max.toString().replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                "," === opts.radixPoint && (opts.max = opts.max.replace(opts.radixPoint, "."))), 
	                mask;
	            },
	            placeholder: "",
	            greedy: !1,
	            digits: "*",
	            digitsOptional: !0,
	            radixPoint: ".",
	            positionCaretOnClick: "radixFocus",
	            groupSize: 3,
	            groupSeparator: "",
	            autoGroup: !1,
	            allowPlus: !0,
	            allowMinus: !0,
	            negationSymbol: {
	                front: "-",
	                back: ""
	            },
	            integerDigits: "+",
	            integerOptional: !0,
	            prefix: "",
	            suffix: "",
	            rightAlign: !0,
	            decimalProtect: !0,
	            min: null,
	            max: null,
	            step: 1,
	            insertMode: !0,
	            autoUnmask: !1,
	            unmaskAsNumber: !1,
	            inputmode: "numeric",
	            postFormat: function(buffer, pos, opts) {
	                opts.numericInput === !0 && (buffer = buffer.reverse(), isFinite(pos) && (pos = buffer.join("").length - pos - 1));
	                var i, l;
	                pos = pos >= buffer.length ? buffer.length - 1 : pos < 0 ? 0 : pos;
	                var charAtPos = buffer[pos], cbuf = buffer.slice();
	                charAtPos === opts.groupSeparator && (cbuf.splice(pos--, 1), charAtPos = cbuf[pos]);
	                var isNegative = cbuf.join("").match(new RegExp("^" + Inputmask.escapeRegex(opts.negationSymbol.front)));
	                isNegative = null !== isNegative && 1 === isNegative.length, pos > (isNegative ? opts.negationSymbol.front.length : 0) + opts.prefix.length && pos < cbuf.length - opts.suffix.length && (cbuf[pos] = "!");
	                var bufVal = cbuf.join(""), bufValOrigin = cbuf.join();
	                if (isNegative && (bufVal = bufVal.replace(new RegExp("^" + Inputmask.escapeRegex(opts.negationSymbol.front)), ""), 
	                bufVal = bufVal.replace(new RegExp(Inputmask.escapeRegex(opts.negationSymbol.back) + "$"), "")), 
	                bufVal = bufVal.replace(new RegExp(Inputmask.escapeRegex(opts.suffix) + "$"), ""), 
	                bufVal = bufVal.replace(new RegExp("^" + Inputmask.escapeRegex(opts.prefix)), ""), 
	                bufVal.length > 0 && opts.autoGroup || bufVal.indexOf(opts.groupSeparator) !== -1) {
	                    var escapedGroupSeparator = Inputmask.escapeRegex(opts.groupSeparator);
	                    bufVal = bufVal.replace(new RegExp(escapedGroupSeparator, "g"), "");
	                    var radixSplit = bufVal.split(charAtPos === opts.radixPoint ? "!" : opts.radixPoint);
	                    if (bufVal = "" === opts.radixPoint ? bufVal : radixSplit[0], charAtPos !== opts.negationSymbol.front && (bufVal = bufVal.replace("!", "?")), 
	                    bufVal.length > opts.groupSize) for (var reg = new RegExp("([-+]?[\\d?]+)([\\d?]{" + opts.groupSize + "})"); reg.test(bufVal) && "" !== opts.groupSeparator; ) bufVal = bufVal.replace(reg, "$1" + opts.groupSeparator + "$2"), 
	                    bufVal = bufVal.replace(opts.groupSeparator + opts.groupSeparator, opts.groupSeparator);
	                    bufVal = bufVal.replace("?", "!"), "" !== opts.radixPoint && radixSplit.length > 1 && (bufVal += (charAtPos === opts.radixPoint ? "!" : opts.radixPoint) + radixSplit[1]);
	                }
	                bufVal = opts.prefix + bufVal + opts.suffix, isNegative && (bufVal = opts.negationSymbol.front + bufVal + opts.negationSymbol.back);
	                var needsRefresh = bufValOrigin !== bufVal.split("").join(), newPos = $.inArray("!", bufVal);
	                if (newPos === -1 && (newPos = pos), needsRefresh) {
	                    for (buffer.length = bufVal.length, i = 0, l = bufVal.length; i < l; i++) buffer[i] = bufVal.charAt(i);
	                    buffer[newPos] = charAtPos;
	                }
	                return newPos = opts.numericInput && isFinite(pos) ? buffer.join("").length - newPos - 1 : newPos, 
	                opts.numericInput && (buffer = buffer.reverse(), $.inArray(opts.radixPoint, buffer) < newPos && buffer.join("").length - opts.suffix.length !== newPos && (newPos -= 1)), 
	                {
	                    pos: newPos,
	                    refreshFromBuffer: needsRefresh,
	                    buffer: buffer,
	                    isNegative: isNegative
	                };
	            },
	            onBeforeWrite: function(e, buffer, caretPos, opts) {
	                var rslt;
	                if (e && ("blur" === e.type || "checkval" === e.type || "keydown" === e.type)) {
	                    var maskedValue = opts.numericInput ? buffer.slice().reverse().join("") : buffer.join(""), processValue = maskedValue.replace(opts.prefix, "");
	                    processValue = processValue.replace(opts.suffix, ""), processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                    "," === opts.radixPoint && (processValue = processValue.replace(opts.radixPoint, "."));
	                    var isNegative = processValue.match(new RegExp("[-" + Inputmask.escapeRegex(opts.negationSymbol.front) + "]", "g"));
	                    if (isNegative = null !== isNegative && 1 === isNegative.length, processValue = processValue.replace(new RegExp("[-" + Inputmask.escapeRegex(opts.negationSymbol.front) + "]", "g"), ""), 
	                    processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.negationSymbol.back) + "$"), ""), 
	                    isNaN(opts.placeholder) && (processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.placeholder), "g"), "")), 
	                    processValue = processValue === opts.negationSymbol.front ? processValue + "0" : processValue, 
	                    "" !== processValue && isFinite(processValue)) {
	                        var floatValue = parseFloat(processValue), signedFloatValue = isNegative ? floatValue * -1 : floatValue;
	                        if (null !== opts.min && isFinite(opts.min) && signedFloatValue < parseFloat(opts.min) ? (floatValue = Math.abs(opts.min), 
	                        isNegative = opts.min < 0, maskedValue = void 0) : null !== opts.max && isFinite(opts.max) && signedFloatValue > parseFloat(opts.max) && (floatValue = Math.abs(opts.max), 
	                        isNegative = opts.max < 0, maskedValue = void 0), processValue = floatValue.toString().replace(".", opts.radixPoint).split(""), 
	                        isFinite(opts.digits)) {
	                            var radixPosition = $.inArray(opts.radixPoint, processValue), rpb = $.inArray(opts.radixPoint, maskedValue);
	                            radixPosition === -1 && (processValue.push(opts.radixPoint), radixPosition = processValue.length - 1);
	                            for (var i = 1; i <= opts.digits; i++) opts.digitsOptional || void 0 !== processValue[radixPosition + i] && processValue[radixPosition + i] !== opts.placeholder.charAt(0) ? rpb !== -1 && void 0 !== maskedValue[rpb + i] && (processValue[radixPosition + i] = processValue[radixPosition + i] || maskedValue[rpb + i]) : processValue[radixPosition + i] = "0";
	                            processValue[processValue.length - 1] === opts.radixPoint && delete processValue[processValue.length - 1];
	                        }
	                        if (floatValue.toString() !== processValue && floatValue.toString() + "." !== processValue || isNegative) return processValue = (opts.prefix + processValue.join("")).split(""), 
	                        !isNegative || 0 === floatValue && "blur" === e.type || (processValue.unshift(opts.negationSymbol.front), 
	                        processValue.push(opts.negationSymbol.back)), opts.numericInput && (processValue = processValue.reverse()), 
	                        rslt = opts.postFormat(processValue, opts.numericInput ? caretPos : caretPos - 1, opts), 
	                        rslt.buffer && (rslt.refreshFromBuffer = rslt.buffer.join("") !== buffer.join("")), 
	                        rslt;
	                    }
	                }
	                if (opts.autoGroup) return rslt = opts.postFormat(buffer, opts.numericInput ? caretPos : caretPos - 1, opts), 
	                rslt.caret = caretPos < (rslt.isNegative ? opts.negationSymbol.front.length : 0) + opts.prefix.length || caretPos > rslt.buffer.length - (rslt.isNegative ? opts.negationSymbol.back.length : 0) ? rslt.pos : rslt.pos + 1, 
	                rslt;
	            },
	            regex: {
	                integerPart: function(opts) {
	                    return new RegExp("[" + Inputmask.escapeRegex(opts.negationSymbol.front) + "+]?\\d+");
	                },
	                integerNPart: function(opts) {
	                    return new RegExp("[\\d" + Inputmask.escapeRegex(opts.groupSeparator) + Inputmask.escapeRegex(opts.placeholder.charAt(0)) + "]+");
	                }
	            },
	            signHandler: function(chrs, maskset, pos, strict, opts) {
	                if (!strict && opts.allowMinus && "-" === chrs || opts.allowPlus && "+" === chrs) {
	                    var matchRslt = maskset.buffer.join("").match(opts.regex.integerPart(opts));
	                    if (matchRslt && matchRslt[0].length > 0) return maskset.buffer[matchRslt.index] === ("-" === chrs ? "+" : opts.negationSymbol.front) ? "-" === chrs ? "" !== opts.negationSymbol.back ? {
	                        pos: 0,
	                        c: opts.negationSymbol.front,
	                        remove: 0,
	                        caret: pos,
	                        insert: {
	                            pos: maskset.buffer.length - 1,
	                            c: opts.negationSymbol.back
	                        }
	                    } : {
	                        pos: 0,
	                        c: opts.negationSymbol.front,
	                        remove: 0,
	                        caret: pos
	                    } : "" !== opts.negationSymbol.back ? {
	                        pos: 0,
	                        c: "+",
	                        remove: [ 0, maskset.buffer.length - 1 ],
	                        caret: pos
	                    } : {
	                        pos: 0,
	                        c: "+",
	                        remove: 0,
	                        caret: pos
	                    } : maskset.buffer[0] === ("-" === chrs ? opts.negationSymbol.front : "+") ? "-" === chrs && "" !== opts.negationSymbol.back ? {
	                        remove: [ 0, maskset.buffer.length - 1 ],
	                        caret: pos - 1
	                    } : {
	                        remove: 0,
	                        caret: pos - 1
	                    } : "-" === chrs ? "" !== opts.negationSymbol.back ? {
	                        pos: 0,
	                        c: opts.negationSymbol.front,
	                        caret: pos + 1,
	                        insert: {
	                            pos: maskset.buffer.length,
	                            c: opts.negationSymbol.back
	                        }
	                    } : {
	                        pos: 0,
	                        c: opts.negationSymbol.front,
	                        caret: pos + 1
	                    } : {
	                        pos: 0,
	                        c: chrs,
	                        caret: pos + 1
	                    };
	                }
	                return !1;
	            },
	            radixHandler: function(chrs, maskset, pos, strict, opts) {
	                if (!strict && opts.numericInput !== !0 && chrs === opts.radixPoint && void 0 !== opts.digits && (isNaN(opts.digits) || parseInt(opts.digits) > 0)) {
	                    var radixPos = $.inArray(opts.radixPoint, maskset.buffer), integerValue = maskset.buffer.join("").match(opts.regex.integerPart(opts));
	                    if (radixPos !== -1 && maskset.validPositions[radixPos]) return maskset.validPositions[radixPos - 1] ? {
	                        caret: radixPos + 1
	                    } : {
	                        pos: integerValue.index,
	                        c: integerValue[0],
	                        caret: radixPos + 1
	                    };
	                    if (!integerValue || "0" === integerValue[0] && integerValue.index + 1 !== pos) return maskset.buffer[integerValue ? integerValue.index : pos] = "0", 
	                    {
	                        pos: (integerValue ? integerValue.index : pos) + 1,
	                        c: opts.radixPoint
	                    };
	                }
	                return !1;
	            },
	            leadingZeroHandler: function(chrs, maskset, pos, strict, opts, isSelection) {
	                if (!strict) {
	                    var buffer = maskset.buffer.slice("");
	                    if (buffer.splice(0, opts.prefix.length), buffer.splice(buffer.length - opts.suffix.length, opts.suffix.length), 
	                    opts.numericInput === !0) {
	                        var buffer = buffer.reverse(), bufferChar = buffer[0];
	                        if ("0" === bufferChar && void 0 === maskset.validPositions[pos - 1]) return {
	                            pos: pos,
	                            remove: buffer.length - 1
	                        };
	                    } else {
	                        pos -= opts.prefix.length;
	                        var radixPosition = $.inArray(opts.radixPoint, buffer), matchRslt = buffer.slice(0, radixPosition !== -1 ? radixPosition : void 0).join("").match(opts.regex.integerNPart(opts));
	                        if (matchRslt && (radixPosition === -1 || pos <= radixPosition)) {
	                            var decimalPart = radixPosition === -1 ? 0 : parseInt(buffer.slice(radixPosition + 1).join(""));
	                            if (0 === matchRslt[0].indexOf("" !== opts.placeholder ? opts.placeholder.charAt(0) : "0") && (matchRslt.index + 1 === pos || isSelection !== !0 && 0 === decimalPart)) return maskset.buffer.splice(matchRslt.index + opts.prefix.length, 1), 
	                            {
	                                pos: matchRslt.index + opts.prefix.length,
	                                remove: matchRslt.index + opts.prefix.length
	                            };
	                            if ("0" === chrs && pos <= matchRslt.index && matchRslt[0] !== opts.groupSeparator) return !1;
	                        }
	                    }
	                }
	                return !0;
	            },
	            definitions: {
	                "~": {
	                    validator: function(chrs, maskset, pos, strict, opts, isSelection) {
	                        var isValid = opts.signHandler(chrs, maskset, pos, strict, opts);
	                        if (!isValid && (isValid = opts.radixHandler(chrs, maskset, pos, strict, opts), 
	                        !isValid && (isValid = strict ? new RegExp("[0-9" + Inputmask.escapeRegex(opts.groupSeparator) + "]").test(chrs) : new RegExp("[0-9]").test(chrs), 
	                        isValid === !0 && (isValid = opts.leadingZeroHandler(chrs, maskset, pos, strict, opts, isSelection), 
	                        isValid === !0)))) {
	                            var radixPosition = $.inArray(opts.radixPoint, maskset.buffer);
	                            isValid = radixPosition !== -1 && (opts.digitsOptional === !1 || maskset.validPositions[pos]) && opts.numericInput !== !0 && pos > radixPosition && !strict ? {
	                                pos: pos,
	                                remove: pos
	                            } : {
	                                pos: pos
	                            };
	                        }
	                        return isValid;
	                    },
	                    cardinality: 1
	                },
	                "+": {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        var isValid = opts.signHandler(chrs, maskset, pos, strict, opts);
	                        return !isValid && (strict && opts.allowMinus && chrs === opts.negationSymbol.front || opts.allowMinus && "-" === chrs || opts.allowPlus && "+" === chrs) && (isValid = !(!strict && "-" === chrs) || ("" !== opts.negationSymbol.back ? {
	                            pos: pos,
	                            c: "-" === chrs ? opts.negationSymbol.front : "+",
	                            caret: pos + 1,
	                            insert: {
	                                pos: maskset.buffer.length,
	                                c: opts.negationSymbol.back
	                            }
	                        } : {
	                            pos: pos,
	                            c: "-" === chrs ? opts.negationSymbol.front : "+",
	                            caret: pos + 1
	                        })), isValid;
	                    },
	                    cardinality: 1,
	                    placeholder: ""
	                },
	                "-": {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        var isValid = opts.signHandler(chrs, maskset, pos, strict, opts);
	                        return !isValid && strict && opts.allowMinus && chrs === opts.negationSymbol.back && (isValid = !0), 
	                        isValid;
	                    },
	                    cardinality: 1,
	                    placeholder: ""
	                },
	                ":": {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        var isValid = opts.signHandler(chrs, maskset, pos, strict, opts);
	                        if (!isValid) {
	                            var radix = "[" + Inputmask.escapeRegex(opts.radixPoint) + "]";
	                            isValid = new RegExp(radix).test(chrs), isValid && maskset.validPositions[pos] && maskset.validPositions[pos].match.placeholder === opts.radixPoint && (isValid = {
	                                caret: pos + 1
	                            });
	                        }
	                        return isValid;
	                    },
	                    cardinality: 1,
	                    placeholder: function(opts) {
	                        return opts.radixPoint;
	                    }
	                }
	            },
	            onUnMask: function(maskedValue, unmaskedValue, opts) {
	                if ("" === unmaskedValue && opts.nullable === !0) return unmaskedValue;
	                var processValue = maskedValue.replace(opts.prefix, "");
	                return processValue = processValue.replace(opts.suffix, ""), processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                opts.unmaskAsNumber ? ("" !== opts.radixPoint && processValue.indexOf(opts.radixPoint) !== -1 && (processValue = processValue.replace(Inputmask.escapeRegex.call(this, opts.radixPoint), ".")), 
	                Number(processValue)) : processValue;
	            },
	            isComplete: function(buffer, opts) {
	                var maskedValue = buffer.join(""), bufClone = buffer.slice();
	                if (opts.postFormat(bufClone, 0, opts), bufClone.join("") !== maskedValue) return !1;
	                var processValue = maskedValue.replace(opts.prefix, "");
	                return processValue = processValue.replace(opts.suffix, ""), processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                "," === opts.radixPoint && (processValue = processValue.replace(Inputmask.escapeRegex(opts.radixPoint), ".")), 
	                isFinite(processValue);
	            },
	            onBeforeMask: function(initialValue, opts) {
	                if (opts.numericInput === !0 && (initialValue = initialValue.split("").reverse().join("")), 
	                "" !== opts.radixPoint && isFinite(initialValue)) {
	                    var vs = initialValue.split("."), groupSize = "" !== opts.groupSeparator ? parseInt(opts.groupSize) : 0;
	                    2 === vs.length && (vs[0].length > groupSize || vs[1].length > groupSize) && (initialValue = initialValue.toString().replace(".", opts.radixPoint));
	                }
	                var kommaMatches = initialValue.match(/,/g), dotMatches = initialValue.match(/\./g);
	                if (dotMatches && kommaMatches ? dotMatches.length > kommaMatches.length ? (initialValue = initialValue.replace(/\./g, ""), 
	                initialValue = initialValue.replace(",", opts.radixPoint)) : kommaMatches.length > dotMatches.length ? (initialValue = initialValue.replace(/,/g, ""), 
	                initialValue = initialValue.replace(".", opts.radixPoint)) : initialValue = initialValue.indexOf(".") < initialValue.indexOf(",") ? initialValue.replace(/\./g, "") : initialValue = initialValue.replace(/,/g, "") : initialValue = initialValue.replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                0 === opts.digits && (initialValue.indexOf(".") !== -1 ? initialValue = initialValue.substring(0, initialValue.indexOf(".")) : initialValue.indexOf(",") !== -1 && (initialValue = initialValue.substring(0, initialValue.indexOf(",")))), 
	                "" !== opts.radixPoint && isFinite(opts.digits) && initialValue.indexOf(opts.radixPoint) !== -1) {
	                    var valueParts = initialValue.split(opts.radixPoint), decPart = valueParts[1].match(new RegExp("\\d*"))[0];
	                    if (parseInt(opts.digits) < decPart.toString().length) {
	                        var digitsFactor = Math.pow(10, parseInt(opts.digits));
	                        initialValue = initialValue.replace(Inputmask.escapeRegex(opts.radixPoint), "."), 
	                        initialValue = Math.round(parseFloat(initialValue) * digitsFactor) / digitsFactor, 
	                        initialValue = initialValue.toString().replace(".", opts.radixPoint);
	                    }
	                }
	                return opts.numericInput === !0 && (initialValue = initialValue.split("").reverse().join("")), 
	                initialValue.toString();
	            },
	            canClearPosition: function(maskset, position, lvp, strict, opts) {
	                var positionInput = maskset.validPositions[position].input, canClear = positionInput !== opts.radixPoint || null !== maskset.validPositions[position].match.fn && opts.decimalProtect === !1 || isFinite(positionInput) || position === lvp || positionInput === opts.groupSeparator || positionInput === opts.negationSymbol.front || positionInput === opts.negationSymbol.back;
	                return canClear;
	            },
	            onKeyDown: function(e, buffer, caretPos, opts) {
	                var $input = $(this);
	                if (e.ctrlKey) switch (e.keyCode) {
	                  case Inputmask.keyCode.UP:
	                    $input.val(parseFloat(this.inputmask.unmaskedvalue()) + parseInt(opts.step)), $input.trigger("setvalue");
	                    break;
	
	                  case Inputmask.keyCode.DOWN:
	                    $input.val(parseFloat(this.inputmask.unmaskedvalue()) - parseInt(opts.step)), $input.trigger("setvalue");
	                }
	            }
	        },
	        currency: {
	            prefix: "$ ",
	            groupSeparator: ",",
	            alias: "numeric",
	            placeholder: "0",
	            autoGroup: !0,
	            digits: 2,
	            digitsOptional: !1,
	            clearMaskOnLostFocus: !1
	        },
	        decimal: {
	            alias: "numeric"
	        },
	        integer: {
	            alias: "numeric",
	            digits: 0,
	            radixPoint: ""
	        },
	        percentage: {
	            alias: "numeric",
	            digits: 2,
	            radixPoint: ".",
	            placeholder: "0",
	            autoGroup: !1,
	            min: 0,
	            max: 100,
	            suffix: " %",
	            allowPlus: !1,
	            allowMinus: !1
	        }
	    }), Inputmask;
	}(jQuery, Inputmask), function($, Inputmask) {
	    function maskSort(a, b) {
	        var maska = (a.mask || a).replace(/#/g, "9").replace(/\)/, "9").replace(/[+()#-]/g, ""), maskb = (b.mask || b).replace(/#/g, "9").replace(/\)/, "9").replace(/[+()#-]/g, ""), maskas = (a.mask || a).split("#")[0], maskbs = (b.mask || b).split("#")[0];
	        return 0 === maskbs.indexOf(maskas) ? -1 : 0 === maskas.indexOf(maskbs) ? 1 : maska.localeCompare(maskb);
	    }
	    var analyseMaskBase = Inputmask.prototype.analyseMask;
	    return Inputmask.prototype.analyseMask = function(mask, opts) {
	        function reduceVariations(masks, previousVariation, previousmaskGroup) {
	            previousVariation = previousVariation || "", previousmaskGroup = previousmaskGroup || maskGroups, 
	            "" !== previousVariation && (previousmaskGroup[previousVariation] = {});
	            for (var variation = "", maskGroup = previousmaskGroup[previousVariation] || previousmaskGroup, i = masks.length - 1; i >= 0; i--) mask = masks[i].mask || masks[i], 
	            variation = mask.substr(0, 1), maskGroup[variation] = maskGroup[variation] || [], 
	            maskGroup[variation].unshift(mask.substr(1)), masks.splice(i, 1);
	            for (var ndx in maskGroup) maskGroup[ndx].length > 500 && reduceVariations(maskGroup[ndx].slice(), ndx, maskGroup);
	        }
	        function rebuild(maskGroup) {
	            var mask = "", submasks = [];
	            for (var ndx in maskGroup) $.isArray(maskGroup[ndx]) ? 1 === maskGroup[ndx].length ? submasks.push(ndx + maskGroup[ndx]) : submasks.push(ndx + opts.groupmarker.start + maskGroup[ndx].join(opts.groupmarker.end + opts.alternatormarker + opts.groupmarker.start) + opts.groupmarker.end) : submasks.push(ndx + rebuild(maskGroup[ndx]));
	            return mask += 1 === submasks.length ? submasks[0] : opts.groupmarker.start + submasks.join(opts.groupmarker.end + opts.alternatormarker + opts.groupmarker.start) + opts.groupmarker.end;
	        }
	        var maskGroups = {};
	        opts.phoneCodes && opts.phoneCodes.length > 1e3 && (mask = mask.substr(1, mask.length - 2), 
	        reduceVariations(mask.split(opts.groupmarker.end + opts.alternatormarker + opts.groupmarker.start)), 
	        mask = rebuild(maskGroups));
	        var mt = analyseMaskBase.call(this, mask, opts);
	        return mt;
	    }, Inputmask.extendAliases({
	        abstractphone: {
	            groupmarker: {
	                start: "<",
	                end: ">"
	            },
	            countrycode: "",
	            phoneCodes: [],
	            mask: function(opts) {
	                return opts.definitions = {
	                    "#": opts.definitions[9]
	                }, opts.phoneCodes.sort(maskSort);
	            },
	            keepStatic: !0,
	            onBeforeMask: function(value, opts) {
	                var processedValue = value.replace(/^0{1,2}/, "").replace(/[\s]/g, "");
	                return (processedValue.indexOf(opts.countrycode) > 1 || processedValue.indexOf(opts.countrycode) === -1) && (processedValue = "+" + opts.countrycode + processedValue), 
	                processedValue;
	            },
	            onUnMask: function(maskedValue, unmaskedValue, opts) {
	                return unmaskedValue;
	            },
	            inputmode: "tel"
	        }
	    }), Inputmask;
	}(jQuery, Inputmask), function($, Inputmask) {
	    return Inputmask.extendAliases({
	        Regex: {
	            mask: "r",
	            greedy: !1,
	            repeat: "*",
	            regex: null,
	            regexTokens: null,
	            tokenizer: /\[\^?]?(?:[^\\\]]+|\\[\S\s]?)*]?|\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9][0-9]*|x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4}|c[A-Za-z]|[\S\s]?)|\((?:\?[:=!]?)?|(?:[?*+]|\{[0-9]+(?:,[0-9]*)?\})\??|[^.?*+^${[()|\\]+|./g,
	            quantifierFilter: /[0-9]+[^,]/,
	            isComplete: function(buffer, opts) {
	                return new RegExp(opts.regex).test(buffer.join(""));
	            },
	            definitions: {
	                r: {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        function RegexToken(isGroup, isQuantifier) {
	                            this.matches = [], this.isGroup = isGroup || !1, this.isQuantifier = isQuantifier || !1, 
	                            this.quantifier = {
	                                min: 1,
	                                max: 1
	                            }, this.repeaterPart = void 0;
	                        }
	                        function analyseRegex() {
	                            var match, m, currentToken = new RegexToken(), opengroups = [];
	                            for (opts.regexTokens = []; match = opts.tokenizer.exec(opts.regex); ) switch (m = match[0], 
	                            m.charAt(0)) {
	                              case "(":
	                                opengroups.push(new RegexToken((!0)));
	                                break;
	
	                              case ")":
	                                groupToken = opengroups.pop(), opengroups.length > 0 ? opengroups[opengroups.length - 1].matches.push(groupToken) : currentToken.matches.push(groupToken);
	                                break;
	
	                              case "{":
	                              case "+":
	                              case "*":
	                                var quantifierToken = new RegexToken((!1), (!0));
	                                m = m.replace(/[{}]/g, "");
	                                var mq = m.split(","), mq0 = isNaN(mq[0]) ? mq[0] : parseInt(mq[0]), mq1 = 1 === mq.length ? mq0 : isNaN(mq[1]) ? mq[1] : parseInt(mq[1]);
	                                if (quantifierToken.quantifier = {
	                                    min: mq0,
	                                    max: mq1
	                                }, opengroups.length > 0) {
	                                    var matches = opengroups[opengroups.length - 1].matches;
	                                    match = matches.pop(), match.isGroup || (groupToken = new RegexToken((!0)), groupToken.matches.push(match), 
	                                    match = groupToken), matches.push(match), matches.push(quantifierToken);
	                                } else match = currentToken.matches.pop(), match.isGroup || (groupToken = new RegexToken((!0)), 
	                                groupToken.matches.push(match), match = groupToken), currentToken.matches.push(match), 
	                                currentToken.matches.push(quantifierToken);
	                                break;
	
	                              default:
	                                opengroups.length > 0 ? opengroups[opengroups.length - 1].matches.push(m) : currentToken.matches.push(m);
	                            }
	                            currentToken.matches.length > 0 && opts.regexTokens.push(currentToken);
	                        }
	                        function validateRegexToken(token, fromGroup) {
	                            var isvalid = !1;
	                            fromGroup && (regexPart += "(", openGroupCount++);
	                            for (var mndx = 0; mndx < token.matches.length; mndx++) {
	                                var matchToken = token.matches[mndx];
	                                if (matchToken.isGroup === !0) isvalid = validateRegexToken(matchToken, !0); else if (matchToken.isQuantifier === !0) {
	                                    var crrntndx = $.inArray(matchToken, token.matches), matchGroup = token.matches[crrntndx - 1], regexPartBak = regexPart;
	                                    if (isNaN(matchToken.quantifier.max)) {
	                                        for (;matchToken.repeaterPart && matchToken.repeaterPart !== regexPart && matchToken.repeaterPart.length > regexPart.length && !(isvalid = validateRegexToken(matchGroup, !0)); ) ;
	                                        isvalid = isvalid || validateRegexToken(matchGroup, !0), isvalid && (matchToken.repeaterPart = regexPart), 
	                                        regexPart = regexPartBak + matchToken.quantifier.max;
	                                    } else {
	                                        for (var i = 0, qm = matchToken.quantifier.max - 1; i < qm && !(isvalid = validateRegexToken(matchGroup, !0)); i++) ;
	                                        regexPart = regexPartBak + "{" + matchToken.quantifier.min + "," + matchToken.quantifier.max + "}";
	                                    }
	                                } else if (void 0 !== matchToken.matches) for (var k = 0; k < matchToken.length && !(isvalid = validateRegexToken(matchToken[k], fromGroup)); k++) ; else {
	                                    var testExp;
	                                    if ("[" == matchToken.charAt(0)) {
	                                        testExp = regexPart, testExp += matchToken;
	                                        for (var j = 0; j < openGroupCount; j++) testExp += ")";
	                                        var exp = new RegExp("^(" + testExp + ")$");
	                                        isvalid = exp.test(bufferStr);
	                                    } else for (var l = 0, tl = matchToken.length; l < tl; l++) if ("\\" !== matchToken.charAt(l)) {
	                                        testExp = regexPart, testExp += matchToken.substr(0, l + 1), testExp = testExp.replace(/\|$/, "");
	                                        for (var j = 0; j < openGroupCount; j++) testExp += ")";
	                                        var exp = new RegExp("^(" + testExp + ")$");
	                                        if (isvalid = exp.test(bufferStr)) break;
	                                    }
	                                    regexPart += matchToken;
	                                }
	                                if (isvalid) break;
	                            }
	                            return fromGroup && (regexPart += ")", openGroupCount--), isvalid;
	                        }
	                        var bufferStr, groupToken, cbuffer = maskset.buffer.slice(), regexPart = "", isValid = !1, openGroupCount = 0;
	                        null === opts.regexTokens && analyseRegex(), cbuffer.splice(pos, 0, chrs), bufferStr = cbuffer.join("");
	                        for (var i = 0; i < opts.regexTokens.length; i++) {
	                            var regexToken = opts.regexTokens[i];
	                            if (isValid = validateRegexToken(regexToken, regexToken.isGroup)) break;
	                        }
	                        return isValid;
	                    },
	                    cardinality: 1
	                }
	            }
	        }
	    }), Inputmask;
	}(jQuery, Inputmask);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Datepicker for Bootstrap v1.9.0 (https://github.com/uxsolutions/bootstrap-datepicker)
	 *
	 * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)
	 */
	
	(function(factory){
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        factory(require('jquery'));
	    } else {
	        factory(jQuery);
	    }
	}(function($, undefined){
		function UTCDate(){
			return new Date(Date.UTC.apply(Date, arguments));
		}
		function UTCToday(){
			var today = new Date();
			return UTCDate(today.getFullYear(), today.getMonth(), today.getDate());
		}
		function isUTCEquals(date1, date2) {
			return (
				date1.getUTCFullYear() === date2.getUTCFullYear() &&
				date1.getUTCMonth() === date2.getUTCMonth() &&
				date1.getUTCDate() === date2.getUTCDate()
			);
		}
		function alias(method, deprecationMsg){
			return function(){
				if (deprecationMsg !== undefined) {
					$.fn.datepicker.deprecated(deprecationMsg);
				}
	
				return this[method].apply(this, arguments);
			};
		}
		function isValidDate(d) {
			return d && !isNaN(d.getTime());
		}
	
		var DateArray = (function(){
			var extras = {
				get: function(i){
					return this.slice(i)[0];
				},
				contains: function(d){
					// Array.indexOf is not cross-browser;
					// $.inArray doesn't work with Dates
					var val = d && d.valueOf();
					for (var i=0, l=this.length; i < l; i++)
	          // Use date arithmetic to allow dates with different times to match
	          if (0 <= this[i].valueOf() - val && this[i].valueOf() - val < 1000*60*60*24)
							return i;
					return -1;
				},
				remove: function(i){
					this.splice(i,1);
				},
				replace: function(new_array){
					if (!new_array)
						return;
					if (!$.isArray(new_array))
						new_array = [new_array];
					this.clear();
					this.push.apply(this, new_array);
				},
				clear: function(){
					this.length = 0;
				},
				copy: function(){
					var a = new DateArray();
					a.replace(this);
					return a;
				}
			};
	
			return function(){
				var a = [];
				a.push.apply(a, arguments);
				$.extend(a, extras);
				return a;
			};
		})();
	
	
		// Picker object
	
		var Datepicker = function(element, options){
			$.data(element, 'datepicker', this);
	
			this._events = [];
			this._secondaryEvents = [];
	
			this._process_options(options);
	
			this.dates = new DateArray();
			this.viewDate = this.o.defaultViewDate;
			this.focusDate = null;
	
			this.element = $(element);
			this.isInput = this.element.is('input');
			this.inputField = this.isInput ? this.element : this.element.find('input');
			this.component = this.element.hasClass('date') ? this.element.find('.add-on, .input-group-addon, .input-group-append, .input-group-prepend, .btn') : false;
			if (this.component && this.component.length === 0)
				this.component = false;
			this.isInline = !this.component && this.element.is('div');
	
			this.picker = $(DPGlobal.template);
	
			// Checking templates and inserting
			if (this._check_template(this.o.templates.leftArrow)) {
				this.picker.find('.prev').html(this.o.templates.leftArrow);
			}
	
			if (this._check_template(this.o.templates.rightArrow)) {
				this.picker.find('.next').html(this.o.templates.rightArrow);
			}
	
			this._buildEvents();
			this._attachEvents();
	
			if (this.isInline){
				this.picker.addClass('datepicker-inline').appendTo(this.element);
			}
			else {
				this.picker.addClass('datepicker-dropdown dropdown-menu');
			}
	
			if (this.o.rtl){
				this.picker.addClass('datepicker-rtl');
			}
	
			if (this.o.calendarWeeks) {
				this.picker.find('.datepicker-days .datepicker-switch, thead .datepicker-title, tfoot .today, tfoot .clear')
					.attr('colspan', function(i, val){
						return Number(val) + 1;
					});
			}
	
			this._process_options({
				startDate: this._o.startDate,
				endDate: this._o.endDate,
				daysOfWeekDisabled: this.o.daysOfWeekDisabled,
				daysOfWeekHighlighted: this.o.daysOfWeekHighlighted,
				datesDisabled: this.o.datesDisabled
			});
	
			this._allow_update = false;
			this.setViewMode(this.o.startView);
			this._allow_update = true;
	
			this.fillDow();
			this.fillMonths();
	
			this.update();
	
			if (this.isInline){
				this.show();
			}
		};
	
		Datepicker.prototype = {
			constructor: Datepicker,
	
			_resolveViewName: function(view){
				$.each(DPGlobal.viewModes, function(i, viewMode){
					if (view === i || $.inArray(view, viewMode.names) !== -1){
						view = i;
						return false;
					}
				});
	
				return view;
			},
	
			_resolveDaysOfWeek: function(daysOfWeek){
				if (!$.isArray(daysOfWeek))
					daysOfWeek = daysOfWeek.split(/[,\s]*/);
				return $.map(daysOfWeek, Number);
			},
	
			_check_template: function(tmp){
				try {
					// If empty
					if (tmp === undefined || tmp === "") {
						return false;
					}
					// If no html, everything ok
					if ((tmp.match(/[<>]/g) || []).length <= 0) {
						return true;
					}
					// Checking if html is fine
					var jDom = $(tmp);
					return jDom.length > 0;
				}
				catch (ex) {
					return false;
				}
			},
	
			_process_options: function(opts){
				// Store raw options for reference
				this._o = $.extend({}, this._o, opts);
				// Processed options
				var o = this.o = $.extend({}, this._o);
	
				// Check if "de-DE" style date is available, if not language should
				// fallback to 2 letter code eg "de"
				var lang = o.language;
				if (!dates[lang]){
					lang = lang.split('-')[0];
					if (!dates[lang])
						lang = defaults.language;
				}
				o.language = lang;
	
				// Retrieve view index from any aliases
				o.startView = this._resolveViewName(o.startView);
				o.minViewMode = this._resolveViewName(o.minViewMode);
				o.maxViewMode = this._resolveViewName(o.maxViewMode);
	
				// Check view is between min and max
				o.startView = Math.max(this.o.minViewMode, Math.min(this.o.maxViewMode, o.startView));
	
				// true, false, or Number > 0
				if (o.multidate !== true){
					o.multidate = Number(o.multidate) || false;
					if (o.multidate !== false)
						o.multidate = Math.max(0, o.multidate);
				}
				o.multidateSeparator = String(o.multidateSeparator);
	
				o.weekStart %= 7;
				o.weekEnd = (o.weekStart + 6) % 7;
	
				var format = DPGlobal.parseFormat(o.format);
				if (o.startDate !== -Infinity){
					if (!!o.startDate){
						if (o.startDate instanceof Date)
							o.startDate = this._local_to_utc(this._zero_time(o.startDate));
						else
							o.startDate = DPGlobal.parseDate(o.startDate, format, o.language, o.assumeNearbyYear);
					}
					else {
						o.startDate = -Infinity;
					}
				}
				if (o.endDate !== Infinity){
					if (!!o.endDate){
						if (o.endDate instanceof Date)
							o.endDate = this._local_to_utc(this._zero_time(o.endDate));
						else
							o.endDate = DPGlobal.parseDate(o.endDate, format, o.language, o.assumeNearbyYear);
					}
					else {
						o.endDate = Infinity;
					}
				}
	
				o.daysOfWeekDisabled = this._resolveDaysOfWeek(o.daysOfWeekDisabled||[]);
				o.daysOfWeekHighlighted = this._resolveDaysOfWeek(o.daysOfWeekHighlighted||[]);
	
				o.datesDisabled = o.datesDisabled||[];
				if (!$.isArray(o.datesDisabled)) {
					o.datesDisabled = o.datesDisabled.split(',');
				}
				o.datesDisabled = $.map(o.datesDisabled, function(d){
					return DPGlobal.parseDate(d, format, o.language, o.assumeNearbyYear);
				});
	
				var plc = String(o.orientation).toLowerCase().split(/\s+/g),
					_plc = o.orientation.toLowerCase();
				plc = $.grep(plc, function(word){
					return /^auto|left|right|top|bottom$/.test(word);
				});
				o.orientation = {x: 'auto', y: 'auto'};
				if (!_plc || _plc === 'auto')
					; // no action
				else if (plc.length === 1){
					switch (plc[0]){
						case 'top':
						case 'bottom':
							o.orientation.y = plc[0];
							break;
						case 'left':
						case 'right':
							o.orientation.x = plc[0];
							break;
					}
				}
				else {
					_plc = $.grep(plc, function(word){
						return /^left|right$/.test(word);
					});
					o.orientation.x = _plc[0] || 'auto';
	
					_plc = $.grep(plc, function(word){
						return /^top|bottom$/.test(word);
					});
					o.orientation.y = _plc[0] || 'auto';
				}
				if (o.defaultViewDate instanceof Date || typeof o.defaultViewDate === 'string') {
					o.defaultViewDate = DPGlobal.parseDate(o.defaultViewDate, format, o.language, o.assumeNearbyYear);
				} else if (o.defaultViewDate) {
					var year = o.defaultViewDate.year || new Date().getFullYear();
					var month = o.defaultViewDate.month || 0;
					var day = o.defaultViewDate.day || 1;
					o.defaultViewDate = UTCDate(year, month, day);
				} else {
					o.defaultViewDate = UTCToday();
				}
			},
			_applyEvents: function(evs){
				for (var i=0, el, ch, ev; i < evs.length; i++){
					el = evs[i][0];
					if (evs[i].length === 2){
						ch = undefined;
						ev = evs[i][1];
					} else if (evs[i].length === 3){
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.on(ev, ch);
				}
			},
			_unapplyEvents: function(evs){
				for (var i=0, el, ev, ch; i < evs.length; i++){
					el = evs[i][0];
					if (evs[i].length === 2){
						ch = undefined;
						ev = evs[i][1];
					} else if (evs[i].length === 3){
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.off(ev, ch);
				}
			},
			_buildEvents: function(){
	            var events = {
	                keyup: $.proxy(function(e){
	                    if ($.inArray(e.keyCode, [27, 37, 39, 38, 40, 32, 13, 9]) === -1)
	                        this.update();
	                }, this),
	                keydown: $.proxy(this.keydown, this),
	                paste: $.proxy(this.paste, this)
	            };
	
	            if (this.o.showOnFocus === true) {
	                events.focus = $.proxy(this.show, this);
	            }
	
	            if (this.isInput) { // single input
	                this._events = [
	                    [this.element, events]
	                ];
	            }
	            // component: input + button
	            else if (this.component && this.inputField.length) {
	                this._events = [
	                    // For components that are not readonly, allow keyboard nav
	                    [this.inputField, events],
	                    [this.component, {
	                        click: $.proxy(this.show, this)
	                    }]
	                ];
	            }
				else {
					this._events = [
						[this.element, {
							click: $.proxy(this.show, this),
							keydown: $.proxy(this.keydown, this)
						}]
					];
				}
				this._events.push(
					// Component: listen for blur on element descendants
					[this.element, '*', {
						blur: $.proxy(function(e){
							this._focused_from = e.target;
						}, this)
					}],
					// Input: listen for blur on element
					[this.element, {
						blur: $.proxy(function(e){
							this._focused_from = e.target;
						}, this)
					}]
				);
	
				if (this.o.immediateUpdates) {
					// Trigger input updates immediately on changed year/month
					this._events.push([this.element, {
						'changeYear changeMonth': $.proxy(function(e){
							this.update(e.date);
						}, this)
					}]);
				}
	
				this._secondaryEvents = [
					[this.picker, {
						click: $.proxy(this.click, this)
					}],
					[this.picker, '.prev, .next', {
						click: $.proxy(this.navArrowsClick, this)
					}],
					[this.picker, '.day:not(.disabled)', {
						click: $.proxy(this.dayCellClick, this)
					}],
					[$(window), {
						resize: $.proxy(this.place, this)
					}],
					[$(document), {
						'mousedown touchstart': $.proxy(function(e){
							// Clicked outside the datepicker, hide it
							if (!(
								this.element.is(e.target) ||
								this.element.find(e.target).length ||
								this.picker.is(e.target) ||
								this.picker.find(e.target).length ||
								this.isInline
							)){
								this.hide();
							}
						}, this)
					}]
				];
			},
			_attachEvents: function(){
				this._detachEvents();
				this._applyEvents(this._events);
			},
			_detachEvents: function(){
				this._unapplyEvents(this._events);
			},
			_attachSecondaryEvents: function(){
				this._detachSecondaryEvents();
				this._applyEvents(this._secondaryEvents);
			},
			_detachSecondaryEvents: function(){
				this._unapplyEvents(this._secondaryEvents);
			},
			_trigger: function(event, altdate){
				var date = altdate || this.dates.get(-1),
					local_date = this._utc_to_local(date);
	
				this.element.trigger({
					type: event,
					date: local_date,
					viewMode: this.viewMode,
					dates: $.map(this.dates, this._utc_to_local),
					format: $.proxy(function(ix, format){
						if (arguments.length === 0){
							ix = this.dates.length - 1;
							format = this.o.format;
						} else if (typeof ix === 'string'){
							format = ix;
							ix = this.dates.length - 1;
						}
						format = format || this.o.format;
						var date = this.dates.get(ix);
						return DPGlobal.formatDate(date, format, this.o.language);
					}, this)
				});
			},
	
			show: function(){
				if (this.inputField.is(':disabled') || (this.inputField.prop('readonly') && this.o.enableOnReadonly === false))
					return;
				if (!this.isInline)
					this.picker.appendTo(this.o.container);
				this.place();
				this.picker.show();
				this._attachSecondaryEvents();
				this._trigger('show');
				if ((window.navigator.msMaxTouchPoints || 'ontouchstart' in document) && this.o.disableTouchKeyboard) {
					$(this.element).blur();
				}
				return this;
			},
	
			hide: function(){
				if (this.isInline || !this.picker.is(':visible'))
					return this;
				this.focusDate = null;
				this.picker.hide().detach();
				this._detachSecondaryEvents();
				this.setViewMode(this.o.startView);
	
				if (this.o.forceParse && this.inputField.val())
					this.setValue();
				this._trigger('hide');
				return this;
			},
	
			destroy: function(){
				this.hide();
				this._detachEvents();
				this._detachSecondaryEvents();
				this.picker.remove();
				delete this.element.data().datepicker;
				if (!this.isInput){
					delete this.element.data().date;
				}
				return this;
			},
	
			paste: function(e){
				var dateString;
				if (e.originalEvent.clipboardData && e.originalEvent.clipboardData.types
					&& $.inArray('text/plain', e.originalEvent.clipboardData.types) !== -1) {
					dateString = e.originalEvent.clipboardData.getData('text/plain');
				} else if (window.clipboardData) {
					dateString = window.clipboardData.getData('Text');
				} else {
					return;
				}
				this.setDate(dateString);
				this.update();
				e.preventDefault();
			},
	
			_utc_to_local: function(utc){
				if (!utc) {
					return utc;
				}
	
				var local = new Date(utc.getTime() + (utc.getTimezoneOffset() * 60000));
	
				if (local.getTimezoneOffset() !== utc.getTimezoneOffset()) {
					local = new Date(utc.getTime() + (local.getTimezoneOffset() * 60000));
				}
	
				return local;
			},
			_local_to_utc: function(local){
				return local && new Date(local.getTime() - (local.getTimezoneOffset()*60000));
			},
			_zero_time: function(local){
				return local && new Date(local.getFullYear(), local.getMonth(), local.getDate());
			},
			_zero_utc_time: function(utc){
				return utc && UTCDate(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate());
			},
	
			getDates: function(){
				return $.map(this.dates, this._utc_to_local);
			},
	
			getUTCDates: function(){
				return $.map(this.dates, function(d){
					return new Date(d);
				});
			},
	
			getDate: function(){
				return this._utc_to_local(this.getUTCDate());
			},
	
			getUTCDate: function(){
				var selected_date = this.dates.get(-1);
				if (selected_date !== undefined) {
					return new Date(selected_date);
				} else {
					return null;
				}
			},
	
			clearDates: function(){
				this.inputField.val('');
				this.update();
				this._trigger('changeDate');
	
				if (this.o.autoclose) {
					this.hide();
				}
			},
	
			setDates: function(){
				var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
				this.update.apply(this, args);
				this._trigger('changeDate');
				this.setValue();
				return this;
			},
	
			setUTCDates: function(){
				var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
				this.setDates.apply(this, $.map(args, this._utc_to_local));
				return this;
			},
	
			setDate: alias('setDates'),
			setUTCDate: alias('setUTCDates'),
			remove: alias('destroy', 'Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead'),
	
			setValue: function(){
				var formatted = this.getFormattedDate();
				this.inputField.val(formatted);
				return this;
			},
	
			getFormattedDate: function(format){
				if (format === undefined)
					format = this.o.format;
	
				var lang = this.o.language;
				return $.map(this.dates, function(d){
					return DPGlobal.formatDate(d, format, lang);
				}).join(this.o.multidateSeparator);
			},
	
			getStartDate: function(){
				return this.o.startDate;
			},
	
			setStartDate: function(startDate){
				this._process_options({startDate: startDate});
				this.update();
				this.updateNavArrows();
				return this;
			},
	
			getEndDate: function(){
				return this.o.endDate;
			},
	
			setEndDate: function(endDate){
				this._process_options({endDate: endDate});
				this.update();
				this.updateNavArrows();
				return this;
			},
	
			setDaysOfWeekDisabled: function(daysOfWeekDisabled){
				this._process_options({daysOfWeekDisabled: daysOfWeekDisabled});
				this.update();
				return this;
			},
	
			setDaysOfWeekHighlighted: function(daysOfWeekHighlighted){
				this._process_options({daysOfWeekHighlighted: daysOfWeekHighlighted});
				this.update();
				return this;
			},
	
			setDatesDisabled: function(datesDisabled){
				this._process_options({datesDisabled: datesDisabled});
				this.update();
				return this;
			},
	
			place: function(){
				if (this.isInline)
					return this;
				var calendarWidth = this.picker.outerWidth(),
					calendarHeight = this.picker.outerHeight(),
					visualPadding = 10,
					container = $(this.o.container),
					windowWidth = container.width(),
					scrollTop = this.o.container === 'body' ? $(document).scrollTop() : container.scrollTop(),
					appendOffset = container.offset();
	
				var parentsZindex = [0];
				this.element.parents().each(function(){
					var itemZIndex = $(this).css('z-index');
					if (itemZIndex !== 'auto' && Number(itemZIndex) !== 0) parentsZindex.push(Number(itemZIndex));
				});
				var zIndex = Math.max.apply(Math, parentsZindex) + this.o.zIndexOffset;
				var offset = this.component ? this.component.parent().offset() : this.element.offset();
				var height = this.component ? this.component.outerHeight(true) : this.element.outerHeight(false);
				var width = this.component ? this.component.outerWidth(true) : this.element.outerWidth(false);
				var left = offset.left - appendOffset.left;
				var top = offset.top - appendOffset.top;
	
				if (this.o.container !== 'body') {
					top += scrollTop;
				}
	
				this.picker.removeClass(
					'datepicker-orient-top datepicker-orient-bottom '+
					'datepicker-orient-right datepicker-orient-left'
				);
	
				if (this.o.orientation.x !== 'auto'){
					this.picker.addClass('datepicker-orient-' + this.o.orientation.x);
					if (this.o.orientation.x === 'right')
						left -= calendarWidth - width;
				}
				// auto x orientation is best-placement: if it crosses a window
				// edge, fudge it sideways
				else {
					if (offset.left < 0) {
						// component is outside the window on the left side. Move it into visible range
						this.picker.addClass('datepicker-orient-left');
						left -= offset.left - visualPadding;
					} else if (left + calendarWidth > windowWidth) {
						// the calendar passes the widow right edge. Align it to component right side
						this.picker.addClass('datepicker-orient-right');
						left += width - calendarWidth;
					} else {
						if (this.o.rtl) {
							// Default to right
							this.picker.addClass('datepicker-orient-right');
						} else {
							// Default to left
							this.picker.addClass('datepicker-orient-left');
						}
					}
				}
	
				// auto y orientation is best-situation: top or bottom, no fudging,
				// decision based on which shows more of the calendar
				var yorient = this.o.orientation.y,
					top_overflow;
				if (yorient === 'auto'){
					top_overflow = -scrollTop + top - calendarHeight;
					yorient = top_overflow < 0 ? 'bottom' : 'top';
				}
	
				this.picker.addClass('datepicker-orient-' + yorient);
				if (yorient === 'top')
					top -= calendarHeight + parseInt(this.picker.css('padding-top'));
				else
					top += height;
	
				if (this.o.rtl) {
					var right = windowWidth - (left + width);
					this.picker.css({
						top: top,
						right: right,
						zIndex: zIndex
					});
				} else {
					this.picker.css({
						top: top,
						left: left,
						zIndex: zIndex
					});
				}
				return this;
			},
	
			_allow_update: true,
			update: function(){
				if (!this._allow_update)
					return this;
	
				var oldDates = this.dates.copy(),
					dates = [],
					fromArgs = false;
				if (arguments.length){
					$.each(arguments, $.proxy(function(i, date){
						if (date instanceof Date)
							date = this._local_to_utc(date);
						dates.push(date);
					}, this));
					fromArgs = true;
				} else {
					dates = this.isInput
							? this.element.val()
							: this.element.data('date') || this.inputField.val();
					if (dates && this.o.multidate)
						dates = dates.split(this.o.multidateSeparator);
					else
						dates = [dates];
					delete this.element.data().date;
				}
	
				dates = $.map(dates, $.proxy(function(date){
					return DPGlobal.parseDate(date, this.o.format, this.o.language, this.o.assumeNearbyYear);
				}, this));
				dates = $.grep(dates, $.proxy(function(date){
					return (
						!this.dateWithinRange(date) ||
						!date
					);
				}, this), true);
				this.dates.replace(dates);
	
				if (this.o.updateViewDate) {
					if (this.dates.length)
						this.viewDate = new Date(this.dates.get(-1));
					else if (this.viewDate < this.o.startDate)
						this.viewDate = new Date(this.o.startDate);
					else if (this.viewDate > this.o.endDate)
						this.viewDate = new Date(this.o.endDate);
					else
						this.viewDate = this.o.defaultViewDate;
				}
	
				if (fromArgs){
					// setting date by clicking
					this.setValue();
					this.element.change();
				}
				else if (this.dates.length){
					// setting date by typing
					if (String(oldDates) !== String(this.dates) && fromArgs) {
						this._trigger('changeDate');
						this.element.change();
					}
				}
				if (!this.dates.length && oldDates.length) {
					this._trigger('clearDate');
					this.element.change();
				}
	
				this.fill();
				return this;
			},
	
			fillDow: function(){
	      if (this.o.showWeekDays) {
				var dowCnt = this.o.weekStart,
					html = '<tr>';
				if (this.o.calendarWeeks){
					html += '<th class="cw">&#160;</th>';
				}
				while (dowCnt < this.o.weekStart + 7){
					html += '<th class="dow';
	        if ($.inArray(dowCnt, this.o.daysOfWeekDisabled) !== -1)
	          html += ' disabled';
	        html += '">'+dates[this.o.language].daysMin[(dowCnt++)%7]+'</th>';
				}
				html += '</tr>';
				this.picker.find('.datepicker-days thead').append(html);
	      }
			},
	
			fillMonths: function(){
	      var localDate = this._utc_to_local(this.viewDate);
				var html = '';
				var focused;
				for (var i = 0; i < 12; i++){
					focused = localDate && localDate.getMonth() === i ? ' focused' : '';
					html += '<span class="month' + focused + '">' + dates[this.o.language].monthsShort[i] + '</span>';
				}
				this.picker.find('.datepicker-months td').html(html);
			},
	
			setRange: function(range){
				if (!range || !range.length)
					delete this.range;
				else
					this.range = $.map(range, function(d){
						return d.valueOf();
					});
				this.fill();
			},
	
			getClassNames: function(date){
				var cls = [],
					year = this.viewDate.getUTCFullYear(),
					month = this.viewDate.getUTCMonth(),
					today = UTCToday();
				if (date.getUTCFullYear() < year || (date.getUTCFullYear() === year && date.getUTCMonth() < month)){
					cls.push('old');
				} else if (date.getUTCFullYear() > year || (date.getUTCFullYear() === year && date.getUTCMonth() > month)){
					cls.push('new');
				}
				if (this.focusDate && date.valueOf() === this.focusDate.valueOf())
					cls.push('focused');
				// Compare internal UTC date with UTC today, not local today
				if (this.o.todayHighlight && isUTCEquals(date, today)) {
					cls.push('today');
				}
				if (this.dates.contains(date) !== -1)
					cls.push('active');
				if (!this.dateWithinRange(date)){
					cls.push('disabled');
				}
				if (this.dateIsDisabled(date)){
					cls.push('disabled', 'disabled-date');
				}
				if ($.inArray(date.getUTCDay(), this.o.daysOfWeekHighlighted) !== -1){
					cls.push('highlighted');
				}
	
				if (this.range){
					if (date > this.range[0] && date < this.range[this.range.length-1]){
						cls.push('range');
					}
					if ($.inArray(date.valueOf(), this.range) !== -1){
						cls.push('selected');
					}
					if (date.valueOf() === this.range[0]){
	          cls.push('range-start');
	        }
	        if (date.valueOf() === this.range[this.range.length-1]){
	          cls.push('range-end');
	        }
				}
				return cls;
			},
	
			_fill_yearsView: function(selector, cssClass, factor, year, startYear, endYear, beforeFn){
				var html = '';
				var step = factor / 10;
				var view = this.picker.find(selector);
				var startVal = Math.floor(year / factor) * factor;
				var endVal = startVal + step * 9;
				var focusedVal = Math.floor(this.viewDate.getFullYear() / step) * step;
				var selected = $.map(this.dates, function(d){
					return Math.floor(d.getUTCFullYear() / step) * step;
				});
	
				var classes, tooltip, before;
				for (var currVal = startVal - step; currVal <= endVal + step; currVal += step) {
					classes = [cssClass];
					tooltip = null;
	
					if (currVal === startVal - step) {
						classes.push('old');
					} else if (currVal === endVal + step) {
						classes.push('new');
					}
					if ($.inArray(currVal, selected) !== -1) {
						classes.push('active');
					}
					if (currVal < startYear || currVal > endYear) {
						classes.push('disabled');
					}
					if (currVal === focusedVal) {
					  classes.push('focused');
	        }
	
					if (beforeFn !== $.noop) {
						before = beforeFn(new Date(currVal, 0, 1));
						if (before === undefined) {
							before = {};
						} else if (typeof before === 'boolean') {
							before = {enabled: before};
						} else if (typeof before === 'string') {
							before = {classes: before};
						}
						if (before.enabled === false) {
							classes.push('disabled');
						}
						if (before.classes) {
							classes = classes.concat(before.classes.split(/\s+/));
						}
						if (before.tooltip) {
							tooltip = before.tooltip;
						}
					}
	
					html += '<span class="' + classes.join(' ') + '"' + (tooltip ? ' title="' + tooltip + '"' : '') + '>' + currVal + '</span>';
				}
	
				view.find('.datepicker-switch').text(startVal + '-' + endVal);
				view.find('td').html(html);
			},
	
			fill: function(){
				var d = new Date(this.viewDate),
					year = d.getUTCFullYear(),
					month = d.getUTCMonth(),
					startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity,
					startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity,
					endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity,
					endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity,
					todaytxt = dates[this.o.language].today || dates['en'].today || '',
					cleartxt = dates[this.o.language].clear || dates['en'].clear || '',
	        titleFormat = dates[this.o.language].titleFormat || dates['en'].titleFormat,
	        todayDate = UTCToday(),
	        titleBtnVisible = (this.o.todayBtn === true || this.o.todayBtn === 'linked') && todayDate >= this.o.startDate && todayDate <= this.o.endDate && !this.weekOfDateIsDisabled(todayDate),
					tooltip,
					before;
				if (isNaN(year) || isNaN(month))
					return;
				this.picker.find('.datepicker-days .datepicker-switch')
							.text(DPGlobal.formatDate(d, titleFormat, this.o.language));
				this.picker.find('tfoot .today')
							.text(todaytxt)
	            .css('display', titleBtnVisible ? 'table-cell' : 'none');
				this.picker.find('tfoot .clear')
							.text(cleartxt)
							.css('display', this.o.clearBtn === true ? 'table-cell' : 'none');
				this.picker.find('thead .datepicker-title')
							.text(this.o.title)
							.css('display', typeof this.o.title === 'string' && this.o.title !== '' ? 'table-cell' : 'none');
				this.updateNavArrows();
				this.fillMonths();
				var prevMonth = UTCDate(year, month, 0),
					day = prevMonth.getUTCDate();
				prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.o.weekStart + 7)%7);
				var nextMonth = new Date(prevMonth);
				if (prevMonth.getUTCFullYear() < 100){
	        nextMonth.setUTCFullYear(prevMonth.getUTCFullYear());
	      }
				nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
				nextMonth = nextMonth.valueOf();
				var html = [];
				var weekDay, clsName;
				while (prevMonth.valueOf() < nextMonth){
					weekDay = prevMonth.getUTCDay();
					if (weekDay === this.o.weekStart){
						html.push('<tr>');
						if (this.o.calendarWeeks){
							// ISO 8601: First week contains first thursday.
							// ISO also states week starts on Monday, but we can be more abstract here.
							var
								// Start of current week: based on weekstart/current date
								ws = new Date(+prevMonth + (this.o.weekStart - weekDay - 7) % 7 * 864e5),
								// Thursday of this week
								th = new Date(Number(ws) + (7 + 4 - ws.getUTCDay()) % 7 * 864e5),
								// First Thursday of year, year from thursday
								yth = new Date(Number(yth = UTCDate(th.getUTCFullYear(), 0, 1)) + (7 + 4 - yth.getUTCDay()) % 7 * 864e5),
								// Calendar week: ms between thursdays, div ms per day, div 7 days
								calWeek = (th - yth) / 864e5 / 7 + 1;
							html.push('<td class="cw">'+ calWeek +'</td>');
						}
					}
					clsName = this.getClassNames(prevMonth);
					clsName.push('day');
	
					var content = prevMonth.getUTCDate();
	
					if (this.o.beforeShowDay !== $.noop){
						before = this.o.beforeShowDay(this._utc_to_local(prevMonth));
						if (before === undefined)
							before = {};
						else if (typeof before === 'boolean')
							before = {enabled: before};
						else if (typeof before === 'string')
							before = {classes: before};
						if (before.enabled === false)
							clsName.push('disabled');
						if (before.classes)
							clsName = clsName.concat(before.classes.split(/\s+/));
						if (before.tooltip)
							tooltip = before.tooltip;
						if (before.content)
							content = before.content;
					}
	
					//Check if uniqueSort exists (supported by jquery >=1.12 and >=2.2)
					//Fallback to unique function for older jquery versions
					if ($.isFunction($.uniqueSort)) {
						clsName = $.uniqueSort(clsName);
					} else {
						clsName = $.unique(clsName);
					}
	
					html.push('<td class="'+clsName.join(' ')+'"' + (tooltip ? ' title="'+tooltip+'"' : '') + ' data-date="' + prevMonth.getTime().toString() + '">' + content + '</td>');
					tooltip = null;
					if (weekDay === this.o.weekEnd){
						html.push('</tr>');
					}
					prevMonth.setUTCDate(prevMonth.getUTCDate() + 1);
				}
				this.picker.find('.datepicker-days tbody').html(html.join(''));
	
				var monthsTitle = dates[this.o.language].monthsTitle || dates['en'].monthsTitle || 'Months';
				var months = this.picker.find('.datepicker-months')
							.find('.datepicker-switch')
								.text(this.o.maxViewMode < 2 ? monthsTitle : year)
								.end()
							.find('tbody span').removeClass('active');
	
				$.each(this.dates, function(i, d){
					if (d.getUTCFullYear() === year)
						months.eq(d.getUTCMonth()).addClass('active');
				});
	
				if (year < startYear || year > endYear){
					months.addClass('disabled');
				}
				if (year === startYear){
					months.slice(0, startMonth).addClass('disabled');
				}
				if (year === endYear){
					months.slice(endMonth+1).addClass('disabled');
				}
	
				if (this.o.beforeShowMonth !== $.noop){
					var that = this;
					$.each(months, function(i, month){
	          var moDate = new Date(year, i, 1);
	          var before = that.o.beforeShowMonth(moDate);
						if (before === undefined)
							before = {};
						else if (typeof before === 'boolean')
							before = {enabled: before};
						else if (typeof before === 'string')
							before = {classes: before};
						if (before.enabled === false && !$(month).hasClass('disabled'))
						    $(month).addClass('disabled');
						if (before.classes)
						    $(month).addClass(before.classes);
						if (before.tooltip)
						    $(month).prop('title', before.tooltip);
					});
				}
	
				// Generating decade/years picker
				this._fill_yearsView(
					'.datepicker-years',
					'year',
					10,
					year,
					startYear,
					endYear,
					this.o.beforeShowYear
				);
	
				// Generating century/decades picker
				this._fill_yearsView(
					'.datepicker-decades',
					'decade',
					100,
					year,
					startYear,
					endYear,
					this.o.beforeShowDecade
				);
	
				// Generating millennium/centuries picker
				this._fill_yearsView(
					'.datepicker-centuries',
					'century',
					1000,
					year,
					startYear,
					endYear,
					this.o.beforeShowCentury
				);
			},
	
			updateNavArrows: function(){
				if (!this._allow_update)
					return;
	
				var d = new Date(this.viewDate),
					year = d.getUTCFullYear(),
					month = d.getUTCMonth(),
					startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity,
					startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity,
					endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity,
					endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity,
					prevIsDisabled,
					nextIsDisabled,
					factor = 1;
				switch (this.viewMode){
					case 4:
						factor *= 10;
						/* falls through */
					case 3:
						factor *= 10;
						/* falls through */
					case 2:
						factor *= 10;
						/* falls through */
					case 1:
						prevIsDisabled = Math.floor(year / factor) * factor <= startYear;
						nextIsDisabled = Math.floor(year / factor) * factor + factor > endYear;
						break;
					case 0:
						prevIsDisabled = year <= startYear && month <= startMonth;
						nextIsDisabled = year >= endYear && month >= endMonth;
						break;
				}
	
				this.picker.find('.prev').toggleClass('disabled', prevIsDisabled);
				this.picker.find('.next').toggleClass('disabled', nextIsDisabled);
			},
	
			click: function(e){
				e.preventDefault();
				e.stopPropagation();
	
				var target, dir, day, year, month;
				target = $(e.target);
	
				// Clicked on the switch
				if (target.hasClass('datepicker-switch') && this.viewMode !== this.o.maxViewMode){
					this.setViewMode(this.viewMode + 1);
				}
	
				// Clicked on today button
				if (target.hasClass('today') && !target.hasClass('day')){
					this.setViewMode(0);
					this._setDate(UTCToday(), this.o.todayBtn === 'linked' ? null : 'view');
				}
	
				// Clicked on clear button
				if (target.hasClass('clear')){
					this.clearDates();
				}
	
				if (!target.hasClass('disabled')){
					// Clicked on a month, year, decade, century
					if (target.hasClass('month')
							|| target.hasClass('year')
							|| target.hasClass('decade')
							|| target.hasClass('century')) {
						this.viewDate.setUTCDate(1);
	
						day = 1;
						if (this.viewMode === 1){
							month = target.parent().find('span').index(target);
							year = this.viewDate.getUTCFullYear();
							this.viewDate.setUTCMonth(month);
						} else {
							month = 0;
							year = Number(target.text());
							this.viewDate.setUTCFullYear(year);
						}
	
						this._trigger(DPGlobal.viewModes[this.viewMode - 1].e, this.viewDate);
	
						if (this.viewMode === this.o.minViewMode){
							this._setDate(UTCDate(year, month, day));
						} else {
							this.setViewMode(this.viewMode - 1);
							this.fill();
						}
					}
				}
	
				if (this.picker.is(':visible') && this._focused_from){
					this._focused_from.focus();
				}
				delete this._focused_from;
			},
	
			dayCellClick: function(e){
				var $target = $(e.currentTarget);
				var timestamp = $target.data('date');
				var date = new Date(timestamp);
	
				if (this.o.updateViewDate) {
					if (date.getUTCFullYear() !== this.viewDate.getUTCFullYear()) {
						this._trigger('changeYear', this.viewDate);
					}
	
					if (date.getUTCMonth() !== this.viewDate.getUTCMonth()) {
						this._trigger('changeMonth', this.viewDate);
					}
				}
				this._setDate(date);
			},
	
			// Clicked on prev or next
			navArrowsClick: function(e){
				var $target = $(e.currentTarget);
				var dir = $target.hasClass('prev') ? -1 : 1;
				if (this.viewMode !== 0){
					dir *= DPGlobal.viewModes[this.viewMode].navStep * 12;
				}
				this.viewDate = this.moveMonth(this.viewDate, dir);
				this._trigger(DPGlobal.viewModes[this.viewMode].e, this.viewDate);
				this.fill();
			},
	
			_toggle_multidate: function(date){
				var ix = this.dates.contains(date);
				if (!date){
					this.dates.clear();
				}
	
				if (ix !== -1){
					if (this.o.multidate === true || this.o.multidate > 1 || this.o.toggleActive){
						this.dates.remove(ix);
					}
				} else if (this.o.multidate === false) {
					this.dates.clear();
					this.dates.push(date);
				}
				else {
					this.dates.push(date);
				}
	
				if (typeof this.o.multidate === 'number')
					while (this.dates.length > this.o.multidate)
						this.dates.remove(0);
			},
	
			_setDate: function(date, which){
				if (!which || which === 'date')
					this._toggle_multidate(date && new Date(date));
				if ((!which && this.o.updateViewDate) || which === 'view')
					this.viewDate = date && new Date(date);
	
				this.fill();
				this.setValue();
				if (!which || which !== 'view') {
					this._trigger('changeDate');
				}
				this.inputField.trigger('change');
				if (this.o.autoclose && (!which || which === 'date')){
					this.hide();
				}
			},
	
			moveDay: function(date, dir){
				var newDate = new Date(date);
				newDate.setUTCDate(date.getUTCDate() + dir);
	
				return newDate;
			},
	
			moveWeek: function(date, dir){
				return this.moveDay(date, dir * 7);
			},
	
			moveMonth: function(date, dir){
				if (!isValidDate(date))
					return this.o.defaultViewDate;
				if (!dir)
					return date;
				var new_date = new Date(date.valueOf()),
					day = new_date.getUTCDate(),
					month = new_date.getUTCMonth(),
					mag = Math.abs(dir),
					new_month, test;
				dir = dir > 0 ? 1 : -1;
				if (mag === 1){
					test = dir === -1
						// If going back one month, make sure month is not current month
						// (eg, Mar 31 -> Feb 31 == Feb 28, not Mar 02)
						? function(){
							return new_date.getUTCMonth() === month;
						}
						// If going forward one month, make sure month is as expected
						// (eg, Jan 31 -> Feb 31 == Feb 28, not Mar 02)
						: function(){
							return new_date.getUTCMonth() !== new_month;
						};
					new_month = month + dir;
					new_date.setUTCMonth(new_month);
					// Dec -> Jan (12) or Jan -> Dec (-1) -- limit expected date to 0-11
					new_month = (new_month + 12) % 12;
				}
				else {
					// For magnitudes >1, move one month at a time...
					for (var i=0; i < mag; i++)
						// ...which might decrease the day (eg, Jan 31 to Feb 28, etc)...
						new_date = this.moveMonth(new_date, dir);
					// ...then reset the day, keeping it in the new month
					new_month = new_date.getUTCMonth();
					new_date.setUTCDate(day);
					test = function(){
						return new_month !== new_date.getUTCMonth();
					};
				}
				// Common date-resetting loop -- if date is beyond end of month, make it
				// end of month
				while (test()){
					new_date.setUTCDate(--day);
					new_date.setUTCMonth(new_month);
				}
				return new_date;
			},
	
			moveYear: function(date, dir){
				return this.moveMonth(date, dir*12);
			},
	
			moveAvailableDate: function(date, dir, fn){
				do {
					date = this[fn](date, dir);
	
					if (!this.dateWithinRange(date))
						return false;
	
					fn = 'moveDay';
				}
				while (this.dateIsDisabled(date));
	
				return date;
			},
	
			weekOfDateIsDisabled: function(date){
				return $.inArray(date.getUTCDay(), this.o.daysOfWeekDisabled) !== -1;
			},
	
			dateIsDisabled: function(date){
				return (
					this.weekOfDateIsDisabled(date) ||
					$.grep(this.o.datesDisabled, function(d){
						return isUTCEquals(date, d);
					}).length > 0
				);
			},
	
			dateWithinRange: function(date){
				return date >= this.o.startDate && date <= this.o.endDate;
			},
	
			keydown: function(e){
				if (!this.picker.is(':visible')){
					if (e.keyCode === 40 || e.keyCode === 27) { // allow down to re-show picker
						this.show();
						e.stopPropagation();
	        }
					return;
				}
				var dateChanged = false,
					dir, newViewDate,
					focusDate = this.focusDate || this.viewDate;
				switch (e.keyCode){
					case 27: // escape
						if (this.focusDate){
							this.focusDate = null;
							this.viewDate = this.dates.get(-1) || this.viewDate;
							this.fill();
						}
						else
							this.hide();
						e.preventDefault();
						e.stopPropagation();
						break;
					case 37: // left
					case 38: // up
					case 39: // right
					case 40: // down
						if (!this.o.keyboardNavigation || this.o.daysOfWeekDisabled.length === 7)
							break;
						dir = e.keyCode === 37 || e.keyCode === 38 ? -1 : 1;
	          if (this.viewMode === 0) {
	  					if (e.ctrlKey){
	  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');
	
	  						if (newViewDate)
	  							this._trigger('changeYear', this.viewDate);
	  					} else if (e.shiftKey){
	  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');
	
	  						if (newViewDate)
	  							this._trigger('changeMonth', this.viewDate);
	  					} else if (e.keyCode === 37 || e.keyCode === 39){
	  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveDay');
	  					} else if (!this.weekOfDateIsDisabled(focusDate)){
	  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveWeek');
	  					}
	          } else if (this.viewMode === 1) {
	            if (e.keyCode === 38 || e.keyCode === 40) {
	              dir = dir * 4;
	            }
	            newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');
	          } else if (this.viewMode === 2) {
	            if (e.keyCode === 38 || e.keyCode === 40) {
	              dir = dir * 4;
	            }
	            newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');
	          }
						if (newViewDate){
							this.focusDate = this.viewDate = newViewDate;
							this.setValue();
							this.fill();
							e.preventDefault();
						}
						break;
					case 13: // enter
						if (!this.o.forceParse)
							break;
						focusDate = this.focusDate || this.dates.get(-1) || this.viewDate;
						if (this.o.keyboardNavigation) {
							this._toggle_multidate(focusDate);
							dateChanged = true;
						}
						this.focusDate = null;
						this.viewDate = this.dates.get(-1) || this.viewDate;
						this.setValue();
						this.fill();
						if (this.picker.is(':visible')){
							e.preventDefault();
							e.stopPropagation();
							if (this.o.autoclose)
								this.hide();
						}
						break;
					case 9: // tab
						this.focusDate = null;
						this.viewDate = this.dates.get(-1) || this.viewDate;
						this.fill();
						this.hide();
						break;
				}
				if (dateChanged){
					if (this.dates.length)
						this._trigger('changeDate');
					else
						this._trigger('clearDate');
					this.inputField.trigger('change');
				}
			},
	
			setViewMode: function(viewMode){
				this.viewMode = viewMode;
				this.picker
					.children('div')
					.hide()
					.filter('.datepicker-' + DPGlobal.viewModes[this.viewMode].clsName)
						.show();
				this.updateNavArrows();
	      this._trigger('changeViewMode', new Date(this.viewDate));
			}
		};
	
		var DateRangePicker = function(element, options){
			$.data(element, 'datepicker', this);
			this.element = $(element);
			this.inputs = $.map(options.inputs, function(i){
				return i.jquery ? i[0] : i;
			});
			delete options.inputs;
	
			this.keepEmptyValues = options.keepEmptyValues;
			delete options.keepEmptyValues;
	
			datepickerPlugin.call($(this.inputs), options)
				.on('changeDate', $.proxy(this.dateUpdated, this));
	
			this.pickers = $.map(this.inputs, function(i){
				return $.data(i, 'datepicker');
			});
			this.updateDates();
		};
		DateRangePicker.prototype = {
			updateDates: function(){
				this.dates = $.map(this.pickers, function(i){
					return i.getUTCDate();
				});
				this.updateRanges();
			},
			updateRanges: function(){
				var range = $.map(this.dates, function(d){
					return d.valueOf();
				});
				$.each(this.pickers, function(i, p){
					p.setRange(range);
				});
			},
			clearDates: function(){
				$.each(this.pickers, function(i, p){
					p.clearDates();
				});
			},
			dateUpdated: function(e){
				// `this.updating` is a workaround for preventing infinite recursion
				// between `changeDate` triggering and `setUTCDate` calling.  Until
				// there is a better mechanism.
				if (this.updating)
					return;
				this.updating = true;
	
				var dp = $.data(e.target, 'datepicker');
	
				if (dp === undefined) {
					return;
				}
	
				var new_date = dp.getUTCDate(),
					keep_empty_values = this.keepEmptyValues,
					i = $.inArray(e.target, this.inputs),
					j = i - 1,
					k = i + 1,
					l = this.inputs.length;
				if (i === -1)
					return;
	
				$.each(this.pickers, function(i, p){
					if (!p.getUTCDate() && (p === dp || !keep_empty_values))
						p.setUTCDate(new_date);
				});
	
				if (new_date < this.dates[j]){
					// Date being moved earlier/left
					while (j >= 0 && new_date < this.dates[j]){
						this.pickers[j--].setUTCDate(new_date);
					}
				} else if (new_date > this.dates[k]){
					// Date being moved later/right
					while (k < l && new_date > this.dates[k]){
						this.pickers[k++].setUTCDate(new_date);
					}
				}
				this.updateDates();
	
				delete this.updating;
			},
			destroy: function(){
				$.map(this.pickers, function(p){ p.destroy(); });
				$(this.inputs).off('changeDate', this.dateUpdated);
				delete this.element.data().datepicker;
			},
			remove: alias('destroy', 'Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead')
		};
	
		function opts_from_el(el, prefix){
			// Derive options from element data-attrs
			var data = $(el).data(),
				out = {}, inkey,
				replace = new RegExp('^' + prefix.toLowerCase() + '([A-Z])');
			prefix = new RegExp('^' + prefix.toLowerCase());
			function re_lower(_,a){
				return a.toLowerCase();
			}
			for (var key in data)
				if (prefix.test(key)){
					inkey = key.replace(replace, re_lower);
					out[inkey] = data[key];
				}
			return out;
		}
	
		function opts_from_locale(lang){
			// Derive options from locale plugins
			var out = {};
			// Check if "de-DE" style date is available, if not language should
			// fallback to 2 letter code eg "de"
			if (!dates[lang]){
				lang = lang.split('-')[0];
				if (!dates[lang])
					return;
			}
			var d = dates[lang];
			$.each(locale_opts, function(i,k){
				if (k in d)
					out[k] = d[k];
			});
			return out;
		}
	
		var old = $.fn.datepicker;
		var datepickerPlugin = function(option){
			var args = Array.apply(null, arguments);
			args.shift();
			var internal_return;
			this.each(function(){
				var $this = $(this),
					data = $this.data('datepicker'),
					options = typeof option === 'object' && option;
				if (!data){
					var elopts = opts_from_el(this, 'date'),
						// Preliminary otions
						xopts = $.extend({}, defaults, elopts, options),
						locopts = opts_from_locale(xopts.language),
						// Options priority: js args, data-attrs, locales, defaults
						opts = $.extend({}, defaults, locopts, elopts, options);
					if ($this.hasClass('input-daterange') || opts.inputs){
						$.extend(opts, {
							inputs: opts.inputs || $this.find('input').toArray()
						});
						data = new DateRangePicker(this, opts);
					}
					else {
						data = new Datepicker(this, opts);
					}
					$this.data('datepicker', data);
				}
				if (typeof option === 'string' && typeof data[option] === 'function'){
					internal_return = data[option].apply(data, args);
				}
			});
	
			if (
				internal_return === undefined ||
				internal_return instanceof Datepicker ||
				internal_return instanceof DateRangePicker
			)
				return this;
	
			if (this.length > 1)
				throw new Error('Using only allowed for the collection of a single element (' + option + ' function)');
			else
				return internal_return;
		};
		$.fn.datepicker = datepickerPlugin;
	
		var defaults = $.fn.datepicker.defaults = {
			assumeNearbyYear: false,
			autoclose: false,
			beforeShowDay: $.noop,
			beforeShowMonth: $.noop,
			beforeShowYear: $.noop,
			beforeShowDecade: $.noop,
			beforeShowCentury: $.noop,
			calendarWeeks: false,
			clearBtn: false,
			toggleActive: false,
			daysOfWeekDisabled: [],
			daysOfWeekHighlighted: [],
			datesDisabled: [],
			endDate: Infinity,
			forceParse: true,
			format: 'mm/dd/yyyy',
			keepEmptyValues: false,
			keyboardNavigation: true,
			language: 'en',
			minViewMode: 0,
			maxViewMode: 4,
			multidate: false,
			multidateSeparator: ',',
			orientation: "auto",
			rtl: false,
			startDate: -Infinity,
			startView: 0,
			todayBtn: false,
			todayHighlight: false,
			updateViewDate: true,
			weekStart: 0,
			disableTouchKeyboard: false,
			enableOnReadonly: true,
			showOnFocus: true,
			zIndexOffset: 10,
			container: 'body',
			immediateUpdates: false,
			title: '',
			templates: {
				leftArrow: '&#x00AB;',
				rightArrow: '&#x00BB;'
			},
	    showWeekDays: true
		};
		var locale_opts = $.fn.datepicker.locale_opts = [
			'format',
			'rtl',
			'weekStart'
		];
		$.fn.datepicker.Constructor = Datepicker;
		var dates = $.fn.datepicker.dates = {
			en: {
				days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
				daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
				daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
				months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
				monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
				today: "Today",
				clear: "Clear",
				titleFormat: "MM yyyy"
			}
		};
	
		var DPGlobal = {
			viewModes: [
				{
					names: ['days', 'month'],
					clsName: 'days',
					e: 'changeMonth'
				},
				{
					names: ['months', 'year'],
					clsName: 'months',
					e: 'changeYear',
					navStep: 1
				},
				{
					names: ['years', 'decade'],
					clsName: 'years',
					e: 'changeDecade',
					navStep: 10
				},
				{
					names: ['decades', 'century'],
					clsName: 'decades',
					e: 'changeCentury',
					navStep: 100
				},
				{
					names: ['centuries', 'millennium'],
					clsName: 'centuries',
					e: 'changeMillennium',
					navStep: 1000
				}
			],
			validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
			nonpunctuation: /[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,
			parseFormat: function(format){
				if (typeof format.toValue === 'function' && typeof format.toDisplay === 'function')
	                return format;
	            // IE treats \0 as a string end in inputs (truncating the value),
				// so it's a bad format delimiter, anyway
				var separators = format.replace(this.validParts, '\0').split('\0'),
					parts = format.match(this.validParts);
				if (!separators || !separators.length || !parts || parts.length === 0){
					throw new Error("Invalid date format.");
				}
				return {separators: separators, parts: parts};
			},
			parseDate: function(date, format, language, assumeNearby){
				if (!date)
					return undefined;
				if (date instanceof Date)
					return date;
				if (typeof format === 'string')
					format = DPGlobal.parseFormat(format);
				if (format.toValue)
					return format.toValue(date, format, language);
				var fn_map = {
						d: 'moveDay',
						m: 'moveMonth',
						w: 'moveWeek',
						y: 'moveYear'
					},
					dateAliases = {
						yesterday: '-1d',
						today: '+0d',
						tomorrow: '+1d'
					},
					parts, part, dir, i, fn;
				if (date in dateAliases){
					date = dateAliases[date];
				}
				if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/i.test(date)){
					parts = date.match(/([\-+]\d+)([dmwy])/gi);
					date = new Date();
					for (i=0; i < parts.length; i++){
						part = parts[i].match(/([\-+]\d+)([dmwy])/i);
						dir = Number(part[1]);
						fn = fn_map[part[2].toLowerCase()];
						date = Datepicker.prototype[fn](date, dir);
					}
					return Datepicker.prototype._zero_utc_time(date);
				}
	
				parts = date && date.match(this.nonpunctuation) || [];
	
				function applyNearbyYear(year, threshold){
					if (threshold === true)
						threshold = 10;
	
					// if year is 2 digits or less, than the user most likely is trying to get a recent century
					if (year < 100){
						year += 2000;
						// if the new year is more than threshold years in advance, use last century
						if (year > ((new Date()).getFullYear()+threshold)){
							year -= 100;
						}
					}
	
					return year;
				}
	
				var parsed = {},
					setters_order = ['yyyy', 'yy', 'M', 'MM', 'm', 'mm', 'd', 'dd'],
					setters_map = {
						yyyy: function(d,v){
							return d.setUTCFullYear(assumeNearby ? applyNearbyYear(v, assumeNearby) : v);
						},
						m: function(d,v){
							if (isNaN(d))
								return d;
							v -= 1;
							while (v < 0) v += 12;
							v %= 12;
							d.setUTCMonth(v);
							while (d.getUTCMonth() !== v)
								d.setUTCDate(d.getUTCDate()-1);
							return d;
						},
						d: function(d,v){
							return d.setUTCDate(v);
						}
					},
					val, filtered;
				setters_map['yy'] = setters_map['yyyy'];
				setters_map['M'] = setters_map['MM'] = setters_map['mm'] = setters_map['m'];
				setters_map['dd'] = setters_map['d'];
				date = UTCToday();
				var fparts = format.parts.slice();
				// Remove noop parts
				if (parts.length !== fparts.length){
					fparts = $(fparts).filter(function(i,p){
						return $.inArray(p, setters_order) !== -1;
					}).toArray();
				}
				// Process remainder
				function match_part(){
					var m = this.slice(0, parts[i].length),
						p = parts[i].slice(0, m.length);
					return m.toLowerCase() === p.toLowerCase();
				}
				if (parts.length === fparts.length){
					var cnt;
					for (i=0, cnt = fparts.length; i < cnt; i++){
						val = parseInt(parts[i], 10);
						part = fparts[i];
						if (isNaN(val)){
							switch (part){
								case 'MM':
									filtered = $(dates[language].months).filter(match_part);
									val = $.inArray(filtered[0], dates[language].months) + 1;
									break;
								case 'M':
									filtered = $(dates[language].monthsShort).filter(match_part);
									val = $.inArray(filtered[0], dates[language].monthsShort) + 1;
									break;
							}
						}
						parsed[part] = val;
					}
					var _date, s;
					for (i=0; i < setters_order.length; i++){
						s = setters_order[i];
						if (s in parsed && !isNaN(parsed[s])){
							_date = new Date(date);
							setters_map[s](_date, parsed[s]);
							if (!isNaN(_date))
								date = _date;
						}
					}
				}
				return date;
			},
			formatDate: function(date, format, language){
				if (!date)
					return '';
				if (typeof format === 'string')
					format = DPGlobal.parseFormat(format);
				if (format.toDisplay)
	                return format.toDisplay(date, format, language);
	            var val = {
					d: date.getUTCDate(),
					D: dates[language].daysShort[date.getUTCDay()],
					DD: dates[language].days[date.getUTCDay()],
					m: date.getUTCMonth() + 1,
					M: dates[language].monthsShort[date.getUTCMonth()],
					MM: dates[language].months[date.getUTCMonth()],
					yy: date.getUTCFullYear().toString().substring(2),
					yyyy: date.getUTCFullYear()
				};
				val.dd = (val.d < 10 ? '0' : '') + val.d;
				val.mm = (val.m < 10 ? '0' : '') + val.m;
				date = [];
				var seps = $.extend([], format.separators);
				for (var i=0, cnt = format.parts.length; i <= cnt; i++){
					if (seps.length)
						date.push(seps.shift());
					date.push(val[format.parts[i]]);
				}
				return date.join('');
			},
			headTemplate: '<thead>'+
				              '<tr>'+
				                '<th colspan="7" class="datepicker-title"></th>'+
				              '</tr>'+
								'<tr>'+
									'<th class="prev">'+defaults.templates.leftArrow+'</th>'+
									'<th colspan="5" class="datepicker-switch"></th>'+
									'<th class="next">'+defaults.templates.rightArrow+'</th>'+
								'</tr>'+
							'</thead>',
			contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
			footTemplate: '<tfoot>'+
								'<tr>'+
									'<th colspan="7" class="today"></th>'+
								'</tr>'+
								'<tr>'+
									'<th colspan="7" class="clear"></th>'+
								'</tr>'+
							'</tfoot>'
		};
		DPGlobal.template = '<div class="datepicker">'+
								'<div class="datepicker-days">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										'<tbody></tbody>'+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-months">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-years">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-decades">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-centuries">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
							'</div>';
	
		$.fn.datepicker.DPGlobal = DPGlobal;
	
	
		/* DATEPICKER NO CONFLICT
		* =================== */
	
		$.fn.datepicker.noConflict = function(){
			$.fn.datepicker = old;
			return this;
		};
	
		/* DATEPICKER VERSION
		 * =================== */
		$.fn.datepicker.version = '1.9.0';
	
		$.fn.datepicker.deprecated = function(msg){
			var console = window.console;
			if (console && console.warn) {
				console.warn('DEPRECATED: ' + msg);
			}
		};
	
	
		/* DATEPICKER DATA-API
		* ================== */
	
		$(document).on(
			'focus.datepicker.data-api click.datepicker.data-api',
			'[data-provide="datepicker"]',
			function(e){
				var $this = $(this);
				if ($this.data('datepicker'))
					return;
				e.preventDefault();
				// component click requires us to explicitly show it
				datepickerPlugin.call($this, 'show');
			}
		);
		$(function(){
			datepickerPlugin.call($('[data-provide="datepicker-inline"]'));
		});
	
	}));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(4);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaConnectDocuments',
				dom: {
					list: '#yotaConnectDocumentsList',
					template: '#yotaConnectDocumentsTemplate',
					print: '#yotaConnectDocumentsPrint',
					save: '#yotaConnectDocumentsSave',
					email: '#yotaConnectDocumentsEmail',
					form: '#yotaConnectDocumentsForm',
					input: '#yotaConnectDocumentsInput'
				},
				classes: {
					email: 'b-connect-documents_state_email'
				},
				data: {
					print: '#',
					save: '#',
					list: []
				}
			};
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.data = this.options.data;
			this.sended = false;
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$list = this.$el.find(this.options.dom.list);
				this.$template = this.$el.find(this.options.dom.template);
				this.template = _underscore2.default.template(this.$template.html().trim());
				this.$print = this.$el.find(this.options.dom.print);
				this.$save = this.$el.find(this.options.dom.save);
				this.$email = this.$el.find(this.options.dom.email);
				this.$form = this.$el.find(this.options.dom.form);
				this.$input = this.$el.find(this.options.dom.input);
				return this;
			}
		}, {
			key: 'update',
			value: function update(data) {
				var self = this;
				if (typeof data !== 'undefined') {
					self.data = data;
				}
				var html = '';
				_jquery2.default.each(self.data.list, function (key, item) {
					html += self.template(item);
				});
				self.$list.html(html);
				self.$print.attr('href', this.data.print);
				self.$save.attr('href', this.data.save);
	
				return self;
			}
		}, {
			key: 'onEmail',
			value: function onEmail() {
				this.$el.addClass(this.options.classes.email);
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(event) {
				/* eslint no-alert: 0 */
				var self = this;
				event.preventDefault();
				if (!self.sended) {
					if (self.$input.val().trim() != '') {
						self.sended = true;
						_jquery2.default.ajax({
							url: self.$form.attr('action'),
							type: self.$form.attr('method'),
							data: self.$form.serialize(),
							dataType: 'json',
							success: function success(json) {
								if (json && json.success) {
									self.$input.val('');
									self.$el.removeClass(self.options.classes.email);
								}
								self.sended = false;
							},
							error: function error() {
								self.sended = false;
							}
						});
					}
				}
	
				return self;
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom().update();
	
					this.$email.on('click', this.onEmail.bind(this));
					this.$form.on('submit', this.onSubmit.bind(this));
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(4);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaConnectThank',
				dom: {
					message: '#yotaConnectThankMessage',
					template: '#yotaConnectThankTemplate'
				},
				data: {
					type: '',
					login: ''
				}
			};
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.data = this.options.data;
			this.sended = false;
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$message = this.$el.find(this.options.dom.message);
				this.$template = this.$el.find(this.options.dom.template);
				this.template = _underscore2.default.template(this.$template.html().trim());
				return this;
			}
		}, {
			key: 'update',
			value: function update(data) {
				if (typeof data !== 'undefined') {
					this.data = data;
				}
	
				var html = this.template(this.data);
				this.$message.html(html);
	
				return self;
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom().update();
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _select = __webpack_require__(62);
	
	var _select2 = _interopRequireDefault(_select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaTariffType',
				dom: {
					container: '.js-tariff-type-container',
					close: '.js-tariff-type-close',
					select: '.js-tariff-type-select',
					next: '.js-tariff-type-button-next',
					ok: '.js-tariff-type-button-ok',
					description: '.js-tariff-type-description'
				},
				classes: {
					state: {
						open: 'b-tariff-type_state_open'
					},
					button: {
						disabled: 'b-button_state_disabled',
						hidden: 'b-button_state_hidden'
					},
					description: {
						hidden: 'b-tariff-type__description_hidden'
					}
				},
				quantity: 0,
				mnp: false,
				fields: [],
				tariffType: '',
				TARIFF_TYPE_SNG: 'TARIFF_TYPE_SNG',
				TARIFF_TYPE_B2B: 'TARIFF_TYPE_B2B'
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.quantity = this.options.quantity;
			this.mnp = this.options.mnp;
			this.fields = this.options.fields;
			this.tariffType = this.options.tariffType;
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			this.defaultTariffType = {
				text: 'Выберите одно из значений',
				value: '',
				hidden: true
			};
			this.tariffTypes = [{
				text: 'Близкие страны',
				value: this.options.TARIFF_TYPE_SNG
			}, {
				text: 'Стандартный B2B',
				value: this.options.TARIFF_TYPE_B2B
			}];
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$container = this.$el.find(this.options.dom.container);
				this.$close = this.$el.find(this.options.dom.close);
				this.$select = this.$el.find(this.options.dom.select);
				this.$select = this.$el.find(this.options.dom.select);
				this.$next = this.$el.find(this.options.dom.next);
				this.$ok = this.$el.find(this.options.dom.ok);
				this.$description = this.$el.find(this.options.dom.description);
	
				return this;
			}
		}, {
			key: 'onClick',
			value: function onClick(event) {
				var self = this;
				var $target = (0, _jquery2.default)(event.target);
				if (!$target.is(self.$container) && !$target.closest(self.$container).length) {
					self.close();
				}
				return self;
			}
		}, {
			key: 'open',
			value: function open(data) {
				var quantity = data.quantity,
				    mnp = data.mnp,
				    fields = data.fields;
	
	
				this.quantity = quantity;
				this.mnp = mnp;
				this.fields = fields;
	
				this.update();
				this.$el.addClass(this.options.classes.state.open);
	
				return this;
			}
		}, {
			key: 'close',
			value: function close() {
				this.$el.removeClass(this.options.classes.state.open);
				return this;
			}
		}, {
			key: 'update',
			value: function update() {
				var quantity = this.quantity,
				    mnp = this.mnp,
				    fields = this.fields,
				    tariffType = this.tariffType,
				    defaultTariffType = this.defaultTariffType;
				var _options$classes = this.options.classes,
				    button = _options$classes.button,
				    description = _options$classes.description;
	
	
				if (tariffType !== defaultTariffType.value) {
					// if (tariffType === this.options.TARIFF_TYPE_SNG) {
					//
					// 	if (quantity > 1) {
					//
					// 		if (mnp && fields.length > 1) {
					// 			this.$description
					// 				.text(`Для тарифа СНГ может быть оформлена только 1 SIM-карта. Пожалуйста, вернитесь назад и выберите только 1 номер для переноса`)
					// 				.removeClass(description.hidden);
					// 			this.$next.addClass(button.hidden);
					// 			this.$ok.removeClass(`${button.hidden} ${button.disabled}`);
					// 			return;
					// 		}
					//
					//
					// 		this.$description
					// 			.text(`Вы выбрали ${quantity} ${this.declOfNum(quantity, ['SIM-карту', 'SIM-карты', 'SIM-карт'])}, для тарифа СНГ будет оформлена только 1 SIM-карта`)
					// 			.removeClass(description.hidden);
					// 		this.$ok.addClass(button.hidden);
					// 		this.$next.removeClass(`${button.hidden} ${button.disabled}`);
					// 		return;
					// 	}
					// }
					this.$ok.addClass(button.hidden);
					this.$next.removeClass(button.hidden + ' ' + button.disabled);
					this.$description.text('').addClass(description.hidden);
				} else {
					this.$ok.addClass(button.hidden);
					this.$next.removeClass(button.hidden).addClass(button.disabled);
					this.$description.text('').addClass(description.hidden);
				}
			}
		}, {
			key: 'onSelect',
			value: function onSelect(event, data) {
				this.tariffType = data.value;
				this.update();
			}
		}, {
			key: 'onNext',
			value: function onNext() {
				this.$window.trigger('yota.connect.tariffType.submit', this.tariffType);
				this.close(); // todo
			}
		}, {
			key: 'renderSelect',
			value: function renderSelect() {
				var options = [this.defaultTariffType].concat(_toConsumableArray(this.tariffTypes));
				this.select = new _select2.default({ el: this.$select }).render();
				this.select.setOptions(options);
				this.select.setValue(this.defaultTariffType.value);
			}
		}, {
			key: 'declOfNum',
			value: function declOfNum(number, titles) {
				var cases = [2, 0, 1, 1, 1, 2];
				return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
					self.renderSelect();
	
					self.$el.on('click', self.onClick.bind(self));
					self.$close.on('click', self.close.bind(self));
					self.$ok.on('click', self.close.bind(self));
					self.$next.on('click', self.onNext.bind(self));
					self.$select.on('yota.select.change', self.onSelect.bind(self));
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _animation = __webpack_require__(9);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaConnectPromo',
				dom: {
					formCaptcha: '.js-connect-promo-captcha-form',
					formCode: '.js-connect-promo-code-form',
					shake: '.js-connect-promo-shake',
					resend: '.js-connect-promo-resend',
					blocked: '.js-connect-promo-blocked',
					field: '.js-field',
					input: '.js-field-input'
				},
				classes: {
					form: {
						send: {
							blocked: 'b-connect-promo__form_send_blocked'
						}
					},
					field: {
						state: {
							error: 'b-field_state_error'
						}
					}
				}
			};
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.sended = false;
			this.timer = 0;
			this.interval = false;
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$formCaptcha = this.$el.find(this.options.dom.formCaptcha);
				this.$formCode = this.$el.find(this.options.dom.formCode);
				this.$resend = this.$el.find(this.options.dom.resend);
				this.$blocked = this.$el.find(this.options.dom.blocked);
				if (this.$formCaptcha.length) {
					this.$shake = this.$formCaptcha.find(this.options.dom.shake);
				}
				if (this.$formCode.length) {
					this.$shake = this.$formCode.find(this.options.dom.shake);
				}
				if (this.$formCaptcha.length || this.$formCode.length) {
					this.$field = this.$shake.find(this.options.dom.field);
					this.$input = this.$shake.find(this.options.dom.input);
				}
				return this;
			}
		}, {
			key: 'onSubmitCaptcha',
			value: function onSubmitCaptcha(e) {
				var self = this;
				if (this.$input.val().trim() == '') {
					self.$field.addClass(self.options.classes.field.state.error);
					self.shake.play('shake');
				} else if (!self.sended && self.$formCaptcha.data('send') == 'ajax') {
					self.sended = true;
					_jquery2.default.ajax({
						url: self.$formCaptcha.attr('action'),
						type: self.$formCaptcha.attr('method'),
						data: self.$formCaptcha.serialize(),
						dataType: 'json',
						success: function success(json) {
							if (json && json.success) {
								if (json.location) {
									window.location.assign(json.location);
								}
							} else {
								self.shake.play('shake');
								self.$field.addClass(self.options.classes.field.state.error);
							}
							self.sended = false;
						}
					});
					e.preventDefault();
				}
			}
		}, {
			key: 'onSubmitCode',
			value: function onSubmitCode(e) {
				var self = this;
				if (this.$input.val().trim() == '') {
					self.$field.addClass(self.options.classes.field.state.error);
					self.shake.play('shake');
				} else if (!self.sended && self.$formCode.data('send') == 'ajax') {
					self.sended = true;
					_jquery2.default.ajax({
						url: self.$formCode.attr('action'),
						type: self.$formCode.attr('method'),
						data: self.$formCode.serialize(),
						dataType: 'json',
						success: function success(json) {
							if (json && json.success) {
								if (json.location) {
									window.location.assign(json.location);
								}
							} else {
								self.shake.play('shake');
								self.$field.addClass(self.options.classes.field.state.error);
							}
							self.sended = false;
						}
					});
					e.preventDefault();
				}
			}
		}, {
			key: 'declOfNum',
			value: function declOfNum(number, titles) {
				var cases = [2, 0, 1, 1, 1, 2];
				return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
			}
		}, {
			key: 'updateTimer',
			value: function updateTimer() {
				var text = this.$blocked.data('template').trim();
				text += ' ' + this.timer + ' ' + this.declOfNum(this.timer, ['секунду', 'секунды', 'секунд']);
				this.$blocked.html(text);
			}
		}, {
			key: 'startTimer',
			value: function startTimer(time) {
				this.timer = time - 1;
				this.updateTimer();
				this.$formCode.addClass(this.options.classes.form.send.blocked);
				clearInterval(this.interval);
				this.interval = setInterval(this.stopTimer.bind(this), 1000);
				return this;
			}
		}, {
			key: 'stopTimer',
			value: function stopTimer() {
				this.timer--;
				this.updateTimer();
				if (this.timer <= 0) {
					this.$formCode.removeClass(this.options.classes.form.send.blocked);
					clearInterval(this.interval);
				}
				return this;
			}
		}, {
			key: 'onResend',
			value: function onResend() {
				var self = this;
				if (self.timer <= 0) {
					_jquery2.default.ajax({
						url: self.$formCode.attr('action'),
						type: self.$formCode.attr('method'),
						data: { type: 'resend' },
						dataType: 'json',
						success: function success(json) {
							if (json && json.success) {
								if (json.location) {
									window.location.assign(json.location);
								}
								self.startTimer(json.timer || 60);
							} else {
								(0, _jquery2.default)(function () {
									return new _animation2.default({ el: self.$resend }).play('shake');
								});
							}
							self.sended = false;
						},
						error: function error() {
							self.sended = false;
						}
					});
				}
			}
		}, {
			key: 'onFocus',
			value: function onFocus() {
				this.$field.removeClass(this.options.classes.field.state.error);
				return this;
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom();
	
					this.shake = new _animation2.default({ el: this.$shake });
					if (this.$input.length) {
						this.$input.on('focusin', this.onFocus.bind(this));
					}
					if (this.$formCaptcha.length) {
						this.$formCaptcha.on('submit', this.onSubmitCaptcha.bind(this));
					}
	
					if (this.$formCode.length) {
						this.$formCode.on('submit', this.onSubmitCode.bind(this));
					}
	
					if (this.$resend.length) {
						this.$resend.on('click', this.onResend.bind(this));
					}
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _input = __webpack_require__(18);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _animation = __webpack_require__(9);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaCallback',
				dom: {
					form: '#yotaCallbackForm',
					phone: '#yotaCallbackPhone',
					numbered: '#yotaCallbackNumbered',
					name: '#yotaCallbackName'
				},
				classes: {
					state: {
						send: 'b-callback_state_send',
						client: 'b-callback_state_client'
					},
					field: {
						state: {
							error: 'b-field_state_error'
						}
					}
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.sended = false;
			this.$el = (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				var self = this;
				self.$form = (0, _jquery2.default)(self.options.dom.form);
				self.$phone = (0, _jquery2.default)(self.options.dom.phone);
				self.$numbered = (0, _jquery2.default)(self.options.dom.numbered);
				self.$name = (0, _jquery2.default)(self.options.dom.name);
				self.$field = self.$numbered.add(self.$name);
				return self;
			}
		}, {
			key: 'validate',
			value: function validate() {
				var self = this;
				var numbered = self.numbered.validate();
				self.$phone.val(self.$numbered.val().replace(/[^\d]/gi, ''));
				if (numbered <= 0) {
					self.$numbered.parent().addClass(self.options.classes.field.state.error);
					(0, _jquery2.default)(function () {
						return new _animation2.default({ el: self.$numbered.parent() }).play('shake');
					});
				}
	
				var name = self.$name.val().trim();
				if (name != '' && name.length > 128) {
					self.$name.parent().addClass(self.options.classes.field.state.error);
					(0, _jquery2.default)(function () {
						return new _animation2.default({ el: self.$name.parent() }).play('shake');
					});
					numbered = 0;
				}
				return numbered;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				var $filed = (0, _jquery2.default)(event.currentTarget);
				$filed.parent().removeClass(this.options.classes.field.state.error);
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(event) {
				/* eslint no-alert: 0 */
				var self = this;
				event.preventDefault();
				if (!self.sended) {
					if (self.validate() > 0) {
						self.sended = true;
						_jquery2.default.ajax({
							url: self.$form.attr('action'),
							type: self.$form.attr('method'),
							data: self.$form.serialize(),
							dataType: 'json',
							success: function success(json) {
								if (json && json.success) {
									if (json.client) {
										self.$el.addClass(self.options.classes.state.client);
									} else {
										self.$el.addClass(self.options.classes.state.send);
									}
								} else {
									alert(self.$form.data('error'));
								}
								self.sended = false;
							},
							error: function error() {
								alert(self.$form.data('error'));
								self.sended = false;
							}
						});
					}
				}
	
				return self;
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
					self.$form.on('submit', self.onSubmit.bind(self));
					self.numbered = new _input2.default(self.$numbered);
					self.$field.on('change input focusin', self.onFocus.bind(self));
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _city = __webpack_require__(72);
	
	var _city2 = _interopRequireDefault(_city);
	
	var _input = __webpack_require__(18);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _animation = __webpack_require__(9);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaB2bModemOrder',
				dom: {
					form: '#yotaB2bModemOrderForm',
					phone: '#yotaB2bModemOrderPhone',
					city: '#yotaB2bModemOrderCity',
					citySearch: '.js-city',
					type: '#yotaB2bModemOrderType',
					subtype: '#yotaB2bModemOrderSubype',
					name: '#yotaB2bModemOrderName',
					fio: '#yotaB2bModemOrderFio',
					numbered: '#yotaB2bModemOrderNumbered',
					mail: '#yotaB2bModemOrderMail'
				},
				classes: {
					state: {
						send: 'b-b2b-modem-order_state_send'
					},
					field: {
						state: {
							error: 'b-field_state_error'
						}
					}
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.sended = false;
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				var self = this;
				self.$form = (0, _jquery2.default)(self.options.dom.form);
	
				self.$phone = (0, _jquery2.default)(self.options.dom.phone);
				self.$city = (0, _jquery2.default)(self.options.dom.city);
				self.$citySearch = self.$el.find(self.options.dom.citySearch);
				self.$type = (0, _jquery2.default)(self.options.dom.type);
				self.$subtype = (0, _jquery2.default)(self.options.dom.subtype);
				self.$name = (0, _jquery2.default)(self.options.dom.name);
				self.$fio = (0, _jquery2.default)(self.options.dom.fio);
				self.$numbered = (0, _jquery2.default)(self.options.dom.numbered);
				self.$mail = (0, _jquery2.default)(self.options.dom.mail);
	
				self.$field = self.$name.add(self.$fio).add(self.$numbered).add(self.$mail).add(self.$citySearch);
				return self;
			}
		}, {
			key: 'validate',
			value: function validate() {
				var self = this;
				var numbered = self.numbered.validate();
				self.$phone.val(self.$numbered.val().replace(/[^\d]/gi, ''));
				if (numbered <= 0) {
					self.$numbered.parent().addClass(self.options.classes.field.state.error);
					(0, _jquery2.default)(function () {
						return new _animation2.default({ el: self.$numbered.parent() }).play('shake');
					});
				}
	
				var name = self.$name.val().trim();
				if (name == '' || name.length > 128) {
					self.$name.parent().addClass(self.options.classes.field.state.error);
					(0, _jquery2.default)(function () {
						return new _animation2.default({ el: self.$name.parent() }).play('shake');
					});
					numbered = 0;
				}
	
				var city = self.$city.val().trim();
				if (city == '') {
					self.$citySearch.addClass(self.options.classes.field.state.error);
					(0, _jquery2.default)(function () {
						return new _animation2.default({ el: self.$citySearch.parent() }).play('shake');
					});
					numbered = 0;
				}
	
				var fio = self.$fio.val().trim();
				if (fio == '' || fio.length > 128) {
					self.$fio.parent().addClass(self.options.classes.field.state.error);
					(0, _jquery2.default)(function () {
						return new _animation2.default({ el: self.$fio.parent() }).play('shake');
					});
					numbered = 0;
				}
	
				var mail = self.$mail.val().trim();
				if (mail == '' || mail.length > 128 || !/^(.)+[\@](.)+[\.](.)+/.test(mail)) {
					self.$mail.parent().addClass(self.options.classes.field.state.error);
					(0, _jquery2.default)(function () {
						return new _animation2.default({ el: self.$mail.parent() }).play('shake');
					});
					numbered = 0;
				}
	
				return numbered;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				var $filed = (0, _jquery2.default)(event.currentTarget);
				$filed.parent().removeClass(this.options.classes.field.state.error);
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(event) {
				/* eslint no-alert: 0 */
				var self = this;
				event.preventDefault();
				if (!self.sended) {
					if (self.validate() > 0) {
						self.sended = true;
						_jquery2.default.ajax({
							url: self.$form.attr('action'),
							type: self.$form.attr('method'),
							data: self.$form.serialize(),
							dataType: 'json',
							success: function success(json) {
								if (json && json.success) {
									self.$el.addClass(self.options.classes.state.send);
								} else {
									alert(json.error || self.$form.data('error'));
								}
								self.sended = false;
							},
							error: function error() {
								alert(self.$form.data('error'));
								self.sended = false;
							}
						});
					}
				}
	
				return self;
			}
		}, {
			key: 'onCitySet',
			value: function onCitySet(data) {
				this.$city.val(data.code);
				this.$citySearch.removeClass(this.options.classes.field.state.error);
			}
		}, {
			key: 'onDataSet',
			value: function onDataSet(event, data) {
				this.$type.html(data.type);
				this.$subtype.html(data.subtype);
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
					self.$form.on('submit', self.onSubmit.bind(self));
					self.numbered = new _input2.default(self.$numbered);
	
					self.city = new _city2.default({
						el: this.$citySearch,
						callback: {
							set: self.onCitySet.bind(self)
						}
					}).render();
	
					self.$field.on('change input focusin', self.onFocus.bind(self));
					self.$window.on('yota.b2b.modem.change', self.onDataSet.bind(self));
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaB2bTariffModem',
				dom: {
					price: '.js-b2b-tariff-modem-price',
					radio: '.js-b2b-tariff-modem-radio',
					tabs: '.js-b2b-tariff-modem-tabs',
					region: '.js-b2b-tariff-modem-region',
					sppedin: '.js-b2b-tariff-modem-sppedin',
					sppedout: '.js-b2b-tariff-modem-sppedout'
				},
				classes: {
					once: 'b-b2b-tariff-modem_type_once',
					global: 'b-b2b-tariff-modem_state_global',
					tab: 'b-b2b-tariff-modem__tab_state_active'
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			this.data = {};
			this.type = false;
			this.subtype = false;
			this.isOnce = false;
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$price = this.$el.find(this.options.dom.price);
				if (!this.isOnce) {
					this.$radio = this.$el.find(this.options.dom.radio);
					this.$region = this.$el.find(this.options.dom.region);
					this.$sppedin = this.$el.find(this.options.dom.sppedin);
					this.$sppedout = this.$el.find(this.options.dom.sppedout);
				}
				this.$tabs = this.$el.find(this.options.dom.tabs);
				return this;
			}
		}, {
			key: 'tab',
			value: function tab(event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
				this.$tabs.removeClass(this.options.classes.tab);
				$target.addClass(this.options.classes.tab);
				this.getData();
				return this;
			}
		}, {
			key: 'getData',
			value: function getData() {
				if (this.isOnce) {
					this.type = this.$tabs.filter('.' + this.options.classes.tab).data('js');
					this.subtype = this.$el.data('subtype');
				} else {
					this.subtype = this.$tabs.filter('.' + this.options.classes.tab).data('js');
					this.type = this.$radio.filter(':checked').val();
					this.$el.toggleClass(this.options.classes.global, this.subtype === 'global');
				}
				this.$price.html(this.data[this.subtype][this.type]);
				this.$window.trigger('yota.b2b.modem.change', [{ type: this.type, subtype: this.subtype }]);
				return this;
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.isOnce = this.$el.hasClass(this.options.classes.once);
					if (yotaPortlets.b2bTariffModem) {
						this.data = yotaPortlets.b2bTariffModem;
						this.getDom();
						this.getData();
	
						if (!this.isOnce) {
							this.$radio.on('change', this.getData.bind(this));
							if (this.data.regionName) {
								this.$region.html(this.data.regionName.replace(/-/g, '&#8209;'));
							}
							if (this.data.limit) {
								this.$sppedin.html(this.data.limit['in']);
								this.$sppedout.html(this.data.limit['out']);
							}
						}
						this.$tabs.on('click', this.tab.bind(this));
					} else {
						console.error('The b2bTariffModem portlet has no data, set data to "yotaPortlets.b2bTariffModem"');
					}
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaTabletPromo',
				dom: {
					slides: '.js-tablet-promo-slides',
					slide: '.js-tablet-promo-slide'
				},
				classes: {
					slide: {
						slide: 'b-tablet-promo__slide',
						active: 'b-tablet-promo__slide_state_active'
					}
				},
				timeout: 4000
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$slides = this.$el.find(this.options.dom.slides);
				this.$slide = this.$el.find(this.options.dom.slide);
				return this;
			}
		}, {
			key: 'startShow',
			value: function startShow() {
				var self = this;
				this.show = setInterval(function () {
					var $activeSlide = self.$slide.filter('.' + self.options.classes.slide.active);
					var $nextSlide = $activeSlide.next('.' + self.options.classes.slide.slide);
					self.$slide.removeClass(self.options.classes.slide.active);
	
					if ($nextSlide.hasClass(self.options.classes.slide.slide)) {
						$nextSlide.addClass(self.options.classes.slide.active);
					} else {
						self.$slide.first().addClass(self.options.classes.slide.active);
					}
				}, self.options.timeout);
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom();
					this.startShow();
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _form = __webpack_require__(95);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _prefixed = __webpack_require__(10);
	
	var _prefixed2 = _interopRequireDefault(_prefixed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaWay',
				dom: {
					promo: '#yotaWayPromo',
					form: '#yotaWayForm'
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			this.prefixed = new _prefixed2.default();
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$promo = this.$el.find(this.options.dom.promo);
				this.$form = this.$el.find(this.options.dom.form);
				return this;
			}
		}, {
			key: 'onScroll',
			value: function onScroll() {
				var delta = (550 - window.pageYOffset) / 550;
				if (delta < 0) {
					delta = 0;
				}
				this.$promo.css(this.prefixed.css.transform, 'scale(' + delta + ') translateZ(0)').css('opacity', delta);
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom();
					this.form = new _form2.default({ el: this.$form }).render();
					this.$window.on('scroll resize', this.onScroll.bind(this)).trigger('resize');
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _select = __webpack_require__(62);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _animation = __webpack_require__(9);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaWayForm',
				dom: {
					thankyou: '#yotaWayThankyou',
					selects: ['#wayFormPositionExpirience', '#wayFormExperienceBoss', '#wayFormExperience', '#wayFormSubsidiary'],
					shake: '#yotaWayShake',
					field: '.js-field',
					select: '.js-select',
					input: {
						field: '.js-field-input',
						select: '.js-select-input'
					}
				},
				classes: {
					thankyou: 'b-way-thankyou_state_open',
					error: {
						field: 'b-field_state_error',
						select: 'b-select_state_error'
					}
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$thankyou = (0, _jquery2.default)(this.options.dom.thankyou);
				this.$selects = this.$el.find(this.options.dom.selects.join(', '));
				this.$field = this.$el.find(this.options.dom.field);
				this.$select = this.$el.find(this.options.dom.select);
				this.$shake = this.$el.find(this.options.dom.shake);
				return this;
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(event) {
				var self = this;
				var valid = self.validate();
	
				if (valid) {
					_jquery2.default.ajax({
						url: self.$el.attr('action'),
						type: self.$el.attr('method'),
						data: self.$el.serialize(),
						dataType: 'json',
						success: function success(json) {
							if (json.success) {
								self.$thankyou.addClass(self.options.classes.thankyou);
							} else {
								/* eslint no-alert: 0 */
								alert(self.$el.data('error'));
							}
						}
					});
				} else {
					(0, _jquery2.default)(function () {
						return new _animation2.default({ el: self.$shake }).play('shake');
					});
				}
				event.preventDefault();
			}
		}, {
			key: 'validate',
			value: function validate() {
				var self = this;
				var valid = true;
				self.$field.each(function () {
					var $field = (0, _jquery2.default)(this);
					var $input = $field.find(self.options.dom.input.field);
					if ($input.val().trim() == '') {
						$field.addClass(self.options.classes.error.field);
						valid = false;
					}
				});
				self.$select.each(function () {
					var $select = (0, _jquery2.default)(this);
					var $input = $select.find(self.options.dom.input.select);
					if ($input.val().trim() == '') {
						$select.addClass(self.options.classes.error.select);
						valid = false;
					}
				});
				return valid;
			}
		}, {
			key: 'fieldFocusIn',
			value: function fieldFocusIn(event) {
				var $input = (0, _jquery2.default)(event.currentTarget);
				var $field = $input.closest(this.$field);
				$field.removeClass(this.options.classes.error.field);
			}
		}, {
			key: 'selectClick',
			value: function selectClick(event) {
				var $select = (0, _jquery2.default)(event.currentTarget);
				$select.removeClass(this.options.classes.error.select);
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
	
					self.selects = [];
	
					self.$selects.each(function () {
						var select = new _select2.default({ el: (0, _jquery2.default)(this) }).render();
						self.selects.push(select);
					});
	
					self.$el.on('submit', self.onSubmit.bind(self));
	
					self.$field.on('focusin', self.options.dom.input.field, self.fieldFocusIn.bind(self));
					self.$select.on('click', self.selectClick.bind(self));
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _sliderRange = __webpack_require__(68);
	
	var _sliderRange2 = _interopRequireDefault(_sliderRange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaB2bTariffVoice',
				dom: {
					sliderRange: '.js-slider-range',
					price: '#yotaB2bTariffVoicePrice',
					toggler: '#yotaB2bTariffVoiceToggler',
					sms: '.js-tariff-set-sms'
				},
				classes: {
					minutes: 'b-b2b-tariff-mobile_minutes_max'
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			this.activated = false;
			this.price = false;
			this.$sms = (0, _jquery2.default)(this.options.dom.sms);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$sliderRange = this.$el.find(this.options.dom.sliderRange);
				this.$price = this.$el.find(this.options.dom.price);
				this.$toggler = this.$el.find(this.options.dom.toggler);
				return this;
			}
		}, {
			key: 'onSlide',
			value: function onSlide(position, rate) {
				rate.action = rate.action || false;
				this.rate = rate;
				this.price = this.rate.price;
				this.setPrice(false, rate.price);
				this.$el.toggleClass(this.options.classes.minutes, this.data.rates.length - 1 == position);
				this.$el.data('params', [this.rate.ancor]);
				this.$window.trigger('yota.router.check');
			}
		}, {
			key: 'setPrice',
			value: function setPrice(event, price) {
				var set = price || this.price;
				if (this.unlimitedSms()) {
					this.$price.text(parseInt(set) + parseInt(this.data.unlimitedSmsPrice) + parseInt(this.data.internet));
				} else {
					this.$price.text(parseInt(set) + parseInt(this.data.internet));
				}
			}
		}, {
			key: 'unlimitedSms',
			value: function unlimitedSms() {
				if (this.$toggler.prop('checked')) {
					return true;
				}
				return false;
			}
		}, {
			key: 'activate',
			value: function activate() {
				var self = this;
				if (!self.activated && self.$el.data('activated') === true) {
					self.activated = true;
					setTimeout(function () {
						self.sliderRange.animate();
					}, 100);
				}
			}
		}, {
			key: 'update',
			value: function update() {
				var params = this.$el.data('params') || [];
				if (params.length) {
					this.data.baseRate = this.sliderRange.getRate(params[0], 'ancor').rate.price;
					this.sliderRange.update({ base: this.data.baseRate });
				}
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					if (yotaPortlets.b2bTariffVoice) {
						this.data = yotaPortlets.b2bTariffVoice;
						this.price = this.data.baseRate;
						this.getDom();
						this.$toggler.on('change', this.setPrice.bind(this));
						this.$sms.html(this.data.smsPrice);
	
						this.sliderRange = new _sliderRange2.default({
							el: this.$sliderRange,
							base: this.data.baseRate,
							rates: this.data.rates,
							callback: {
								update: this.onSlide.bind(this)
							},
							colors: {
								start: [0, 173, 238],
								edit: [0, 0, 0]
							}
						});
	
						var labels = [];
						_jquery2.default.each(this.data.rates, function (key, item) {
							labels.push({
								js: key,
								price: item.minutes
							});
						});
	
						this.sliderRange.buildLabels(labels);
	
						this.$el.on('yota.router.activate', this.activate.bind(this)).on('yota.router.update', this.update.bind(this)).trigger('yota.router.update');
	
						this.sliderRange.render();
						this.$el.data('params', [this.rate.ancor]);
						this.$window.trigger('yota.router.check');
						this.$el.trigger('yota.router.activate');
					} else {
						console.error('The b2bTariffVoice portlet has no data, set data to "yotaPortlets.b2bTariffVoice"');
					}
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaSelfcare',
				dom: {
					item: '.js-selfcare-item',
					slide: '.js-selfcare-slide'
				},
				classes: {
					item: 'b-selfcare__item_state_active',
					slide: 'b-selfcare__slide_state_active'
				}
			};
	
			this.active = -1;
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$slide = this.$el.find(this.options.dom.slide);
				this.$item = this.$el.find(this.options.dom.item);
				return this;
			}
		}, {
			key: 'onHover',
			value: function onHover(e) {
				var index = (0, _jquery2.default)(e.currentTarget).index();
				this.setActive(index);
			}
		}, {
			key: 'onLeave',
			value: function onLeave() {
				var self = this;
				self.setActive(self.active);
			}
		}, {
			key: 'onClick',
			value: function onClick(e) {
				var index = (0, _jquery2.default)(e.currentTarget).index();
				this.active = index;
			}
		}, {
			key: 'setActive',
			value: function setActive(e) {
				var $target = typeof e == 'number' ? this.$item.eq(e) : (0, _jquery2.default)(e.currentTarget);
				var index = $target.index();
				if (this.active == -1) {
					this.active = index;
				}
				this.$item.removeClass(this.options.classes.item);
				this.$slide.removeClass(this.options.classes.slide);
				this.$item.eq(index).addClass(this.options.classes.item);
				this.$slide.eq(index).addClass(this.options.classes.slide);
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom();
					this.$item.on('mouseover', this.onHover.bind(this));
					this.$item.on('mouseleave', this.onLeave.bind(this));
					this.$item.on('click', this.onClick.bind(this));
					this.setActive(0);
				}
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _animation = __webpack_require__(9);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaPlankton',
				dom: {
					slides: '.js-plankton-slides',
					slide: '.js-plankton-slide',
					submit: '.js-plankton-submit',
					form: '.js-plankton-form'
				},
				classes: {
					slide: {
						slide: 'b-plankton__slide',
						active: 'b-plankton__slide_state_active'
					}
				},
				timeout: 4000
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$slides = this.$el.find(this.options.dom.slides);
				this.$slide = this.$el.find(this.options.dom.slide);
				this.$submit = this.$el.find(this.options.dom.submit);
				this.$form = this.$el.find(this.options.dom.form);
				return this;
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(e) {
				var self = this;
				e.preventDefault();
				_jquery2.default.ajax({
					url: self.$form.attr('action'),
					type: self.$form.attr('method'),
					data: self.$form.serialize(),
					dataType: 'json',
					success: function success(json) {
						if (json.success) {
							if (json.location) {
								window.location.href = json.location;
							}
						} else {
							(0, _jquery2.default)(function () {
								return new _animation2.default({ el: self.$form }).play('shake');
							});
						}
					}
				});
			}
		}, {
			key: 'startShow',
			value: function startShow() {
				var self = this;
				this.show = setInterval(function () {
					var $activeSlide = self.$slide.filter('.' + self.options.classes.slide.active);
					var $nextSlide = $activeSlide.next('.' + self.options.classes.slide.slide);
					self.$slide.removeClass(self.options.classes.slide.active);
	
					if ($nextSlide.hasClass(self.options.classes.slide.slide)) {
						$nextSlide.addClass(self.options.classes.slide.active);
					} else {
						self.$slide.first().addClass(self.options.classes.slide.active);
					}
				}, self.options.timeout);
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom();
					this.startShow();
					this.$submit.on('click', this.onSubmit.bind(this));
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _prefixed = __webpack_require__(10);
	
	var _prefixed2 = _interopRequireDefault(_prefixed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#abcParalax',
				dom: {
					top: '.js-abc-paralax-top',
					bottom: '.js-abc-paralax-bottom'
				},
				delta: 400
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			this.prefixed = new _prefixed2.default();
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				var self = this;
				self.$top = self.$el.find(self.options.dom.top);
				self.$bottom = self.$el.find(self.options.dom.bottom);
				return self;
			}
		}, {
			key: 'onScroll',
			value: function onScroll() {
				var scroll = window.pageYOffset;
				var top = this.$el.offset().top;
				var height = this.$el.height();
				var wHeight = this.$window.height();
				var max = height - wHeight;
				var pos = scroll - top;
	
				// if (pos < 0) {
				// 	pos = 0;
				// }
				// if (pos > max) {
				// 	pos = max;
				// }
	
				var delta = (this.options.delta - this.options.delta / max * pos) * -1;
				this.$top.css(this.prefixed.css.transform, 'translateY(' + Math.ceil(delta - pos * 0.2) + 'px) translateZ(0)');
				this.$bottom.css(this.prefixed.css.transform, 'translateY(' + Math.ceil(delta) + 'px) translateZ(0)');
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
	
					self.$window.on('scroll resize', self.onScroll.bind(self));
	
					self.onScroll();
					setTimeout(function () {
						self.onScroll();
					}, 250);
					setTimeout(function () {
						self.onScroll();
					}, 750);
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _sliderRange = __webpack_require__(68);
	
	var _sliderRange2 = _interopRequireDefault(_sliderRange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaTariffVoice',
				dom: {
					sliderRange: '.js-slider-range',
					price: '#yotaTariffVoicePrice',
					toggler: '#yotaTariffVoiceToggler',
					sms: '.js-tariff-set-sms',
					speed: {
						hour2: '.js-tariff-set-2hour',
						hour24: '.js-tariff-set-24hour'
					},
					input: {
						minutes: '#yotaTariffVoiceInputMinutes',
						price: '#yotaTariffVoiceInputPrice'
					}
				},
				classes: {
					minutes: 'b-tariff-mobile_minutes_max'
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			this.activated = false;
			this.price = false;
			this.$sms = (0, _jquery2.default)(this.options.dom.sms);
			this.speed = {};
			this.speed.$hour2 = (0, _jquery2.default)(this.options.dom.speed.hour2);
			this.speed.$hour24 = (0, _jquery2.default)(this.options.dom.speed.hour24);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$sliderRange = this.$el.find(this.options.dom.sliderRange);
				this.$price = this.$el.find(this.options.dom.price);
				this.$toggler = this.$el.find(this.options.dom.toggler);
				this.input = {};
				this.input.$minutes = this.$el.find(this.options.dom.input.minutes);
				this.input.$price = this.$el.find(this.options.dom.input.price);
				return this;
			}
		}, {
			key: 'onSlide',
			value: function onSlide(position, rate) {
				rate.action = rate.action || false;
				this.rate = rate;
				this.price = this.rate.price;
				this.setPrice(false, rate.price);
				this.input.$minutes.val(this.rate.minutes);
				this.input.$price.val(this.rate.price);
				this.$el.toggleClass(this.options.classes.minutes, this.data.rates.length - 1 == position);
				this.$el.data('params', [this.rate.ancor]);
				this.$window.trigger('yota.router.check');
			}
		}, {
			key: 'setPrice',
			value: function setPrice(event, price) {
				var set = price || this.price;
				if (this.unlimitedSms()) {
					this.$price.text(parseInt(set) + parseInt(this.data.unlimitedSmsPrice) + parseInt(this.data.internet));
				} else {
					this.$price.text(parseInt(set) + parseInt(this.data.internet));
				}
			}
		}, {
			key: 'unlimitedSms',
			value: function unlimitedSms() {
				if (this.$toggler.prop('checked')) {
					return true;
				}
				return false;
			}
		}, {
			key: 'activate',
			value: function activate() {
				var self = this;
				if (!self.activated && self.$el.data('activated') === true) {
					self.activated = true;
					setTimeout(function () {
						self.sliderRange.animate();
					}, 100);
				}
			}
		}, {
			key: 'update',
			value: function update() {
				var params = this.$el.data('params') || [];
				if (params.length) {
					this.data.baseRate = this.sliderRange.getRate(params[0], 'ancor').rate.price;
					this.sliderRange.update({ base: this.data.baseRate });
				}
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					if (yotaPortlets.tariffVoice) {
						this.data = yotaPortlets.tariffVoice;
						this.price = this.data.baseRate;
						this.getDom();
						this.$toggler.on('change', this.setPrice.bind(this));
						this.$sms.html(this.data.smsPrice);
						if (typeof this.data['2hour'] != 'undefined') {
							this.speed.$hour2.html(this.data['2hour']);
						}
						if (typeof this.data['24hour'] != 'undefined') {
							this.speed.$hour24.html(this.data['24hour']);
						}
	
						this.sliderRange = new _sliderRange2.default({
							el: this.$sliderRange,
							base: this.data.baseRate,
							rates: this.data.rates,
							callback: {
								update: this.onSlide.bind(this)
							}
						});
	
						var labels = [];
						_jquery2.default.each(this.data.rates, function (key, item) {
							labels.push({
								js: key,
								price: item.minutes
							});
						});
	
						this.sliderRange.buildLabels(labels);
	
						this.$el.on('yota.router.activate', this.activate.bind(this)).on('yota.router.update', this.update.bind(this)).trigger('yota.router.update');
	
						this.sliderRange.render();
						this.$el.data('params', [this.rate.ancor]);
						this.$window.trigger('yota.router.check');
						this.$el.trigger('yota.router.activate');
					} else {
						console.error('The tariffVoice portlet has no data, set data to "yotaPortlets.tariffVoice"');
					}
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _tabs = __webpack_require__(102);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _accordion = __webpack_require__(103);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-info',
				dom: {
					accordion: '.js-accordion'
				}
			};
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$accordion = (0, _jquery2.default)(this.options.dom.accordion);
				return this;
			}
		}, {
			key: 'tabs',
			value: function tabs() {
				var self = this;
				self.tabs = [];
				self.$el.each(function () {
					var $el = (0, _jquery2.default)(this);
					var tabs = new _tabs2.default({ el: $el }).render();
					self.tabs.push(tabs);
				});
				return self;
			}
		}, {
			key: 'accordion',
			value: function accordion() {
				var self = this;
				self.accordion = [];
				self.$accordion.each(function () {
					var $accordion = (0, _jquery2.default)(this);
					var accordion = new _accordion2.default({ el: $accordion }).render();
					self.accordion.push(accordion);
				});
				return self;
			}
		}, {
			key: 'render',
			value: function render() {
				this.getDom();
				if (this.$el.length) {
					this.tabs();
					if (this.$accordion.length) {
						this.accordion();
					}
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-info',
				dom: {
					tab: '.js-info-tab',
					panel: '.js-info-panel',
					overlay: '.js-overlay'
				},
				classes: {
					tab: 'b-info__tab_state_active',
					panel: 'b-info__panel_state_active'
				}
			};
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$window = (0, _jquery2.default)(window);
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$tab = this.$el.find(this.options.dom.tab);
				this.$panel = this.$el.find(this.options.dom.panel);
				this.$overlay = this.$el.closest(this.options.dom.overlay);
				return this;
			}
		}, {
			key: 'setActiveTab',
			value: function setActiveTab() {
				var $tab = this.$tab.filter('.' + this.options.classes.tab);
				if (!$tab.length) {
					$tab = this.$tab.first();
				}
				var $panel = this.$panel.eq($tab.index());
	
				var _$tab$data = $tab.data(),
				    hash = _$tab$data.hash;
	
				this.$panel.not($panel).removeClass(this.options.classes.panel);
				$panel.addClass(this.options.classes.panel);
				this.$overlay.data('params', [hash]);
				this.$window.trigger('yota.router.check');
			}
		}, {
			key: 'onClick',
			value: function onClick(event) {
				var $tab = (0, _jquery2.default)(event.currentTarget);
				this.$tab.not($tab).removeClass(this.options.classes.tab);
				$tab.addClass(this.options.classes.tab);
				this.setActiveTab();
				event.preventDefault();
			}
		}, {
			key: 'update',
			value: function update() {
				var params = this.$overlay.data('params') || [];
				if (params.length) {
					var $tab = this.$tab.filter('[data-hash="' + params[0] + '"]');
					this.$tab.not($tab).removeClass(this.options.classes.tab);
					$tab.addClass(this.options.classes.tab);
					this.setActiveTab();
				}
			}
		}, {
			key: 'activate',
			value: function activate() {
				var params = this.$overlay.data('params') || [];
				if (params.length) {
					var $tab = this.$tab.filter('[data-hash="' + params[0] + '"]');
					if (!$tab.hasClass(this.options.classes.tab)) {
						$tab.addClass(this.options.classes.tab);
						this.setActiveTab();
					}
					this.$tab.not($tab).removeClass(this.options.classes.tab);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				this.getDom();
				if (this.$tab.length) {
					this.$tab.on('click', this.onClick.bind(this));
	
					this.$overlay.on('yota.router.update', this.update.bind(this)).on('yota.router.activate', this.activate.bind(this)).trigger('yota.router.update').trigger('yota.router.activate');
	
					this.setActiveTab();
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-accordion',
				dom: {
					item: '.js-accordion-item',
					toggle: '.js-accordion-toggle',
					wrapper: '.js-accordion-wrapper',
					content: '.js-accordion-content'
				},
				classes: {
					active: 't-accordion__item_state_active'
				}
			};
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			this.prevent = false;
			this.timeout = false;
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$item = this.$el.find(this.options.dom.item);
				this.$toggle = this.$el.find(this.options.dom.toggle);
				this.$wrapper = this.$el.find(this.options.dom.wrapper);
				this.$content = this.$el.find(this.options.dom.content);
				return this;
			}
		}, {
			key: 'onClick',
			value: function onClick(event) {
				var self = this;
				self.prevent = true;
				var $item = (0, _jquery2.default)(event.currentTarget).closest(self.$item);
				self.$item.not($item).removeClass(self.options.classes.active);
				var $wrapper = $item.find(self.$wrapper);
				var $content = $item.find(self.$content);
				$wrapper.css({ height: $content.outerHeight(true) });
				$item.toggleClass(self.options.classes.active);
				event.preventDefault();
				clearTimeout(self.timeout);
				self.timeout = setTimeout(function () {
					self.prevent = false;
					self.onResize();
				}, 1000);
				return self;
			}
		}, {
			key: 'onResize',
			value: function onResize() {
				var self = this;
				if (!self.prevent) {
					self.$item.each(function () {
						var $item = (0, _jquery2.default)(this);
						var $wrapper = $item.find(this.$wrapper);
						var $content = $item.find(this.$content);
						$wrapper.css({ height: $content.outerHeight(true) });
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom();
					this.$toggle.on('click', this.onClick.bind(this));
					this.$window.on('resize', this.onResize.bind(this));
					this.onResize();
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _input = __webpack_require__(18);
	
	var _input2 = _interopRequireDefault(_input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#backwayCartPhoneTemp'
			};
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					console.log(this.$el);
					this.numbered = new _input2.default(this.$el, { placeholder: false });
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _groups = __webpack_require__(106);
	
	var _groups2 = _interopRequireDefault(_groups);
	
	var _slides = __webpack_require__(107);
	
	var _slides2 = _interopRequireDefault(_slides);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#showcase',
				dom: {
					groups: '#showcaseGroups',
					slides: '#showcaseSlides'
				}
			};
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.data = [];
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$groups = this.$el.find(this.options.dom.groups);
				this.$slides = this.$el.find(this.options.dom.slides);
				return this;
			}
		}, {
			key: 'setSlide',
			value: function setSlide(index, ancor) {
				this.slides.set(index);
				this.$el.data('params', [ancor]);
				this.$window.trigger('yota.router.check');
			}
		}, {
			key: 'checkSlideChange',
			value: function checkSlideChange() {
				return !this.slides.prevent;
			}
		}, {
			key: 'update',
			value: function update() {
				var params = this.$el.data('params') || [];
				var set = -1;
				if (params.length) {
					set = this.groups.setAncor(params[0]);
				}
	
				if (set >= 0) {
					this.slides.set(set, true);
				} else {
					var active = this.groups.getActive();
					if (active !== false) {
						this.$el.data('params', [active.ancor]);
					} else {
						this.slides.set(0, true);
						this.groups.setActive(0);
						this.update();
					}
					this.$window.trigger('yota.router.check');
				}
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom();
					this.groups = new _groups2.default({
						el: this.$groups,
						callback: {
							set: this.setSlide.bind(this),
							check: this.checkSlideChange.bind(this)
						}
					}).render();
					this.slides = new _slides2.default({
						el: this.$slides
					}).render();
	
					this.$el.on('yota.router.update', this.update.bind(this)).trigger('yota.router.update');
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#showcaseGroups',
				dom: {
					thumb: '.js-showcase-thumb'
				},
				classes: {
					count: 'b-showcase-groups_items_count-',
					thumb: {
						state: {
							active: 'b-showcase-groups__thumb_state_active'
						}
					}
				},
				callback: {
					set: false,
					check: false
				},
				data: []
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$thumb = this.$el.find(this.options.dom.thumb);
				return this;
			}
		}, {
			key: 'build',
			value: function build() {
				this.$el.addClass(this.options.classes.count + this.$thumb.length);
				this.$thumb = this.$el.find(this.options.dom.thumb);
				return this;
			}
		}, {
			key: 'onClick',
			value: function onClick(event) {
				var change = true;
				if (typeof this.options.callback.check == 'function') {
					change = this.options.callback.check();
				}
				if (change) {
					var $target = (0, _jquery2.default)(event.currentTarget);
	
					var _$target$data = $target.data(),
					    index = _$target$data.index,
					    ancor = _$target$data.ancor;
	
					this.$thumb.not($target).removeClass(this.options.classes.thumb.state.active);
					$target.addClass(this.options.classes.thumb.state.active);
					if (typeof this.options.callback.set == 'function') {
						this.options.callback.set(index, ancor);
					}
				}
			}
		}, {
			key: 'setAncor',
			value: function setAncor(ancor) {
				var $target = this.$thumb.filter('[data-ancor="' + ancor + '"]');
				var index = -1;
				if ($target.length) {
					if (!$target.hasClass(this.options.classes.thumb.state.active)) {
						this.$thumb.not($target).removeClass(this.options.classes.thumb.state.active);
						$target.addClass(this.options.classes.thumb.state.active);
					}
					index = $target.data('index');
				}
				return index;
			}
		}, {
			key: 'getActive',
			value: function getActive() {
				var $active = this.$thumb.filter('.' + this.options.classes.thumb.state.active);
				if (!$active.length) {
					return false;
				}
	
				var _$active$data = $active.data(),
				    index = _$active$data.index,
				    ancor = _$active$data.ancor;
	
				return { index: index, ancor: ancor };
			}
		}, {
			key: 'setActive',
			value: function setActive(index) {
				this.$thumb.eq(index).addClass(this.options.classes.thumb.state.active);
				return this;
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom();
					this.build();
					this.$el.on('click', this.options.dom.thumb, this.onClick.bind(this));
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _slider = __webpack_require__(57);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _slide = __webpack_require__(108);
	
	var _slide2 = _interopRequireDefault(_slide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#showcaseSlides',
				dom: {
					container: '#showcaseSlidesContainer',
					slider: '#showcaseSlidesSlider',
					slide: '.js-showcase-slide'
				},
				slider: {
					el: '#showcaseSlidesSlider',
					dom: {
						slide: '.js-showcase-slider-slide',
						control: '.js-showcase-slider-control',
						page: '.js-showcase-slider-page'
					}
				},
				callback: {
					set: false
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.data = this.options.data;
			this.prevent = false;
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$container = this.$el.find(this.options.dom.container);
				return this;
			}
		}, {
			key: 'build',
			value: function build() {
				this.$slider = this.$el.find(this.options.dom.slider);
				this.$slide = this.$el.find(this.options.dom.slide);
				return this;
			}
		}, {
			key: 'setSlideStart',
			value: function setSlideStart() {
				this.prevent = true;
			}
		}, {
			key: 'setSlideEnd',
			value: function setSlideEnd() {
				this.prevent = false;
			}
		}, {
			key: 'set',
			value: function set(index) {
				var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				var change = false;
				if (!this.prevent || force) {
					this.slider.setSlide(index, false, force);
					change = true;
				}
				return change;
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
					self.build();
	
					self.options.slider.callback = {
						start: self.setSlideStart.bind(self),
						end: self.setSlideEnd.bind(self)
					};
					self.options.slider.el = this.$slider;
					self.slider = new _slider2.default(self.options.slider).render();
	
					self.slide = [];
					self.$slide.each(function (index) {
						var $slide = (0, _jquery2.default)(this);
						self.slide[index] = new _slide2.default({ el: $slide }).render();
					});
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _slider = __webpack_require__(57);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-showcase-slide',
				dom: {
					slider: '.js-showcase-slide-slider',
					config: '.js-showcase-slide-config',
					toggle: '.js-showcase-slide-toggle'
				},
				classes: {
					config: {
						state: {
							open: 'b-showcase-slide__config_state_open'
						}
					}
				},
				slider: {
					el: '.js-showcase-slide-slider-slider',
					dom: {
						slide: '.js-showcase-slide-slider-slide',
						control: '.js-showcase-slide-slider-control',
						page: '.js-showcase-slide-slider-page'
					}
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$config = this.$el.find(this.options.dom.config);
				this.$toggle = this.$el.find(this.options.dom.toggle);
				this.$slider = this.$el.find(this.options.dom.slider);
				return this;
			}
		}, {
			key: 'configToggle',
			value: function configToggle() {
				this.$config.toggleClass(this.options.classes.config.state.open);
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom();
					this.$toggle.on('click', this.configToggle.bind(this));
					this.options.slider.el = this.$slider;
					this.slider = new _slider2.default(this.options.slider).render();
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _input = __webpack_require__(18);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _animation = __webpack_require__(9);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	__webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaPayment',
				recaptchaKey: yotaPortlets.recaptchaKey,
				recaptchaPrefix: yotaPortlets.recaptchaPrefix,
				dom: {
					form: '#yotaPaymentForm',
					radioPhone: '#yotaPaymentRadioPhone',
					radioModem: '#yotaPaymentRadioModem',
					amount: '#yotaPaymentAmount',
					phone: '#yotaPaymentPhone',
					modem: '#yotaPaymentModem',
					efc: '#yotaPaymentEfc',
					way: '#inplatFrameContainer',
					title: '#yotaPaymentTitle',
					amountAttr: '.js-payment-attr-amount',
					recaptcha: '.js-recaptcha',
					tryAgainAfterExceed: '.js-try-again-after-exceed'
				},
				classes: {
					error: 'b-payment__field_state_error',
					modem: 'b-payment_state_modem',
					blocked: 'b-payment_state_blocked',
					paymentUnavailable: 'b-payment_state_unavailable',
					requestCountExceed: 'b-payment_state_request_count_exceed',
					incorrectAccount: 'b-payment_state_incorrect_account',
					recaptchaOk: 'b-payment_state_recaptcha_ok',
					way: 'b-payment_state_way',
					load: 'b-payment_state_load',
					efcTypePhone: 'efc-type-phone',
					field: {
						state: {
							disabled: 'b-field_state_disabled',
							error: 'b-field_state_error'
						}
					}
				}
			};
	
			this.errorCodes = {
				INCORRECT_ACCOUNT: 'INCORRECT_ACCOUNT',
				REQUEST_COUNT_EXCEED: 'REQUEST_COUNT_EXCEED',
				PAYMENT_IS_TEMPORARILY_UNAVAILABLE: 'PAYMENT_IS_TEMPORARILY_UNAVAILABLE'
			};
	
			this.patternMail = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
			this.patternPhone = /^((79)|(89)|(9))\d{9}$/;
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.isPhone = true;
			this.sended = false;
			this.init = false;
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$form = (0, _jquery2.default)(this.options.dom.form);
				this.$radioPhone = (0, _jquery2.default)(this.options.dom.radioPhone);
				this.$radioModem = (0, _jquery2.default)(this.options.dom.radioModem);
				this.$radio = this.$radioPhone.add(this.$radioModem);
				this.$amount = (0, _jquery2.default)(this.options.dom.amount);
				this.$phone = (0, _jquery2.default)(this.options.dom.phone);
				this.$modem = (0, _jquery2.default)(this.options.dom.modem);
				this.$efc = (0, _jquery2.default)(this.options.dom.efc);
				this.$way = (0, _jquery2.default)(this.options.dom.way);
				this.way = this.$way[0];
				this.$title = (0, _jquery2.default)(this.options.dom.title);
				this.$amountAttr = (0, _jquery2.default)(this.options.dom.amountAttr);
				this.$recaptcha = (0, _jquery2.default)(this.options.dom.recaptcha);
				this.$tryAgainAfterExceed = (0, _jquery2.default)(this.options.dom.tryAgainAfterExceed);
				this.$window = (0, _jquery2.default)(window);
				return this;
			}
		}, {
			key: 'onChangeType',
			value: function onChangeType(event) {
				if (this.$el.hasClass(this.options.classes.blocked) || this.$el.hasClass(this.options.classes.way) || this.$el.hasClass(this.options.classes.load)) {
					this.$radioPhone.prop('checked', this.isPhone);
					this.$radioModem.prop('checked', !this.isPhone);
					event.preventDefault();
					return false;
				}
				this.isPhone = this.$radioPhone.prop('checked');
				this.$el.toggleClass(this.options.classes.modem, !this.isPhone);
	
				this.$amount.parent().removeClass(this.options.classes.field.state.error).parent().removeClass(this.options.classes.error);
				this.$phone.parent().removeClass(this.options.classes.field.state.error);
				this.$modem.parent().removeClass(this.options.classes.field.state.error);
	
				this.animation.amount.stop('shake');
				this.animation.modem.stop('shake');
				this.animation.phone.stop('shake');
			}
		}, {
			key: 'declOfNum',
			value: function declOfNum(number, titles) {
				var cases = [2, 0, 1, 1, 1, 2];
				return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
			}
		}, {
			key: 'onInputAmount',
			value: function onInputAmount(event) {
				var value = this.$amount.val();
				if (value !== '') {
					var amount = value.replace(/[^\d]/ig, '').replace(/^0/ig, '');
					this.$amountAttr.attr('data-after', this.declOfNum(amount, ['рубль', 'рубля', 'рублей']));
					if (amount > this.amount.max) {
						amount = this.amount.max;
					}
					if (amount < this.amount.min) {
						amount = this.amount.min;
					}
					amount = String(amount).split(/(?=(?:\d{3})+(?!\d))/).join(' ');
					if (amount != value) {
						event.currentTarget.value = amount;
					}
				} else {
					this.$amountAttr.attr('data-after', 'рублей');
				}
				return this;
			}
		}, {
			key: 'onInputEfc',
			value: function onInputEfc(event) {
				var value = this.$efc.val();
				if (value !== '') {
					var efc = (0, _jquery2.default)(event.currentTarget).hasClass(this.options.classes.efcTypePhone) ? value.replace(/[^\dA-Z-_.@+()]/gi, '') : value.replace(/[^\dA-Z-_.@]/gi, '');
					if (efc != value) {
						event.currentTarget.value = efc;
					}
	
					if (event.type === 'blur') {
						if (this.patternPhone.test(efc.replace(/[\s-()+]/gi, '')) || this.patternPhone.test(efc)) {
							this.setEfcMask();
						}
					}
				}
				return this;
			}
		}, {
			key: 'validate',
			value: function validate() {
				var self = this;
				var phone = self.phone.validate();
				var modem = self.modem.validate();
				var amount = self.$amount.val();
				var efc = self.$efc.val();
				var error = false;
	
				if (amount == '') {
					error = true;
					self.$amount.prop('disabled', false).parent().addClass(self.options.classes.field.state.error).removeClass(self.options.classes.field.state.disabled).parent().addClass(self.options.classes.error);
					self.animation.amount.play('shake');
				} else {
					self.animation.amount.stop('shake');
				}
	
				if (efc == '' || !this.patternMail.test(efc) && !this.patternPhone.test(efc) && !this.patternPhone.test(efc.replace(/[\s-+()]/gi, ''))) {
					error = true;
					self.$efc.prop('disabled', false).parent().addClass(self.options.classes.field.state.error).removeClass(self.options.classes.field.state.disabled).parent().addClass(self.options.classes.error);
					self.animation.efc.play('shake');
				} else {
					self.animation.efc.stop('shake');
					if (this.patternPhone.test(efc.replace(/[\s-()+]/gi, '')) || this.patternPhone.test(efc)) {
						this.setEfcMask();
					}
				}
	
				if (phone <= '' && self.isPhone) {
					error = true;
					self.$phone.prop('disabled', false).parent().addClass(self.options.classes.field.state.error).removeClass(self.options.classes.field.state.disabled);
					self.animation.phone.play('shake');
				} else {
					self.animation.phone.stop('shake');
				}
	
				if (modem <= '' && !self.isPhone) {
					error = true;
					self.$modem.prop('disabled', false).parent().addClass(self.options.classes.field.state.error).removeClass(self.options.classes.field.state.disabled);
					self.animation.modem.play('shake');
				} else {
					self.animation.modem.stop('shake');
				}
	
				return !error;
			}
		}, {
			key: 'setEfcMask',
			value: function setEfcMask() {
				this.$efc.addClass(this.options.classes.efcTypePhone);
				var efc = this.$efc.val().replace(/[-()]/gi, '');
				if (efc.length === 11) {
					this.$efc.val(efc.slice(1));
				} else {
					this.$efc.val(efc);
				}
				this.$efc.inputmask('+7 (999) 999-99-99');
			}
		}, {
			key: 'removeEfcMask',
			value: function removeEfcMask() {
				this.$efc.inputmask('remove');
				this.$efc.removeClass(this.options.classes.efcTypePhone);
			}
		}, {
			key: 'onEfcFocus',
			value: function onEfcFocus(event) {
				var $filed = (0, _jquery2.default)(event.currentTarget);
				$filed.parent().removeClass(this.options.classes.field.state.error).parent().removeClass(this.options.classes.error);
				if (this.$efc.inputmask) {
					this.removeEfcMask();
				}
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				var $filed = (0, _jquery2.default)(event.currentTarget);
				$filed.parent().removeClass(this.options.classes.field.state.error).parent().removeClass(this.options.classes.error);
			}
		}, {
			key: 'startWait',
			value: function startWait() {
				var self = this;
				self.wait = setTimeout(function () {
					self.errorWay();
				}, 30000);
			}
		}, {
			key: 'startWay',
			value: function startWay(src) {
				this.$el.removeClass(this.options.classes.blocked).addClass(this.options.classes.way);
	
				this.$title.data('normal', this.$title.text()).text(this.$title.data('way'));
	
				this.$amount.add(this.$phone).add(this.$modem).add(this.$efc).prop('disabled', true).parent().addClass(this.options.classes.field.state.disabled);
	
				if (this.init) {
					this.startWait();
					/* eslint-disable new-cap */
					window.InplatPaymentOpenInFrame({
						link: src,
						target: this.way
					});
				}
			}
		}, {
			key: 'errorWay',
			value: function errorWay() {
				this.$title.text(this.$title.data('normal'));
				this.startBlocked();
				this.$way.html('');
			}
		}, {
			key: 'startBlocked',
			value: function startBlocked(blockedCssClass) {
				var _options$classes = this.options.classes,
				    paymentUnavailable = _options$classes.paymentUnavailable,
				    blocked = _options$classes.blocked;
	
				var blockedClassName = blockedCssClass || paymentUnavailable + ' ' + blocked;
	
				this.$amount.add(this.$phone).add(this.$modem).add(this.$efc).prop('disabled', true).parent().addClass(this.options.classes.field.state.disabled);
				this.$el.addClass(blockedClassName).removeClass(this.options.classes.load).removeClass(this.options.classes.way);
			}
		}, {
			key: 'stopBlocked',
			value: function stopBlocked(blockedCssClass) {
				var _options$classes2 = this.options.classes,
				    paymentUnavailable = _options$classes2.paymentUnavailable,
				    blocked = _options$classes2.blocked;
	
				var blockedClassName = (blockedCssClass || paymentUnavailable) + ' ' + blocked;
	
				this.$amount.add(this.$phone).add(this.$modem).add(this.$efc).prop('disabled', false).parent().removeClass(this.options.classes.field.state.disabled);
				this.$el.removeClass(blockedClassName).removeClass(this.options.classes.recaptchaOk).removeClass(this.options.classes.way);
			}
		}, {
			key: 'startError',
			value: function startError(error) {
	
				this.$el.removeClass(this.options.classes.load).removeClass(this.options.classes.way);
	
				if (!error.amount) {
					this.$amount.parent().addClass(this.options.classes.field.state.error);
					this.$amount.parent().parent().addClass(this.options.classes.error);
					this.animation.amount.play('shake');
				} else {
					this.animation.amount.stop('shake');
				}
	
				if (!error.phone) {
					this.$phone.parent().addClass(this.options.classes.field.state.error);
					this.animation.phone.play('shake');
				} else {
					this.animation.phone.stop('shake');
				}
	
				if (!error.modem) {
					this.$modem.parent().addClass(this.options.classes.field.state.error);
					this.animation.modem.play('shake');
				} else {
					this.animation.modem.stop('shake');
				}
	
				if (error.contactType === null) {
					this.$efc.parent().addClass(this.options.classes.field.state.error);
					this.animation.efc.play('shake');
				} else {
					this.animation.efc.stop('shake');
				}
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(event) {
				var self = this;
				event.preventDefault();
				if (self.$el.hasClass(self.options.classes.paymentUnavailable)) {
					self.stopBlocked(self.options.classes.paymentUnavailable);
				} else if (self.$el.hasClass(self.options.classes.requestCountExceed)) {
					self.stopBlocked(self.options.classes.requestCountExceed);
				} else if (self.$el.hasClass(self.options.classes.incorrectAccount)) {
					self.stopBlocked(self.options.classes.incorrectAccount);
				} else if (self.validate()) {
					if (!self.sended) {
						self.$el.addClass(self.options.classes.load);
						self.sended = true;
						_jquery2.default.ajax({
							url: self.$form.attr('action'),
							type: self.$form.attr('method'),
							data: self.$form.serialize(),
							dataType: 'json',
							success: function success(json) {
								if (json) {
									if (json.location) {
										window.location.assign(json.location);
									} else {
										if (json.success && json.src) {
											self.startWay(json.src);
										}
										if (!json.success && !!json.fields) {
											self.startError(json.fields);
										}
										if (!json.success && json.errorCode === self.errorCodes.PAYMENT_IS_TEMPORARILY_UNAVAILABLE) {
											self.startBlocked(self.options.classes.paymentUnavailable);
										}
										if (!json.success && json.errorCode === self.errorCodes.REQUEST_COUNT_EXCEED) {
											grecaptcha.reset();
											self.startBlocked(self.options.classes.requestCountExceed);
										}
										if (!json.success && json.errorCode === self.errorCodes.INCORRECT_ACCOUNT) {
											self.startBlocked(self.options.classes.incorrectAccount);
										}
									}
								} else {
									alert(self.$form.data('error'));
								}
								self.sended = false;
							},
							error: function error() {
								alert(self.$form.data('error'));
								self.$el.removeClass(self.options.classes.load);
								self.sended = false;
							}
						});
					}
				}
			}
		}, {
			key: 'bindMessage',
			value: function bindMessage() {
				var self = this;
	
				var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
				var eventer = window[eventMethod];
				var messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';
	
				eventer(messageEvent, function (e) {
					var key = e.message ? 'message' : 'data';
					var data = e[key];
					self.frameMessage(data);
				}, false);
			}
		}, {
			key: 'frameMessage',
			value: function frameMessage(data) {
				if (data.setHeight) {
					this.way.style.height = data.setHeight;
				}
				if (data.setSrc) {
					this.startWay(data.setSrc);
				}
			}
		}, {
			key: 'stopLoad',
			value: function stopLoad() {
				var self = this;
				clearTimeout(self.wait);
				setTimeout(function () {
					self.$el.removeClass(self.options.classes.load);
				}, 500);
			}
		}, {
			key: 'initInplatCallbacks',
			value: function initInplatCallbacks() {
				var self = this;
	
				window.InplatPaymentCallbacks = function (params) {
					if (params.event === 'formIframeResized') {
						self.frameMessage({ setHeight: params.custom + 'px' });
					}
					if (params.event === 'errorOpened') {
						self.errorWay();
						self.stopLoad();
					}
					if (params.event === 'yotaLoaded') {
						self.stopLoad();
					}
				};
	
				return self;
			}
		}, {
			key: 'onLoadRecaptcha',
			value: function onLoadRecaptcha() {
				this.recaptcha = grecaptcha.render(this.$recaptcha[0], {
					sitekey: this.options.recaptchaKey,
					callback: this.onReceiveRecaptchaResponse.bind(this)
				});
			}
		}, {
			key: 'onReceiveRecaptchaResponse',
			value: function onReceiveRecaptchaResponse(recaptchaResponse) {
				var _data,
				    _this = this;
	
				var validationUrl = this.$form.data('actionrecaptcha');
	
				(0, _jquery2.default)('#g-recaptcha-response').removeAttr('name');
	
				if (!recaptchaResponse || !validationUrl) {
					return;
				}
	
				_jquery2.default.ajax({
					url: validationUrl,
					type: this.$form.attr('method'),
					dataType: 'json',
					data: (_data = {}, _defineProperty(_data, this.options.recaptchaPrefix + 'g-recaptcha-response', recaptchaResponse), _defineProperty(_data, this.options.recaptchaPrefix + 'cmd', 'recaptcha'), _defineProperty(_data, this.options.recaptchaPrefix + 'type', this.isPhone ? 'phone' : 'modem'), _defineProperty(_data, this.options.recaptchaPrefix + 'amount', this.$amount.val()), _defineProperty(_data, this.options.recaptchaPrefix + 'phone', this.isPhone ? this.$phone.val() : ''), _defineProperty(_data, this.options.recaptchaPrefix + 'modem', !this.isPhone ? this.$modem.val() : ''), _defineProperty(_data, this.options.recaptchaPrefix + 'efc', this.$efc.val()), _data)
				}).then(function (response) {
					if (response && response.success) {
						_this.$el.addClass(_this.options.classes.recaptchaOk);
						_this.$tryAgainAfterExceed.removeAttr('disabled');
					} else if (response && response.errorCode === _this.errorCodes.REQUEST_COUNT_EXCEED) {
						_this.$el.addClass(_this.options.classes.recaptchaOk);
						_this.$tryAgainAfterExceed.removeAttr('disabled');
					} else if (response && response.errorCode === _this.errorCodes.PAYMENT_IS_TEMPORARILY_UNAVAILABLE) {
						_this.stopBlocked(_this.options.classes.requestCountExceed);
						_this.startBlocked(_this.options.classes.paymentUnavailable);
					} else if (response && response.errorCode === _this.errorCodes.INCORRECT_ACCOUNT) {
						_this.stopBlocked(_this.options.classes.requestCountExceed);
						_this.startBlocked(_this.options.classes.incorrectAccount);
					} else {
						alert(_this.$form.data('error'));
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				if (this.$el.length) {
					this.getDom();
					this.amount = {
						min: this.$amount.data('min'),
						max: this.$amount.data('max')
					};
					window.onloadCardPaymentRecaptcha = this.onLoadRecaptcha.bind(this);
					this.animation = {
						amount: new _animation2.default({ el: this.$amount.parent().parent() }),
						phone: new _animation2.default({ el: this.$phone.parent().parent() }),
						modem: new _animation2.default({ el: this.$modem.parent().parent() }),
						efc: new _animation2.default({ el: this.$efc.parent().parent() })
					};
					this.phone = new _input2.default(this.$phone, { mask: '+7 (###) ###-##-##' });
					this.modem = new _input2.default(this.$modem, { mask: '##########' });
					this.$radio.on('change', this.onChangeType.bind(this)).trigger('change');
					this.$amount.on('input keyup paste change blur', this.onInputAmount.bind(this)).trigger('blur');
					this.$efc.on('input keyup paste change blur', this.onInputEfc.bind(this)).trigger('blur');
					this.$tryAgainAfterExceed.attr('disabled', true);
					this.$form.on('submit', this.onSubmit.bind(this));
					this.$phone.add(this.$modem).add(this.$amount).on('change input focusin', this.onFocus.bind(this));
					this.$efc.on('change input focusin', this.onEfcFocus.bind(this));
	
					this.$window.on('yota.payment.inplatInitiated', function () {
						_this2.init = true;
					});
	
					this.bindMessage();
					this.initInplatCallbacks();
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _select = __webpack_require__(62);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _overlay = __webpack_require__(49);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _price = __webpack_require__(111);
	
	var _price2 = _interopRequireDefault(_price);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaRoamingBox',
				dom: {
					overlay: '#yotaOverlayRoaming',
					select: '.js-roaming-select',
					content: '.js-roaming-content',
					data: '.js-roaming-data',
					freeItemHideFor: '.js-roaming-hidefor'
				},
				classes: {
					state: {
						select: 'b-roaming-box_state_select',
						scroll: 'b-roaming-box_state_scroll'
					}
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			this.preventChange = false;
			this.current = false;
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$selects = (0, _jquery2.default)(this.options.dom.select);
				this.$overlay = (0, _jquery2.default)(this.options.dom.overlay);
				this.$data = (0, _jquery2.default)(this.options.dom.data);
				this.$content = this.$el.find(this.options.dom.content);
				this.$freeItemHideFor = this.$el.find(this.options.dom.freeItemHideFor);
			}
		}, {
			key: 'prepareOptions',
			value: function prepareOptions(data) {
				var self = this;
				var options = [];
				_jquery2.default.each(data, function (key, item) {
					options.push({
						value: key,
						text: item.title
					});
					if (yotaPortlets.region.products.roaming && yotaPortlets.region.roaming == item.code) {
						self.current = key;
					}
				});
				return options;
			}
		}, {
			key: 'setData',
			value: function setData(d) {
				var self = this;
				var data = d;
				self.$data = (0, _jquery2.default)(self.options.dom.data);
				self.$data.each(function () {
					var $data = (0, _jquery2.default)(this);
					var name = $data.data('name');
					var delta = $data.data('delta') || 0;
					var factor = $data.data('factor') || 1;
					var text = $data.data('text') || false;
					if (data[name]) {
						var value = text ? data[name] : data[name] * parseFloat(factor) + parseInt(delta);
						$data.text(value);
					}
				});
			}
		}, {
			key: 'setHideFreeItem',
			value: function setHideFreeItem(d) {
				var code = d.code;
				_jquery2.default.each(this.$freeItemHideFor, function (index, item) {
					var $item = (0, _jquery2.default)(item);
					var hideForData = $item.attr('data-hidefor');
					var hideForList = hideForData.split('|');
					var isHidden = hideForList.indexOf(code) !== -1;
					if (isHidden) {
						$item.css({ display: 'none' });
					} else {
						$item.css({ display: 'block' });
					}
				});
			}
		}, {
			key: 'onSelect',
			value: function onSelect(event, data) {
				var self = this;
				var value = data.value;
				if (!self.preventChange) {
					self.preventChange = true;
					_jquery2.default.each(self.select, function (key, select) {
						select.setValue(value);
					});
					self.setData(self.data[value]);
					self.setHideFreeItem(self.data[value]);
					self.price.set(self.data[value]);
					self.$el.addClass(self.options.classes.state.select);
					if (!self.overlay.isActive()) {
						self.$overlay.trigger('yota.overlay.open');
					}
					self.$overlay.data('params', [self.data[value].code.toLowerCase()]);
					self.$window.trigger('yota.router.check');
					self.onResize();
					setTimeout(function () {
						self.preventChange = false;
					}, 100);
				}
			}
		}, {
			key: 'onClear',
			value: function onClear() {
				_jquery2.default.each(this.select, function (key, select) {
					select.clear();
				});
				this.$el.removeClass(this.options.classes.state.select);
				this.$overlay.data('params', []);
				this.$window.trigger('yota.router.check');
				this.onResize();
			}
		}, {
			key: 'onOpen',
			value: function onOpen() {
				this.onResize();
			}
		}, {
			key: 'onClose',
			value: function onClose() {
				this.onClear();
				this.onResize();
			}
		}, {
			key: 'onResize',
			value: function onResize() {
				var windowHeight = this.$window.outerHeight(true);
				var contentHeight = this.$content.outerHeight(true);
				this.$el.toggleClass(this.options.classes.state.scroll, windowHeight < contentHeight);
			}
		}, {
			key: 'init',
			value: function init() {
				var self = this;
	
				self.getDom();
				self.data = yotaPortlets.roaming;
				self.select = [];
				self.selectOptions = self.prepareOptions(self.data);
	
				self.$selects.each(function () {
					var select = new _select2.default({ el: (0, _jquery2.default)(this) }).render();
					select.setOptions(self.selectOptions);
					self.select.push(select);
				});
	
				self.overlay = new _overlay2.default({
					el: self.$overlay,
					callback: {
						open: self.onOpen.bind(self),
						close: self.onClose.bind(self)
					}
				});
	
				self.$selects.on('yota.select.change', self.onSelect.bind(self)).on('yota.select.clean', self.onClear.bind(self));
	
				self.price = new _price2.default().render();
	
				self.$window.on('resize.yota.roaming', self.onResize.bind(self)).trigger('resize.yota.roaming');
	
				if (self.current !== false) {
					self.onSelect(false, { value: self.current });
				}
	
				self.$overlay.on('yota.router.update', this.update.bind(this)).on('yota.router.activate', this.activate.bind(this)).trigger('yota.router.update').trigger('yota.router.activate');
	
				return self;
			}
		}, {
			key: 'find',
			value: function find(code) {
				var self = this;
				var find = code;
				var search = false;
				_jquery2.default.each(self.selectOptions, function (key, item) {
					if (self.data[item.value].code.toLowerCase() == find) {
						search = item.value;
					}
				});
				return search;
			}
		}, {
			key: 'update',
			value: function update() {
				var params = this.$overlay.data('params') || [];
				if (params.length) {
					var value = this.find(params[0]);
					if (value !== false) {
						this.onSelect(false, { value: value });
					}
				}
			}
		}, {
			key: 'activate',
			value: function activate() {
				var params = this.$overlay.data('params') || [];
				if (params.length) {
					var value = this.find(params[0]);
					if (value !== false) {
						this.onSelect(false, { value: value });
					}
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					if (yotaPortlets.roaming) {
						if (yotaPortlets.roamingWait === true) {
							self.wait = setInterval(function () {
								if (yotaPortlets.roamingWait !== true) {
									self.init();
									clearInterval(self.wait);
								}
							}, 250);
						} else {
							self.init();
						}
					} else {
						console.error('The overlayRoaming portlet has no data, set data to "yotaPortlets.roaming"');
					}
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 111 */
64,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _animation = __webpack_require__(9);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _input = __webpack_require__(18);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _prefixed = __webpack_require__(10);
	
	var _prefixed2 = _interopRequireDefault(_prefixed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaVoiceMobileApp',
				dom: {
					item: '.js-voice-mobile-app-item',
					send: '#yotaVoiceMobileAppSend',
					resend: '#yotaVoiceMobileAppResend',
					form: '#yotaVoiceMobileAppForm',
					input: '#yotaVoiceMobileAppInput',
					circle: '#yotaVoiceMobileAppNext'
				},
				classes: {
					itemActive: 'b-voice-mobile-app__item_state_active',
					form: 'b-voice-mobile-app_state_form',
					end: 'b-voice-mobile-app_state_end',
					error: 'b-voice-mobile-app_state_error'
				}
			};
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.prefixed = new _prefixed2.default();
			this.current = Number(this.$el.data('current')) || 1;
			this.deg = this.current * 90 - 315;
			this.interval = false;
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$item = this.$el.find(this.options.dom.item);
				this.$send = this.$el.find(this.options.dom.send);
				this.$resend = this.$el.find(this.options.dom.resend);
				this.$form = this.$el.find(this.options.dom.form);
				this.$input = this.$el.find(this.options.dom.input);
				this.$circle = this.$el.find(this.options.dom.circle);
				return this;
			}
		}, {
			key: 'onClick',
			value: function onClick(event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
				if ($target.hasClass(this.options.classes.itemActive)) {
					return;
				}
				var value = Number($target.data('value'));
				this.setCurrent(value);
				this.setAuto();
			}
		}, {
			key: 'setCurrent',
			value: function setCurrent(current) {
				var delta = this.current - current;
				if (delta > 1) {
					delta -= 4;
				}
				if (delta == -3) {
					delta += 4;
				}
				this.current = current;
				this.deg = this.deg - delta * 90;
				this.$el.attr('data-current', this.current);
				this.$circle.css(this.prefixed.css.transform, 'translateX(-50%) translateY(-50%) translateZ(0) rotate(' + this.deg + 'deg)');
			}
		}, {
			key: 'onResend',
			value: function onResend() {
				this.$input.val('');
				this.$el.removeClass(this.options.classes.end).removeClass(this.options.classes.error).addClass(this.options.classes.form);
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(event) {
				var self = this;
				event.preventDefault();
				if (self.validate() > 0) {
					_jquery2.default.ajax({
						url: self.$form.attr('action'),
						type: self.$form.attr('method'),
						data: self.$form.serialize(),
						dataType: 'json',
						success: function success(json) {
							if (json && json.success) {
								self.$el.removeClass(self.options.classes.form).removeClass(self.options.classes.error).addClass(self.options.classes.end);
							} else {
								self.$el.removeClass(self.options.classes.form).removeClass(self.options.classes.end).addClass(self.options.classes.error);
							}
						}
					});
				} else {
					this.form.play('shake');
				}
			}
		}, {
			key: 'init',
			value: function init() {
				this.$item.on('click', this.onClick.bind(this));
				this.$send.on('click', this.onResend.bind(this));
				this.$resend.on('click', this.onResend.bind(this));
				this.$form.on('submit', this.onSubmit.bind(this));
				this.numbered = new _input2.default(this.$input, { placeholder: true });
				this.form = new _animation2.default({ el: this.$form });
				return this;
			}
		}, {
			key: 'validate',
			value: function validate() {
				return this.numbered.validate();
			}
		}, {
			key: 'setAuto',
			value: function setAuto() {
				var self = this;
				clearInterval(self.interval);
				self.interval = setInterval(function () {
					var current = self.current + 1;
					if (current > 4) {
						current = 1;
					}
					self.setCurrent(current);
				}, 4000);
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom();
					this.init();
					this.setAuto();
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaDevices',
				dom: {
					slide: '.js-slider-slide',
					next: '#yotaDevicesNext',
					prev: '#yotaDevicesPrev'
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.prevent = false;
			this.background = -9;
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$slide = this.$el.find(this.options.dom.slide);
				this.$next = this.$el.find(this.options.dom.next);
				this.$prev = this.$el.find(this.options.dom.prev);
				return this;
			}
		}, {
			key: 'dir',
			value: function dir(set) {
				var self = this;
				var active = set;
				var count = self.$slide.length;
				if (!self.prevent) {
					self.prevent = true;
					self.$slide.each(function () {
						var $this = (0, _jquery2.default)(this);
						var index = $this.index();
						var sets = index - active;
						if (sets < 3 - count || sets < 0) {
							sets += count;
						}
						$this.attr('data-old', $this.attr('data-position')).attr('data-set', 'false').attr('data-position', sets);
	
						setTimeout(function () {
							$this.attr('data-set', 'true');
						}, 5);
						setTimeout(function () {
							self.prevent = false;
						}, 505);
					});
				}
				return self;
			}
		}, {
			key: 'onPrev',
			value: function onPrev() {
				var $active = this.$slide.filter('[data-position="0"]').prev();
				if (!$active.is(this.$slide)) {
					$active = this.$slide.last();
				}
				this.dir($active.index());
			}
		}, {
			key: 'onNext',
			value: function onNext() {
				var $active = this.$slide.filter('[data-position="0"]').next();
				if (!$active.is(this.$slide)) {
					$active = this.$slide.first();
				}
				this.dir($active.index());
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					this.getDom();
					this.$prev.on('click', this.onPrev.bind(this));
					this.$next.on('click', this.onNext.bind(this));
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _sliderRange = __webpack_require__(68);
	
	var _sliderRange2 = _interopRequireDefault(_sliderRange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaTariffMobile',
				dom: {
					sliderRange: '.js-slider-range',
					price: '#yotaTariffMobilePrice',
					togglerSms: '#yotaTariffMobileTogglerSms',
					togglerApp: '#yotaTariffMobileTogglerApp',
					sms: '#yotaTariffMobileSms',
					app: '#yotaTariffMobileApp',
					// speed: {
					// 	hour2: '.js-tariff-set-2hour',
					// 	hour24: '.js-tariff-set-24hour'
					// },
					input: {
						minutes: '#yotaTariffMobileInputMinutes',
						price: '#yotaTariffMobileInputPrice'
					},
	
					set: {
						data: '.js-tariff-mobile-setdata',
						hide: '.js-tariff-mobile-hidefor'
					}
	
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.$window = (0, _jquery2.default)(window);
			this.activated = false;
			this.price = false;
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$sliderRange = this.$el.find(this.options.dom.sliderRange);
				this.$price = this.$el.find(this.options.dom.price);
				this.$togglerSms = this.$el.find(this.options.dom.togglerSms);
				this.$togglerApp = this.$el.find(this.options.dom.togglerApp);
				this.$sms = this.$el.find(this.options.dom.sms);
				this.$app = this.$el.find(this.options.dom.app);
				this.input = {};
				this.input.$minutes = this.$el.find(this.options.dom.input.minutes);
				this.input.$price = this.$el.find(this.options.dom.input.price);
	
				this.set = {};
				this.set.$data = (0, _jquery2.default)(this.options.dom.set.data);
				this.set.$hide = (0, _jquery2.default)(this.options.dom.set.hide);
				return this;
			}
		}, {
			key: 'onSlide',
			value: function onSlide(position, rate) {
				rate.action = rate.action || false;
				this.rate = rate;
				this.price = this.rate.price;
				this.setPrice(false, rate.price);
				this.input.$minutes.val(this.rate.minutes);
				this.input.$price.val(this.rate.price);
				this.$el.data('params', [this.rate.ancor]);
				this.$window.trigger('yota.router.check');
	
				this.updateData();
			}
		}, {
			key: 'setPrice',
			value: function setPrice(event, price) {
				var set = price || this.price;
				var text = set + parseInt(this.data.internet);
	
				if (this.unlimitedSms()) {
					text += parseInt(this.data.unlimitedSmsPrice);
				}
				if (this.unlimitedApp()) {
					text += parseInt(this.data.unlimitedAppPrice);
				}
				this.$price.text(text);
	
				this.updateData();
			}
		}, {
			key: 'unlimitedSms',
			value: function unlimitedSms() {
				if (this.$togglerSms.prop('checked')) {
					return true;
				}
				return false;
			}
		}, {
			key: 'unlimitedApp',
			value: function unlimitedApp() {
				if (this.$togglerApp.prop('checked')) {
					return true;
				}
				return false;
			}
		}, {
			key: 'activate',
			value: function activate() {
				var self = this;
				if (!self.activated && self.$el.data('activated') === true) {
					self.activated = true;
					setTimeout(function () {
						self.sliderRange.animate();
					}, 100);
				}
			}
		}, {
			key: 'update',
			value: function update() {
				var params = this.$el.data('params') || [];
				if (params.length) {
					this.data.baseRate = this.sliderRange.getRate(params[0], 'ancor').rate.price;
					this.sliderRange.update({ base: this.data.baseRate });
				}
			}
		}, {
			key: 'updateData',
			value: function updateData() {
				var self = this;
				var data = {};
				data.app = self.$togglerApp.prop('checked') ? 'on' : 'off';
				data.sms = self.$togglerSms.prop('checked') ? 'on' : 'off';
				data.price = String(self.rate.price);
				data.minutes = String(self.rate.minutes);
				data.internet = String(self.rate.internet);
				data.ancor = String(self.rate.ancor);
	
				self.set.$data.each(function () {
					var $this = (0, _jquery2.default)(this);
					var param = $this.data('param');
					if (typeof data[param] != 'undefined') {
						$this.html(data[param]);
					}
				});
	
				self.set.$hide.each(function () {
					var $this = (0, _jquery2.default)(this);
					var param = $this.data('param');
					var showon = $this.data('showon') || false;
					var hideon = $this.data('hideon') || false;
					var values = (showon || hideon).split('|');
					var show = showon !== false && hideon === false;
	
					if (typeof data[param] != 'undefined') {
						var hasValue = values.indexOf(data[param]) !== -1;
						if (show && hasValue || !show && !hasValue) {
							$this.show();
						} else {
							$this.hide();
						}
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					if (yotaPortlets.tariffMobile) {
						this.data = yotaPortlets.tariffMobile;
	
						this.price = this.data.baseRate;
						this.getDom();
	
						this.$togglerSms.on('change', this.setPrice.bind(this));
						this.$togglerApp.on('change', this.setPrice.bind(this));
						this.$sms.html(this.data.unlimitedSmsPrice);
						this.$app.html(this.data.unlimitedAppPrice);
	
						this.sliderRange = new _sliderRange2.default({
							el: this.$sliderRange,
							base: this.data.baseRate,
							rates: this.data.rates,
							callback: {
								update: this.onSlide.bind(this)
							}
						});
	
						var labels = [];
						_jquery2.default.each(this.data.rates, function (key, item) {
							labels.push({
								js: key,
								price: item.minutes,
								internet: item.internet
							});
						});
	
						this.$el.on('yota.router.activate', this.activate.bind(this)).on('yota.router.update', this.update.bind(this)).trigger('yota.router.update');
	
						this.sliderRange.render();
						this.sliderRange.buildLabels(labels, true);
						this.sliderRange.onSlide(this.sliderRange.position);
	
						this.$el.data('params', [this.rate.ancor]);
	
						this.$window.trigger('yota.router.check');
						this.$el.trigger('yota.router.activate');
					} else {
						console.error('The tariffMobile portlet has no data, set data to "yotaPortlets.tariffMobile"');
					}
				}
				return this;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _nocity = __webpack_require__(116);
	
	var _nocity2 = _interopRequireDefault(_nocity);
	
	var _nodelivery = __webpack_require__(118);
	
	var _nodelivery2 = _interopRequireDefault(_nodelivery);
	
	var _info = __webpack_require__(119);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _main = __webpack_require__(120);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _analytics = __webpack_require__(121);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaOrder',
				dom: {
					nocity: '#yotaOrderNoCity',
					nodelivery: '#yotaOrderNoDelivery',
					main: '#yotaOrderMain',
					info: '#yotaOrderInfo'
				},
				classes: {
					nocity: 'b-order_state_nocity',
					nodelivery: 'b-order_state_nodelivery'
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.analytics = new _analytics2.default();
			this.data = {};
			this.city = false;
			this.count = 1;
			this.$window = (0, _jquery2.default)(window);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$nocity = this.$el.find(this.options.dom.nocity);
				this.$nodelivery = this.$el.find(this.options.dom.nodelivery);
				this.$main = this.$el.find(this.options.dom.main);
				this.$info = this.$el.find(this.options.dom.info);
				return this;
			}
		}, {
			key: 'onCitySet',
			value: function onCitySet(data, from) {
				if (data != false) {
					this.city = data;
					this.$el.removeClass(this.options.classes.nocity);
					this.$el.toggleClass(this.options.classes.nodelivery, !data.deliveryAvailable);
					this.nodelivery.setCity(data);
					this.main.setCity(data);
				}
	
				if (from == 'init') {
					this.ga('init', data);
				} else {
					this.ga('setCity', data);
				}
			}
		}, {
			key: 'onCountSet',
			value: function onCountSet(count) /* from */{
				this.main.setCount(count);
				if (this.count != count) {
					this.ga('setCount', count);
				}
				this.count = count;
			}
		}, {
			key: 'onExpressSet',
			value: function onExpressSet(check) /* from */{
				this.ga('setExpress', check);
			}
		}, {
			key: 'onSmsSend',
			value: function onSmsSend(type) /* from */{
				this.ga('sendSms', type);
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					if (yotaPortlets.order) {
						self.data = yotaPortlets.order;
					}
	
					self.getDom();
					self.nocity = new _nocity2.default({
						el: self.$nocity,
						callback: {
							set: self.onCitySet.bind(self)
						}
					}).render();
	
					self.nodelivery = new _nodelivery2.default({
						el: self.$nodelivery,
						callback: {
							set: self.onCitySet.bind(self)
						}
					}).render();
	
					self.main = new _main2.default({
						el: self.$main,
						callback: {
							set: self.onCitySet.bind(self),
							express: self.onExpressSet.bind(self),
							sms: self.onSmsSend.bind(self)
						}
					}).render();
	
					self.info = new _info2.default({
						el: self.$info,
						callback: {
							set: self.onCountSet.bind(self)
						}
					}).render();
	
					self.analytics.setData(self.data.analytics);
	
					self.onCitySet(self.data.data.city, 'init');
				}
				return self;
			}
		}, {
			key: 'ga',
			value: function ga(type, data) {
				switch (type) {
					case 'setCity':
						{
							this.analytics.push({
								event: 'checkoutEvent#4',
								PRICE: this.info.getPrice(),
								QUANTITY: this.info.getCount(),
								'Город доставки': data.name
							});
							break;
						}
	
					case 'sendSms':
						{
							this.analytics.push({
								event: 'checkoutEvent#7',
								PRICE: this.info.getPrice(),
								QUANTITY: this.info.getCount(),
								'Город доставки': this.city.name,
								'Способ доставки': this.main.getExpress() ? 'Доставка за 90 минут' : 'Стандартная доставка'
							});
							break;
						}
	
					case 'setExpress':
						{
							this.analytics.push({
								event: 'checkoutEvent#6',
								PRICE: this.info.getPrice(),
								QUANTITY: this.info.getCount(),
								'Город доставки': this.city.name,
								'Способ доставки': data ? 'Доставка за 90 минут' : 'Стандартная доставка'
							});
							break;
						}
	
					case 'setCount':
						{
							this.analytics.push({
								event: 'checkoutEvent#5',
								PRICE: this.info.getPrice(),
								QUANTITY: data,
								'Город доставки': this.city.name
							});
							break;
						}
	
					case 'init':
						{
							if (data == false) {
								this.analytics.push({
									event: 'checkoutEvent#1',
									PRICE: this.info.getPrice(),
									QUANTITY: this.info.getCount()
								});
							} else {
								this.analytics.push({
									event: 'checkoutEvent#' + (data.deliveryAvailable ? '3' : '2'),
									PRICE: this.info.getPrice(),
									QUANTITY: this.info.getCount(),
									'Город доставки': data.name
								});
							}
							break;
						}
				}
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _city = __webpack_require__(117);
	
	var _city2 = _interopRequireDefault(_city);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaOrderNoCity',
				dom: {
					city: '.js-city'
				},
				callback: {
					set: false
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$city = this.$el.find(this.options.dom.city);
				return this;
			}
		}, {
			key: 'onCitySet',
			value: function onCitySet(data) {
				if (typeof this.options.callback.set == 'function') {
					this.options.callback.set(data, 'nocity');
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
	
					self.city = new _city2.default({
						el: self.$city,
						callback: {
							set: self.onCitySet.bind(self)
						}
					}).render();
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(27);
	
	var _underscore = __webpack_require__(4);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _transcriptor = __webpack_require__(47);
	
	var _transcriptor2 = _interopRequireDefault(_transcriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(29)(_jquery2.default);
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '.js-city',
				dom: {
					input: '.js-city-input',
					dropdown: '.js-city-dropdown',
					search: '.js-city-search',
					item: '.js-city-item',
					template: {
						search: '.js-city-search-template'
					},
					form: {
						search: {
							el: '.js-city-form-search',
							query: '.js-city-form-search-query'
						}
					}
				},
				classes: {
					state: {
						open: 'b-order-city_state_open',
						search: 'b-order-city_state_search',
						empty: 'b-order-city_state_empty'
					},
					item: {
						state: {
							active: 'b-order-city__item_state_active',
							hidden: 'b-order-city__item_state_hidden'
						}
					}
				},
				size: {
					height: 34,
					count: 7
				},
				callback: {
					set: false,
					clear: false
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.searchQuery = '';
			this.preventSearch = false;
			this.searchInputDebounced = false;
			this.searchInputDebounce = false;
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.$document = (0, _jquery2.default)(document);
			this.$window = (0, _jquery2.default)(window);
			this.transcriptor = new _transcriptor2.default();
			this.data = [];
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$input = this.$el.find(this.options.dom.input);
				this.$dropdown = this.$el.find(this.options.dom.dropdown);
				this.$list = this.$el.find(this.options.dom.list);
				this.$listItems = this.$list.find(this.options.dom.item);
				this.$search = this.$el.find(this.options.dom.search);
				this.$searchItems = this.$search.find(this.options.dom.item);
				this.$templateSearch = this.$el.find(this.options.dom.template.search);
				this.templateSearch = _underscore2.default.template(this.$templateSearch.html().trim());
				this.$fromSearch = this.$el.find(this.options.dom.form.search.el);
				this.$fromSearchQuery = this.$el.find(this.options.dom.form.search.query);
				return this;
			}
		}, {
			key: 'addData',
			value: function addData(data) {
				var self = this;
				_jquery2.default.each(data, function (key, value) {
					self.data[value.id] = value;
				});
				return self;
			}
		}, {
			key: 'setSearchOptions',
			value: function setSearchOptions(options) {
				this.addData(options);
				this.$search.html(this.templateSearch({ data: options }));
				this.$searchItems = this.$search.find(this.options.dom.item);
				this.$items = this.$searchItems;
				this.$el.toggleClass(this.options.classes.state.empty, this.$items.length === 0);
				this.$el.addClass(this.options.classes.state.search);
	
				this.$items.first().addClass(this.options.classes.item.state.active);
				return this;
			}
		}, {
			key: 'search',
			value: function search(query) {
				var self = this;
				var thisQuery = self.transcriptor.toCyrillic(query);
				self.searchQuery = thisQuery;
				self.$fromSearchQuery.val(thisQuery);
				_jquery2.default.ajax({
					url: self.$fromSearch.attr('action'),
					type: self.$fromSearch.attr('method'),
					data: self.$fromSearch.find(':input').serialize(),
					dataType: 'json',
					success: function success(json) {
						if (thisQuery === self.searchQuery) {
							self.find(json);
						}
					}
				});
			}
		}, {
			key: 'find',
			value: function find(data) {
				this.setSearchOptions(data);
			}
		}, {
			key: 'set',
			value: function set(id) {
				var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				var self = this;
				if (val != false) {
					self.$input.val(val);
				} else if (typeof self.options.callback.set == 'function') {
					self.options.callback.set(self.data[id]);
				}
				return this;
			}
		}, {
			key: 'filter',
			value: function filter(query) {
				var self = this;
				var thisQuery = query;
	
				clearTimeout(self.searchInputDebounce);
	
				if (query.length >= 2) {
					self.searchInputDebounce = setTimeout(function () {
						self.searchInputDebounced = false;
						self.search(thisQuery);
					}, self.searchInputDebounced ? 0 : 300);
					self.searchInputDebounced = true;
					self.$el.addClass(self.options.classes.state.open);
				} else {
					self.searchQuery = '';
					self.$items = self.$listItems;
					self.$el.removeClass(self.options.classes.state.search).removeClass(self.options.classes.state.empty);
				}
				return self;
			}
		}, {
			key: 'clear',
			value: function clear() {
				this.filter('');
				this.$input.val('');
				if (typeof this.options.callback.clear == 'function') {
					this.options.callback.clear();
				}
				return this;
			}
		}, {
			key: 'open',
			value: function open() {
				var self = this;
				setTimeout(function () {
					self.$el.addClass(self.options.classes.state.open);
				}, 150);
				self.$el.removeClass(self.options.classes.state.search).removeClass(self.options.classes.state.empty);
				self.$el.find(self.options.dom.item).removeClass(self.options.classes.item.state.active);
				self.$dropdown.data('position', 0);
				self.$dropdown.mNCustomScrollbar('scrollTo', 0);
				self.$el.trigger('yota.city.open');
				return this;
			}
		}, {
			key: 'close',
			value: function close() {
				this.$el.removeClass(this.options.classes.state.search).removeClass(this.options.classes.state.empty).removeClass(this.options.classes.state.open);
	
				this.$el.trigger('yota.city.close');
				this.filter('');
				this.$input.val('');
				return this;
			}
		}, {
			key: 'onFocusIn',
			value: function onFocusIn() {
				var filter = this.$input.val().trim();
				this.open().filter(filter);
				if (filter.length >= 2) {
					this.$el.addClass(this.options.classes.state.search);
				}
			}
		}, {
			key: 'onDocumentClick',
			value: function onDocumentClick(event) {
				var $target = (0, _jquery2.default)(event.target);
				if (this.$el.hasClass(this.options.classes.state.open)) {
					if (!$target.is(this.$el) && !$target.closest(this.$el).length) {
						this.clear().close();
					}
				}
			}
		}, {
			key: 'onHover',
			value: function onHover(event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
				this.$items.not($target).removeClass(this.options.classes.item.state.active);
				$target.addClass(this.options.classes.item.state.active);
			}
		}, {
			key: 'selectActive',
			value: function selectActive() {
				var $active = this.getActive();
				if ($active !== false) {
					$active.trigger('click');
					this.$input.blur();
				}
				return this;
			}
		}, {
			key: 'getActive',
			value: function getActive() {
				var $visible = this.$items.filter(this.options.dom.item + ':not(.' + this.options.classes.item.state.hidden + ')');
				var $active = $visible.filter('.' + this.options.classes.item.state.active).eq(0);
				this.$items.not($active).removeClass(this.options.classes.item.state.active);
				if (!$active.length) {
					$visible.first().addClass(this.options.classes.item.state.active);
					return false;
				}
				return $active;
			}
		}, {
			key: 'scrollToItem',
			value: function scrollToItem($active) {
				var itemHeight = $active.outerHeight(true);
				var itemTop = $active.position().top;
				var scrollTop = this.$dropdown.data('position');
				var scrollHeight = this.$dropdown.outerHeight(true);
				var scrollTo = false;
				if (itemTop < scrollTop) {
					scrollTo = itemTop;
				}
				if (itemTop + itemHeight - scrollHeight > scrollTop) {
					scrollTo = itemTop + itemHeight - scrollHeight;
				}
				if (scrollTo !== false) {
					this.$dropdown.mNCustomScrollbar('scrollTo', scrollTo);
				}
				return this;
			}
		}, {
			key: 'moveActive',
			value: function moveActive(direction) {
				var $active = this.getActive();
				if ($active !== false) {
					var $set = $active[direction ? 'nextAll' : 'prevAll'](this.options.dom.item + ':not(.' + this.options.classes.item.state.hidden + ')').eq(0);
					if (!$set.length) {
						$set = this.$items.filter(':not(.' + this.options.classes.item.state.hidden + ')')[direction ? 'first' : 'last']();
					}
					this.$items.not($set).removeClass(this.options.classes.item.state.active);
					$set.addClass(this.options.classes.item.state.active);
					this.scrollToItem($set);
				}
				return this;
			}
		}, {
			key: 'onInput',
			value: function onInput(event) {
				var code = event.which;
				var codeUp = code === 38;
				var codeDown = code === 40;
				var codeEnter = code === 13;
	
				if (codeUp || codeDown || codeEnter) {
					event.preventDefault();
					if (codeEnter) {
						this.selectActive();
					} else {
						this.moveActive(codeDown);
					}
				} else if (!this.preventSearch) {
					var filter = this.$input.val().trim();
					this.filter(filter);
				}
			}
		}, {
			key: 'onClick',
			value: function onClick(event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
				this.preventSearch = true;
				this.set($target.data('value'));
				this.$input.val($target.text());
				this.close();
				this.preventSearch = false;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.$el.find(this.options.dom.input).focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
	
					self.$dropdown.mNCustomScrollbar({
						autoDraggerLength: false,
						mouseWheel: {
							enable: true,
							preventDefault: true
						},
						contentTouchScroll: self.options.size.height * 2,
						mouseWheelPixels: self.options.size.height * 2,
						scrollButtons: false,
						scrollInertia: self.options.size.height * self.options.size.count,
						theme: '',
						callbacks: {
							onCreate: function onCreate() {
								self.$dropdown.data('position', 0);
							},
							onUpdate: function onUpdate() {
								if (this.mncs) {
									self.$dropdown.data('position', this.mncs.top < 0 ? -this.mncs.top : 0);
								}
							},
							whileScrolling: function whileScrolling() {
								if (this.mncs) {
									self.$dropdown.data('position', this.mncs.top < 0 ? -this.mncs.top : 0);
								}
							}
						}
					});
	
					self.$document.on('click.city', self.onDocumentClick.bind(self));
	
					self.$el.on('focusin.city', self.options.dom.input, self.onFocusIn.bind(self)).on('input.city paste.city keydown.city', self.options.dom.input, self.onInput.bind(self)).on('click.city', self.options.dom.item, self.onClick.bind(self)).on('mouseover.city', self.options.dom.item, self.onHover.bind(self));
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _city = __webpack_require__(117);
	
	var _city2 = _interopRequireDefault(_city);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaOrderNoDelivery',
				dom: {
					city: '.js-city',
					name: '#yotaOrderNoDeliveryCityName',
					button: '#yotaOrderNoDeliveryButton'
				},
				classes: {
					find: 'b-order-nodelivery_state_find'
				},
				callback: {
					set: false
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$city = this.$el.find(this.options.dom.city);
				this.$name = this.$el.find(this.options.dom.name);
				this.$button = this.$el.find(this.options.dom.button);
				return this;
			}
		}, {
			key: 'setCity',
			value: function setCity(data) {
				this.$el.removeClass(this.options.classes.find);
				this.$name.html(data.name);
				var href = this.$button.data('href').replace('{#code}', data.code).replace('{#center}', data.center).replace('{#id}', data.id).replace('{#map1}', data.map[0]).replace('{#map2}', data.map[1]);
				this.$button.attr('href', href);
			}
		}, {
			key: 'onCitySet',
			value: function onCitySet(data) {
				if (typeof this.options.callback.set == 'function') {
					this.options.callback.set(data, 'nodelivery');
				}
			}
		}, {
			key: 'onCityClear',
			value: function onCityClear() /* data */{
				this.$el.removeClass(this.options.classes.find);
			}
		}, {
			key: 'find',
			value: function find(event) {
				event.preventDefault();
				this.$el.addClass(this.options.classes.find);
				this.city.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
	
					self.city = new _city2.default({
						el: self.$city,
						callback: {
							set: self.onCitySet.bind(self),
							clear: self.onCityClear.bind(self)
						}
					}).render();
	
					self.$name.on('click', self.find.bind(self));
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaOrderInfo',
				dom: {
					count: '#yotaOrderInfoCount',
					price: '#yotaOrderInfoPrice',
					minus: '#yotaOrderInfoMinus',
					plus: '#yotaOrderInfoPlus'
				},
				callback: {
					set: false
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$count = this.$el.find(this.options.dom.count);
				this.$price = this.$el.find(this.options.dom.price);
				this.$minus = this.$el.find(this.options.dom.minus);
				this.$plus = this.$el.find(this.options.dom.plus);
				return this;
			}
		}, {
			key: 'getPrice',
			value: function getPrice() {
				return parseInt(this.$price.data('price'), 10);
			}
		}, {
			key: 'getCount',
			value: function getCount() {
				return parseInt(this.$count.data('count'), 10);
			}
		}, {
			key: 'set',
			value: function set(count) {
				var price = this.$price.data('price');
				this.$count.data('count', count).html(count);
				this.$price.html(price * count);
	
				if (typeof this.options.callback.set == 'function') {
					this.options.callback.set(count, 'info');
				}
			}
		}, {
			key: 'plus',
			value: function plus(event) {
				var count = parseInt(this.$count.data('count'), 10);
				var max = parseInt(this.$plus.data('max'), 10);
				if (count < max) {
					count++;
				}
				this.set(count);
				event.preventDefault();
			}
		}, {
			key: 'minus',
			value: function minus(event) {
				var count = parseInt(this.$count.data('count'), 10);
				var min = parseInt(this.$minus.data('min'), 10);
				if (count > min) {
					count--;
				}
				this.set(count);
				event.preventDefault();
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
					self.$minus.on('click', self.minus.bind(self));
					self.$plus.on('click', self.plus.bind(self));
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _city = __webpack_require__(117);
	
	var _city2 = _interopRequireDefault(_city);
	
	var _animation = __webpack_require__(9);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _input = __webpack_require__(18);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _cookie = __webpack_require__(46);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaOrderMain',
				dom: {
					city: '.js-city',
					name: '#yotaOrderMainCityName',
					express: '#yotaOrderMainExpress',
	
					tooltip: '#yotaOrderMainTooltip',
					tooltipShow: '#yotaOrderMainTooltipShow',
					tooltipClose: '#yotaOrderMainTooltipClose',
	
					form: '#yotaOrderMainForm',
					cmd: '#yotaOrderMainCmd',
					cityJson: '#yotaOrderMainCityJson',
					cityId: '#yotaOrderMainCityId',
					cityCode: '#yotaOrderMainCityCode',
	
					count: '#yotaOrderMainCount',
	
					phone: '#yotaOrderMainPhone',
					phoneHidden: '#yotaOrderMainPhoneHidden',
					send: '#yotaOrderMainSend',
					order: '#yotaOrderMainOrder',
	
					code: '#yotaOrderMainCode',
	
					resend: '#yotaOrderMainResend',
	
					submit: '#yotaOrderMainSubmit'
				},
				classes: {
					find: 'b-order-main_state_find',
					express: 'b-order-main_state_express',
					tooltip: 'b-order-main__tooltip_state_open',
					phoneError: 'b-order-main_phone_error',
					phoneSend: 'b-order-main_phone_send',
					wait: 'b-order-main_state_wait',
					codeError: 'b-order-main_code_error',
					codeOk: 'b-order-main_code_ok'
				},
				callback: {
					set: false,
					express: false,
					sms: false
				}
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = this.options.el instanceof _jquery2.default ? this.options.el : (0, _jquery2.default)(this.options.el);
			this.$document = (0, _jquery2.default)(document);
	
			this.send = false;
			this.timer = 0;
			this.interval = false;
			this.sms = false;
			this.cmd = 'send';
			this.cookie = new _cookie2.default();
	
			return this;
		}
	
		_createClass(_class, [{
			key: 'getDom',
			value: function getDom() {
				this.$city = this.$el.find(this.options.dom.city);
				this.$name = this.$el.find(this.options.dom.name);
				this.$express = this.$el.find(this.options.dom.express);
	
				this.$tooltip = this.$el.find(this.options.dom.tooltip);
				this.$tooltipShow = this.$el.find(this.options.dom.tooltipShow);
				this.$tooltipClose = this.$el.find(this.options.dom.tooltipClose);
	
				this.$form = this.$el.find(this.options.dom.form);
				this.$cmd = this.$el.find(this.options.dom.cmd);
				this.$cityJson = this.$el.find(this.options.dom.cityJson);
				this.$cityId = this.$el.find(this.options.dom.cityId);
				this.$cityCode = this.$el.find(this.options.dom.cityCode);
	
				this.$count = this.$el.find(this.options.dom.count);
	
				this.$phone = this.$el.find(this.options.dom.phone);
				this.$phoneHidden = this.$el.find(this.options.dom.phoneHidden);
				this.$send = this.$el.find(this.options.dom.send);
				this.$order = this.$el.find(this.options.dom.order);
	
				this.$code = this.$el.find(this.options.dom.code);
	
				this.$resend = this.$el.find(this.options.dom.resend);
	
				this.$submit = this.$el.find(this.options.dom.submit);
	
				return this;
			}
		}, {
			key: 'setCity',
			value: function setCity(data) {
				this.$el.removeClass(this.options.classes.find);
				this.$name.html(data.name);
				this.$el.toggleClass(this.options.classes.express, data.deliveryExpress);
				this.$express.prop('checked', !!data.deliveryExpress);
	
				this.$cityJson.val(JSON.stringify(data));
				this.$cityId.val(data.id);
				this.$cityCode.val(data.code);
			}
		}, {
			key: 'setCount',
			value: function setCount(count) {
				this.$count.val(count);
			}
		}, {
			key: 'onCitySet',
			value: function onCitySet(data) {
				if (typeof this.options.callback.set == 'function') {
					this.options.callback.set(data, 'main');
				}
			}
		}, {
			key: 'find',
			value: function find(event) {
				event.preventDefault();
				this.$el.addClass(this.options.classes.find);
				this.city.focus();
			}
		}, {
			key: 'tooltipShow',
			value: function tooltipShow() {
				this.$tooltip.toggleClass(this.options.classes.tooltip);
			}
		}, {
			key: 'tooltipClose',
			value: function tooltipClose() {
				this.$tooltip.removeClass(this.options.classes.tooltip);
			}
		}, {
			key: 'onDocumentTooltipClick',
			value: function onDocumentTooltipClick(event) {
				var $target = (0, _jquery2.default)(event.target);
				if (this.$tooltip.hasClass(this.options.classes.tooltip)) {
					if (!$target.is(this.$tooltip) && !$target.closest(this.$tooltip).length) {
						this.tooltipClose();
					}
				}
			}
		}, {
			key: 'validate',
			value: function validate() {
				var _this = this;
	
				var valid = true;
				if (this.$phone.length) {
					var phone = this.$phone.val().replace(/[^\d]/gi, '');
					if (phone.length < 11) {
						this.$el.addClass(this.options.classes.phoneError);
						(0, _jquery2.default)(function () {
							return new _animation2.default({ el: _this.$phone.parent() }).play('shake');
						});
						valid = false;
					}
				}
	
				if (this.$code.length && this.$el.hasClass(this.options.classes.phoneSend)) {
					var code = this.$code.val().replace(/[^\d]/gi, '');
					if (code.length < 3) {
						this.$el.addClass(this.options.classes.codeError);
						(0, _jquery2.default)(function () {
							return new _animation2.default({ el: _this.$code.parent() }).play('shake');
						});
						valid = false;
					}
				}
	
				return valid;
			}
		}, {
			key: 'onSend',
			value: function onSend(event) {
				event.preventDefault();
				var valid = this.validate();
				if (valid) {
					this.$form.submit();
				}
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit(event) {
				event.preventDefault();
	
				var self = this;
				var valid = self.validate();
	
				if (!valid) {
					return false;
				}
	
				if (!self.send && valid) {
					if (self.cmd === 'send') {
						self.send = true;
						self.$cmd.val('send');
						self.$phoneHidden.val(this.$phone.val());
						_jquery2.default.ajax({
							url: self.$form.attr('action'),
							type: self.$form.attr('method'),
							data: self.$form.find(':input').serialize(),
							dataType: 'json',
							success: function success(json) {
								if (json && json.success && json.order) {
									self.cmd = 'order';
									self.$order.val(json.order);
									self.$el.addClass(self.options.classes.phoneSend);
									self.$phone.prop('disabled', true);
									self.$code.prop('disabled', false);
									self.startTimer(json.time || self.$resend.data('time') || 60);
								} else {
									self.$el.addClass(self.options.classes.phoneError);
									(0, _jquery2.default)(function () {
										return new _animation2.default({ el: self.$phone.parent() }).play('shake');
									});
								}
								self.send = false;
							}
						});
	
						if (typeof this.options.callback.sms == 'function') {
							this.options.callback.sms('send', 'main');
						}
					}
					if (self.cmd === 'order') {
						self.send = true;
						self.$cmd.val('order');
						_jquery2.default.ajax({
							url: self.$form.attr('action'),
							type: self.$form.attr('method'),
							data: self.$form.find(':input').serialize(),
							dataType: 'json',
							success: function success(json) {
								if (json && json.success) {
									if (json.analytics && json.location) {
										self.cookie.set('checkoutEvent8_1', encodeURIComponent(json.analytics['event']), 365);
										self.cookie.set('checkoutEvent8_2', encodeURIComponent(json.analytics['NAME']), 365);
										self.cookie.set('checkoutEvent8_3', encodeURIComponent(json.analytics['ID_PRODUCT']), 365);
										self.cookie.set('checkoutEvent8_4', encodeURIComponent(json.analytics['CATEGORY']), 365);
										self.cookie.set('checkoutEvent8_5', encodeURIComponent(json.analytics['PRICE']), 365);
										self.cookie.set('checkoutEvent8_6', encodeURIComponent(json.analytics['QUANTITY']), 365);
										self.cookie.set('checkoutEvent8_7', encodeURIComponent(json.analytics['Город доставки']), 365);
										self.cookie.set('checkoutEvent8_8', encodeURIComponent(json.analytics['Способ доставки']), 365);
										self.cookie.set('checkoutEvent8_9', encodeURIComponent(json.analytics['ID_TRANSACTION']), 365);
										self.cookie.set('checkoutEvent8_10', encodeURIComponent(json.analytics['REVENUE']), 365);
									}
									if (json.location) {
										window.location.assign(json.location);
									}
								} else {
									self.$el.addClass(self.options.classes.codeError);
									(0, _jquery2.default)(function () {
										return new _animation2.default({ el: self.$code }).play('shake');
									});
									self.$submit.prop('disabled', true);
								}
								self.send = false;
							}
						});
					}
				}
			}
		}, {
			key: 'updateTimer',
			value: function updateTimer() {
				var _$resend$data = this.$resend.data(),
				    text = _$resend$data.text;
	
				text = text.replace('{{=time}}', this.timer);
				this.$resend.html(text);
			}
		}, {
			key: 'startTimer',
			value: function startTimer(time) {
				this.timer = time - 1;
				this.updateTimer();
				this.$el.addClass(this.options.classes.wait);
				clearInterval(this.interval);
				this.interval = setInterval(this.stopTimer.bind(this), 1000);
				return this;
			}
		}, {
			key: 'stopTimer',
			value: function stopTimer() {
				this.timer--;
				this.updateTimer();
				if (this.timer <= 0) {
					this.$el.removeClass(this.options.classes.wait);
	
					var _$resend$data2 = this.$resend.data(),
					    send = _$resend$data2.send;
	
					this.$resend.html(send);
					clearInterval(this.interval);
				}
				return this;
			}
		}, {
			key: 'onPhoneFocusIn',
			value: function onPhoneFocusIn() {
				this.$el.removeClass(this.options.classes.phoneError);
			}
		}, {
			key: 'onInput',
			value: function onInput(event) {
				var $target = (0, _jquery2.default)(event.currentTarget);
				this.$el.removeClass(this.options.classes.codeError);
				var val = $target.val();
				if (val.length > 4) {
					$target[0].value = val.substr(0, 4);
				}
				this.$el.toggleClass(this.options.classes.codeOk, val.length >= 4);
				this.$submit.prop('disabled', val.length < 4);
			}
		}, {
			key: 'onResend',
			value: function onResend() {
				var self = this;
				event.preventDefault();
				if (!self.send) {
					self.send = true;
					self.$cmd.val('resend');
					_jquery2.default.ajax({
						url: self.$form.attr('action'),
						type: self.$form.attr('method'),
						data: self.$form.find(':input').serialize(),
						dataType: 'json',
						success: function success(json) {
							if (json && json.success) {
								self.startTimer(json.time || self.$resend.data('time') || 60);
							}
							self.send = false;
						}
					});
				}
	
				if (typeof this.options.callback.sms == 'function') {
					this.options.callback.sms('resend', 'main');
				}
			}
		}, {
			key: 'onExpress',
			value: function onExpress() {
				if (typeof this.options.callback.express == 'function') {
					this.options.callback.express(this.$express.prop('checked'), 'main');
				}
			}
		}, {
			key: 'getExpress',
			value: function getExpress() {
				return this.$express.prop('checked');
			}
		}, {
			key: 'render',
			value: function render() {
				var self = this;
				if (self.$el.length) {
					self.getDom();
	
					self.city = new _city2.default({
						el: self.$city,
						callback: {
							set: self.onCitySet.bind(self)
						}
					}).render();
	
					self.numbered = new _input2.default(self.$phone, { placeholder: false });
	
					self.$name.on('click', self.find.bind(self));
	
					self.$tooltipShow.on('click', self.tooltipShow.bind(self));
					self.$tooltipClose.on('click', self.tooltipClose.bind(self));
	
					self.$document.on('click.order.main', self.onDocumentTooltipClick.bind(self));
	
					self.$send.on('click', self.onSend.bind(self));
					self.$form.on('submit', self.onSubmit.bind(self));
	
					self.$phone.on('focusin', self.onPhoneFocusIn.bind(self));
					this.$code.on('change input blur keypress focus', self.onInput.bind(self));
					this.$resend.on('click', self.onResend.bind(self));
	
					this.$express.on('change', self.onExpress.bind(self));
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(data) {
			_classCallCheck(this, _class);
	
			this.data = data || {};
			this.checkDataLayer();
			return this;
		}
	
		_createClass(_class, [{
			key: 'checkDataLayer',
			value: function checkDataLayer() {
				if (typeof window.dataLayer == 'undefined') {
					window.dataLayer = {};
					window.dataLayer.push = function (data) {
						console.log('dataLayer.push', data);
					};
				}
			}
		}, {
			key: 'setData',
			value: function setData(data) {
				var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				this.data = replace ? data : _jquery2.default.extend(true, {}, this.data, data);
				return this;
			}
		}, {
			key: 'push',
			value: function push(data) {
				this.setData(data);
				window.dataLayer.push(this.data);
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _analytics = __webpack_require__(121);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _cookie = __webpack_require__(46);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(options) {
			_classCallCheck(this, _class);
	
			var defaults = {
				el: '#yotaOrderThankyou'
			};
	
			this.options = _jquery2.default.extend(true, {}, defaults, options);
			this.$el = (0, _jquery2.default)(this.options.el);
			this.analytics = new _analytics2.default();
			this.data = {};
			this.$window = (0, _jquery2.default)(window);
			this.cookie = new _cookie2.default();
			return this;
		}
	
		_createClass(_class, [{
			key: 'render',
			value: function render() {
				if (this.$el.length) {
					if (yotaPortlets.orderThankyou) {
						this.data = yotaPortlets.orderThankyou;
					} else {
						var e1 = this.cookie.get('checkoutEvent8_1');
						if (typeof e1 != 'undefined') {
							this.data = {};
							this.data.analytics = {};
							this.data.analytics['event'] = decodeURIComponent(e1);
							this.data.analytics['NAME'] = decodeURIComponent(this.cookie.get('checkoutEvent8_2'));
							this.data.analytics['ID_PRODUCT'] = decodeURIComponent(this.cookie.get('checkoutEvent8_3'));
							this.data.analytics['CATEGORY'] = decodeURIComponent(this.cookie.get('checkoutEvent8_4'));
							this.data.analytics['PRICE'] = decodeURIComponent(this.cookie.get('checkoutEvent8_5'));
							this.data.analytics['QUANTITY'] = decodeURIComponent(this.cookie.get('checkoutEvent8_6'));
							this.data.analytics['Город доставки'] = decodeURIComponent(this.cookie.get('checkoutEvent8_7'));
							this.data.analytics['Способ доставки'] = decodeURIComponent(this.cookie.get('checkoutEvent8_8'));
							this.data.analytics['ID_TRANSACTION'] = decodeURIComponent(this.cookie.get('checkoutEvent8_9'));
							this.data.analytics['REVENUE'] = decodeURIComponent(this.cookie.get('checkoutEvent8_10'));
						}
					}
	
					this.analytics.setData(this.data.analytics);
					this.analytics.push({});
	
					this.cookie.remove('checkoutEvent8_1');
					this.cookie.remove('checkoutEvent8_2');
					this.cookie.remove('checkoutEvent8_3');
					this.cookie.remove('checkoutEvent8_4');
					this.cookie.remove('checkoutEvent8_5');
					this.cookie.remove('checkoutEvent8_6');
					this.cookie.remove('checkoutEvent8_7');
					this.cookie.remove('checkoutEvent8_8');
					this.cookie.remove('checkoutEvent8_9');
					this.cookie.remove('checkoutEvent8_10');
				}
				return self;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// migrate-app.min.js